const PRIVATE_DATA: string = JSON.stringify(
  {
      "status": "UPTODATE",
      "dashboard": {
        "sex": "M",
        "dobMillis": 813801600000,
        "locale": "nl",
        "result": {
            "tag": "DASHBOARD",
            "groups": [
                {
                    "tag": "DASHBOARD_SUMMARY",
                    "name": "Samenvatting",
                    "groups": [
                        {
                            "tag": "DASHBOARD_SUMMARY_BODY",
                            "name": "Body",
                            "groups": [],
                            "results": [
                                {
                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                    "name": "Gewicht uit bodyscan",
                                    "unit": "kg",
                                    "values": [
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 83.2,
                                            "stringValue": "83.2",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1623937440000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 66.3,
                                            "stringValue": "66.3",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1623939540000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 83.4,
                                            "stringValue": "83.4",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1638437400000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 63.4,
                                            "stringValue": "63.4",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                            "resultText": "Gewicht uit bodyscan",
                                            "keyWords": "totaal gewicht",
                                            "advice": "Je gewicht is maar Ã©Ã©n parameter van je lichaamsbouw en je gezondheid. Bekijk ook steeds je spiermassa en vetverdeling in je lichaam.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1639648080000
                                        }
                                    ],
                                    "visualization": "TEXTUAL",
                                    "source": "DXA",
                                    "expired": true
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO",
                                    "name": "Buik-heupratio",
                                    "unit": "",
                                    "values": [
                                        {
                                            "riskLevel": "BAD",
                                            "doubleValue": 1.2,
                                            "stringValue": "1.2",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1623937440000
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "doubleValue": 0.79,
                                            "stringValue": "0.79",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1623939540000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 0.89,
                                            "stringValue": "0.89",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1638437400000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 0.99,
                                            "stringValue": "0.99",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_GOOD",
                                            "resultText": "Je middel-heupratio is goed",
                                            "keyWords": "goed",
                                            "advice": "Goed bezig! Een lage middel-heupratio betekent dat de hoeveelheid vet niet is opgeslagen rond je middel. Houden zo!",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1639648080000
                                        }
                                    ],
                                    "visualization": "SLIDER_REVERSE",
                                    "source": "DXA",
                                    "expired": true
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                    "name": "Buikvet",
                                    "unit": "kg",
                                    "values": [
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 1.3,
                                            "stringValue": "1.3",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1623937440000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 1,
                                            "stringValue": "1.0",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1623939540000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 0.8,
                                            "stringValue": "0.8",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1638437400000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 1.7,
                                            "stringValue": "1.7",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                            "resultText": "Buikvet",
                                            "keyWords": "buikvet",
                                            "advice": "Zelfs als je gewicht en lichaamsvet constant blijven, verandert de vetverdeling over je lichaam naarmate je ouder wordt en zal vet eerder naar je buikgebied verschuiven. Door ervoor te zorgen dat je een gezond visceraal vetniveau hebt, neemt de kans op bepaalde aandoeningen, zoals hartziekten en hoge bloeddruk, af en kan het ontstaan van diabetes type 2 worden vertraagd.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1639648080000
                                        }
                                    ],
                                    "visualization": "HUMAN",
                                    "source": "DXA",
                                    "expired": true
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                    "name": "Heupvet",
                                    "unit": "kg",
                                    "values": [
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 2.4,
                                            "stringValue": "2.4",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1623937440000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 3.6,
                                            "stringValue": "3.6",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1623939540000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 2.2,
                                            "stringValue": "2.2",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1638437400000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 3.8,
                                            "stringValue": "3.8",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                            "resultText": "Heupvet",
                                            "keyWords": "heupvet",
                                            "advice": "Je heupen en dijen zijn een veilige opslagplaats voor vet. Als je op een gezond gewicht zit en als vet op je heupen het enige is dat je stoort, hoef je jezelf zeker geen zorgen te maken over dit laagje.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1639648080000
                                        }
                                    ],
                                    "visualization": "HUMAN",
                                    "source": "DXA"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI",
                                    "name": "BMI uit bodyscan",
                                    "values": [
                                        {
                                            "riskLevel": "BAD",
                                            "doubleValue": 28.78892733564014,
                                            "stringValue": "28.78892733564014",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI_OVERGEWICHT_BAD",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1623937440000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 23.4906462585034,
                                            "stringValue": "23.4906462585034",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI_NORMAAL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1623939540000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 21.489860599345512,
                                            "stringValue": "21.489860599345512",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI_NORMAAL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1638437400000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 24.157902758725804,
                                            "stringValue": "24.157902758725804",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI_NORMAAL_GOOD",
                                            "resultText": "Je BMI - of Body Mass Index - is de verhouding tussen je gewicht en je lichaamslengte. In jouw geval ligt die tussen 18,5 en 25. Dit betekent dat je ten opzichte van je lengte een gezond gewicht hebt.",
                                            "keyWords": "normaal",
                                            "advice": "Je gewicht valt binnen de gemiddelde grenzen. Dat betekent niet automatisch dat je evenwichtig eet en voldoende beweegt. Het omgekeerde geldt ook: mensen met (licht) overgewicht eten niet per definitie ongezond. Fixeer je dus niet op je BMI of het getal op de weegschaal.",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1639648080000
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "DXA"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK",
                                    "name": "Buikomtrek",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116168810
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709124272513
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709223914112
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "resultText": "Uit jouw antwoorden blijkt dat je buikomtrek licht verhoogd is. Als vrouw is dat tussen de 80 en 88 centimeter.",
                                            "keyWords": "licht te hoog",
                                            "advice": "Wat sommige coaches en influencers ook mogen beweren: er bestaat helaas geen miraculeus crashdieet om snel die buik kwijt te raken. Toch helpen alle beetjes. Als je erin slaagt om 5 Ã  10% van je gewicht te verliezen, dan heeft dat een heilzaam effect op je buikvet. Met de nodige deskundige hulp lukt het zelfs om bij veel overgewicht de gezonde balans terug te vinden.\n\nIn een ideaal scenario vind je een gezond voedingspatroon dat je je eigen maakt om ook op lange termijn een gezond gewicht Ã©n je buikomtrek te behouden. Het klassieke jojo-effect dat ervoor zorgt dat je continu afvalt en vervolgens weer bijkomt, is namelijk erg slecht voor je gezondheid. Bij deze nog wat inspiratie:\n\n* Ga fietsen, zwemmen, wandelen, dansen, trappen lopen: maak zelf een keuze waar je je goed en gemotiveerd bij voelt.\n* Probeer elke dag twintig minuten intensief - zodat je bijna buiten adem bent - te bewegen.\n* Lukt het niet om elke dag te bewegen? Probeer dan minstens vier keer per week beweging (maar dan wel 30 Ã  45 minuten) in te plannen.",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1719837987002
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP",
                                    "name": "Middel-heupverhouding",
                                    "values": [
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "licht verhoogd",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_MAN_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "sterk verhoogd",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116168810
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "sterk verhoogd",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709124272513
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_MAN_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709223914112
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "sterk verhoogd",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "sterk verhoogd",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "sterk verhoogd",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "sterk verhoogd",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "sterk verhoogd",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                            "resultText": "Jouw middel-heup verhouding is sterk verhoogd. Dit betekent dat de verhouding hoger is dan 0.85.",
                                            "keyWords": "sterk verhoogd",
                                            "advice": "Je middel-heupratio zou best wat lager liggen. Gewicht verliezen is hier vaak noodzakelijk en dan meer specifiek ter hoogte van de buik. Een gezondheidsprofessional kan je daarbij helpen.",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1719837987002
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI",
                                    "name": "Body Mass Index",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normaal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normaal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116168810
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normaal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709124272513
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "overgewicht",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_OVERGEWICHT_BAD",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709223914112
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normaal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normaal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normaal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normaal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normaal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                            "resultText": "Je BMI - of Body Mass Index is de verhouding tussen je gewicht en je lichaamslengte. In jouw geval ligt die tussen 18,5 en 25. Dat betekent dat je ten opzichte van je lengte een gezond gewicht hebt.",
                                            "keyWords": "normaal",
                                            "advice": "Je gewicht valt binnen de gemiddelde grenzen. Dat betekent niet automatisch dat je evenwichtig eet en voldoende beweegt. Het omgekeerde geldt ook: mensen met (licht) overgewicht eten niet per definitie ongezond. Fixeer je dus niet op je BMI of het getal op de weegschaal.",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1719837987002
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                    "name": "Jouw gerapporteerd gewicht",
                                    "unit": "kg",
                                    "values": [
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 70,
                                            "intValue": 70,
                                            "stringValue": "70",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 70,
                                            "intValue": 70,
                                            "stringValue": "70",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 70,
                                            "intValue": 70,
                                            "stringValue": "70",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 70,
                                            "intValue": 70,
                                            "stringValue": "70",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                            "resultText": "Jouw gerapporteerd gewicht",
                                            "advice": "Een gezond gewicht vermindert het risico op diverse gezondheidsproblemen zoals obesitas, diabetes type 2, hart- en vaatziekten, gewrichtsproblemen en meer. Het is echter belangrijk om op te merken dat gewicht slechts Ã©Ã©n aspect is van gezondheid en dat andere factoren zoals lichamelijke fitheid, voedingspatroon, stressniveaus en genetica ook een rol spelen. Daarom is het altijd raadzaam om een holistische benadering van gezondheid te hanteren en niet alleen te focussen op gewicht maar ook op andere aspecten van een gezonde levensstijl.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711641908053
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                }
                            ],
                            "scoreResult": [
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.5",
                                    "score": 6.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 27.69230769230769,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 40.82439729256978,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.0",
                                    "score": 8,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 22.967145790554415,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.0",
                                    "score": 8,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 22.97741273100616,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 40.96433188835653,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 40.982584226937405,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 40.988668339797705,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 41.00083656551829,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 41.0860141455624,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 41.110350597003574,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 41.57882728724618,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 41.657920754429995,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 41.66400486729028,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SUMMARY_MOVE",
                            "name": "Move",
                            "groups": [],
                            "results": [
                                {
                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_VO2MAX",
                                    "name": "VO2max",
                                    "unit": "ml/min/kg",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "doubleValue": 39,
                                            "stringValue": "39.0",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_VO2MAX_VERYGOOD",
                                            "resultText": "Je VO2max is heel goed! Goed bezig!",
                                            "keyWords": "heel goed",
                                            "advice": "Hoogintensieve intervaltraining (HIIT) wordt beschouwd als een van de beste manieren om je VO2max verder te vergroten. Dat komt omdat HIIT ervoor zorgt dat de intensiteit van je inspanning voor korte tijd nabij of zelfs boven de anaerobe drempel komt alvorens je terugkeert naar een lagere, aerobe intensiteit. Deze vorm van korte, herhaalde overbelasting zorgt ervoor dat je hart en longen zich aanpassen aan de eisen die eraan worden gesteld.",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1634296260000
                                        }
                                    ],
                                    "visualization": "SLIDER",
                                    "source": "MPT",
                                    "expired": true
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_MAXHR",
                                    "name": "Maximale hartslag",
                                    "unit": "bpm",
                                    "values": [
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 140,
                                            "stringValue": "140.0",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_MAXHR",
                                            "resultText": "Maximale hartslag",
                                            "keyWords": "maximale hartslag",
                                            "advice": "Veel trainingsschema's zijn gebaseerd op je maximale hartslag. De maximale hartslag kan bovendien gebruikt worden om oververmoeidheid en overtraining vast te stellen.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1634296260000
                                        }
                                    ],
                                    "visualization": "TEXTUAL",
                                    "source": "MPT"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_TOTAL",
                                    "name": "Blessurerisico",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "doubleValue": 6,
                                            "intValue": 6,
                                            "stringValue": "6",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_TOTAL_VERYBAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1701262160936
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "doubleValue": 21,
                                            "intValue": 21,
                                            "stringValue": "21",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_TOTAL_VERYGOOD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1709304560863
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "doubleValue": 10,
                                            "intValue": 10,
                                            "stringValue": "10",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_TOTAL_VERYBAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711122827360
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "doubleValue": 11,
                                            "intValue": 11,
                                            "stringValue": "11",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_TOTAL_BAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711386354904
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "doubleValue": 6,
                                            "intValue": 6,
                                            "stringValue": "6",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_TOTAL_VERYBAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1712586378172
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "doubleValue": 13,
                                            "intValue": 13,
                                            "stringValue": "13",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_TOTAL_BAD",
                                            "resultText": "hoog",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1712666380937
                                        }
                                    ],
                                    "visualization": "SLIDER",
                                    "source": "FMS"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_RER",
                                    "name": "RER",
                                    "unit": "",
                                    "values": [
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 1.2,
                                            "stringValue": "1.2",
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_RER",
                                            "resultText": "RER",
                                            "keyWords": "RER",
                                            "advice": "Een tip om je metabole efficiÃ«ntie te verbeteren is om in de voorbereidingsfase Ã©Ã©n of twee keer per week 's ochtends vroeg voor het ontbijt een nuchtere training uit te voeren, bijvoorbeeld een halfuurtje joggen of een uur rustig fietsen. Water, zwarte thee of zwarte koffie mogen wel vooraf gedronken worden.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1634296260000
                                        }
                                    ],
                                    "visualization": "TEXTUAL",
                                    "source": "MPT"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE",
                                    "name": "Cardioactiviteten",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "heel goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116273299
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125592987
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                            "resultText": "Er staan bij jou veel te weinig cardio-activiteiten op de planning.",
                                            "keyWords": "veel te weinig",
                                            "advice": "Als je je conditie op peil wilt houden, dan is Ã©Ã©n uur cardio per week aanbevolen. Dat kan onder de vorm van wandelen, fietsen, joggen ...",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721051549562
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT",
                                    "name": "Spierversterkende activiteiten",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "heel goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116273299
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125592987
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                            "resultText": "Uit je antwoorden blijkt dat je te weinig tijd aan spierversterkende oefeningen spendeert. ",
                                            "keyWords": "matig",
                                            "advice": "Om optimale gezondheidswinst uit spierversterkende oefeningen te halen, zou je die activiteit vaker moeten uitvoeren. Start eens met het uitvoeren van krachtoefeningen gedurende twintig Ã  dertig minuten. En tracht dit op wekelijkse basis twee keer uit te voeren. Good luck. We're in this together! ",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721051549562
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL",
                                    "name": "Hoeveelheid slaap",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116315184
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125621844
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "resultText": "Op basis van je antwoorden slaap je niet altijd zeven tot negen uren per nacht.",
                                            "keyWords": "matig",
                                            "advice": "Tracht toch zo vaak mogelijk te streven naar zeven tot negen uren slaap per nacht. Hou wel in gedachten dat je slaapkwaliteit belangrijker is dan de kwantiteit.",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721056754687
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER",
                                    "name": "Hydratatie",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "heel goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116249576
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125568671
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709224494496
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "resultText": "Je drinkt 1 tot 3 glazen water per dag.",
                                            "keyWords": "te weinig",
                                            "advice": "Water drinken is heel belangrijk, maar niet altijd zo evident. Tracht te streven naar 8 glazen water per dag. Hier alvast enkele tips om makkelijker water te drinken:\n- Start in de ochtend met een glas water.\n- Ben je lang onderweg? Neem een flesje water mee.\n- Zorg ervoor dat er steeds water voor je neus staat.\n- Drink gerust kraantjeswater wanneer er geen flessenwater voorhanden is.\n- Heb je geen zin in water? Ga voor gezonde alternatieven zoals thee of voeg verse munt of citroen toe aan je water.\n- Zet steeds een karaf water op tafel.\n- Vergeet je vaak water te drinken? Installeer een water-app.",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1720965038490
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                }
                            ],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.5",
                                    "score": 7.456998848808757,
                                    "maxScore": 10,
                                    "goalScore": 9.645028210751164,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 23.281552178495364,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.6",
                                    "score": 7.556772459151459,
                                    "maxScore": 10,
                                    "goalScore": 9.680131326152656,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 23.532994827843023,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.3",
                                    "score": 7.253742156121156,
                                    "maxScore": 10,
                                    "goalScore": 9.680131326152656,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 24.519756302818053,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.3",
                                    "score": 7.253742156121156,
                                    "maxScore": 10,
                                    "goalScore": 9.680131326152656,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 24.530717302506392,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.2",
                                    "score": 7.199726374254676,
                                    "maxScore": 10,
                                    "goalScore": 9.583578371314221,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 24.53748782981414,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.2",
                                    "score": 7.157988238176918,
                                    "maxScore": 10,
                                    "goalScore": 9.54184023523646,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 24.584026425987815,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.2",
                                    "score": 7.221044678591849,
                                    "maxScore": 10,
                                    "goalScore": 9.672037082414441,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 24.705533894907113,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.2",
                                    "score": 7.221044678591849,
                                    "maxScore": 10,
                                    "goalScore": 9.672037082414441,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 24.71286817838489,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.137711345258515,
                                    "maxScore": 10,
                                    "goalScore": 9.672037082414441,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 25.053332212965955,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.137711345258515,
                                    "maxScore": 10,
                                    "goalScore": 9.672037082414441,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 25.06817203657796,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.137711345258515,
                                    "maxScore": 10,
                                    "goalScore": 9.672037082414441,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 25.35383864110904,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.137711345258515,
                                    "maxScore": 10,
                                    "goalScore": 9.672037082414441,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 25.402068067848052,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.137711345258515,
                                    "maxScore": 10,
                                    "goalScore": 9.672037082414441,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 25.40577802375105,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SUMMARY_STRESS",
                            "name": "Stress",
                            "groups": [],
                            "results": [
                                {
                                    "tag": "RESULT_LEADLIFE_CORTISOL_SALIVA",
                                    "name": "Jouw cortisolprofiel",
                                    "values": [
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "overspanning",
                                            "tag": "RESULT_LEADLIFE_CORTISOL_SALIVA_ELEVATEDALLDAY_BAD",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig cortisol",
                                            "tag": "RESULT_LEADLIFE_CORTISOL_SALIVA_EXHAUSTION_BAD",
                                            "resultText": "Het lijkt erop dat je te weinig cortisol aanmaakt.",
                                            "keyWords": "te weinig cortisol",
                                            "advice": "Wanneer je cortisollevels te laag zijn kan je het gevoel hebben continu moe te zijn. Jouw bijnieren kunnen dus een boost gebruiken! Ondersteun je bijnieren door vitamine B (zoals vlees, eieren, vis, graanproducten, aardappelen en peulvruchten,..) en vitamine C-rijke voeding (broccoli en avocado, kiwi, aardbeien, sinaasappel, citroen, pompelmoes,...) te eten. Bouw voldoende rust en ontspanning in zodat je bijnieren terug kunnen opladen. Beweeg voldoende maar vermijd intensieve sporten en duursporten, deze zouden te belastend voor je kunnen zijn. Kies voor wandelen, fietsen, zwemmen, yoga of pilates. Zorg ervoor dat je veel in de buitenlucht komt. Doe ontspannende activiteiten die je energie geven. Vermijd snelle suikers, alcohol, koffie en chocolade. Sla geen maaltijden over en eet regelmatig - elke 3 Ã  4 uren.",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1711641908053
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "SALIVA"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL",
                                    "name": "Algemeen stressniveau",
                                    "values": [
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_NEUTRAL",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_GOOD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1709116286347
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_NEUTRAL",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1709125604515
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                            "resultText": "Je geeft aan een hoog stressniveau te ervaren.",
                                            "keyWords": "hoog stressniveau",
                                            "advice": "Om je algemeen stressniveau te beheersen, is het belangrijk om de volgende tips op te volgen.\n- Doe aan sport, maar overdrijf niet. Probeer regelmatig te bewegen, al is het maar voor een kleine wandeling. Let echter wel op voor overtraining, want dit kan je stressniveau negatief beÃ¯nvloeden. Vooral rustige vormen van beweging zijn een goed idee voor jou, zoals wandelen, fietsen en yoga.\n- Doe regelmatig ontspanningstechnieken om je geest te kalmeren en stress te verminderen, zoals diepe ademhaling of meditatie.\n- Zorg voor voldoende slaap, want als je uitgerust bent, kan je beter met stressprikkels omgaan. Probeer een vaste tijdstippen aan te houden om te gaan slapen en op te staan en zorg voor een rustgevende slaapomgeving.\n- Kies voor gezond en voedzaam eten met veel groenten, fruit, volkorengranen. Vermijd comfort food en bewerkt voedsel.\n- Neem bovendien ook voldoende tijd voor jezelf. Ontspan regelmatig en doe dagelijks iets waarvan je geniet.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1721051562556
                                        }
                                    ],
                                    "visualization": "SLIDER",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM",
                                    "name": "Magnesium",
                                    "unit": "mmol/l",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 0.84,
                                            "stringValue": "0.84",
                                            "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1618296780000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 0.8,
                                            "stringValue": "0.80",
                                            "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1636450560000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 0.81,
                                            "stringValue": "0.81",
                                            "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1638455400000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "doubleValue": 13,
                                            "intValue": 13,
                                            "stringValue": "13",
                                            "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_HOOG",
                                            "resultText": "Je magnesiumwaarden zijn licht verhoogd.",
                                            "keyWords": "licht verhoogd",
                                            "advice": "Een overschot aan magnesium ontstaat enkel bij gebruik van tabletten waarin magnesium zit, magnesiumzouten of mineraalwater waarin veel magnesium zit. \n\nBij meer dan 250 milligram magnesium per dag extra, dus naast het magnesium in je eten, kunnen darmklachten zoals diarree ontstaan.",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1711438740448
                                        }
                                    ],
                                    "visualization": "SLIDER",
                                    "source": "BLOOD"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS",
                                    "name": "Huidig stressniveau thuis",
                                    "values": [
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116286347
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125604515
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                            "resultText": "Jouw stressniveau ligt te hoog.",
                                            "keyWords": "hoog",
                                            "advice": "Iemand van wie het lichaam in de doorlopende stressstand staat, gaat negatieve effecten ervaren op het brein en andere organen. Wees aandachtig om je stressniveau onder controle te houden. Hieronder enkel kleine tips:\n\n- Hou zorgen niet voor morgen, praat. Blijf niet alleen zitten kniezen. Zoek iemand met wie je over je problemen kan praten.\n- Vraag hulp. Denk niet dat je zwak overkomt door hulp te vragen. Iemand die met je meedenkt of meewerkt, haalt veel stress voor je weg.\n- Beweeg. Bewegen vraagt energie, maar je krijgt er ook heel veel energie voor terug. Het vraagt niet zo heel veel tijd om elke dag een beetje meer te bewegen.\n- Neem tijdig een time-out. Neem op tijd en stond een beetje 'me-time'. Dan kan je er erna weer nog zo hard tegenaan.\n- Maak keuzes. Je kan niet alle taken aannemen die op je weg komen. Schrap zo veel mogelijk taken die te veel energie kosten en niets opleveren.\n- Eet gezond. Te veel vet, suiker en alcohol zijn niet goed voor je lichaam. Gezonde voeding met veel vezels, groenten en fruit geeft extra energie.\n\nHeb je ernstige klachten of wil je graag advies over positieve ontspanning? Neem dan contact op met je huisarts of een psycholoog.",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721051562556
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK",
                                    "name": "Huidig stressniveau op het werk",
                                    "values": [
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116286347
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125604515
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                            "resultText": "Jouw stressniveau op het werk ligt af en toe wat te hoog.",
                                            "keyWords": "matig",
                                            "advice": "Stress continu vermijden is haast onmogelijk. Maar waar je wel kan aan werken is hoe je met werkgerelateerde stress omgaat.\nEnkele praktische tips:\n- Vind je stressoren.\n- Leer jezelf gezonde stressreacties aan.\n- Leer relaxen.\n- Trek grenzen.\n- Neem afstand.\n- Praat met je baas.\n-Laat je ondersteunen.",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721051562556
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN",
                                    "name": "Huidig stressniveau wegens geldproblemen",
                                    "values": [
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116286347
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125604515
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                            "keyWords": "matig",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721051562556
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                }
                            ],
                            "scoreResult": [
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.7",
                                    "score": 6.668556533072663,
                                    "maxScore": 10,
                                    "goalScore": 9.812642554578039,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 26.486626469524765,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.843356643356643,
                                    "maxScore": 10,
                                    "goalScore": 9.59207459207459,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 25.74990724385724,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.843356643356643,
                                    "maxScore": 10,
                                    "goalScore": 9.59207459207459,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 25.753744785920407,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.843356643356643,
                                    "maxScore": 10,
                                    "goalScore": 9.59207459207459,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 25.76525741210991,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.830536130536131,
                                    "maxScore": 10,
                                    "goalScore": 9.07925407925408,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 28.705166400398554,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.2",
                                    "score": 6.191841491841491,
                                    "maxScore": 10,
                                    "goalScore": 9.44055944055944,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 28.118344973682724,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.7",
                                    "score": 4.746620046620047,
                                    "maxScore": 10,
                                    "goalScore": 9.055944055944055,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 35.19051192115666,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.9",
                                    "score": 3.891919191919192,
                                    "maxScore": 10,
                                    "goalScore": 6.91919191919192,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 32.8017333800182,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.9",
                                    "score": 3.891919191919192,
                                    "maxScore": 10,
                                    "goalScore": 6.91919191919192,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 32.86987765473556,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.9",
                                    "score": 3.891919191919192,
                                    "maxScore": 10,
                                    "goalScore": 6.91919191919192,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 32.889347447511945,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.9",
                                    "score": 3.891919191919192,
                                    "maxScore": 10,
                                    "goalScore": 6.91919191919192,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 33.264140958457396,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.9",
                                    "score": 3.891919191919192,
                                    "maxScore": 10,
                                    "goalScore": 6.91919191919192,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 33.32741778498065,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.9",
                                    "score": 3.891919191919192,
                                    "maxScore": 10,
                                    "goalScore": 6.91919191919192,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 33.332285233174744,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SUMMARY_HEALTH",
                            "name": "Health",
                            "groups": [],
                            "results": [
                                {
                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING",
                                    "name": "Cholesterol verhouding",
                                    "unit": "ratio",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 1.85,
                                            "stringValue": "1.85",
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1618296780000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 2.92,
                                            "stringValue": "2.92",
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1636450560000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 2.69,
                                            "stringValue": "2.69",
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING_NORMAAL",
                                            "resultText": "Je verhouding totale cholesterol/HDL-cholesterol is normaal.",
                                            "keyWords": "normaal ",
                                            "advice": "Cholesterol wordt voor grotendeels in de lever aangemaakt. Door een gezonde levensstijl kun je de cholesterol blijvend positief beÃ¯nvloeden. Een optimale cholesterolratio is lager dan 4. Onder een gezonde levensstijl verstaan we een gezond gewicht, gezonde voeding, voldoende beweging en niet roken.\n\n  * Gezond gewicht. Het risico op een te hoge cholesterol is al veel lager bij een gezond gewicht. Een paar kiloâs eraf heeft al een gunstig effect!\n\n\n  * Gezond eten. Cholesterol in voeding wordt via de darmen opgenomen in het bloed en naar de lever gebracht, maar daarnaast kan de cholesterol ook beÃ¯nvloed worden door andere voedingsstoffen. Zo zorgen verzadigde (verkeerde) vetten en transvetten voor een stijging van de slechte LDL-cholesterol. Verzadigde vetten zitten vooral in dierlijke producten als volle melkproducten, worstsoorten en vette vlees(waren). Transvetten zitten met name in de lekkere extraâs zoals koek, gebak, chocolade, chips, zoutjes en andere snacks. Voedingsvezels en onverzadigde (okÃ©) vetten zorgen juist voor een daling van de slechte LDL-cholesterol. Voedingsvezels zitten in volkoren graanproducten, fruit en groenten. Denk bij onverzadigde vetten aan plantaardige olie, noten, avocado en vis. Vis bevat echter ook weer DHA, een omega 3-vetzuur dat de LDL-cholesterol doet stijgen. Het is daarom belangrijk vis met mate te nemen.\n\n\n  * Voldoende lichaamsbeweging zorgt voor een verlaging van de LDL-cholesterol, doordat de HDL-cholesterol verhoogd wordt. De verhoging van de HDL-cholesterol is een voordeel dat de meeste medicatie niet eens heeft! Dagelijks een halfuur matig intensief bewegen is voldoende.\n\n\n  * Niet roken. Roken leidt tot vernauwing en beschadigingen van de bloedvaten, waardoor de LDL-cholesterol zich beter kan hechten aan de wand. Daarnaast verlaagt roken de hoeveelheid HDL-cholesterol, waardoor de LDL-cholesterol niet voldoende afgevoerd kan worden.",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1638455400000
                                        }
                                    ],
                                    "visualization": "SLIDER_REVERSE",
                                    "source": "BLOOD"
                                },
                                {
                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP",
                                    "name": "hsCRP",
                                    "unit": "mg/l",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 1.2,
                                            "stringValue": "1.2",
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1618296780000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "<4.0",
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1636450560000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "doubleValue": 1.08,
                                            "stringValue": "1.08",
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP_HOOG",
                                            "resultText": "Je hsCRP-waarden zijn licht verhoogd.",
                                            "keyWords": "licht verhoogd",
                                            "advice": "Om je hsCRP-niveau laag te krijgen speelt een gezonde levensstijl een belangrijke rol. Genoeg lichaamsbeweging, voldoende ontspanning en een gezond voedingspatroon zijn enkele voorbeelden die je daarbij kunnen helpen. Voedsel en dranken met veel suikers kunnen het best vermeden of in kleine hoeveelheden genuttigd worden. Broccoli, vette vis en groene thee zijn voedingsmiddelen die worden aanbevolen om het hsCRP-niveau te verlagen.",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1638455400000
                                        }
                                    ],
                                    "visualization": "SLIDER_REVERSE",
                                    "source": "BLOOD"
                                },
                                {
                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C",
                                    "name": "HbA1c",
                                    "unit": "%",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 5.4,
                                            "stringValue": "5.4",
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1618296780000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 5,
                                            "stringValue": "5.0",
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1636450560000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 5.5,
                                            "stringValue": "5.5",
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                            "resultText": "Je HbA1c-waarden zijn normaal.",
                                            "keyWords": "normaal ",
                                            "advice": "Door je levensstijl hier en daar bij te sturen kan je al heel wat doen om je bloedsuikerspiegel stabiel te houden:\n \n  * Verminder je suikerinname uit zoetigheden, koekjes en bewerkt voedsel.\n  * Vervang de snelle koolhydraten door complexe koolhydraten zoals in granen, bonen en noten.\n  * Afwisselend vasten of je maaltijdfrequentie verlagen wordt steeds belangrijker. Een studie in het World Journal of Diabetes claimt dat afwisselend vasten helpt om het bloedsuikerniveau te verbeteren en gewicht te verliezen. De lange periode van vasten fixeert de bloedsuiker en de stofwisseling (het metabolisme) gaat over op het verbranden van vetreserves.\n  * Eet minder verzadigde vetten. Een teveel aan verzadigde vetten kan leiden tot overgewicht, en dat alleen al heeft een heel grote invloed op je bloedsuikerspiegel.\n  * Eet geen transvetten. Niet alleen neemt de kans op overgewicht toe bij consumptie van te veel transvetten, ook krijg je last van inflammatie, zoals bij kunstmatige suikers. Deze ontstekingen in je lichaam hebben een grote invloed op je bloedsuikerspiegel.\n  * Eet wel meer onverzadigde vetten. Die vetten hebben precies de tegenovergestelde effecten op je gezondheid in vergelijking met transvetten. Onverzadigde vetten zorgen ervoor dat je hart- en vaatstelsel gezond en soepel blijft. Daarnaast werken ze ontstekingsremmend. Ontstekingen leiden tot een hoge bloedsuikerspiegel en dat is precies datgene wat door onverzadigde vetten te eten wordt voorkomen.\n  * Eet meer eiwitten. Van alle voedingsgroepen hebben eiwitten de minste invloed op je bloedsuikerspiegel. Door een groter deel van je dieet uit eiwitten te laten bestaan heb je dus wel de energie, maar niet de stijging van je bloedsuikerspiegel.\n  * Drink minder cafeÃ¯ne.\n  * Laat ook alcohol links liggen. Zoals je misschien wel weet, is je alvleesklier verantwoordelijk voor de aanmaak van insuline. Diezelfde alvleesklier maakt ook deel uit van de groep organen die belast is met het verwijderen van alcohol uit je systeem. Als je dus regelmatig alcohol drinkt, belast je de alvleesklier onnodig.\n  * Beweeg voldoende en op regelmatige basis. Meer bewegen vermindert de insulineresistentie en heeft tot gevolg dat je meer calorieÃ«n verbrandt. Er zit wel een addertje onder het gras: je moet consistent bewegen om een effect te hebben.\n  * Slaap voldoende. Wanneer je te weinig slaapt, kan je problemen krijgen met je cellen voor insuline. Tracht minimaal 6 Ã  7 uur per nacht te slapen.\n  * Wees stress de baas. Stresshormonen jagen je bloedsuikerspiegel omhoog. Op het moment dat jouw hersenen een potentiÃ«le noodsituatie detecteren, schakelt dit mechanisme in en je kunt het niet stoppen. Wat je wel kan doen, is stresssituaties leren beheersen.",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1638455400000
                                        }
                                    ],
                                    "visualization": "SLIDER_REVERSE",
                                    "source": "BLOOD"
                                },
                                {
                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR",
                                    "name": "HOMA-IR",
                                    "unit": "%",
                                    "values": [
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 1.13,
                                            "stringValue": "1.13",
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1618296780000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 0.51,
                                            "stringValue": "0.51",
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1636450560000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 0.48,
                                            "stringValue": "0.48",
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1638455400000
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 16,
                                            "intValue": 16,
                                            "stringValue": "16",
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711120920560
                                        },
                                        {
                                            "riskLevel": "NOT_APPLICABLE",
                                            "doubleValue": 96,
                                            "intValue": 96,
                                            "stringValue": "96",
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                            "resultText": "Je HOMA-IR-waarde is een berekende waarde.",
                                            "keyWords": "berekende waarde",
                                            "advice": "Een ideale HOMA-IR-index is rond 1%. Wees insulineresistentie steeds een stap voor en houd rekening met deze aspecten: \n\n  * Eet langzaam verterend voedsel\n  * Sport kort, maar krachtig\n  * Eet minder koolhydraten\n  * Slaap voldoende\n  * Drink groene thee\n  * Streef naar een gezond gewicht\n  * Gebruik kruiden zoals gember, kaneel, ginseng, appelazijn of kurkuma\n\nIs je waarde hoger dan 1%? Weet dan dat insulineresistentie meerdere oorzaken kan hebben. Vaak is het dan ook een combinatie van meerdere factoren. Zoals bij iedere lichamelijke klacht is er een genetische component, maar hoe je leeft kan ervoor zorgen dat bepaalde genen tot uiting komen. Als we kijken naar levensstijl dan zien we een aantal dingen die de kans verhogen op insulineresistentie:\n\n  * Overgewicht en veel buikvet of orgaanvet\n  * Een hoge inname van sterk bewerkte (geraffineerde) voedingsmiddelen met toegevoegde suikers die de bloedsuiker snel laten stijgen\n  * Inactief leven \n  * Chronische stress \n  * Laaggradige ontstekingen door bijvoorbeeld voedselovergevoeligheden, âlekkende darmsyndroomâ, onbalans in de darmbacteriÃ«n, hoge suikerinname en stress.\n  * Roken\n  * Hoge alcohol- en fructoseconsumptie (alcoholische en niet-alcoholische leververvetting) \n  * Zwangerschap (zwangerschapsresistentie en zwangerschapsdiabetes) \n  * Slaaptekort (slaapgebrek) \n  * Gebruik van bepaalde medicijnen zoals corticosteroÃ¯den \n\nMaak voor jezelf even de balans op. Aan welke factoren kan je werken?",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1711438740448
                                        }
                                    ],
                                    "visualization": "TEXTUAL",
                                    "source": "BLOOD"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN",
                                    "name": "Hart- en vaataandoeningen",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normale kans",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_GOED_1_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116321992
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125631427
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                            "resultText": "Je risico op hart- en vaatziekten is verhoogd omdat bij jou al een hart- en vaatziekte werd vastgesteld.",
                                            "keyWords": "aandoening aanwezig",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721056884600
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES",
                                    "name": "Diabetes type 2",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "normale kans",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_GOED_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116325923
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125636410
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "aandoening aanwezig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                            "resultText": "Je gaf aan dat bij jou diabetes type 2 werd vastgesteld. Een gezonde levensstijl is voor jou van groot belang.",
                                            "keyWords": "aandoening aanwezig",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721056886864
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP",
                                    "name": "Hoge bloeddruk",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "geen hoge bloeddruk",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "hoge bloeddruk",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116321992
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "hoge bloeddruk",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125631427
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "hoge bloeddruk",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "hoge bloeddruk",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "hoge bloeddruk",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "hoge bloeddruk",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "hoge bloeddruk",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                            "resultText": "Je hebt een hoge bloeddruk.",
                                            "keyWords": "hoge bloeddruk",
                                            "advice": "Er zijn enkele zaken waarme je rekening kan houden in je levensstijl voor je hoge bloeddruk:\n- Beperk je zoutinname: verminder je consumptie van zoute voedingsmiddelen, zoals bewerkte snacks, fastfood en ingeblikt voedsel.\n- Focus op gezonde voeding: richt je vooral op het eten van groenten, fruit, volkoren granen en gezonde vetten (zoals noten, vette vis en olijfolie).\n- Beheers je gewicht: streef naar een gezond gewicht.\n- Let op met alcoholgebruik: consumeer alcohol met mate.\n- Rook niet.\n- Laat je regelmatig opvolgen door een zorgverlener.",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721056884600
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK",
                                    "name": "Buikomtrek",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116168810
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709124272513
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709223914112
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "licht te hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                            "resultText": "Uit jouw antwoorden blijkt dat je buikomtrek licht verhoogd is. Als vrouw is dat tussen de 80 en 88 centimeter.",
                                            "keyWords": "licht te hoog",
                                            "advice": "Wat sommige coaches en influencers ook mogen beweren: er bestaat helaas geen miraculeus crashdieet om snel die buik kwijt te raken. Toch helpen alle beetjes. Als je erin slaagt om 5 Ã  10% van je gewicht te verliezen, dan heeft dat een heilzaam effect op je buikvet. Met de nodige deskundige hulp lukt het zelfs om bij veel overgewicht de gezonde balans terug te vinden.\n\nIn een ideaal scenario vind je een gezond voedingspatroon dat je je eigen maakt om ook op lange termijn een gezond gewicht Ã©n je buikomtrek te behouden. Het klassieke jojo-effect dat ervoor zorgt dat je continu afvalt en vervolgens weer bijkomt, is namelijk erg slecht voor je gezondheid. Bij deze nog wat inspiratie:\n\n* Ga fietsen, zwemmen, wandelen, dansen, trappen lopen: maak zelf een keuze waar je je goed en gemotiveerd bij voelt.\n* Probeer elke dag twintig minuten intensief - zodat je bijna buiten adem bent - te bewegen.\n* Lukt het niet om elke dag te bewegen? Probeer dan minstens vier keer per week beweging (maar dan wel 30 Ã  45 minuten) in te plannen.",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1719837987002
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                }
                            ],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.2",
                                    "score": 8.246112831097353,
                                    "maxScore": 10,
                                    "goalScore": 8.731148950808393,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 19.058759482634546,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.0",
                                    "score": 5.96348488113194,
                                    "maxScore": 10,
                                    "goalScore": 9.615729967200556,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 29.62200369728257,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.3",
                                    "score": 6.3107071033541615,
                                    "maxScore": 10,
                                    "goalScore": 9.615729967200556,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 27.996339354354493,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.3",
                                    "score": 6.286897579544639,
                                    "maxScore": 10,
                                    "goalScore": 9.615729967200556,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 28.11492865863097,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.7",
                                    "score": 5.726595681007446,
                                    "maxScore": 10,
                                    "goalScore": 9.6674651057004,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 31.119634076856336,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.6",
                                    "score": 5.628354760707702,
                                    "maxScore": 10,
                                    "goalScore": 9.569224185400657,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 31.355022697946104,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.8963429816371,
                                    "maxScore": 10,
                                    "goalScore": 9.722833321362732,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 30.41490228911677,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.8963429816371,
                                    "maxScore": 10,
                                    "goalScore": 9.722833321362732,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 30.42393150161168,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.8963429816371,
                                    "maxScore": 10,
                                    "goalScore": 9.722833321362732,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 30.48713598907608,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.8963429816371,
                                    "maxScore": 10,
                                    "goalScore": 9.722833321362732,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 30.505194414065905,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.8963429816371,
                                    "maxScore": 10,
                                    "goalScore": 9.722833321362732,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 30.852819095120083,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.8963429816371,
                                    "maxScore": 10,
                                    "goalScore": 9.722833321362732,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 30.91150897633702,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.8963429816371,
                                    "maxScore": 10,
                                    "goalScore": 9.722833321362732,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 30.916023582584476,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SUMMARY_FOOD",
                            "name": "Food",
                            "groups": [],
                            "results": [
                                {
                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE",
                                    "name": "Verwerking cafeÃ¯ne",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "snel",
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_MATIG",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "snel",
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "snel",
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                            "resultText": "Volgens jouw DNA-analyse ben je een 'fast metabolizer' als het aankomt op de verwerking van cafeÃ¯ne. Jij breekt cafeÃ¯ne met andere woorden heel snel af.",
                                            "keyWords": "snel",
                                            "advice": "CafeÃ¯ne kan helpen om je sport- en mentale prestaties te optimaliseren. Jouw lichaam is dan misschien wel in staat om cafeÃ¯ne snel af te breken, dat betekent nog altijd niet dat je kan overdrijven. Het advies van de Hoge Gezondheidsraad is om als gezonde volwassene per dag maximaal 5,7 mg cafeÃ¯ne per kg lichaamsgewicht binnen te krijgen. Een persoon van 60 kg mag dus hoogstens 340 mg cafeÃ¯ne per dag opnemen. Wanneer je een doorsnee kopje koffie van 80 mg cafeÃ¯ne neemt, komt dat dus neer op maximaal 4 koppen per dag.",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "time": 1711438861261
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "DNA"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN",
                                    "name": "Gezonde vetten",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "zeer goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "zeer goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116249576
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125568671
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709224494496
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "resultText": "Je schenkt voldoende aandacht aan de inname van gezonde vetten in je voedingspatroon.",
                                            "keyWords": "goed",
                                            "advice": "Goed bezig! Onverzadigde vetten hebben bewezen gezondheidsvoordelen en worden beschouwd als de gezondste van de vetten. Blijf deze op regelmatige basis toevoegen aan je eetpatroon. Wees steeds aandachtig om voldoende te variÃ«ren.",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1720965038490
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER",
                                    "name": "Hydratatie",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "heel goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116249576
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125568671
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709224494496
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_WATER_BAD",
                                            "resultText": "Je drinkt 1 tot 3 glazen water per dag.",
                                            "keyWords": "te weinig",
                                            "advice": "Water drinken is heel belangrijk, maar niet altijd zo evident. Tracht te streven naar 8 glazen water per dag. Hier alvast enkele tips om makkelijker water te drinken:\n- Start in de ochtend met een glas water.\n- Ben je lang onderweg? Neem een flesje water mee.\n- Zorg ervoor dat er steeds water voor je neus staat.\n- Drink gerust kraantjeswater wanneer er geen flessenwater voorhanden is.\n- Heb je geen zin in water? Ga voor gezonde alternatieven zoals thee of voeg verse munt of citroen toe aan je water.\n- Zet steeds een karaf water op tafel.\n- Vergeet je vaak water te drinken? Installeer een water-app.",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1720965038490
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL",
                                    "name": "Totale cholesterol",
                                    "unit": "mg/dl",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 173,
                                            "intValue": 173,
                                            "stringValue": "173",
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1618296780000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 170,
                                            "intValue": 170,
                                            "stringValue": "170",
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1636450560000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "doubleValue": 224,
                                            "intValue": 224,
                                            "stringValue": "224",
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_HOOG",
                                            "resultText": "Je totale cholesterolwaarden zijn licht verhoogd.",
                                            "keyWords": "licht verhoogd",
                                            "advice": "Wil je je âslechteâ LDL-cholesterol verlagen en de âgoedeâ HDL-cholesterol verhogen? Trek dan je sportkleren maar aan! Door voldoende te bewegen en gevarieerd te eten kom je al een heel eind. Dat laatste doe je onder andere door veel groenten, fruit en voedingsvezels te eten en je zoutgebruik te minderen. Probeer daarnaast ook zo veel mogelijk verzadigd vet in je eten te vervangen door onverzadigd vet.\n\nDoor je voeding aan te passen kun je je cholesterolgehalte met zoân 10 procent verlagen! Door daarnaast ook plantensterolen te gebruiken kun je het nog eens met 10 procent doen dalen. Die plantensterolen zijn vetachtige stoffen die je, uiteraard, in planten vindt. Qua structuur lijken ze heel erg op cholesterol, maar ze zorgen ervoor dat cholesterol minder opgenomen wordt in de darmen. Door dagelijks 1,5 Ã  3 gram plantensterolen uit verrijkte voedingsmiddelen te gebruiken kun je je cholesterolgehalte met ongeveer 10 procent verlagen. Probeer daar ook niet mee te overdrijven, want als je meer dan 3 gram plantensterolen per dag gebruikt, daalt je cholesterolgehalte niet verder.",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1638455400000
                                        }
                                    ],
                                    "visualization": "SLIDER_REVERSE",
                                    "source": "BLOOD"
                                },
                                {
                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD",
                                    "name": "Vitamine D",
                                    "unit": "ng/ml",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 38.6,
                                            "stringValue": "38.6",
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1618296780000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "doubleValue": 58.7,
                                            "stringValue": "58.7",
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_HOOG",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1636450560000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "doubleValue": 31.8,
                                            "stringValue": "31.8",
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                            "resultText": "Je vitamine D-waarden zijn normaal.",
                                            "keyWords": "normaal ",
                                            "advice": "Optimale waarden van 25-OH Vit D3 zijn tussen de 20ng/ml en 50 ng/ml. Is je waarde tussen 12ng/ml en 20ng/ml? Dan dien je extra aandacht te besteden aan je vitamine D-inname. \n\nOm normale vitamine D-waarden te behouden is het belangrijk om je lichaam voldoende bloot te stellen aan onmiddellijk zonlicht en voeding te eten die rijk is aan vitamine D. Je vindt vitamine D onder andere in vette vissoorten (paling, makreel, zalm en haring), eidooier en aan zonlicht blootgestelde paddenstoelen. Omdat calcium belangrijk is voor de opname van vitamine D combineer je die champignons of vette vis het best met een calciumrijk voedingsmiddel. Denk bijvoorbeeld aan spinazie, Chinese kool of tofoe.\n\nWaar wij wonen, is het makkelijker gezegd dan gedaan om vitamine D binnen te krijgen via zonlicht. In de zomer is een kwartier blootstelling van armen en hoofd op de middag voldoende om je vitamine D-gehalte in de bloedspiegel op niveau te houden. Het teveel aan aangemaakte vitamine D wordt opgeslagen in vetweefsel, een reserve die ontoereikend is om ons de hele winter en lente te voorzien van voldoende van die vitamine. Uit onderzoek blijkt dat zelfs tot ongeveer 90 procent van de Belgische bevolking aan het einde van de winter een gebrek aan vitamine D heeft.\n\nVoor iedereen geldt een dagelijkse aanbevolen hoeveelheid van 10 microgram vitamine D. Alleen mensen van boven de 70 moeten 20 microgram per dag binnenkrijgen.",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "time": 1638455400000
                                        }
                                    ],
                                    "visualization": "SLIDER",
                                    "source": "BLOOD"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR",
                                    "name": "Kant-en-klare voeding",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "bijna nooit",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "te veel",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116249576
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "af en toe",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125568671
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "vaak",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709224494496
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "vaak",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "vaak",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "vaak",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "vaak",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "vaak",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                            "resultText": "Je eet 1 of 2 keer per week een kant-en-klaarmaaltijd.",
                                            "keyWords": "vaak",
                                            "advice": "Kant-en-klaarmaaltijden zijn niet per definitie ongezond, maar je haalt er doorgaans niet de dagelijkse aanbevolen hoeveelheid groenten mee. Zo veel mogelijk vers koken en zo weinig mogelijk verwerkte producten eten blijft de beste keuze. ",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1720965038490
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN",
                                    "name": "Groenten",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116249576
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125568671
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709224494496
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                            "resultText": "Jij eet te weinig groenten of varieert te weinig tussen verschillende soorten groenten.\n",
                                            "keyWords": "te weinig",
                                            "advice": "Probeer je dagelijkse porties te vergroten of vaker groenten te eten. Kies ook voor voldoende variatie, want elke groente heeft haar eigen gezondheidsvoordelen. ",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1720965038490
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER",
                                    "name": "Suiker",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "heel weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te veel",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116249576
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te veel",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125568671
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te veel",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709224494496
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te veel",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te veel",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te veel",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te veel",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te veel",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                            "resultText": "Je eet 4 keer of meer per week zoetigheid.",
                                            "keyWords": "veel te veel",
                                            "advice": "Voor jou is het aangeraden om de suikerrijke voedingsproducten het liefst wat te minderen of te vermijden. Te veel van dat soort voedsel is namelijk slecht voor je lichaam. Een overvloed aan suiker kan je alvleesklier overbelasten, overgewicht veroorzaken en de kans op diabetes type 2 verhogen. Daarnaast is het, maar dat wist je hopelijk al, slecht voor je tanden. Laat die suikerrijke hap dus liever links liggen en kies voor gezondere en vezelrijke alternatieven zoals groenten, fruit of noten. ",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1720965038490
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT",
                                    "name": "Fruit",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "stringValue": "veel te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116249576
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125568671
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709224494496
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                            "resultText": "Uit je antwoorden blijkt dat je voldoende fruit eet.",
                                            "keyWords": "goed",
                                            "advice": "Jij eet voldoende fruit. Tracht ook steeds voldoende te variÃ«ren in je fruitkeuze, want elke fruitsoort heeft haar eigen gezondheidsvoordelen. ",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1720965038490
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN",
                                    "name": "Gezonde vetten",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "zeer goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "VERY_GOOD",
                                            "stringValue": "zeer goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_VERYGOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116249576
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125568671
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709224494496
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                            "resultText": "Je schenkt voldoende aandacht aan de inname van gezonde vetten in je voedingspatroon.",
                                            "keyWords": "goed",
                                            "advice": "Goed bezig! Onverzadigde vetten hebben bewezen gezondheidsvoordelen en worden beschouwd als de gezondste van de vetten. Blijf deze op regelmatige basis toevoegen aan je eetpatroon. Wees steeds aandachtig om voldoende te variÃ«ren.",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1720965038490
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                }
                            ],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.599420049710025,
                                    "maxScore": 10,
                                    "goalScore": 9.64098315382491,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 20.180162820945135,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.5",
                                    "score": 6.513708613335789,
                                    "maxScore": 10,
                                    "goalScore": 9.651876400012274,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 27.22172990433935,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.440179201571081,
                                    "maxScore": 10,
                                    "goalScore": 9.651876400012274,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 27.5366315741544,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.440179201571081,
                                    "maxScore": 10,
                                    "goalScore": 9.651876400012274,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 27.548941199355184,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.765131639510264,
                                    "maxScore": 10,
                                    "goalScore": 9.362116051428396,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 29.93527015339248,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.871068458682378,
                                    "maxScore": 10,
                                    "goalScore": 9.46805287060051,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 29.740987459836948,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.3",
                                    "score": 5.291896805670625,
                                    "maxScore": 10,
                                    "goalScore": 9.455057688176993,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 32.955593632244444,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.3",
                                    "score": 5.291896805670625,
                                    "maxScore": 10,
                                    "goalScore": 9.455057688176993,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 32.965377094804104,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.3",
                                    "score": 5.291896805670625,
                                    "maxScore": 10,
                                    "goalScore": 9.455057688176993,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 33.03386133272179,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.3",
                                    "score": 5.291896805670625,
                                    "maxScore": 10,
                                    "goalScore": 9.455057688176993,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 33.05342825784113,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.3",
                                    "score": 5.291896805670625,
                                    "maxScore": 10,
                                    "goalScore": 9.455057688176993,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 33.43009156638838,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.3",
                                    "score": 5.291896805670625,
                                    "maxScore": 10,
                                    "goalScore": 9.455057688176993,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 33.49368407302622,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.3",
                                    "score": 5.291896805670625,
                                    "maxScore": 10,
                                    "goalScore": 9.455057688176993,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 33.49857580430606,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SUMMARY_SLEEP",
                            "name": "Sleep",
                            "groups": [],
                            "results": [
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL",
                                    "name": "Hoeveelheid slaap",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "goed",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_GOOD",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116315184
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "te weinig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125621844
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "matig",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                            "resultText": "Op basis van je antwoorden slaap je niet altijd zeven tot negen uren per nacht.",
                                            "keyWords": "matig",
                                            "advice": "Tracht toch zo vaak mogelijk te streven naar zeven tot negen uren slaap per nacht. Hou wel in gedachten dat je slaapkwaliteit belangrijker is dan de kwantiteit.",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721056754687
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_KWALITEIT",
                                    "name": "Slaapkwaliteit",
                                    "values": [
                                        {
                                            "riskLevel": "VERY_BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_KWALITEIT_VERYBAD",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_KWALITEIT_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709116315184
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_KWALITEIT_GOOD",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1709125621844
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_KWALITEIT_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711120924050
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_KWALITEIT_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711383360935
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_KWALITEIT_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711438861261
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_KWALITEIT_BAD",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1711641908053
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_KWALITEIT_BAD",
                                            "resultText": "Je slaapkwaliteit is slecht.",
                                            "keyWords": "slecht",
                                            "advice": "Volgende adviezen kunnen helpen om je slaapkwaliteit te verbeteren:\n- Ga sporten en bewegen, overdag of vroeg in de avond.\n- Neem 's avonds geen koffie of andere drank met cafeÃ¯ne en vermijd nicotine.\n- Stop een uur voor het slapengaan met kijken naar je tv, tablet, computer en smartphone.\n- Zorg een uur voor het slapengaan voor ontspanning (korte wandeling, warm bad, ontspanningsoefeningen, muziek ...).\n- Sta steeds rond dezelfde tijd op en ga rond een vaste tijd naar bed.",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "time": 1721056754687
                                        }
                                    ],
                                    "visualization": "SLIDER",
                                    "source": "INTAKE"
                                }
                            ],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.7",
                                    "score": 7.727272727272727,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 23.294117647058822,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.6",
                                    "score": 5.606060606060606,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 32.769854042954655,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.6",
                                    "score": 5.606060606060606,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 32.77473777679116,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.6",
                                    "score": 5.606060606060606,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 32.78938897830068,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.0",
                                    "score": 6.007130124777183,
                                    "maxScore": 10,
                                    "goalScore": 9.84848484848485,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 30.2218309072482,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.0",
                                    "score": 5.962566844919787,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 30.9299054950384,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.825311942959002,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 31.663370019528553,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.825311942959002,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 31.672769862194286,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.923351158645276,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 31.21325390023241,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.923351158645276,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 31.231742426161762,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.923351158645276,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 31.587646550301834,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.923351158645276,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 31.647734259572232,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.923351158645276,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 31.652356391054568,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SUMMARY_MOTIVATION",
                            "name": "DASHBOARD_SUMMARY_MOTIVATION",
                            "groups": [],
                            "results": [
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTERNAL",
                                    "name": "Intrinsieke motivatie",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTERNAL_GOOD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "neutraal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTERNAL_NEUTRAL",
                                            "resultText": "Je intrinsieke motivatie is neutraal.",
                                            "keyWords": "neutraal",
                                            "advice": "Dat betekent dat je motivatie soms uit jezelf en soms uit een ander komt. De redenen om gezonder te leven verschillen. Het is belangrijk voor je om haalbare doelen op te stellen. Deel je einddoelen op in kleinere en concrete subdoelen.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1709130266302
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTROJECTED",
                                    "name": "Geaccepteerde motivatie",
                                    "values": [
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTROJECTED_BAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "laag",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTROJECTED_GOOD",
                                            "resultText": "Je geaccepteerde motivatie is laag.",
                                            "keyWords": "laag",
                                            "advice": "Dat betekent dat je motivatie om gezond te leven niet afhankelijk is van wat je denkt dat anderen denken. Dat is positief. Jij bepaalt zelf dat het goed is voor je om gezond te leven.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1709130266302
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_EXTERNAL",
                                    "name": "Externe motivatie",
                                    "values": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "laag",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_EXTERNAL_GOOD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_EXTERNAL_BAD",
                                            "resultText": "Je externe motivatie is hoog.",
                                            "keyWords": "hoog",
                                            "advice": "Dat betekent dat je bepaald gedrag stelt, omdat het van je verwacht wordt. Het is goed voor jou om jezelf eens een beloning te geven als je je (sub)doel bereikt hebt. Durf jezelf bemoedigend toe te spreken als je een taak succesvol hebt afgerond.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1709130266302
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_AMOTIVATION",
                                    "name": "Amotivatie",
                                    "values": [
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "hoog",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_AMOTIVATION_BAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "neutraal",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_AMOTIVATION_NEUTRAL",
                                            "resultText": "Je amotivatie is neutraal.",
                                            "keyWords": "neutraal",
                                            "advice": "Dat betekent dat je soms gemotiveerd bent en soms niet. Je ziet niet altijd het nut van gedragsverandering in. Het is voor jou belangrijk om in kleine stappen te werken. Het is ook goed om je vooruitgang bij te houden.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1709130266302
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                },
                                {
                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_RAI",
                                    "name": "Relatieve autonomie index",
                                    "values": [
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "laag",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_RAI_BAD",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1672527600000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "laag",
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_RAI_BAD",
                                            "resultText": "Je relatieve autonomie index is laag.",
                                            "keyWords": "laag",
                                            "advice": "Dat betekent dat het moeilijk is voor je om gezonder te leven. Extra inzichten en persoonlijke coaching zijn nuttig voor jou. Dit zal je helpen om een gezondere levensstijl te hanteren.",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "time": 1709130266302
                                        }
                                    ],
                                    "visualization": "TEXTUAL_COLOR",
                                    "source": "INTAKE"
                                }
                            ]
                        }
                    ],
                    "results": [],
                    "scoreResult": [
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.5",
                            "score": 7.533060164993588,
                            "maxScore": 10,
                            "goalScore": 9.638300478327084,
                            "realAge": 27.211498973305954,
                            "leadlifeAge": 23.03040262655796,
                            "goalAge": 18,
                            "time": 1672613999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.2",
                            "score": 6.1638972005060735,
                            "maxScore": 10,
                            "goalScore": 9.75663538090668,
                            "realAge": 28.369609856262834,
                            "leadlifeAge": 29.078833687926966,
                            "goalAge": 18.3709787816564,
                            "time": 1709161199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.7",
                            "score": 6.742340951743941,
                            "maxScore": 10,
                            "goalScore": 9.75663538090668,
                            "realAge": 28.372347707049965,
                            "leadlifeAge": 26.588043389957033,
                            "goalAge": 18.373716632443532,
                            "time": 1709247599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.7",
                            "score": 6.738372697775687,
                            "maxScore": 10,
                            "goalScore": 9.75663538090668,
                            "realAge": 28.380561259411362,
                            "leadlifeAge": 26.615593772310287,
                            "goalAge": 18.38193018480493,
                            "time": 1709506799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.8",
                            "score": 5.838186658347617,
                            "maxScore": 10,
                            "goalScore": 9.590149742696992,
                            "realAge": 28.432580424366872,
                            "leadlifeAge": 30.280692440815137,
                            "goalAge": 18.43394934976044,
                            "time": 1711148399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.885303299054713,
                            "maxScore": 10,
                            "goalScore": 9.669946121966177,
                            "realAge": 28.44079397672827,
                            "leadlifeAge": 30.30170452977085,
                            "goalAge": 18.442162902121833,
                            "time": 1711407599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.6",
                            "score": 5.580202742579771,
                            "maxScore": 10,
                            "goalScore": 9.65097869131637,
                            "realAge": 28.4435318275154,
                            "leadlifeAge": 31.900515508415687,
                            "goalAge": 18.444900752908968,
                            "time": 1711493999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.4",
                            "score": 5.4377526001296275,
                            "maxScore": 10,
                            "goalScore": 9.294853335191014,
                            "realAge": 28.449007529089666,
                            "leadlifeAge": 31.537577329169974,
                            "goalAge": 18.45037645448323,
                            "time": 1711666799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.4",
                            "score": 5.440203580521785,
                            "maxScore": 10,
                            "goalScore": 9.294853335191014,
                            "realAge": 28.487337440109513,
                            "leadlifeAge": 31.588857196458275,
                            "goalAge": 18.48870636550308,
                            "time": 1712872799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.4",
                            "score": 5.440203580521785,
                            "maxScore": 10,
                            "goalScore": 9.294853335191014,
                            "realAge": 28.49828884325804,
                            "leadlifeAge": 31.607568203238348,
                            "goalAge": 18.49965776865161,
                            "time": 1713218399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.4",
                            "score": 5.440203580521785,
                            "maxScore": 10,
                            "goalScore": 9.294853335191014,
                            "realAge": 28.709103353867214,
                            "leadlifeAge": 31.967755083754753,
                            "goalAge": 18.71047227926078,
                            "time": 1719871199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.4",
                            "score": 5.440203580521785,
                            "maxScore": 10,
                            "goalScore": 9.294853335191014,
                            "realAge": 28.744695414099933,
                            "leadlifeAge": 32.028565855789985,
                            "goalAge": 18.746064339493497,
                            "time": 1720994399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.4",
                            "score": 5.440203580521785,
                            "maxScore": 10,
                            "goalScore": 9.294853335191014,
                            "realAge": 28.747433264887064,
                            "leadlifeAge": 32.033243607485005,
                            "goalAge": 18.748802190280628,
                            "time": 1721080799000
                        }
                    ]
                },
                {
                    "tag": "DASHBOARD_FOOD",
                    "name": "Food",
                    "groups": [
                        {
                            "tag": "DASHBOARD_FOOD_MACRO",
                            "name": "MacronutriÃ«nten",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_VERZADIGDEVETTEN",
                                    "name": "Verzadigde vetten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse blijkt dat jouw lichaam het moeilijker heeft om de verzadigde vetten te verwerken.",
                                                    "keyWords": "moeilijke verwerking",
                                                    "advice": "Doordat jouw lichaam het moeilijk heeft om verzadigde vetten te verwerken, is een voedingspatroon met zo weinig mogelijk verzadigde vetten in jouw geval optimaal. Bij een te hoge inname stijgt de kans op overgewicht, insulineresistentie en diabetes type 2 (suikerziekte). Probeer het energieprocent van je hoeveelheid verzadigde vetten terug te dringen tot minder dan 7 procent. Bronnen van verzadigde vetten zijn onder andere vet vlees, volle melkproducten en volvette kaas. Daarnaast zit er veel verzadigd vet in koekjes en gebakjes.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN",
                                            "name": "Triglyceriden",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 62,
                                                    "intValue": 62,
                                                    "stringValue": "62",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 77,
                                                    "intValue": 77,
                                                    "stringValue": "77",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 85,
                                                    "intValue": 85,
                                                    "stringValue": "85",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN_NORMAAL",
                                                    "resultText": "Je triglyceridenwaarden zijn neutraal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Zoals wel vaker in dit rapport is het ook voor je triglyceridenwaarden belangrijk om een gezonde levensstijl te hanteren. Tracht steeds te streven naar triglyceridewaarden lager dan 100 mg/dl. Matig de verzadigde vetten die je binnenkrijgt en zorg vooral dat je voldoende groenten eet. Beperk ook je alcoholverbruik en probeer 30 minuten per dag te bewegen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL",
                                            "name": "Totale cholesterol",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 173,
                                                    "intValue": 173,
                                                    "stringValue": "173",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 170,
                                                    "intValue": 170,
                                                    "stringValue": "170",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 224,
                                                    "intValue": 224,
                                                    "stringValue": "224",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_HOOG",
                                                    "resultText": "Je totale cholesterolwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Wil je je âslechteâ LDL-cholesterol verlagen en de âgoedeâ HDL-cholesterol verhogen? Trek dan je sportkleren maar aan! Door voldoende te bewegen en gevarieerd te eten kom je al een heel eind. Dat laatste doe je onder andere door veel groenten, fruit en voedingsvezels te eten en je zoutgebruik te minderen. Probeer daarnaast ook zo veel mogelijk verzadigd vet in je eten te vervangen door onverzadigd vet.\n\nDoor je voeding aan te passen kun je je cholesterolgehalte met zoân 10 procent verlagen! Door daarnaast ook plantensterolen te gebruiken kun je het nog eens met 10 procent doen dalen. Die plantensterolen zijn vetachtige stoffen die je, uiteraard, in planten vindt. Qua structuur lijken ze heel erg op cholesterol, maar ze zorgen ervoor dat cholesterol minder opgenomen wordt in de darmen. Door dagelijks 1,5 Ã  3 gram plantensterolen uit verrijkte voedingsmiddelen te gebruiken kun je je cholesterolgehalte met ongeveer 10 procent verlagen. Probeer daar ook niet mee te overdrijven, want als je meer dan 3 gram plantensterolen per dag gebruikt, daalt je cholesterolgehalte niet verder.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 27,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 27.556468172484603,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 27.560574948665298,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 27.572895277207394,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 27.65092402464066,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "65.0",
                                            "score": 65,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 28.372558310956666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "65.0",
                                            "score": 65,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 28.37677038909072,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "65.0",
                                            "score": 65,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 28.385194545358814,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "65.0",
                                            "score": 65,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 28.44416363923551,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "65.0",
                                            "score": 65,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 28.461011951771706,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "65.0",
                                            "score": 65,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 28.78534196809351,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "65.0",
                                            "score": 65,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 28.84009898383615,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "65.0",
                                            "score": 65,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 28.844311061970195,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_TRANSVETTEN",
                                    "name": "Transvetten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN_MATIG",
                                                    "resultText": "Het onderzoek van jouw genen wijst uit dat jouw lichaam transvetten niet zo goed verwerkt.",
                                                    "keyWords": "minder goede verwerking",
                                                    "advice": "Het is sowieso niet aangeraden om veel transvetten te eten, maar in jouw geval is het zeker belangrijk daarop te letten. Door je hoeveelheid transvetten onder 1% energiewaarde per dag te houden beperk je het risico op hart- en vaatziekten. Transvetten komen van nature voor in melk en vlees van herkauwers zoals koeien en schapen. Daarom kom je ze ook tegen in harde margarines, bak- en braadvetten. Zoals we al vertelden, duiken ze vooral op in gebak, koekjes en snacks. Probeer dus zo veel mogelijk te kiezen voor vloeibaar of zacht vet en eet niet te veel koekjes en gebakjes om de inname van transvet te beperken.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR",
                                            "name": "Kant-en-klare voeding",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "bijna nooit",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "af en toe",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "resultText": "Je eet 1 of 2 keer per week een kant-en-klaarmaaltijd.",
                                                    "keyWords": "vaak",
                                                    "advice": "Kant-en-klaarmaaltijden zijn niet per definitie ongezond, maar je haalt er doorgaans niet de dagelijkse aanbevolen hoeveelheid groenten mee. Zo veel mogelijk vers koken en zo weinig mogelijk verwerkte producten eten blijft de beste keuze. ",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO",
                                            "name": "Buik-heupratio",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 1.2,
                                                    "stringValue": "1.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 0.79,
                                                    "stringValue": "0.79",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.89,
                                                    "stringValue": "0.89",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.99,
                                                    "stringValue": "0.99",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_GOOD",
                                                    "resultText": "Je middel-heupratio is goed",
                                                    "keyWords": "goed",
                                                    "advice": "Goed bezig! Een lage middel-heupratio betekent dat de hoeveelheid vet niet is opgeslagen rond je middel. Houden zo!",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK",
                                            "name": "Buikomtrek",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116168810
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709124272513
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709223914112
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "resultText": "Uit jouw antwoorden blijkt dat je buikomtrek licht verhoogd is. Als vrouw is dat tussen de 80 en 88 centimeter.",
                                                    "keyWords": "licht te hoog",
                                                    "advice": "Wat sommige coaches en influencers ook mogen beweren: er bestaat helaas geen miraculeus crashdieet om snel die buik kwijt te raken. Toch helpen alle beetjes. Als je erin slaagt om 5 Ã  10% van je gewicht te verliezen, dan heeft dat een heilzaam effect op je buikvet. Met de nodige deskundige hulp lukt het zelfs om bij veel overgewicht de gezonde balans terug te vinden.\n\nIn een ideaal scenario vind je een gezond voedingspatroon dat je je eigen maakt om ook op lange termijn een gezond gewicht Ã©n je buikomtrek te behouden. Het klassieke jojo-effect dat ervoor zorgt dat je continu afvalt en vervolgens weer bijkomt, is namelijk erg slecht voor je gezondheid. Bij deze nog wat inspiratie:\n\n* Ga fietsen, zwemmen, wandelen, dansen, trappen lopen: maak zelf een keuze waar je je goed en gemotiveerd bij voelt.\n* Probeer elke dag twintig minuten intensief - zodat je bijna buiten adem bent - te bewegen.\n* Lukt het niet om elke dag te bewegen? Probeer dan minstens vier keer per week beweging (maar dan wel 30 Ã  45 minuten) in te plannen.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1719837987002
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "280.0",
                                            "score": 280,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 19.607142857142858,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "180.0",
                                            "score": 180,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 31.128602935584457,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "205.0",
                                            "score": 205,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 27.3365052336355,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "205.0",
                                            "score": 205,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 27.348725396904896,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.24888116674565,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "135.0",
                                            "score": 135,
                                            "maxScore": 310,
                                            "goalScore": 310,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 42.34867036783532,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.27457484336335,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.2874216816722,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.37734954983415,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.40304322645186,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_MUFA",
                                    "name": "Enkelvoudig onverzadigde vetten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA_MATIG",
                                                    "resultText": "Uit jouw DNA-analyse kunnen we opmaken dat jouw lichaam behoefte heeft aan een voedingspatroon dat rijk is aan enkelvoudig onverzadigde vetten. Dat is vooral belangrijk om overgewicht tegen te gaan.",
                                                    "keyWords": "hogere nood",
                                                    "advice": "In jouw geval is het aangeraden te kiezen voor een gezond en gevarieerd eetpatroon met een minimum van 13% energiewaarde uit enkelvoudig onverzadigde vetten. Die mono-onverzadigde vetten vind je vooral in olijven, olijfolie, pinda's en de meeste noten. Olijfolie bevat daarnaast omega 9-vetzuur, dat helpt om het cholesterolgehalte in je bloed te doen dalen. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_PUFA",
                                    "name": "Meervoudig onverzadigde vetten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA_HOOG",
                                                    "resultText": "Op basis van jouw DNA-analyse kunnen we vaststellen dat jouw lichaam nood heeft aan een voedingspatroon rijk aan meervoudig onverzadigde vetten.",
                                                    "keyWords": "hogere nood",
                                                    "advice": "Als we je een tip mogen geven: let erop dat je voldoende omega 3-vetzuren opneemt. Ze zullen je helpen om een gezonde BMI te behouden. Tot de meervoudige of polyonverzadigde vetzuren behoren de essentiÃ«le omega 6- en omega 3-vetzuren. Die eerste vind je onder andere in zonnebloem-, mais-, soja-, tarwekiem-, saffloer- en druivenpitolie. De omega 3-vetzuren zitten dan weer in lijnzaad, koolzaad, noten, soja en de olie van die producten. Die oliÃ«n zijn ideaal voor koude bereidingen! Maar ook vette vissoorten, zoals zalm, zijn rijk aan omega 3. Voeg ze vaker toe aan je voedingspatroon om gezonder te leven.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN",
                                            "name": "Gezonde vetten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "zeer goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "zeer goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "resultText": "Je schenkt voldoende aandacht aan de inname van gezonde vetten in je voedingspatroon.",
                                                    "keyWords": "goed",
                                                    "advice": "Goed bezig! Onverzadigde vetten hebben bewezen gezondheidsvoordelen en worden beschouwd als de gezondste van de vetten. Blijf deze op regelmatige basis toevoegen aan je eetpatroon. Wees steeds aandachtig om voldoende te variÃ«ren.",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "80.0",
                                            "score": 80,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 24.111909650924026,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 35.07709538921038,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 35.09277580735486,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "80.0",
                                            "score": 80,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 24.194558521560577,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "80.0",
                                            "score": 80,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 24.205338809034906,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 24.593201003878622,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 24.600501939310973,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 24.65160848733744,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 24.666210358202147,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 24.947296372347708,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 24.994752452657995,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 24.998402920374172,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_SUIKERS",
                                    "name": "Suikers",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS_MATIG",
                                                    "resultText": "Op basis van jouw DNA-resultaten kunnen we vaststellen dat jouw lichaam koolhydraten en suikers niet optimaal verwerkt. ",
                                                    "keyWords": "matige verwerking",
                                                    "advice": "Als jij te veel koolhydraten binnenkrijgt, ben je gevoeliger om bij te komen of insulineresistentie te ontwikkelen. Dat laatste betekent dat je lichaam niet goed reageert op insuline, waardoor je kans hebt op een te hoge bloedsuikerspiegel en type 2 diabetes kan krijgen. Spring dan ook slim met koolhydraten om. Dat doe je door voedingsmiddelen te kiezen waarvan is aangetoond dat ze gezondheidswinst opleveren of andere goede voedingsstoffen zoals vezels, vitaminen en mineralen bevatten. Het best zijn complexe koolhydraten en voedingsproducten met een lage glycemische index. Denk daarbij aan volkoren graanproducten (volkorenbrood en volkorenpasta), aardappelen, peulvruchten, groenten en fruit. Vermijd anderzijds koolhydraatrijke producten die arm zijn aan voedingsstoffen, zoals frisdrank, koekjes en snoep.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER",
                                            "name": "Suiker",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "heel weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "resultText": "Je eet 4 keer of meer per week zoetigheid.",
                                                    "keyWords": "veel te veel",
                                                    "advice": "Voor jou is het aangeraden om de suikerrijke voedingsproducten het liefst wat te minderen of te vermijden. Te veel van dat soort voedsel is namelijk slecht voor je lichaam. Een overvloed aan suiker kan je alvleesklier overbelasten, overgewicht veroorzaken en de kans op diabetes type 2 verhogen. Daarnaast is het, maar dat wist je hopelijk al, slecht voor je tanden. Laat die suikerrijke hap dus liever links liggen en kies voor gezondere en vezelrijke alternatieven zoals groenten, fruit of noten. ",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C",
                                            "name": "HbA1c",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5.4,
                                                    "stringValue": "5.4",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5,
                                                    "stringValue": "5.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5.5,
                                                    "stringValue": "5.5",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                                    "resultText": "Je HbA1c-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Door je levensstijl hier en daar bij te sturen kan je al heel wat doen om je bloedsuikerspiegel stabiel te houden:\n \n  * Verminder je suikerinname uit zoetigheden, koekjes en bewerkt voedsel.\n  * Vervang de snelle koolhydraten door complexe koolhydraten zoals in granen, bonen en noten.\n  * Afwisselend vasten of je maaltijdfrequentie verlagen wordt steeds belangrijker. Een studie in het World Journal of Diabetes claimt dat afwisselend vasten helpt om het bloedsuikerniveau te verbeteren en gewicht te verliezen. De lange periode van vasten fixeert de bloedsuiker en de stofwisseling (het metabolisme) gaat over op het verbranden van vetreserves.\n  * Eet minder verzadigde vetten. Een teveel aan verzadigde vetten kan leiden tot overgewicht, en dat alleen al heeft een heel grote invloed op je bloedsuikerspiegel.\n  * Eet geen transvetten. Niet alleen neemt de kans op overgewicht toe bij consumptie van te veel transvetten, ook krijg je last van inflammatie, zoals bij kunstmatige suikers. Deze ontstekingen in je lichaam hebben een grote invloed op je bloedsuikerspiegel.\n  * Eet wel meer onverzadigde vetten. Die vetten hebben precies de tegenovergestelde effecten op je gezondheid in vergelijking met transvetten. Onverzadigde vetten zorgen ervoor dat je hart- en vaatstelsel gezond en soepel blijft. Daarnaast werken ze ontstekingsremmend. Ontstekingen leiden tot een hoge bloedsuikerspiegel en dat is precies datgene wat door onverzadigde vetten te eten wordt voorkomen.\n  * Eet meer eiwitten. Van alle voedingsgroepen hebben eiwitten de minste invloed op je bloedsuikerspiegel. Door een groter deel van je dieet uit eiwitten te laten bestaan heb je dus wel de energie, maar niet de stijging van je bloedsuikerspiegel.\n  * Drink minder cafeÃ¯ne.\n  * Laat ook alcohol links liggen. Zoals je misschien wel weet, is je alvleesklier verantwoordelijk voor de aanmaak van insuline. Diezelfde alvleesklier maakt ook deel uit van de groep organen die belast is met het verwijderen van alcohol uit je systeem. Als je dus regelmatig alcohol drinkt, belast je de alvleesklier onnodig.\n  * Beweeg voldoende en op regelmatige basis. Meer bewegen vermindert de insulineresistentie en heeft tot gevolg dat je meer calorieÃ«n verbrandt. Er zit wel een addertje onder het gras: je moet consistent bewegen om een effect te hebben.\n  * Slaap voldoende. Wanneer je te weinig slaapt, kan je problemen krijgen met je cellen voor insuline. Tracht minimaal 6 Ã  7 uur per nacht te slapen.\n  * Wees stress de baas. Stresshormonen jagen je bloedsuikerspiegel omhoog. Op het moment dat jouw hersenen een potentiÃ«le noodsituatie detecteren, schakelt dit mechanisme in en je kunt het niet stoppen. Wat je wel kan doen, is stresssituaties leren beheersen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_GEWICHT_DIABETES_HOMAIR",
                                            "name": "HOMA-IR",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.13,
                                                    "stringValue": "1.13",
                                                    "tag": "RESULT_BLOOD_GEWICHT_DIABETES_HOMAIR_NORMAAL",
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.51,
                                                    "stringValue": "0.51",
                                                    "tag": "RESULT_BLOOD_GEWICHT_DIABETES_HOMAIR_NORMAAL",
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.48,
                                                    "stringValue": "0.48",
                                                    "tag": "RESULT_BLOOD_GEWICHT_DIABETES_HOMAIR_NORMAAL",
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 16,
                                                    "intValue": 16,
                                                    "stringValue": "16",
                                                    "tag": "RESULT_BLOOD_GEWICHT_DIABETES_HOMAIR_NORMAAL",
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 96,
                                                    "intValue": 96,
                                                    "stringValue": "96",
                                                    "tag": "RESULT_BLOOD_GEWICHT_DIABETES_HOMAIR_NORMAAL",
                                                    "resultText": "Je HOMA-IR-waarde is een berekende waarde.",
                                                    "keyWords": "berekende waarde",
                                                    "advice": "Een ideale HOMA-IR-index is rond 1%. Wees insulineresistentie steeds een stap voor en houd rekening met deze aspecten: \n\n  * Eet langzaam verterend voedsel\n  * Sport kort, maar krachtig\n  * Eet minder koolhydraten\n  * Slaap voldoende\n  * Drink groene thee\n  * Streef naar een gezond gewicht\n  * Gebruik kruiden zoals gember, kaneel, ginseng, appelazijn of kurkuma\n\nIs je waarde hoger dan 1%? Weet dan dat insulineresistentie meerdere oorzaken kan hebben. Vaak is het dan ook een combinatie van meerdere factoren. Zoals bij iedere lichamelijke klacht is er een genetische component, maar hoe je leeft kan ervoor zorgen dat bepaalde genen tot uiting komen. Als we kijken naar levensstijl dan zien we een aantal dingen die de kans verhogen op insulineresistentie:\n\n  * Overgewicht en veel buikvet of orgaanvet\n  * Een hoge inname van sterk bewerkte (geraffineerde) voedingsmiddelen met toegevoegde suikers die de bloedsuiker snel laten stijgen\n  * Inactief leven \n  * Chronische stress \n  * Laaggradige ontstekingen door bijvoorbeeld voedselovergevoeligheden, âlekkende darmsyndroomâ, onbalans in de darmbacteriÃ«n, hoge suikerinname en stress.\n  * Roken\n  * Hoge alcohol- en fructoseconsumptie (alcoholische en niet-alcoholische leververvetting) \n  * Zwangerschap (zwangerschapsresistentie en zwangerschapsdiabetes) \n  * Slaaptekort (slaapgebrek) \n  * Gebruik van bepaalde medicijnen zoals corticosteroÃ¯den \n\nMaak voor jezelf even de balans op. Aan welke factoren kan je werken?",
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "155.0",
                                            "score": 155,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "80.0",
                                            "score": 80,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 35.59377138945928,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "80.0",
                                            "score": 80,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 35.59907597535935,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "80.0",
                                            "score": 80,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 35.61498973305955,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_ZETMEEL",
                                    "name": "Zetmeel",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "zeer goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL_MATIG",
                                                    "resultText": "Uit de resultaten van jouw DNA-analyse blijkt dat jij zetmeelhoudende producten zeer goed verwerkt.",
                                                    "keyWords": "zeer goede verwerking",
                                                    "advice": "Zetmeelhoudende producten zoals pasta, rijst en aardappelen vormen voor jouw lichaam geen uitdaging! Doordat die heel goed verwerkt worden, zal jij bij inname ervan niet extra snel bijkomen. Zetmeelhoudende producten kunnen dus zonder problemen deel uitmaken van je voedingspatroon.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.7",
                                    "score": 8.732394366197184,
                                    "maxScore": 10,
                                    "goalScore": 9.577464788732394,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 19.741935483870964,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.915492957746479,
                                    "maxScore": 10,
                                    "goalScore": 9.577464788732394,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 29.743489456015123,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.915492957746479,
                                    "maxScore": 10,
                                    "goalScore": 9.577464788732394,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 29.747922166813336,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.915492957746479,
                                    "maxScore": 10,
                                    "goalScore": 9.577464788732394,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 29.76122029920798,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.9",
                                    "score": 4.859154929577465,
                                    "maxScore": 10,
                                    "goalScore": 9.577464788732394,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 36.333581327064046,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.9",
                                    "score": 4.859154929577465,
                                    "maxScore": 10,
                                    "goalScore": 9.577464788732394,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 36.34977035780535,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.8",
                                    "score": 4.788732394366197,
                                    "maxScore": 10,
                                    "goalScore": 9.507042253521126,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 36.618552965333976,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.8",
                                    "score": 4.788732394366197,
                                    "maxScore": 10,
                                    "goalScore": 9.507042253521126,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 36.62942384345935,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.8",
                                    "score": 4.788732394366197,
                                    "maxScore": 10,
                                    "goalScore": 9.507042253521126,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 36.705519990336995,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.8",
                                    "score": 4.788732394366197,
                                    "maxScore": 10,
                                    "goalScore": 9.507042253521126,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 36.72726174658775,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.8",
                                    "score": 4.788732394366197,
                                    "maxScore": 10,
                                    "goalScore": 9.507042253521126,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 37.14579055441478,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.8",
                                    "score": 4.788732394366197,
                                    "maxScore": 10,
                                    "goalScore": 9.507042253521126,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 37.21645126222973,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.8",
                                    "score": 4.788732394366197,
                                    "maxScore": 10,
                                    "goalScore": 9.507042253521126,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 37.22188670129242,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_FOOD_VITAMINES",
                            "name": "Vitamines en mineralen",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_VITAMINESB2",
                                    "name": "Vitamine B2",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2_HOOG",
                                                    "resultText": "Op basis van de resultaten van jouw DNA-analyse blijkt dat jouw lichaam een sterk verhoogde nood aan vitamine B2 heeft. ",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Vitamine B2 vind je vooral in melk en melkproducten, maar ook in vlees, vleeswaren, groenten, fruit, brood en graanproducten. Probeer die producten dan ook toe te voegen aan jouw eetpatroon en let daarbij altijd op mogelijke intoleranties. Met het DNA-onderzoek bepalen we zoals gezegd niet of je nu een tekort hebt aan vitamine B2. Om dat te weten te komen, moet je een bloedonderzoek laten doen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_VITAMINESB6",
                                    "name": "Vitamine B6",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6_HOOG",
                                                    "resultText": "Op basis van jouw DNA-analyse kunnen we concluderen dat jouw lichaam een sterk verhoogde nood aan vitamine B6 heeft.",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Vitamine B6 vind je vooral in vlees, eieren, vis, brood, graanproducten, aardappelen, peulvruchten, groenten, melk en melkproducten en kaas. Probeer die producten dan ook toe te voegen aan jouw eetpatroon en let daarbij altijd op mogelijke intoleranties. Met het DNA-onderzoek bepalen we zoals gezegd niet of je nu een tekort hebt aan vitamine B6. Om dat te weten te komen, moet je een bloedonderzoek laten doen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_FOLIUMZUUR",
                                    "name": "Foliumzuur",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_HOOG",
                                                    "resultText": "Uit je DNA-analyse kunnen we opmaken dat jouw lichaam een sterk verhoogde nood aan foliumzuur heeft.",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Probeer net iets meer te variÃ«ren in jouw voedingspatroon zodat je wat extra foliumzuur opneemt. Foliumzuur komt van nature vooral voor in groene groenten, volkorenproducten, brood, vlees en zuivel. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR",
                                            "name": "Foliumzuur",
                                            "unit": "Âµg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 22.21,
                                                    "stringValue": "22.21",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 7.86,
                                                    "stringValue": "7.86",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 9.43,
                                                    "stringValue": "9.43",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 90,
                                                    "intValue": 90,
                                                    "stringValue": "90",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_LAAG",
                                                    "resultText": "Je foliumzuurwaarden zijn licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Foliumzuur komt van nature voor in verschillende groenten. Vooral de groene soorten zoals spinazie, boerenkool, rucola, broccoli en sla zijn rijke bronnen van foliumzuur. Ook in fruit en volkorenproducten vind je deze vitamine. In vlees en melkproducten zit ook foliumzuur, maar in mindere mate dan in de groente en fruit. Een tekort aan foliumzuur kan je behandelen door het innemen van supplementen met extra foliumzuur. Na verloop van tijd kom je zo terug aan het gewenste niveau.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_VITAMINESB12",
                                    "name": "Vitamine B12",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_HOOG",
                                                    "resultText": "Op basis van de resultaten van je DNA-analyse blijkt dat jouw lichaam een sterk verhoogde nood aan vitamine B12 heeft.",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Probeer in jouw voedingspatroon wat meer te variÃ«ren, zodat jouw lichaam over voldoende vitamine B12 beschikt. Je vindt die vitamine bijvoorbeeld in dierlijke producten zoals melk, melkproducten, vlees, vleeswaren, vis en eieren. Daarnaast kan vitamine B12 ook voorkomen in plantaardige producten, zoals zeewier en algen. Let uiteraard op mogelijke intoleranties. Met het DNA-onderzoek bepalen we zoals gezegd niet of je nu een tekort hebt aan vitamine B12. Om dat te weten te komen, moet je een bloedonderzoek laten doen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12",
                                            "name": "Vitamine B12",
                                            "unit": "ng/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 476,
                                                    "intValue": 476,
                                                    "stringValue": "476",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 436,
                                                    "intValue": 436,
                                                    "stringValue": "436",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 355,
                                                    "intValue": 355,
                                                    "stringValue": "355",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 48,
                                                    "intValue": 48,
                                                    "stringValue": "48",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "resultText": "Je vitamine B12-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Voor mannen en vrouwen boven de 14 is het aanbevolen om dagelijks 2,8 microgram vitamine B12 binnen te krijgen. Als je gezond en gevarieerd eet, krijg je voldoende vitamine B12 binnen. Tracht te streven naar waarden boven de 500ng/l.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_VITAMINESD",
                                    "name": "Vitamine D",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD",
                                            "name": "Vitamine D",
                                            "unit": "ng/ml",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 38.6,
                                                    "stringValue": "38.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 58.7,
                                                    "stringValue": "58.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 31.8,
                                                    "stringValue": "31.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "resultText": "Je vitamine D-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Optimale waarden van 25-OH Vit D3 zijn tussen de 20ng/ml en 50 ng/ml. Is je waarde tussen 12ng/ml en 20ng/ml? Dan dien je extra aandacht te besteden aan je vitamine D-inname. \n\nOm normale vitamine D-waarden te behouden is het belangrijk om je lichaam voldoende bloot te stellen aan onmiddellijk zonlicht en voeding te eten die rijk is aan vitamine D. Je vindt vitamine D onder andere in vette vissoorten (paling, makreel, zalm en haring), eidooier en aan zonlicht blootgestelde paddenstoelen. Omdat calcium belangrijk is voor de opname van vitamine D combineer je die champignons of vette vis het best met een calciumrijk voedingsmiddel. Denk bijvoorbeeld aan spinazie, Chinese kool of tofoe.\n\nWaar wij wonen, is het makkelijker gezegd dan gedaan om vitamine D binnen te krijgen via zonlicht. In de zomer is een kwartier blootstelling van armen en hoofd op de middag voldoende om je vitamine D-gehalte in de bloedspiegel op niveau te houden. Het teveel aan aangemaakte vitamine D wordt opgeslagen in vetweefsel, een reserve die ontoereikend is om ons de hele winter en lente te voorzien van voldoende van die vitamine. Uit onderzoek blijkt dat zelfs tot ongeveer 90 procent van de Belgische bevolking aan het einde van de winter een gebrek aan vitamine D heeft.\n\nVoor iedereen geldt een dagelijkse aanbevolen hoeveelheid van 10 microgram vitamine D. Alleen mensen van boven de 70 moeten 20 microgram per dag binnenkrijgen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_IJZER",
                                    "name": "Ijzer",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_MATIG",
                                                    "resultText": "Op basis van je DNA-analyse merken we dat je een verhoogde gevoeligheid hebt voor een tekort aan transferrine en ijzerwaarden in jouw bloedplasma. ",
                                                    "keyWords": "licht verhoogde nood",
                                                    "advice": "Een tekort aan ijzer kan ertoe leiden dat je sneller vermoeid en buiten adem bent, last hebt van een bleke huid en rusteloze benen die je steeds het gevoel geven dat je ze moet bewegen. Als je wil voorkomen dat jouw lichaam met een ijzertekort kampt, raden wij jou aan om met de volgende zaken rekening te houden.\n\n- Eet genoeg vlees(vervangers) die voldoende ijzer bevatten.\n- Kies vooral voor volkorenbrood, volkorenpasta en peulvruchten.\n- Neem bij iedere maaltijd groenten en/of fruitsoorten die rijk zijn aan vitamine C.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER",
                                            "name": "Ijzer",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 107,
                                                    "intValue": 107,
                                                    "stringValue": "107",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 123,
                                                    "intValue": 123,
                                                    "stringValue": "123",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 100,
                                                    "intValue": 100,
                                                    "stringValue": "100",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "resultText": "Je ijzerwaarde is normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Idealiter bedragen je ijzerwaarden tussen de 70 en 125Î¼g/dl. Door gezond en gevarieerd te eten krijg je dat normaal binnen. VegetariÃ«rs krijgen over het algemeen alleen non-heemijzer binnen, waardoor de opname door het lichaam wat lager is. Wie geen vlees eet, heeft soms lagere ijzervoorraden dan anderen, maar dat niveau is nog steeds voldoende.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE",
                                            "name": "Ferritine",
                                            "unit": "Âµg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 22.3,
                                                    "stringValue": "22.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 186.3,
                                                    "stringValue": "186.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 60.6,
                                                    "stringValue": "60.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 40,
                                                    "intValue": 40,
                                                    "stringValue": "40",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_HOOG",
                                                    "resultText": "Je ferritinewaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een methode om je ferritinewaarden te verlagen is je voedselpatroon aan te passen aan het te hoge ferritinegehalte in je bloed. Een speciaal voedingspatroon kan een oplossing zijn om het overschot te beperken. Er zijn namelijk een aantal producten die je kunnen helpen om je ijzeroverschot naar beneden te brengen, zoals:\n\n  * Thee tijdens de maaltijd\n  * Vruchtensappen overdag\n  * Boter, kaas en eieren\n  * Vis\n  * Volkorenproducten\n\nVolgende producten kan je beter vermijden:\n\n  * Koffie\n  * Sla\n  * Gedroogd fruit\n  * Rundvlees en varkensvlees\n  * Groenten zoals broccoli, sperziebonen en andijvie\n  * Olijven, vooral zwarte\n  * Artisjokken\n\nEen belangrijke tip om de ferritinewaarden in je bloed te verlagen is om rekening te houden met je gewicht. Overgewicht werkt niet bevorderlijk om het ijzergehalte in je bloed te reduceren. Als je het terugdringen van je gewicht combineert met een regelmatig bezoek aan de sportschool en aan een aangepast dieet merk je al snel dat je lichaam daar positief op reageert.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 27.667351129363453,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 27.675564681724847,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 27.733059548254623,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 27.749486652977414,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 28.065708418891173,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 28.119096509240247,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 28.123203285420942,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_CALCIUM",
                                    "name": "Calcium",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_LAAG",
                                                    "resultText": "Op basis van jouw DNA-resultaten blijkt dat je geen verhoogde nood hebt aan calcium voor jouw botstevigheid.",
                                                    "keyWords": "geen extra nood",
                                                    "advice": "Doordat jij geen genetische aanleg hebt voor verlaagde calciumniveaus volstaat het voor jou om gezond en gevarieerd te blijven eten. Extra calcium innemen is voor jou dan ook niet noodzakelijk.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM",
                                            "name": "Calcium",
                                            "unit": "10^6/Âµl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.25,
                                                    "stringValue": "2.25",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.41,
                                                    "stringValue": "2.41",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 98,
                                                    "intValue": 98,
                                                    "stringValue": "98",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 45,
                                                    "intValue": 45,
                                                    "stringValue": "45",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "resultText": "Je calciumwaarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Wanneer je gezond en gevarieerd eet, krijgt je normaal gezien voldoende calcium binnen. \n\nCalciumrijke voedingsproducten zijn vooral zuivelproducten (bijvoorbeeld melk of yoghurt) of met calcium verrijkte plantaardige varianten van zuivel, zoals sojamelk en amandelmelk. \n\nDaarnaast zijn nog heel wat andere voedingsstoffen rijk aan calcium. Denk bijvoorbeeld aan noten, groene groenten (zoals broccoli, spinazie, Chinese kool of rammenas), bonen, zeewier, vis (zoals maatjes, zeebrasem of sardines) en zaden.\n\nOmdat vitamine D onmisbaar is voor de opname van calcium in je lichaam, is het belangrijk dat je er voldoende binnenkrijgt.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_MAGNESIUM",
                                    "name": "Magnesium",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM",
                                            "name": "Magnesium",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.84,
                                                    "stringValue": "0.84",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.8,
                                                    "stringValue": "0.80",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.81,
                                                    "stringValue": "0.81",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_HOOG",
                                                    "resultText": "Je magnesiumwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een overschot aan magnesium ontstaat enkel bij gebruik van tabletten waarin magnesium zit, magnesiumzouten of mineraalwater waarin veel magnesium zit. \n\nBij meer dan 250 milligram magnesium per dag extra, dus naast het magnesium in je eten, kunnen darmklachten zoals diarree ontstaan.\n",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_KALIUM",
                                    "name": "Kalium",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_KALIUM",
                                            "name": "Kalium",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.26,
                                                    "stringValue": "4.26",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_KALIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 5.22,
                                                    "stringValue": "5.22",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_KALIUM_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 5.59,
                                                    "stringValue": "5.59",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_KALIUM_HOOG",
                                                    "resultText": "Je kaliumwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Probeer kaliumrijke producten wat te beperken. Voedingsmiddelen die veel kalium bevatten, zijn:\n \n  * Aardappelen\n  * Cacao\n  * Groenten (vooral tomaten)\n  * Fruit\n  * Vloeibare melkproducten zoals melk en yoghurt\n  * Noten en zaden zoals amandelen, cashewnoten, pinda's of lijnzaad\n  * Peulvruchten en linzen\n  * Koffie (ook cafeÃ¯nevrij)",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MACRO_ZINK",
                                    "name": "Zink",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK",
                                            "name": "Zink",
                                            "unit": "pg",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 76.7,
                                                    "stringValue": "76.7",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 71.7,
                                                    "stringValue": "71.7",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 25,
                                                    "intValue": 25,
                                                    "stringValue": "25",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 46,
                                                    "intValue": 46,
                                                    "stringValue": "46",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "resultText": "Je zinkwaarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "De belangrijkste leverancier van het mineraal zink zijn dierlijke producten zoals vlees, zuivel en vis. Ook verschillende noten bevatten zink. Toch vind je zink vooral in schaal- en schelpdieren zoals oesters, garnalen en mosselen. In brood, peulvruchten en rijst zal je het dan weer een pak minder vinden. Probeer steeds te mikken op 90 Âµg/dL.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.7",
                                    "score": 8.72549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.411764705882353,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 19.415730337078653,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.7",
                                    "score": 8.72549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.411764705882353,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 19.815887225157468,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.7",
                                    "score": 8.72549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.411764705882353,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 19.81884041252336,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.7",
                                    "score": 8.72549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.411764705882353,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 19.827699974621048,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.9",
                                    "score": 7.9411764705882355,
                                    "maxScore": 10,
                                    "goalScore": 9.313725490196079,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 21.62006405218817,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.6",
                                    "score": 7.647058823529412,
                                    "maxScore": 10,
                                    "goalScore": 9.019607843137255,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 21.752294705066774,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.372549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 26.390396461854372,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.372549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 26.3982309271837,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.372549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 26.453072184489027,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.372549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 26.46874111514769,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.372549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 26.770368030326967,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.372549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 26.82129205496762,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.372549019607843,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 26.825209287632287,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_FOOD_EETGEDRAG",
                            "name": "Eetgedrag",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_ZOET",
                                    "name": "Zoete smaak",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET_MATIG",
                                                    "resultText": "Jij bent een kleine snoeper: jouw DNA toont aan dat je een lichte voorkeur voor zoete smaken hebt.",
                                                    "keyWords": "lichte voorkeur",
                                                    "advice": "Geniet, maar met mate. Te veel zoete voedingsproducten zijn slecht voor je lichaam. Een overvloed aan suiker kan je alvleesklier overbelasten, overgewicht veroorzaken en de kans op diabetes type 2 verhogen. Daarnaast is het, maar dat wist je hopelijk al, slecht voor je tanden. Laat die suikerrijke hap dus liever links liggen en kies voor gezondere en vezelrijke alternatieven zoals groenten, fruit of noten. Let wel op je intoleranties en allergieÃ«n!",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER",
                                            "name": "Suiker",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "heel weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_SUIKER_VERYBAD",
                                                    "resultText": "Je eet 4 keer of meer per week zoetigheid.",
                                                    "keyWords": "veel te veel",
                                                    "advice": "Voor jou is het aangeraden om de suikerrijke voedingsproducten het liefst wat te minderen of te vermijden. Te veel van dat soort voedsel is namelijk slecht voor je lichaam. Een overvloed aan suiker kan je alvleesklier overbelasten, overgewicht veroorzaken en de kans op diabetes type 2 verhogen. Daarnaast is het, maar dat wist je hopelijk al, slecht voor je tanden. Laat die suikerrijke hap dus liever links liggen en kies voor gezondere en vezelrijke alternatieven zoals groenten, fruit of noten. ",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "30.0",
                                            "score": 30,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "30.0",
                                            "score": 30,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "30.0",
                                            "score": 30,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_BITTER",
                                    "name": "Bittere smaak",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "moeilijk te proeven",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER_MATIG",
                                                    "resultText": "Jouw DNA wijst uit dat je neutraal in staat bent om de smaak 'bitter' te proeven.",
                                                    "keyWords": "neutraal",
                                                    "advice": "Doordat je toch in staat bent om de smaak wat te proeven is de kans groot dat je bittere voedingsproducten links laat liggen. Toch is dat geen slim idee, want ze bevatten vaak belangrijke vitamines Ã©n helpen jouw zin in zoetigheid te verminderen. Het is niet zo moeilijk om te weten over welke voeding het gaat: het zijn de (donker)groene groenten zoals spinazie, broccoli, kolenâ¦ Wat Popeye zou eten dus! Je bent misschien geneigd om daar een hoop zout over te gooien om âde boel wat op smaak te brengenâ, maar hou jezelf wat in: te veel zout kan leiden tot een verhoogde bloeddruk.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_SNACKS",
                                    "name": "Snackgedrag",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS_HOOG",
                                                    "resultText": "Jij snakt naar snacks! Op basis van jouw DNA-resultaten blijkt namelijk dat jij een verhoogde neiging hebt om tussendoortjes te eten.",
                                                    "keyWords": "verhoogde neiging",
                                                    "advice": "Als we je een tip mogen geven: plan je maaltijden zo goed mogelijk in en probeer er geen te skippen. Zo zal je minder snel naar suikerrijke tussendoortjes zoals koeken, snoep of chocolade grijpen. Natuurlijk is het prima om af en toe een zak chips open te trekken, maar kies vooral voor gezondere en vezelrijke alternatieven zoals groenten, fruit of noten. Let uiteraard wel altijd op mogelijke intoleranties.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_TUSSENDOORTJES",
                                            "name": "Tussendoortjes",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "ongezond",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_TUSSENDOORTJES_ZEERSLECHT_1",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "ongezond",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_TUSSENDOORTJES_ZEERSLECHT_1",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_TUSSENDOORTJES_ZEERGOED",
                                                    "resultText": "Je eet voldoende tussendoortjes en je hebt aandacht voor de gezonde varianten. Keep up the good work.",
                                                    "keyWords": "goed",
                                                    "advice": "Blijf je inname van gezonde tussendoortjes volhouden om je lichaam van voldoende energie te voorzien gedurende de dag.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_VERZADIGING",
                                    "name": "Verzadiging",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "iets trager ervaren",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijker ervaren",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "iets trager ervaren",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijker ervaren",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING_HOOG",
                                                    "resultText": "Het DNA-onderzoek wijst uit dat jij niet snel een verzadigd gevoel hebt na het eten van een maaltijd.",
                                                    "keyWords": "moeilijker ervaren",
                                                    "advice": "Doordat jij minder snel het gevoel hebt verzadigd te zijn, is er een kans dat jij je overeet of snoept tussen maaltijden door. Let daar dus mee op en eet trager zodat je van je maaltijd kan genieten. Probeer daarnaast om zowel tijdens als tussen je maaltijden door te kiezen voor voedingsstoffen die een verzadigd gevoel opwekken. Denk bijvoorbeeld aan eiwitten of (vette) vis en voeding met trage koolhydraten, zoals volkorenproducten en peulvruchten.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_REGELMAAT",
                                    "name": "Regelmaat",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte nood",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge nood",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge nood",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte nood",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING_MATIG",
                                                    "resultText": "Uit jouw DNA-resultaten kunnen we opmaken dat een regelmatig eetpatroon zeer belangrijk is voor jou.",
                                                    "keyWords": "lichte nood",
                                                    "advice": "Op regelmatige tijdstippen eten is voor jou echt belangrijk. Hou daar dan ook rekening mee als je je dagelijkse maaltijden inplant. Af en toe kan je tijdelijk vasten, maar besteed toch aandacht aan regelmaat tijdens de periode waarin je eet.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_AANTALMAALTIJDEN",
                                            "name": "Aantal maaltijden",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_AANTALMAALTIJDEN_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "overslaan",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_AANTALMAALTIJDEN_ZEERSLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "overslaan",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_AANTALMAALTIJDEN_ZEERSLECHT",
                                                    "resultText": "Je aantal maaltijden is niet optimaal. Je slaat maaltijden over, wat niet altijd ten goede van je gezondheid komt. Je ontneemt je lichaam zijn brandstof. Het gevolg is dat je bloedsuikerspiegel daalt en je lichaam een tekort aan energie ervaart. Op termijn kan het overslaan van maaltijden leiden tot chronische ziektes.",
                                                    "keyWords": "overslaan",
                                                    "advice": "Om je lichaam goed te laten functioneren, kan je best drie gebalanceerde maaltijden per dag eten. Als het overslaan van maaltijden deel uitmaakt van een specifiek voedingspatroon, zoals intermittent fasting, moet je erop letten dat je tijdens de dag voldoende eet.",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_HYDRATATIE",
                                    "name": "Hydratatie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER",
                                            "name": "Inname water",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "minder dan 3",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERSLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "minder dan 3",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERSLECHT",
                                                    "resultText": "Jij drinkt minder dan 3 glazen water doorheen de dag.",
                                                    "keyWords": "minder dan 3",
                                                    "advice": "Dat is te weinig. Probeer je aantal glazen per dag geleidelijk aan op te drijven. In het ideale geval zou je acht of meer glazen per dag drinken.",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse leiden we af dat je tijdens het sporten last kan hebben van overmatig zweten.",
                                                    "keyWords": "verhoogde nood",
                                                    "advice": "Doordat jij van nature de neiging hebt om tijdens het sporten extra te zweten, raden we je aan om dagelijks minstens 1,5 liter water te drinken. Bij matige lichaamsbeweging zoals joggen of fietsen drink je beter wat extra. Ben je van plan om intensiever en langer te sporten? Drink dan voor, tijdens Ã©n na het sporten extra water om uitdroging te voorkomen. Per uur intensief sporten raden we een liter water aan.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_KANTENKLAAR",
                                    "name": "Kant-en-klare maaltijden",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR",
                                            "name": "Kant-en-klare voeding",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "bijna nooit",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "af en toe",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_KANT_EN_KLAAR_BAD",
                                                    "resultText": "Je eet 1 of 2 keer per week een kant-en-klaarmaaltijd.",
                                                    "keyWords": "vaak",
                                                    "advice": "Kant-en-klaarmaaltijden zijn niet per definitie ongezond, maar je haalt er doorgaans niet de dagelijkse aanbevolen hoeveelheid groenten mee. Zo veel mogelijk vers koken en zo weinig mogelijk verwerkte producten eten blijft de beste keuze. ",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 24.494638375541868,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_VLEESENVLEESVERVANGERS",
                                    "name": "Vlees en vleesvervangers",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_VLEES",
                                            "name": "Inname vlees en vleesvervangers",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_VLEES_ZEERSLECHT_3",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_VLEES_ZEERSLECHT_3",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "niet genoeg",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_VLEES_MATIG_2",
                                                    "resultText": "Jij eet alleen vleesvervangers, maar niet vaak genoeg.",
                                                    "keyWords": "niet genoeg",
                                                    "advice": "Probeer elke dag een portie proteÃ¯nerijke vleesvervangers te eten. Zet ze daarom geleidelijk aan vaker op het menu. ",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_VIS",
                                    "name": "Vis",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_VIS",
                                            "name": "Inname vis",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "te weinig variatie",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_VIS_MATIG",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_VIS_ZEERSLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "te weinig variatie",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_VIS_MATIG",
                                                    "resultText": "Jij eet te weinig vis of je kiest nooit voor de vette soorten zoals zalm en makreel.",
                                                    "keyWords": "te weinig variatie",
                                                    "advice": "Probeer 2 keer per week (vette) vis op het menu te zetten. Vette vis, zoals zalm, haring en makreel, heeft een positief effect op je gezondheid. ",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 36,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_GROENTEN",
                                    "name": "Groenten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GROENTEN",
                                            "name": "Inname groenten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GROENTEN_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GROENTEN_ZEERSLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "te weinig variatie",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GROENTEN_MATIG",
                                                    "resultText": "Jij eet te weinig groenten of varieert te weinig tussen verschillende soorten groenten.",
                                                    "keyWords": "te weinig variatie",
                                                    "advice": "Probeer je dagelijkse porties te vergroten of vaker groenten te eten. Kies ook voor voldoende variatie, want elke groente heeft haar eigen gezondheidsvoordelen.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_FRUIT",
                                    "name": "Fruit",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_FRUIT",
                                            "name": "Inname fruit",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_FRUIT_ZEERSLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "te weinig variatie",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_FRUIT_MATIG",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "te weinig variatie",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_FRUIT_MATIG",
                                                    "resultText": "Uit je antwoorden blijkt dat je te weinig fruit eet, ofwel varieer je te weinig tussen verschillende soorten fruit.",
                                                    "keyWords": "te weinig variatie",
                                                    "advice": "Probeer je dagelijkse porties fruit te vergroten of vaker fruit te eten. Ga bovendien voor genoeg variatie in je fruit. Elke soort fruit heeft haar eigen gezondheidsvoordelen. ",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_GRANEN",
                                    "name": "Granen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GRANEN",
                                            "name": "Inname granen",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GRANEN_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "niet optimaal",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GRANEN_MATIG",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "niet goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GRANEN_ZEERSLECHT",
                                                    "resultText": "Jij eet te veel of te weinig porties granen per dag. Bovendien kies je altijd voor de ongezonde ongeraffineerde variant.",
                                                    "keyWords": "niet goed",
                                                    "advice": "Je kiest beter voor de volkorenvariant ofwel pas je best je aantal porties per dag of je portiegrootte aan. ",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_ZUIVEL",
                                    "name": "Zuivel",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_ZUIVEL",
                                            "name": "Inname zuivel",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "niet optimaal",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_ZUIVEL_MATIG_1",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "niet optimaal",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_ZUIVEL_MATIG_2",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te weinig en/of te zoet",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_ZUIVEL_ZEERSLECHT_2",
                                                    "resultText": "Jij drinkt weinig plantaardige dranken en kiest vaak voor de gezoete variant.",
                                                    "keyWords": "te weinig en/of te zoet",
                                                    "advice": "Probeer voor de ongezoete variant te kiezen en vaker plantaardige dranken te drinken. Er bestaan tal van soorten om uit te kiezen en af te wisselen: zo is er haverdrink, kokosdrink en soyadrink. Maar wist je dat er ook erwtendrink en rijstdrink bestaan? Soja- of erwtendrink verrijkt met calcium, vitamine B2 en vitamine B12 zijn de meest volwaardige vervanger, omdat hier ook meer eiwit in zit in vergelijking met andere verrijkte zuivelalternatieven.",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 36,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_OLIE",
                                    "name": "OliÃ«n",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_OLIEN",
                                            "name": "Gebruik smeer- en bereidingsvetten",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "varieer meer",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_OLIEN_MATIG",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "varieer meer",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_OLIEN_MATIG",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "niet goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_OLIEN_ZEERSLECHT",
                                                    "resultText": "Jij kiest bij de vetstoffen vaak voor een ongezonde variant en gebruikt te grote porties.",
                                                    "keyWords": "niet goed",
                                                    "advice": "Probeer altijd voor de gezonde variant van olie, dus plantaardige olie met uitzondering van kokosolie en palmolie, te kiezen en vetstoffen met mate te gebruiken. ",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 36,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_EETPATROON",
                                    "name": "Eetpatroon",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_ALGEMEEN",
                                            "name": "Eetpatroon",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "niet optimaal",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_ALGEMEEN_MATIG",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "onregelmatig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_ALGEMEEN_SLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "niet optimaal",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_EETPATROON_ALGEMEEN_MATIG",
                                                    "resultText": "Jouw eetpatroon is niet optimaal. Je eet te veel tussendoortjes of kiest te vaak voor ongezonde tussendoortjes, of je eet meer/minder maaltijden dan aangewezen is.",
                                                    "keyWords": "niet optimaal",
                                                    "advice": "Probeer te letten op een goede balans tussen je hoofdmaaltijden en tussendoortjes. Een gezond eetpatroon bestaat uit dagelijks drie hoofdmaaltijden en twee tot drie tussendoortje tussen die hoofdmaaltijden door.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 36,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_EETGEDRAG_BURNEDCAL",
                                    "name": "Verbrande kcal",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                            "name": "Gemiddelde hoeveelheid verbruikte kcal",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2040,
                                                    "intValue": 2040,
                                                    "stringValue": "2040",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2035,
                                                    "intValue": 2035,
                                                    "stringValue": "2035",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2028,
                                                    "intValue": 2028,
                                                    "stringValue": "2028",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2241,
                                                    "intValue": 2241,
                                                    "stringValue": "2241",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2024,
                                                    "intValue": 2024,
                                                    "stringValue": "2024",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "resultText": "Gemiddelde hoeveelheid verbruikte kcal",
                                                    "advice": "Je dagelijkse calorieverbruik bestaat uit twee componenten: de calorieÃ«n die je verbrandt tijdens beweging en de calorieÃ«n die je verbrandt in rust. Krijg je meer calorieÃ«n binnen dan dat je verbruikt? Dan kom je aan. En verbruik je meer calorieÃ«n dan je dat je er binnenkrijgt? Dan val je af. Om je totale calorieverbruik te optimaliseren, is het belangrijk om zowel regelmatig te bewegen als een gezond basaalmetabolisme te ondersteunen. Dit betekent dat je actief moet blijven om calorieÃ«n te verbranden en tegelijkertijd je rustmetabolisme moet ondersteunen. Dit kan worden bereikt door een combinatie van lichaamsbeweging, een gezond voedingspatroon, voldoende slaap en effectief stressmanagement.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.1",
                                    "score": 6.102941176470588,
                                    "maxScore": 10,
                                    "goalScore": 9.779411764705882,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 28.843373493975903,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.5",
                                    "score": 3.5294117647058822,
                                    "maxScore": 10,
                                    "goalScore": 9.779411764705882,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 43.369609856262834,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.161764705882353,
                                    "maxScore": 10,
                                    "goalScore": 9.779411764705882,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 43.37234770704997,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.161764705882353,
                                    "maxScore": 10,
                                    "goalScore": 9.779411764705882,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 43.380561259411365,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.8",
                                    "score": 2.8308823529411766,
                                    "maxScore": 10,
                                    "goalScore": 9.632352941176471,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 43.432580424366876,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.9",
                                    "score": 2.8676470588235294,
                                    "maxScore": 10,
                                    "goalScore": 9.669117647058824,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 43.44079397672827,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.9",
                                    "score": 2.8676470588235294,
                                    "maxScore": 10,
                                    "goalScore": 9.669117647058824,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 43.4435318275154,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.9",
                                    "score": 2.8676470588235294,
                                    "maxScore": 10,
                                    "goalScore": 9.669117647058824,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 43.44900752908967,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.9",
                                    "score": 2.8676470588235294,
                                    "maxScore": 10,
                                    "goalScore": 9.669117647058824,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 43.48733744010951,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.9",
                                    "score": 2.8676470588235294,
                                    "maxScore": 10,
                                    "goalScore": 9.669117647058824,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 43.49828884325804,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.9",
                                    "score": 2.8676470588235294,
                                    "maxScore": 10,
                                    "goalScore": 9.669117647058824,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 43.709103353867214,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.9",
                                    "score": 2.8676470588235294,
                                    "maxScore": 10,
                                    "goalScore": 9.669117647058824,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 43.74469541409994,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.9",
                                    "score": 2.8676470588235294,
                                    "maxScore": 10,
                                    "goalScore": 9.669117647058824,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 43.747433264887064,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_FOOD_INTOL",
                            "name": "Overgevoeligheden",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_FOOD_INTOL_GLUTEN",
                                    "name": "Gluten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN_HOOG",
                                                    "resultText": "In jouw DNA-onderzoek vonden we meerdere variaties in jouw genen die aanleiding kunnen geven tot een slechte vertering van gluten. Dat betekent dat de kans bestaat dat jouw lichaam het moeilijker heeft om gluten te verteren.",
                                                    "keyWords": "zeer gevoelig",
                                                    "advice": "Gluten binnenspelen is op basis van je DNA niet ideaal voor jouw lichaam. Typische klachten die jij misschien herkent, zijn diarree, buikpijn, vermoeidheid, neerslachtigheid en gewichtsverlies. Vaak komen die op of worden die erger bij volwassenen tussen 30 en 50 jaar. We raden jou aan om over te schakelen op een glutenvrij dieet. Dat betekent dat je bepaalde granen en graanproducten voortaan beter links laat liggen. Pas wel op, want veel graanproducten zoals brood en pasta bevatten voedingsvezels, ijzer, vitamine B1 en foliumzuur. Zorg er dus voor dat je die stoffen toch voldoende binnenkrijgt!",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_COELIAKIE_GLUTEN",
                                            "name": "Gluten",
                                            "unit": "U/ml",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<3.0",
                                                    "tag": "RESULT_BLOOD_VOEDING_COELIAKIE_GLUTEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<3.0",
                                                    "tag": "RESULT_BLOOD_VOEDING_COELIAKIE_GLUTEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<3.0",
                                                    "tag": "RESULT_BLOOD_VOEDING_COELIAKIE_GLUTEN_NORMAAL",
                                                    "resultText": "Je anti-tTG IgA-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "In de test merken we geen antistoffen tegen gluten. Dat betekent dat de kans op coeliakie of glutenintolerantie bij jou heel klein is. Blijf je toch last hebben van bepaalde klachten zoals een opgezwollen buik, diarree, hoofdpijn of vermoeidheid? Ga dan zeker raad vragen bij je (huis)arts.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_INTOL_LACTOSE",
                                    "name": "Lactose",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE_HOOG",
                                                    "resultText": "Uit de analyse van jouw genen blijkt dat de kans bestaat dat je lactose-intolerant bent. Dat betekent dat jouw lichaam gevoelig kan reageren bij opname van lactose. Typische klachten die daarbij komen kijken en die jij misschien herkent, zijn braken, krampen, diarree of winderigheid.",
                                                    "keyWords": "zeer gevoelig",
                                                    "advice": "Jouw lichaam geeft een duidelijk signaal: het vindt lactose niet fijn. In jouw geval is het aangewezen over te schakelen op een lactosevrij voedingspatroon of dieet. Kies daarbij voor plantaardige alternatieven voor zuivel zoals amandel- of rijstmelk.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_INTOL_CAFEINE",
                                    "name": "CafeÃ¯ne",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE",
                                            "name": "Verwerking cafeÃ¯ne",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "snel",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "snel",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "snel",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                                    "resultText": "Volgens jouw DNA-analyse ben je een 'fast metabolizer' als het aankomt op de verwerking van cafeÃ¯ne. Jij breekt cafeÃ¯ne met andere woorden heel snel af.",
                                                    "keyWords": "snel",
                                                    "advice": "CafeÃ¯ne kan helpen om je sport- en mentale prestaties te optimaliseren. Jouw lichaam is dan misschien wel in staat om cafeÃ¯ne snel af te breken, dat betekent nog altijd niet dat je kan overdrijven. Het advies van de Hoge Gezondheidsraad is om als gezonde volwassene per dag maximaal 5,7 mg cafeÃ¯ne per kg lichaamsgewicht binnen te krijgen. Een persoon van 60 kg mag dus hoogstens 340 mg cafeÃ¯ne per dag opnemen. Wanneer je een doorsnee kopje koffie van 80 mg cafeÃ¯ne neemt, komt dat dus neer op maximaal 4 koppen per dag.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_INTOL_ZOUT",
                                    "name": "Zout",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_LAAG",
                                                    "resultText": "Uit jouw DNA-analyse kunnen we opmaken dat je beschikt over een normale gevoeligheid voor zout. Er is voor jou geen grotere kans op verhoogde bloeddruk als je een normale hoeveelheid zout eet.",
                                                    "keyWords": "weinig gevoelig",
                                                    "advice": "Hou je aan de normale hoeveelheid zout. Voor een volwassene bedraagt die minder dan 5 gram zout (2000 milligram natrium), de aanbevolen hoeveelheid kalium per dag is 3510 milligram.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM",
                                            "name": "Natrium",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 142,
                                                    "intValue": 142,
                                                    "stringValue": "142",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 141,
                                                    "intValue": 141,
                                                    "stringValue": "141",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 143,
                                                    "intValue": 143,
                                                    "stringValue": "143",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 2,
                                                    "intValue": 2,
                                                    "stringValue": "2",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM_LAAG",
                                                    "resultText": "Je natriumwaarden zijn licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Het gebeurt niet vaak dat iemand een tekort aan natrium heeft. Doordat het in bijna al onze voeding zit, krijg je al snel voldoende binnen. Zelfs mensen met een zoutarm dieet krijgen vaak alsnog voldoende natrium via hun voeding binnen. Een tekort aan zout kan ontstaan als gevolg van uitdroging door ernstige diarree of hevig braken.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN",
                                            "name": "Hart- en vaataandoeningen",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale kans",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_GOED_1_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116321992
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125631427
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "resultText": "Je risico op hart- en vaatziekten is verhoogd omdat bij jou al een hart- en vaatziekte werd vastgesteld.",
                                                    "keyWords": "aandoening aanwezig",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1721056884600
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "160.0",
                                            "score": 160,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 160,
                                            "goalScore": 155,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 160,
                                            "goalScore": 160,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.6",
                                    "score": 9.583333333333334,
                                    "maxScore": 10,
                                    "goalScore": 9.583333333333334,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.416666666666667,
                                    "maxScore": 10,
                                    "goalScore": 9.583333333333334,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 32.5025009213921,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.416666666666667,
                                    "maxScore": 10,
                                    "goalScore": 9.583333333333334,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 32.50734481124625,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.416666666666667,
                                    "maxScore": 10,
                                    "goalScore": 9.583333333333334,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 32.52187648080872,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.6",
                                    "score": 4.583333333333333,
                                    "maxScore": 10,
                                    "goalScore": 8.75,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 35.19208512226994,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.0",
                                    "score": 5,
                                    "maxScore": 10,
                                    "goalScore": 9.166666666666666,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 33.81063198722335,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.5",
                                    "score": 3.5416666666666665,
                                    "maxScore": 10,
                                    "goalScore": 9.166666666666666,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 43.4435318275154,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.5",
                                    "score": 3.5416666666666665,
                                    "maxScore": 10,
                                    "goalScore": 9.166666666666666,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 43.44900752908967,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.5",
                                    "score": 3.5416666666666665,
                                    "maxScore": 10,
                                    "goalScore": 9.166666666666666,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 43.48733744010951,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.5",
                                    "score": 3.5416666666666665,
                                    "maxScore": 10,
                                    "goalScore": 9.166666666666666,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 43.49828884325804,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.5",
                                    "score": 3.5416666666666665,
                                    "maxScore": 10,
                                    "goalScore": 9.166666666666666,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 43.709103353867214,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.5",
                                    "score": 3.5416666666666665,
                                    "maxScore": 10,
                                    "goalScore": 9.166666666666666,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 43.74469541409994,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.5",
                                    "score": 3.5416666666666665,
                                    "maxScore": 10,
                                    "goalScore": 9.166666666666666,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 43.747433264887064,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_FOOD_MIDDELEN",
                            "name": "Middelen",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_FOOD_MIDDELEN_ALCOHOL",
                                    "name": "Alcohol",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING",
                                            "name": "DNA alcholverslaving",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING_HOOG",
                                                    "resultText": "Op basis van jouw DNA-resultaten kunnen we concluderen dat de kans op een alcoholverslaving zeker aanwezig is. Wees dus uiterst waakzaam zodat jij niet afhankelijk van alcohol wordt: overdadig alcoholgebruik is gevaarlijk, verslavend Ã©n schadelijk voor de gezondheid.",
                                                    "keyWords": "hoge kans",
                                                    "advice": "Jouw genetische gevoeligheid om afhankelijk te zijn van alcohol is hoog. Daarom is alcohol volledig links laten liggen in jouw geval de beste optie. Merk je dat je afhankelijk bent van alcohol, probeer dan hulp in te schakelen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_ALCOHOL",
                                            "name": "Alcoholgebruik",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_ALCOHOL_ZEERGOED_1",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116232664
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "af en toe te hoog",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_ALCOHOL_MATIG",
                                                    "resultText": "Op basis van je antwoorden komt naar voor dat het aantal alcohol consumpties af en toe te hoog ligt of dat alcohol te frequent aan bod komt.",
                                                    "keyWords": "af en toe te hoog",
                                                    "advice": "Je alcoholgebruik ligt net boven de aanbevelingen van een evenwichtig alcoholverbruik. Op alcoholafhankelijkheid scoor je jezelf laag. Ga na voor jezelf of je je hierin kan vinden. Indien je dringende vragen of klachten hebt, neem dan contact op met je huisarts of psycholoog.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125534944
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_GGT",
                                            "name": "GGT",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 11,
                                                    "intValue": 11,
                                                    "stringValue": "11",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_GGT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 15,
                                                    "intValue": 15,
                                                    "stringValue": "15",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_GGT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_GGT_NORMAAL",
                                                    "resultText": "Je gamma-GT-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "De aanwezigheid van gamma-GT in het bloed is normaal gesproken laag. Een gezonde levensstijl en geen overmatig alcoholgebruik kunnen je helpen deze waarden zo laag mogelijk te houden.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_AST",
                                            "name": "AST",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 25,
                                                    "intValue": 25,
                                                    "stringValue": "25",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_AST_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 23,
                                                    "intValue": 23,
                                                    "stringValue": "23",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_AST_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 19,
                                                    "intValue": 19,
                                                    "stringValue": "19",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_AST_NORMAAL",
                                                    "resultText": "Je AST-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Er zijn een aantal zaken die je kan doen om je AST-waarden te beÃ¯nvloeden:\n\n * Beperk je alcoholgebruik. Alcoholmisbruik zal namelijk leiden tot een toename van je AST omdat ethanol giftig is voor levercellen en die beschadigt. Af en toe wat alcohol drinken (wijn, bier, highballs of cocktails) zal geen aanzienlijke invloed hebben op je AST of andere leverenzymen. Toch zal regelmatig gematigd drinken (meer dan een paar glazen per dag) of doorzakken in het weekend zeker een impact hebben op je enzymniveaus. \n  * Probeer een supplement met kurkumapoeder. Het is het meest klinisch geteste kruid, want het is een krachtige ontstekingsremmer en antioxidant die veel organen in het lichaam helpt genezen, inclusief je lever. De meest geneeskrachtige stof in kurkuma is curcumine, waarvan is aangetoond dat die een hoog leverenzymniveau (ALT en AST) bij zowel dieren als mensen kan verminderen. De benodigde hoeveelheden om een duidelijke impact te hebben op leverenzymen zijn ongeveer 3000 mg per dag, maximaal 12 weken lang.\n  * Drink af en toe wat koffie. Onderzoek uit 2014 heeft uitgewezen dat het regelmatig drinken van matige hoeveelheden gewone of cafeÃ¯nevrije koffie de gezondheid van de lever kan verbeteren en circulatie van leverenzymen, zoals AST, kan doen afnemen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_ALT",
                                            "name": "ALT",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 18,
                                                    "intValue": 18,
                                                    "stringValue": "18",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_ALT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_ALT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_ALT_NORMAAL",
                                                    "resultText": "Je ALT-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Om je ALT-waarde normaal te houden is een gezonde levensstijl belangrijk. Dit zijn enkele zaken die je kan doen:\n\n * Drink zo weinig mogelijk alcohol. Overmatig alcoholgebruik is de meest voorkomende oorzaak van leverschade, maar zelfs matige alcoholconsumptie kan de levercellen na verloop van tijd al beschadigen.\n  * Beperk het eten van fastfood. Veel suiker en vet is slecht voor de lever, dus als je dat laat staan wordt je lever gezonder en verlaag je je ALT-waarde.\n  * Eet meer groenten en fruit, want die ontgiften het lichaam op natuurlijke wijze. Terwijl ze dat doen, komt er minder druk te staan op de lever, waardoor die beter kan herstellen en je ALT-waarde omlaag gaat. \n  * Wees voorzichtig met het nemen van supplementen. Hoewel er kruidenmiddelen zijn waarvan wordt gezegd dat ze de lever gezonder maken en de ALT-waarde verbeteren, is er meestal weinig wetenschappelijk bewijs dat ze werken. Sommige kruidenmiddelen en supplementen kunnen zelfs schadelijk zijn voor de lever en de ALT-waarde verslechteren.\n  * Beweeg regelmatig. Door beweging verbetert je algehele gezondheid, dus als je regelmatig aan cardiovasculaire en aerobe beweging doet, verbetert dat ook de gezondheid van je lever en je ALT-waarde.\n  * Stop met roken, indien van toepassing. Chemische toevoegingen in sigaretten bevatten gifstoffen die de levercellen beschadigen als je lever ze probeert te filteren. Als je stopt met roken wordt je lever sterker en daalt je ALT-waarde.\n  * Vermijd chemische stoffen in je omgeving. Veel huishoudelijke schoonmaakmiddelen bevatten ook allerlei gifstoffen die de lever kunnen beschadigen, dus probeer zo min mogelijk aan deze stoffen bloot te staan als je je lever gezonder wil maken en je ALT-waarde wil verlagen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_MCV",
                                            "name": "MCV",
                                            "unit": "fl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 92.2,
                                                    "stringValue": "92.2",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_MCV_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 89.4,
                                                    "stringValue": "89.4",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_MCV_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 96.8,
                                                    "stringValue": "96.8",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_MCV_NORMAAL",
                                                    "resultText": "Je MCV is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Jouw rode bloedcellen hebben een normale grootte. Toch kan je met een normale MCV bloedarmoede hebben als er te weinig rode bloedcellen zijn of als andere RBC-indices abnormaal zijn.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_HEMOGLOBINE",
                                            "name": "Hemoglobine",
                                            "unit": "g/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 13.7,
                                                    "stringValue": "13.7",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_HEMOGLOBINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 15.1,
                                                    "stringValue": "15.1",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_HEMOGLOBINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 15.3,
                                                    "stringValue": "15.3",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_HEMOGLOBINE_NORMAAL",
                                                    "resultText": "Je hemoglobinewaarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Een gezond en gevarieerd voedingspatroon helpt je bij normale hemoglobinewaarden. Zorg steeds voor: \n\n  * Voldoende inname van vitamines en mineralen zoals ijzer, foliumzuur en vitamine C.\n  * Drink voldoende water\n  * Overdrijf niet in het gebruik van cafeÃ¯nehoudende dranken\n\nMannen streven het best naar waarden tussen de 14 Ã  16g/dl en vrouwen tussen de 13 Ã  14g/dl.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_URINEZUUR",
                                            "name": "Urinezuur",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 3.8,
                                                    "stringValue": "3.8",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_URINEZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.8,
                                                    "stringValue": "4.8",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_URINEZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.1,
                                                    "stringValue": "4.1",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_URINEZUUR_NORMAAL",
                                                    "resultText": "Je urinezuurwaarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Wat je eet, bevat vaak purinehoudende voedingsstoffen die kunnen bijdragen tot een verhoging van het urinezuur. Door je dieet te wijzigen kan je de productie van urinezuur dus verlagen! We kunnen voeding opdelen in drie categorieÃ«n:\n\n * Voedsel met een hoog purinegehalte: wild, gans, sardines, haring, ansjovis, forel, zalm, kabeljauw, zeevruchten (kreeft, mosselen, oesters), orgaanvlees, peulvruchten en spinazie.\n  * Voedsel met een gemiddeld purinegehalte: konijn, schaap, rund, kalf, duif, kalkoen, eend, schaaldieren, asperges, paddenstoelen en bloemkool.\n  * Voedsel waarin weinig of geen purines zitten: fruit, melk, kaas, bladgroenten, eieren, rijst, deegwaren, granen, brood, aardappelen en jam of confituur.\n\nDrink ook voldoende water. Gesuikerde dranken, ook de lightvarianten, geven namelijk een verhoogd urinezuurgehalte in je bloed.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "305.0",
                                            "score": 305,
                                            "maxScore": 310,
                                            "goalScore": 305,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "355.0",
                                            "score": 355,
                                            "maxScore": 410,
                                            "goalScore": 405,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 20.958440581889697,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "355.0",
                                            "score": 355,
                                            "maxScore": 410,
                                            "goalScore": 405,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 20.96156404546375,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "355.0",
                                            "score": 355,
                                            "maxScore": 410,
                                            "goalScore": 405,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 20.970934436185907,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "355.0",
                                            "score": 355,
                                            "maxScore": 410,
                                            "goalScore": 405,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 21.030280244092896,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "355.0",
                                            "score": 355,
                                            "maxScore": 410,
                                            "goalScore": 405,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 21.03965063481505,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "350.0",
                                            "score": 350,
                                            "maxScore": 410,
                                            "goalScore": 400,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 21.079886574753107,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "350.0",
                                            "score": 350,
                                            "maxScore": 410,
                                            "goalScore": 400,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 21.086144519409405,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "350.0",
                                            "score": 350,
                                            "maxScore": 410,
                                            "goalScore": 400,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 21.129950132003522,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "350.0",
                                            "score": 350,
                                            "maxScore": 410,
                                            "goalScore": 400,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 21.142466021316125,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "350.0",
                                            "score": 350,
                                            "maxScore": 410,
                                            "goalScore": 400,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 21.38339689058375,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "350.0",
                                            "score": 350,
                                            "maxScore": 410,
                                            "goalScore": 400,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 21.42407353084971,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "350.0",
                                            "score": 350,
                                            "maxScore": 410,
                                            "goalScore": 400,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 21.42720250317786,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_FOOD_MIDDELEN_CAFEINE",
                                    "name": "CafeÃ¯ne",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE",
                                            "name": "Verwerking cafeÃ¯ne",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "snel",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "snel",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "snel",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                                    "resultText": "Volgens jouw DNA-analyse ben je een 'fast metabolizer' als het aankomt op de verwerking van cafeÃ¯ne. Jij breekt cafeÃ¯ne met andere woorden heel snel af.",
                                                    "keyWords": "snel",
                                                    "advice": "CafeÃ¯ne kan helpen om je sport- en mentale prestaties te optimaliseren. Jouw lichaam is dan misschien wel in staat om cafeÃ¯ne snel af te breken, dat betekent nog altijd niet dat je kan overdrijven. Het advies van de Hoge Gezondheidsraad is om als gezonde volwassene per dag maximaal 5,7 mg cafeÃ¯ne per kg lichaamsgewicht binnen te krijgen. Een persoon van 60 kg mag dus hoogstens 340 mg cafeÃ¯ne per dag opnemen. Wanneer je een doorsnee kopje koffie van 80 mg cafeÃ¯ne neemt, komt dat dus neer op maximaal 4 koppen per dag.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE",
                                            "name": "DNA cafeÃ¯ne en slaap",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_LAAG",
                                                    "resultText": "Volgens jouw DNA-analyse breek jij cafeÃ¯ne zeer snel af. Daarom zal jij weinig tot geen effect ervaren als je vlak voor het slapen cafeÃ¯ne inneemt.",
                                                    "keyWords": "weinig hinder",
                                                    "advice": "Als slaapmutsje kan een koffie of een ander drankje dat cafeÃ¯ne bevat in jouw geval geen kwaad. Het zal jou niet nodeloos wakker houden, maar overdrijf er ook niet mee.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE",
                                            "name": "DNA cafeÃ¯ne en sport",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "minder gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_LAAG",
                                                    "resultText": "Op basis van jouw DNA-analyse blijkt dat jij cafeÃ¯ne snel afbreekt.",
                                                    "keyWords": "gunstig effect",
                                                    "advice": "Omdat jij cafeÃ¯ne snel afbreekt, kan je een maximaal voordeel halen uit cafeÃ¯ne door die minder dan een uur voor de aanvang van jouw training of wedstrijd in te nemen. Afhankelijk van hoelang je sport, kan je tijdens de training of wedstrijd extra cafeÃ¯ne innemen.\n\nHet is heel simpel om te berekenen hoeveel cafeÃ¯ne je nodig hebt om effect te ervaren. De ondergrens ligt op 3 mg/kg lichaamsgewicht, de bovengrens op 6 mg/kg. Wanneer je die bovengrens overschrijdt, verdwijnen de voordelen en ervaar je nadelen.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_CAFEINE",
                                            "name": "CafeÃ¯negebruik",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed evenwicht",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_CAFEINE_ZEERGOED_1",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116232664
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed evenwicht",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_CAFEINE_ZEERGOED_1",
                                                    "resultText": "Op basis van je antwoorden blijkt dat je huidige inname van cafeÃ¯ne onder je persoonlijk aanvaardbare grens (5,7 mg x lichaamsgewicht) per dag ligt.",
                                                    "keyWords": "goed evenwicht",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125534944
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "30.0",
                                            "score": 30,
                                            "maxScore": 30,
                                            "goalScore": 30,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 130,
                                            "goalScore": 110,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 130,
                                            "goalScore": 130,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.9",
                                    "score": 9.852941176470589,
                                    "maxScore": 10,
                                    "goalScore": 9.852941176470589,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.0",
                                    "score": 8.981481481481481,
                                    "maxScore": 10,
                                    "goalScore": 9.907407407407407,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 20.264894119971494,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.0",
                                    "score": 8.981481481481481,
                                    "maxScore": 10,
                                    "goalScore": 9.907407407407407,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 20.267914223417094,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.0",
                                    "score": 8.981481481481481,
                                    "maxScore": 10,
                                    "goalScore": 9.907407407407407,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 20.27697453375389,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.61111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.537037037037036,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 20.41609444113253,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.0",
                                    "score": 8.981481481481481,
                                    "maxScore": 10,
                                    "goalScore": 9.907407407407407,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 20.343416809557073,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.88888888888889,
                                    "maxScore": 10,
                                    "goalScore": 9.814814814814815,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 20.366244581336986,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.88888888888889,
                                    "maxScore": 10,
                                    "goalScore": 9.814814814814815,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 20.3722906684919,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.88888888888889,
                                    "maxScore": 10,
                                    "goalScore": 9.814814814814815,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 20.41461327857632,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.88888888888889,
                                    "maxScore": 10,
                                    "goalScore": 9.814814814814815,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 20.42670545288615,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.88888888888889,
                                    "maxScore": 10,
                                    "goalScore": 9.814814814814815,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 20.659479808350444,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.88888888888889,
                                    "maxScore": 10,
                                    "goalScore": 9.814814814814815,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 20.698779374857402,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.88888888888889,
                                    "maxScore": 10,
                                    "goalScore": 9.814814814814815,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 20.70180241843486,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        }
                    ],
                    "results": [],
                    "scoreResult": [
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "8.6",
                            "score": 8.599420049710025,
                            "maxScore": 10,
                            "goalScore": 9.64098315382491,
                            "realAge": 27.211498973305954,
                            "leadlifeAge": 20.180162820945135,
                            "goalAge": 18,
                            "time": 1672613999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.5",
                            "score": 6.513708613335789,
                            "maxScore": 10,
                            "goalScore": 9.651876400012274,
                            "realAge": 28.369609856262834,
                            "leadlifeAge": 27.22172990433935,
                            "goalAge": 18.3709787816564,
                            "time": 1709161199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.4",
                            "score": 6.440179201571081,
                            "maxScore": 10,
                            "goalScore": 9.651876400012274,
                            "realAge": 28.372347707049965,
                            "leadlifeAge": 27.5366315741544,
                            "goalAge": 18.373716632443532,
                            "time": 1709247599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.4",
                            "score": 6.440179201571081,
                            "maxScore": 10,
                            "goalScore": 9.651876400012274,
                            "realAge": 28.380561259411362,
                            "leadlifeAge": 27.548941199355184,
                            "goalAge": 18.38193018480493,
                            "time": 1709506799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.8",
                            "score": 5.765131639510264,
                            "maxScore": 10,
                            "goalScore": 9.362116051428396,
                            "realAge": 28.432580424366872,
                            "leadlifeAge": 29.93527015339248,
                            "goalAge": 18.43394934976044,
                            "time": 1711148399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.871068458682378,
                            "maxScore": 10,
                            "goalScore": 9.46805287060051,
                            "realAge": 28.44079397672827,
                            "leadlifeAge": 29.740987459836948,
                            "goalAge": 18.442162902121833,
                            "time": 1711407599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.3",
                            "score": 5.291896805670625,
                            "maxScore": 10,
                            "goalScore": 9.455057688176993,
                            "realAge": 28.4435318275154,
                            "leadlifeAge": 32.955593632244444,
                            "goalAge": 18.444900752908968,
                            "time": 1711493999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.3",
                            "score": 5.291896805670625,
                            "maxScore": 10,
                            "goalScore": 9.455057688176993,
                            "realAge": 28.449007529089666,
                            "leadlifeAge": 32.965377094804104,
                            "goalAge": 18.45037645448323,
                            "time": 1711666799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.3",
                            "score": 5.291896805670625,
                            "maxScore": 10,
                            "goalScore": 9.455057688176993,
                            "realAge": 28.487337440109513,
                            "leadlifeAge": 33.03386133272179,
                            "goalAge": 18.48870636550308,
                            "time": 1712872799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.3",
                            "score": 5.291896805670625,
                            "maxScore": 10,
                            "goalScore": 9.455057688176993,
                            "realAge": 28.49828884325804,
                            "leadlifeAge": 33.05342825784113,
                            "goalAge": 18.49965776865161,
                            "time": 1713218399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.3",
                            "score": 5.291896805670625,
                            "maxScore": 10,
                            "goalScore": 9.455057688176993,
                            "realAge": 28.709103353867214,
                            "leadlifeAge": 33.43009156638838,
                            "goalAge": 18.71047227926078,
                            "time": 1719871199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.3",
                            "score": 5.291896805670625,
                            "maxScore": 10,
                            "goalScore": 9.455057688176993,
                            "realAge": 28.744695414099933,
                            "leadlifeAge": 33.49368407302622,
                            "goalAge": 18.746064339493497,
                            "time": 1720994399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.3",
                            "score": 5.291896805670625,
                            "maxScore": 10,
                            "goalScore": 9.455057688176993,
                            "realAge": 28.747433264887064,
                            "leadlifeAge": 33.49857580430606,
                            "goalAge": 18.748802190280628,
                            "time": 1721080799000
                        }
                    ]
                },
                {
                    "tag": "DASHBOARD_MOVE",
                    "name": "DASHBOARD_MOVE",
                    "groups": [
                        {
                            "tag": "DASHBOARD_MOVE_GEWOONTEN",
                            "name": "Jouw beweeggewoonten",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_MOVE_GEWOONTEN_DAGELIJKS",
                                    "name": "Dagelijkse activiteiten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_LICHT",
                                            "name": "Jouw dagelijkse activiteiten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_LICHT_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_LICHT_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117071154
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_LICHT_ZEERGOED",
                                                    "resultText": "Goed bezig! Op basis van jouw antwoorden blijkt dat je het grootste deel van je wakkere dag beweegt.  ",
                                                    "keyWords": "goed bezig",
                                                    "advice": "Blijf je beweeggewoonten volhouden. Idealiter voer je dagelijks minimaal 30 minuten licht intensieve beweging uit.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709129381796
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_STEPS",
                                            "name": "Gemiddeld aantal stappen",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 8309,
                                                    "intValue": 8309,
                                                    "stringValue": "8309",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_STEPS_YOUNG_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 9308,
                                                    "intValue": 9308,
                                                    "stringValue": "9308",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_STEPS_YOUNG_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 8462,
                                                    "intValue": 8462,
                                                    "stringValue": "8462",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_STEPS_YOUNG_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 11243,
                                                    "intValue": 11243,
                                                    "stringValue": "11243",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_STEPS_YOUNG_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 6179,
                                                    "intValue": 6179,
                                                    "stringValue": "6179",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_STEPS_YOUNG_GOOD",
                                                    "resultText": "Jij zet dagelijks tussen 5000 en 7500 stappen.",
                                                    "keyWords": "Goed",
                                                    "advice": "Je bent goed bezig, maar probeer dagelijks voor die 7500 stappen te gaan! Voldoende beweging is belangrijk voor de algemene gezondheid en vermindert het risico op verschillende ziekten. Hier zijn enkele tips die kunnen helpen om je doel te bereiken:\n- Maak er een gewoonte van om dagelijks een korte wandeling te maken. Een avondwandeling is bijvoorbeeld een geweldige manier om de dag af te sluiten.\n- Probeer nieuwe sporten of activiteiten uit en maak van beweging een sociale activiteit.\n- Laat de auto zo veel mogelijk staan. Ga zoveel mogelijk te voet naar de bakker, de slager, de post of de kapper.\n- Plan regelmatig lange afstandswandelingen in, bijvoorbeeld in de natuur of in de stad.",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_ACTIVEBURNEDCAL",
                                            "name": "Gemiddelde hoeveelheid kcal verbruikt door activiteit",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 394,
                                                    "intValue": 394,
                                                    "stringValue": "394",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_ACTIVEBURNEDCAL",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 393,
                                                    "intValue": 393,
                                                    "stringValue": "393",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_ACTIVEBURNEDCAL",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 389,
                                                    "intValue": 389,
                                                    "stringValue": "389",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_ACTIVEBURNEDCAL",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 615,
                                                    "intValue": 615,
                                                    "stringValue": "615",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_ACTIVEBURNEDCAL",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 389,
                                                    "intValue": 389,
                                                    "stringValue": "389",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_ACTIVEBURNEDCAL",
                                                    "resultText": "Gemiddelde hoeveelheid kcal verbruikt door activiteit",
                                                    "advice": "Je verbrandt extra calorieÃ«n door regelmatig fysieke activiteiten uit te voeren. Voldoende fysieke activiteit verbetert de conditie en vermindert het risico op chronische ziekten. Bovendien vermindert het stress en verbetert het de stemming. Probeer regelmatig te bewegen, kies leuke activiteiten die je uitdagen en eet gezond om je gezondheid te optimaliseren.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                            "name": "Gemiddelde hoeveelheid verbruikte kcal",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2040,
                                                    "intValue": 2040,
                                                    "stringValue": "2040",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2035,
                                                    "intValue": 2035,
                                                    "stringValue": "2035",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2028,
                                                    "intValue": 2028,
                                                    "stringValue": "2028",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2241,
                                                    "intValue": 2241,
                                                    "stringValue": "2241",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2024,
                                                    "intValue": 2024,
                                                    "stringValue": "2024",
                                                    "tag": "RESULT_WEARABLES_DIRECT_BODY_DAILY_BURNEDCAL",
                                                    "resultText": "Gemiddelde hoeveelheid verbruikte kcal",
                                                    "advice": "Je dagelijkse calorieverbruik bestaat uit twee componenten: de calorieÃ«n die je verbrandt tijdens beweging en de calorieÃ«n die je verbrandt in rust. Krijg je meer calorieÃ«n binnen dan dat je verbruikt? Dan kom je aan. En verbruik je meer calorieÃ«n dan je dat je er binnenkrijgt? Dan val je af. Om je totale calorieverbruik te optimaliseren, is het belangrijk om zowel regelmatig te bewegen als een gezond basaalmetabolisme te ondersteunen. Dit betekent dat je actief moet blijven om calorieÃ«n te verbranden en tegelijkertijd je rustmetabolisme moet ondersteunen. Dit kan worden bereikt door een combinatie van lichaamsbeweging, een gezond voedingspatroon, voldoende slaap en effectief stressmanagement.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_ACTIVE",
                                            "name": "Gemiddelde hoeveelheid tijd actief",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 75,
                                                    "intValue": 75,
                                                    "stringValue": "75",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_ACTIVE",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 80,
                                                    "intValue": 80,
                                                    "stringValue": "80",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_ACTIVE",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 71,
                                                    "intValue": 71,
                                                    "stringValue": "71",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_ACTIVE",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 127,
                                                    "intValue": 127,
                                                    "stringValue": "127",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_ACTIVE",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 71,
                                                    "intValue": 71,
                                                    "stringValue": "71",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_ACTIVE",
                                                    "resultText": "Gemiddelde hoeveelheid tijd actief",
                                                    "advice": "Fysieke activiteit draagt bij aan een betere gezondheid en een beter welzijn en vermindert het risico op chronische ziekten zoals diabetes en hartziekten. Het is aan te raden om gedurende de dag zo actief mogelijk te zijn, aangezien elke vorm van beweging gunstig is voor de gezondheid. Een praktische tip is bijvoorbeeld om de trap te nemen in plaats van de lift, te wandelen tijdens telefoongesprekken of een korte wandeling te maken na de maaltijd. Op die manier kun je gemakkelijk meer beweging integreren in je dagelijkse routine.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE",
                                            "expired": true
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 21.129950132003522,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 21.142466021316125,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 21.38339689058375,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 21.42407353084971,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 21.42720250317786,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_GEWOONTEN_SEDENTAIR",
                                    "name": "Sedentair gedrag",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_STILZITTEN",
                                            "name": "Tijd stilzitten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te veel",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_STILZITTEN_ZEERSLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_STILZITTEN_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117071154
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_STILZITTEN_ZEERGOED",
                                                    "resultText": "Uit de antwoorden die jij gaf blijkt dat jij er toch in slaagt om stilzitten zo veel mogelijk te beperken. Probeer dat vol te houden.",
                                                    "keyWords": "goed bezig",
                                                    "advice": "Doe zo verder, want je beperkt stilzitten tot een minimum!",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709129381796
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_SEDENTARY",
                                            "name": "Gemiddelde tijd zittend",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "10h 14m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_SEDENTARY_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "9h 27m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_SEDENTARY_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "10h 9m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_SEDENTARY_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "8h 11m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_SEDENTARY_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "10h 44m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_SEDENTARY_BAD",
                                                    "resultText": "Je zit dagelijks tussen de 8 en 11 uur.",
                                                    "keyWords": "Te veel",
                                                    "advice": "Je brengt veel tijd al zittend door, wat negatieve gevolgen kan hebben voor je gezondheid. Het is belangrijk om langdurig zitten regelmatig te doorbreken om zo de bloedsomloop te verbeteren, spieren te activeren en de stofwisseling te stimuleren. Probeer aan de hand van volgende tips het langdurig zitten te doorbreken:\n- Probeer zitmomenten en schermtijd te vervangen in een staande activiteit. Misschien kan je wel al staand vergaderen, telefoneren of een koffiepauze inlassen.\n- Probeer elk uur je zittijd te onderbreken met een korte wandeling of enkele rekoefeningen. Stel eventueel een alarm in op je telefoon om je eraan te herinneren regelmatig op te staan.\n- Drink water uit een glas in plaats van een waterfles. Dit moedigt je aan om regelmatig op te staan en je glas bij te vullen.\n- Overweeg het aanschaffen van een zit-sta bureau die je kunt aanpassen naar een staande positie.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 29.494318959616702,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 29.507460643394932,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 29.51184120465435,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 29.52060232717317,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 29.58193018480493,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 29.599452429842575,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 29.93675564681725,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 29.993702943189597,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 29.998083504449006,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_GEWOONTEN_ONDERBREKEN",
                                    "name": "Zitten onderbreken",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_ONDERBREKEN",
                                            "name": "Hoe vaak onderbreek je het stilzitten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "regelmatig onderbreken",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_ONDERBREKEN_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "regelmatiger onderbreken",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_ONDERBREKEN_MATIG",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117071154
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "regelmatiger onderbreken",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_ONDERBREKEN_MATIG",
                                                    "resultText": "Op basis van je antwoorden blijkt dat je je zittende activiteiten vaak, maar onvoldoende onderbreekt.",
                                                    "keyWords": "regelmatiger onderbreken",
                                                    "advice": "Idealiter zou je om het halfuur eens rechtstaan. Probeer dat geleidelijk aan toe te passen doorheen je dag. Beware of the chair!",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709129381796
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_GEWOONTEN_ACTIVITEIT",
                                    "name": "Fysieke activiteiten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_MET",
                                            "name": "Energie van fysieke activiteiten",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 1.5089285714285714,
                                                    "stringValue": "1.5089285714285714",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_MET_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 1.4955357142857142,
                                                    "stringValue": "1.4955357142857142",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_MET_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 1.4866071428571428,
                                                    "stringValue": "1.4866071428571428",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_MET_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 1.6339285714285714,
                                                    "stringValue": "1.6339285714285714",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_MET_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 1.5,
                                                    "stringValue": "1.5",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_MOVE_DAILY_MET_VERYGOOD",
                                                    "resultText": "Jouw MET-waarde is hoger dan 1,45.",
                                                    "keyWords": "heel goed",
                                                    "advice": "MET (Metabolic Equivalent of Task) is een maatstaf die beschrijft hoe snel jij energie verbruikt tijdens een activiteit, in verhouding tot jouw lichaamsgewicht. Je hebt een hoge MET-waarde, wat betekent dat je actief bent op een niveau dat gunstig is voor je gezondheid en conditie. Om je prestaties nog te verbeteren en je gezondheidsvoordelen te maximaliseren kunnen volgende tips helpen:\n  * Probeer voldoende variatie in je fysieke activiteiten toe te voegen om verschillende spiergroepen aan te spreken en je training interessant te houden. \n  * Regelmatige fysieke activiteit is belangrijk, maar zorg ervoor dat je voldoende rustdagen inplant om overtraining te voorkomen en je lichaam de kans te geven zich te herstellen.\n  * Een gezond voedingspatroon ondersteunt je activiteiten en helpt bij het handhaven van een optimale energieverbranding. Kies voedingsmiddelen die je voldoende energie geeft voor je lichamelijke activiteiten.\n\n",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.7",
                                    "score": 6.666666666666667,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 26.999999999999996,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.3",
                                    "score": 8.333333333333334,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 22.04517453798768,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.3",
                                    "score": 8.333333333333334,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 22.048459958932238,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.3",
                                    "score": 8.333333333333334,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 22.058316221765914,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.9",
                                    "score": 7.916666666666667,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 23.284988652328973,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.9",
                                    "score": 7.916666666666667,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 23.295363665838103,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.9",
                                    "score": 7.916666666666667,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 23.298822003674484,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.9",
                                    "score": 7.916666666666667,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 23.305738679347236,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.5",
                                    "score": 7.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 24.65160848733744,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.5",
                                    "score": 7.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 24.666210358202147,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.5",
                                    "score": 7.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 24.947296372347708,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.5",
                                    "score": 7.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 24.994752452657995,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.5",
                                    "score": 7.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 24.998402920374172,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_MOVE_TRAINING",
                            "name": "Trainingsschema",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_DUURSPORT",
                                    "name": "Duursport",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT_HOOG",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT_HOOG",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT_HOOG",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT_HOOG",
                                                    "resultText": "Op basis van jouw DNA-analyse kunnen we opmaken dat jouw lichaam een voorkeur heeft om aan duursport te doen.",
                                                    "keyWords": "grote voorkeur",
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_CARDIO",
                                            "name": "Jouw cardioactivitieten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_CARDIO_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_CARDIO_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117071154
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_CARDIO_ZEERGOED",
                                                    "resultText": "Goed bezig! Op basis van jouw antwoorden kwam naar voren dat je heel wat tijd aan cardioactiviteiten spendeert tijdens jouw week. Doe zo verder!",
                                                    "keyWords": "goed bezig",
                                                    "advice": "Bewegen is gezond voor je lichaam en je geest, dus doe zo verder zoals je bezig bent! Maar als het gaat om je trainingen, is vaker niet altijd beter: vergeet niet dat rustdagen essentieel zijn. Idealiter train je tussen de 150 en 300 minuten per week gematigd intensief of tussen de 75 en 150 minuten per week hoog intensief.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709129381796
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_WALKDURATION",
                                            "name": "Gemiddeld aantal minuten wandelen",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_RUNDURATION",
                                            "name": "Gemiddeld aantal minuten lopen",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_BIKEDURATION",
                                            "name": "Gemiddeld aantal minuten fietsen",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_COVEREDDISTANCE",
                                            "name": "Afstand wandelen",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_COVEREDDISTANCERUN",
                                            "name": "Afstand lopen",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_COVEREDDISTANCEBIKE",
                                            "name": "Afstand fietsen",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_KRACHTSPORT",
                                    "name": "Krachtsport",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT_MATIG",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT_HOOG",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT_HOOG",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT_HOOG",
                                                    "resultText": "Uit jouw DNA kunnen we afleiden dat jouw lichaam een voorkeur voor krachtsporten heeft.",
                                                    "keyWords": "grote voorkeur",
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_SPIER",
                                            "name": "Jouw spierversterkende activiteiten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_SPIER_ZEERSLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_SPIER_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117071154
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed bezig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_BEWEGING_SPIER_ZEERGOED",
                                                    "resultText": "Goed bezig! Doorheen de week spendeer jij heel wat tijd aan spierversterkende oefeningen. Super, keep on going!",
                                                    "keyWords": "goed bezig",
                                                    "advice": "Jij houdt activiteiten lang genoeg vol om er gezondheidswinst uit te halen, dus doe zo verder!",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709129381796
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_SPORTPROFIEL",
                                    "name": "Sportprofiel",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN",
                                            "name": "Sportprofiel",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "duursporter",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN_DUURSPORT",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "kracht- en duursporter",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN_GEMENGD",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "kracht- en duursporter",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN_GEMENGD",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "kracht- en duursporter",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN_GEMENGD",
                                                    "resultText": "Wat jouw sportprofiel betreft, kunnen we concluderen dat jouw lichaam een lichte voorkeur voor zowel kracht- als duursport heeft.",
                                                    "keyWords": "kracht- en duursporter",
                                                    "advice": "Als jij op zoek bent naar een geschikte sport, kan je op basis van jouw genen zowel voor duur- als krachtsport gaan. Keuze zat dus! Ideale duursporten zijn lopen, zwemmen of andere gelijkaardige sporten met een matige intensiteit maar een langere duur. Ga ook voor sprinten en high intensity intervaltrainingen.\n\nKrachtsport wordt vooral gekenmerkt door intensieve oefeningen met focus op kracht, snelheid en weerstandstrainingen. Denk bijvoorbeeld aan oefeningen met gewichten, fitness en crossfit. \n\nAls je gewichtstrainingen doet, is het belangrijk jouw kracht op te bouwen voor je met zware gewichten aan de slag gaat. Eerst leren stappen voor je gaat lopen dus! Let daarnaast steeds op mogelijke blessurerisico's.",
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_INTENSITEIT",
                                    "name": "Intensiteit",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "matig tot laag",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT_MATIG",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "matig tot laag",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT_MATIG",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "matig tot laag",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT_MATIG",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "matig tot laag",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT_MATIG",
                                                    "resultText": "Jouw DNA-resultaten vertellen ons dat het voor jouw lichaam aangewezen is om langdurig aan een matige tot lage intensiteit te sporten.",
                                                    "keyWords": "matig tot laag",
                                                    "advice": "We raden jou aan om te trainen met een matige intensiteit. Concreet komt dat erop neer dat je jouw hartslag tussen 60 Ã  70% van jouw maximale hartslag probeert te houden.",
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_LOWINTENSITY",
                                            "name": "Gemiddelde tijd aan laag intensieve activiteit",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "8h 32m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_LOWINTENSITY",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "8h 45m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_LOWINTENSITY",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "8h 51m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_LOWINTENSITY",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "5h 47m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_LOWINTENSITY",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "8h 32m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_LOWINTENSITY",
                                                    "resultText": "Gemiddelde tijd aan laag intensieve activiteit",
                                                    "advice": "Het is belangrijk om gedurende de dag licht intensieve activiteiten te ondernemen. Dit is goed voor zowel je fysieke als mentale gezondheid. Tijdens licht intensieve activiteiten versnelt je ademhaling niet, blijft je hartslag normaal en kun je nog steeds praten. Mensen die regelmatig bewegen, hebben over het algemeen een lager risico op aandoeningen zoals hart- en vaatziekten, diabetes type 2 en verschillende vormen van kanker. Voorbeelden van licht intensieve activiteiten zijn onder meer telefoneren terwijl je staat, langzaam wandelen en lichte huishoudelijke taken zoals opruimen en koken. Probeer gedurende de dag zoveel mogelijk van deze activiteiten in je dagelijkse routine op te nemen.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_MIDINTENSITY",
                                            "name": "Gemiddelde tijd matig intensieve activiteit",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 9m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_MIDINTENSITY",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 24m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_MIDINTENSITY",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 11m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_MIDINTENSITY",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 25m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_MIDINTENSITY",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 53m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_MIDINTENSITY",
                                                    "resultText": "Gemiddelde tijd matig intensieve activiteit",
                                                    "advice": "Matig intensief bewegen, zoals stevig wandelen, recreatief zwemmen en fietsen, versnelt je ademhaling en hartslag. Dit verlaagt het risico het krijgen van chronische ziekten zoals hart- en vaatziekten, diabetes type 2 en kanker. Probeer wekelijks 150 tot 300 minuten matig intensief te bewegen en doe minstens twee keer per week krachttraining om je spieren en botten te versterken. Je kan alvast enkele slimme krachttrainingen integreren in je dagelijkse leven, zoals bergop fietsen of wandelen, de trap nemen en kleine boodschappen dragen.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HIGHINTENSITY",
                                            "name": "Gemiddelde tijd aan hoge intensieve activiteit",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 18m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HIGHINTENSITY",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 6m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HIGHINTENSITY",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 11m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HIGHINTENSITY",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 39m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HIGHINTENSITY",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 45m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HIGHINTENSITY",
                                                    "resultText": "Gemiddelde tijd aan hoge intensieve activiteit",
                                                    "advice": "Hoog intensief bewegen, zoals hardlopen, sprinten en intervaltraining, zorgt voor een versnelde ademhaling en hartslag en biedt heel wat extra voordelen voor je gezondheid en welzijn. Het verlaagt het risico op chronische ziekten zoals hart- en vaatziekten, diabetes type 2 en kanker. Probeer wekelijks 75 tot 150 minuten aan hoge intensiteit te bewegen. Daarnaast is het belangrijk om minstens twee keer per week krachttraining te doen om je spieren en botten te versterken. Integreer alvast enkele slimme krachtoefeningen in je dagelijkse leven, zoals traplopen, lichaamsgewichtoefeningen en weerstandsbandtraining.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_HERSTELTIJD",
                                    "name": "Hersteltijd",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "ietwat langer",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "langer",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "langer",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "langer",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD_HOOG",
                                                    "resultText": "Gebaseerd op onze analyse en interpretatie van jouw DNA-resultaten heeft jouw lichaam nood aan iets langere hersteltijden tussen trainingen.",
                                                    "keyWords": "langer",
                                                    "advice": "Bouw jouw trainingen langzaam op en plan voldoende hersteltijd tussen de trainingen in. Je hebt nood aan 24 tot 48 uur rust na een extensieve training waarbij je wel zweette, maar nog kon praten. Na een heel intensieve training kan de volledige hersteltijd zelfs drie dagen in beslag nemen. Op basis van jouw DNA raden we je aan wat extra hersteltijd te nemen: verleng de normale hersteltijd met een halve tot een volledige dag.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_SLAAP",
                                    "name": "Slaap en sport",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP_MATIG",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP_MATIG",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP_HOOG",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP_MATIG",
                                                    "resultText": "Op basis van jouw DNA-resultaten blijkt dat jouw lichaam de neiging heeft om minder te slapen dan wat goed is voor jouw sportrecuperatie.",
                                                    "keyWords": "licht verhoogde nood",
                                                    "advice": "Sporters eisen meer van hun lichaam dan niet-sporters. Voor zowel amateurs als professionele sporters zijn slapen en sporten onlosmakelijk met elkaar verbonden. Een goede slaaphygiÃ«ne is voor jou dan ook belangrijk. Dat betekent dat je per nacht zeker zeven tot acht uren zou moeten slapen om jouw lichaam te laten herstellen.\n\nProbeer daarnaast ook elke dag ongeveer op hetzelfde tijdstip te gaan slapen. Kies ervoor om te slapen in een duistere, frisse kamer tussen 18 en 22Â°C. Vermijd ook blauw licht, bijvoorbeeld van je laptop of smartphone, vÃ³Ã³r het slapen. Dat zal je helpen om de doelstellingen van jouw trainingsschema te realiseren.",
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL",
                                            "name": "Hoeveelheid slaap",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116315184
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125621844
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "resultText": "Op basis van je antwoorden slaap je niet altijd zeven tot negen uren per nacht.",
                                                    "keyWords": "matig",
                                                    "advice": "Tracht toch zo vaak mogelijk te streven naar zeven tot negen uren slaap per nacht. Hou wel in gedachten dat je slaapkwaliteit belangrijker is dan de kwantiteit.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1721056754687
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION",
                                            "name": "Gemiddelde slaapduur",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "6h 0m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_1_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "7h 14m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "7h 14m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "7h 38m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "7h 25m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_GOOD",
                                                    "resultText": "Je slaapt dagelijks tussen de 7 en 9 uur.",
                                                    "keyWords": "Optimaal",
                                                    "advice": "Goed bezig! Probeer dit slaappatroon vast te houden. Voldoende slaap is belangrijk voor een goede gezondheid, een goed welzijn en een hoge productiviteit. Blijf aandacht besteden aan een consistente slaap-waakritme en vermijd stimulerende middelen voor het slapengaan.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 24.57859913301392,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 24.589550536162445,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 24.593201003878622,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 24.600501939310973,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 24.65160848733744,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 24.666210358202147,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 24.947296372347708,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 24.994752452657995,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 24.998402920374172,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_OVERTRAINING",
                                    "name": "Overtraining",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_SPORT_OVERTRAINING_CK",
                                            "name": "Creatine kinase",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 80,
                                                    "intValue": 80,
                                                    "stringValue": "80",
                                                    "tag": "RESULT_BLOOD_SPORT_OVERTRAINING_CK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 124,
                                                    "intValue": 124,
                                                    "stringValue": "124",
                                                    "tag": "RESULT_BLOOD_SPORT_OVERTRAINING_CK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 72,
                                                    "intValue": 72,
                                                    "stringValue": "72",
                                                    "tag": "RESULT_BLOOD_SPORT_OVERTRAINING_CK_NORMAAL",
                                                    "resultText": "Je CK-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Er is nog weinig onderzoek dat uitlegt hoe je je CK laag kan houden. We kunnen daarom niet meer doen dan aanraden om voldoende rust te nemen zodat je lichaam kan herstellen. Een ontspannende massage of een bezoek aan de spa is ook een goede optie!",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_BESTETIJD",
                                    "name": "Beste tijd om te sporten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD_GEENVOORKEUR",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD_GEENVOORKEUR",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD_AVOND",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD_GEENVOORKEUR",
                                                    "resultText": "Het onderzoek naar je DNA gaf aan dat jouw lichaam geen specifieke voorkeur qua tijdstip om te sporten heeft.",
                                                    "keyWords": "geen specifieke voorkeur",
                                                    "advice": "In jouw geval is er geen ideaal trainingsmoment, wat betekent dat jij zowel 's ochtends, 's middags als 's avonds mag trainen. Het tijdstip zal geen impact op je sportprestaties hebben, maar probeer wel een regelmaat in te bouwen. Op die manier kan je lichaam eraan wennen en kan je jouw resultaten optimaliseren.",
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_WANNEER",
                                            "name": "Wanneer sport jij",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "ochtend",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_WANNEER_OCHTEND",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "overdag",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_WANNEER_OVERDAG",
                                                    "time": 1709116273299
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_WANNEER_AVOND",
                                                    "time": 1709125592987
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_WANNEER_AVOND",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_WANNEER_AVOND",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_WANNEER_AVOND",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_WANNEER_AVOND",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_WANNEER_AVOND",
                                                    "resultText": "Jij geeft aan voornamelijk in de avond te sporten.",
                                                    "keyWords": "avond",
                                                    "advice": "Het ideale tijdstip om te sporten kan inderdaad variÃ«ren per persoon, afhankelijk van verschillende factoren zoals je dagelijkse schema, energieniveaus, en persoonlijke voorkeuren. \n\nLuister uiteindelijk naar je eigen lichaam en kies een tijdstip dat het beste voelt voor jou en dat past in je dagelijkse routine. Consistentie is vaak belangrijker dan het specifieke tijdstip van de dag.\n\n\n\n\n\n\n",
                                                    "time": 1721051549562
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_CONDITIE",
                                    "name": "Jouw conditie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_VO2MAX",
                                            "name": "VO2max",
                                            "unit": "ml/min/kg",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 39,
                                                    "stringValue": "39.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_VO2MAX_VERYGOOD",
                                                    "resultText": "Je VO2max is heel goed! Goed bezig!",
                                                    "keyWords": "heel goed",
                                                    "advice": "Hoogintensieve intervaltraining (HIIT) wordt beschouwd als een van de beste manieren om je VO2max verder te vergroten. Dat komt omdat HIIT ervoor zorgt dat de intensiteit van je inspanning voor korte tijd nabij of zelfs boven de anaerobe drempel komt alvorens je terugkeert naar een lagere, aerobe intensiteit. Deze vorm van korte, herhaalde overbelasting zorgt ervoor dat je hart en longen zich aanpassen aan de eisen die eraan worden gesteld.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1634296260000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "MPT"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_VO2MAX",
                                            "name": "Wearable VO2max",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_RER",
                                            "name": "RER",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.2,
                                                    "stringValue": "1.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_RER",
                                                    "resultText": "RER",
                                                    "keyWords": "RER",
                                                    "advice": "Een tip om je metabole efficiÃ«ntie te verbeteren is om in de voorbereidingsfase Ã©Ã©n of twee keer per week 's ochtends vroeg voor het ontbijt een nuchtere training uit te voeren, bijvoorbeeld een halfuurtje joggen of een uur rustig fietsen. Water, zwarte thee of zwarte koffie mogen wel vooraf gedronken worden.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1634296260000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "MPT"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_MAXHR",
                                            "name": "Maximale hartslag",
                                            "unit": "bpm",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 140,
                                                    "stringValue": "140.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_MAXHR",
                                                    "resultText": "Maximale hartslag",
                                                    "keyWords": "maximale hartslag",
                                                    "advice": "Veel trainingsschema's zijn gebaseerd op je maximale hartslag. De maximale hartslag kan bovendien gebruikt worden om oververmoeidheid en overtraining vast te stellen.",
                                                    "time": 1634296260000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "MPT"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_WATTAGE",
                                            "name": "Wattage",
                                            "unit": "W",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 210,
                                                    "stringValue": "210.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_WATTAGE",
                                                    "resultText": "Wattage",
                                                    "keyWords": "wattage",
                                                    "advice": "Je wattage zegt meer over je conditie en je vorm in het algemeen dan hartslag of gemiddelde snelheid. Hoe hoger, hoe zwaarder de inspanning. Wil je dit cijfer doen stijgen? Dan zal je extra moeten trainen.",
                                                    "time": 1634296260000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "MPT"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_TIJD",
                                            "name": "Tijd gefietst",
                                            "unit": "sec",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 644,
                                                    "intValue": 644,
                                                    "stringValue": "644",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_TIJD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 458,
                                                    "intValue": 458,
                                                    "stringValue": "458",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_TIJD",
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 458,
                                                    "intValue": 458,
                                                    "stringValue": "458",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_TIJD",
                                                    "resultText": "Tijd gefietst",
                                                    "keyWords": "tijd gefietst",
                                                    "advice": "Idealiter fiets je tussen acht Ã  twaalf minuten in stressniveau om een goede inspanningstest af te leggen.",
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "MPT"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_TRAINING_HARTSLAG",
                                    "name": "Hartslagzones",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_MAXIMAAL",
                                            "name": "Maximale hartslagzone",
                                            "unit": "bpm",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "126-140",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_MAXIMAAL",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "141-157",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_MAXIMAAL",
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "141-157",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_MAXIMAAL",
                                                    "resultText": "Maximale hartslagzone",
                                                    "keyWords": "maximale hartslagzone",
                                                    "advice": "Hoe voelt het?\nHet voelt zeer vermoeiend voor zowel je spieren als je ademhaling.",
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "MPT"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_HARD",
                                            "name": "Harde hartslagzone",
                                            "unit": "bpm",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "112-126",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_HARD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "126-141",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_HARD",
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "126-141",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_HARD",
                                                    "resultText": "Harde hartslagzone",
                                                    "keyWords": "harde hartslagzone",
                                                    "advice": "Hoe voelt het?\nJe spieren voelen vermoeid aan en je ademt zwaar.",
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "MPT"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_GEMIDDELD",
                                            "name": "Gemiddelde hartslagzone",
                                            "unit": "bpm",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "98-112",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_GEMIDDELD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "110-126",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_GEMIDDELD",
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "110-126",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_GEMIDDELD",
                                                    "resultText": "Gemiddelde hartslagzone",
                                                    "keyWords": "gemiddelde hartslagzone",
                                                    "advice": "Hoe voelt het?\nJe begint dieper te ademen en voelt een matige inspanning.",
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "MPT"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_LICHT",
                                            "name": "Lichte hartslagzone",
                                            "unit": "bpm",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "84-98",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_LICHT",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "94-110",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_LICHT",
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "94-110",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_LICHT",
                                                    "resultText": "Lichte hartslagzone",
                                                    "keyWords": "lichte hartslagzone",
                                                    "advice": "Hoe voelt het?\nHet voelt nog altijd comfortabel en gemakkelijk. Je zou wel uren kunnen doorgaan.",
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "MPT"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_ZEERLICHT",
                                            "name": "Zeer lichte hartslagzone",
                                            "unit": "bpm",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "70-84",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_ZEERLICHT",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "79-94",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_ZEERLICHT",
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "79-94",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_INSPANNING_HARTSLAGZONES_ZEERLICHT",
                                                    "resultText": "Zeer lichte hartslagzone",
                                                    "keyWords": "zeer lichte hartslagzone",
                                                    "advice": "Hoe voelt het?\nHet voelt erg gemakkelijk. Je zou wel uren kunnen doorgaan.",
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "MPT"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HR_LIGHT",
                                            "name": "Gemiddeld aantal minuten activiteit met lage hartslag",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HR_MODERATE",
                                            "name": "Gemiddeld aantal minuten activiteit met matige hartslag",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HR_INTENSE",
                                            "name": "Gemiddeld aantal minuten activiteit met intense hartslag",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_MOVE_DAILY_HR_MAXIMAL",
                                            "name": "Gemiddeld aantal minuten activiteit met maximale hartslag",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.7",
                                    "score": 7.717391304347826,
                                    "maxScore": 10,
                                    "goalScore": 9.891304347826088,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 23.07042253521127,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.3",
                                    "score": 8.26086956521739,
                                    "maxScore": 10,
                                    "goalScore": 9.891304347826088,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 21.996829856983325,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.3",
                                    "score": 8.26086956521739,
                                    "maxScore": 10,
                                    "goalScore": 9.891304347826088,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 22.00010807305739,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.3",
                                    "score": 8.26086956521739,
                                    "maxScore": 10,
                                    "goalScore": 9.891304347826088,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 22.00994272127959,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.928571428571429,
                                    "maxScore": 10,
                                    "goalScore": 9.821428571428571,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 20.277344284736483,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.928571428571429,
                                    "maxScore": 10,
                                    "goalScore": 9.821428571428571,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 20.286379192334014,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.928571428571429,
                                    "maxScore": 10,
                                    "goalScore": 9.821428571428571,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 20.289390828199863,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.928571428571429,
                                    "maxScore": 10,
                                    "goalScore": 9.821428571428571,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 20.295414099931552,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.928571428571429,
                                    "maxScore": 10,
                                    "goalScore": 9.821428571428571,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 20.337577002053386,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.928571428571429,
                                    "maxScore": 10,
                                    "goalScore": 9.821428571428571,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 20.349623545516767,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.928571428571429,
                                    "maxScore": 10,
                                    "goalScore": 9.821428571428571,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 20.581519507186858,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.928571428571429,
                                    "maxScore": 10,
                                    "goalScore": 9.821428571428571,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 20.620670773442846,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.9",
                                    "score": 8.928571428571429,
                                    "maxScore": 10,
                                    "goalScore": 9.821428571428571,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 20.62368240930869,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_MOVE_BLESSURE",
                            "name": "Blessurepreventie",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_MOVE_BLESSURE_ONTSTEKING",
                                    "name": "Ontstekingsgevoeligheid",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wat gevoeliger",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE_HOOG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat je heel wat gevoeliger bent dan anderen voor ontstekingen.",
                                                    "keyWords": "heel gevoelig",
                                                    "advice": "Geen paniek: dit resultaat betekent niet dat je altijd ontstekingen zal hebben. Vermijd overtraining, slaapgebrek, een te grote inname van cafeÃ¯ne of geraffineerde suikers en stress, want dat zijn veelvoorkomende oorzaken van (chronische) ontstekingen. Naast gezond sporten met aandacht voor opwarmen, afkoelen en eventueel weerstands- en lenigheidsoefeningen en voldoende rust, is het voor jou ook belangrijk te focussen op anti-inflammatoire voeding. Avocadoâs, gember, olijfolie en vette vis zijn ontstekingsremmend en kunnen het lichaam helpen korte metten te maken met zichtbare en onzichtbare ontstekingen. Luister vooral goed naar je lichaam: wanneer je vermoeid bent of je je ziek voelt, is het tijd om even uit te rusten. Laat ook regelmatig de zogenaamde âinflammatie markersâ in je bloed nakijken.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_SPORT_ONTSTEKING_HSCRP",
                                            "name": "hsCRP",
                                            "unit": "mg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.2,
                                                    "stringValue": "1.2",
                                                    "tag": "RESULT_BLOOD_SPORT_ONTSTEKING_HSCRP_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<4.0",
                                                    "tag": "RESULT_BLOOD_SPORT_ONTSTEKING_HSCRP_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 1.08,
                                                    "stringValue": "1.08",
                                                    "tag": "RESULT_BLOOD_SPORT_ONTSTEKING_HSCRP_HOOG",
                                                    "resultText": "Je HsCRP-waarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Om het niveau van je hsCRP laag te krijgen en houden speelt een gezonde levensstijl een belangrijke rol. Beweeg en ontspan daarom voldoende en zorg voor een evenwichtig voedingspatroon. Voedsel en dranken met veel suikers kunnen het best vermeden of in kleine hoeveelheden genuttigd worden. Broccoli, vette vis en groene thee zijn voedingsmiddelen die worden aanbevolen voor het verlagen van het hsCRP-niveau.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_BLESSURE_OPWARMING",
                                    "name": "Opwarming",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "aandachtspunt",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel belangrijk",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel belangrijk",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "aandachtspunt",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE_MATIG",
                                                    "resultText": "Op basis van jouw DNA-resultaten blijkt dat jij toch wat extra aandacht moet besteden aan specifieke oefeningen ter preventie van blessures.",
                                                    "keyWords": "aandachtspunt",
                                                    "advice": "Om blessures te voorkomen is het belangrijk dat je voldoende aandacht besteedt aan het opwarmen en afkoelen voor en na het sporten. Warm zeker tien tot vijftien minuten op. Als je in jouw opwarming statische en dynamische rekoefeningen integreert en/of lopen, dan mag die maximaal dertig minuten duren. De periode waarin je na het sporten afkoelt, duurt ongeveer tien minuten, maar let er ook op dat je voldoende rust tussen twee trainingen.\n\nWissel op regelmatige basis weerstands- en lenigheidsoefeningen met elkaar af. Die eerste worden gekenmerkt door trainen met een gewicht waarbij vermoeidheid ontstaat bij acht tot twaalf herhalingen. Rekken en strekken zijn dan weer typische lenigheidsoefeningen.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_BLESSURE_RISICO",
                                    "name": "Blessurerisico",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_DEEPSQUAT",
                                            "name": "Deep squat",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "niet uitvoerbaar",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_DEEPSQUAT_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_DEEPSQUAT_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_DEEPSQUAT_NEUTRAL",
                                                    "resultText": "Je bovenlichaam was evenwijdig aan je scheenbeen. Je dijbeen kwam onder je knie. Je knieÃ«n bevonden zich boven je voeten. De stok neigde achter je voeten.",
                                                    "keyWords": "acceptabel",
                                                    "advice": "Een werkpunt hier is je thoracale mobiliteit (de bewegelijkheid van de wervels ter hoogte van de borstkas) en core stabiliteit (ook wel rompstabiliteit genoemd).",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "FMS"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_HURDLESTEP",
                                            "name": "Hurdle step",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "ondermaats",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_HURDLESTEP_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "ondermaats",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_HURDLESTEP_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "ondermaats",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_HURDLESTEP_BAD",
                                                    "resultText": "Er was contact tussen je voet en de horde. Je verloor balans.",
                                                    "keyWords": "ondermaats",
                                                    "advice": "Een van je werkpunten is de stabiliteit van je heup en knie, net als je enkelmobiliteit.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "FMS"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_INLINELUNGE",
                                            "name": "Inline lunge",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_INLINELUNGE_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "ondermaats",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_INLINELUNGE_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_INLINELUNGE_NEUTRAL",
                                                    "resultText": "Er was beweging in je romp. Je voeten bleven niet op Ã©Ã©n lijn achter elkaar staan. Je knie raakte de plank niet achter je voorste hiel.",
                                                    "keyWords": "acceptabel",
                                                    "advice": "Tracht wat meer te focussen op de stabiliteit van je romp en de coÃ¶rdinatie van je boven- en onderlichaam.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "FMS"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_SHOULDER",
                                            "name": "Shoulder mobility",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "optimaal",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_SHOULDER_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_SHOULDER_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "ondermaats",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_SHOULDER_BAD",
                                                    "resultText": "Je vuisten waren meer dan 1,5 handlengte uit elkaar.",
                                                    "keyWords": "ondermaats",
                                                    "advice": "Tracht te werken aan wat we noemen je bilaterale schouder range of motion. Dit zijn oefeningen die gericht zijn op extensie (strekken), rotatie (draaien) en adductie (bewegen naar de lichaamsas toe) en abductie (bewegen van de lichaamsas weg) van het schoudergewricht.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "FMS"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_LEG",
                                            "name": "Active straight leg test",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "optimaal",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_LEG_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_LEG_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_LEG_NEUTRAL",
                                                    "resultText": "Je been ging niet gestrekt voorbij de meetstok en bleef steken ter hoogte van je knie.",
                                                    "keyWords": "acceptabel",
                                                    "advice": "Focus op oefeningen die de stabiliteit in het bekken stimuleren en blijf die hamstrings stretchen.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "FMS"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_PUSHUP",
                                            "name": "Trunk stability push-up",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_PUSHUP_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "ondermaats",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_PUSHUP_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_PUSHUP_NEUTRAL",
                                                    "resultText": "Je lichaam ging in een relatief vlotte beweging omhoog zonder kromming in je rug.",
                                                    "keyWords": "acceptabel",
                                                    "advice": "Focus op oefeningen die als doel hebben het samen laten bewegen van de rug met de heup.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "FMS"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_STABILITY",
                                            "name": "Rotation stability",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "acceptabel",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_STABILITY_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "ondermaats",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_STABILITY_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711124660524
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "ondermaats",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_FMS_STABILITY_BAD",
                                                    "resultText": "Je was niet in staat om een herhaling uit te voeren door het verliezen van balans en/of het niet kunnen aantikken van je elleboog met je knie.",
                                                    "keyWords": "ondermaats",
                                                    "advice": "Focus op oefeningen die werken aan stabiliteit in core, bekken en schouders en de coÃ¶rdinatie om de beweging uit te voeren.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711439892842
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "FMS"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "375.0",
                                            "score": 375,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 33.6,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "375.0",
                                            "score": 375,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 34.29249372575862,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "375.0",
                                            "score": 375,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 34.29760438056126,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "375.0",
                                            "score": 375,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 34.3129363449692,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "250.0",
                                            "score": 250,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "250.0",
                                            "score": 250,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "275.0",
                                            "score": 275,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "275.0",
                                            "score": 275,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "275.0",
                                            "score": 275,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "275.0",
                                            "score": 275,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "275.0",
                                            "score": 275,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "275.0",
                                            "score": 275,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "275.0",
                                            "score": 275,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.2",
                                    "score": 5.194805194805195,
                                    "maxScore": 10,
                                    "goalScore": 9.87012987012987,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 34.2,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.2",
                                    "score": 5.194805194805195,
                                    "maxScore": 10,
                                    "goalScore": 9.87012987012987,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 34.904859685147166,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.2",
                                    "score": 5.194805194805195,
                                    "maxScore": 10,
                                    "goalScore": 9.87012987012987,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 34.91006160164271,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.2",
                                    "score": 5.194805194805195,
                                    "maxScore": 10,
                                    "goalScore": 9.87012987012987,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 34.92566735112937,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.4",
                                    "score": 3.4415584415584415,
                                    "maxScore": 10,
                                    "goalScore": 9.74025974025974,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 43.432580424366876,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.4",
                                    "score": 3.4415584415584415,
                                    "maxScore": 10,
                                    "goalScore": 9.74025974025974,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 43.44079397672827,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.8",
                                    "score": 3.831168831168831,
                                    "maxScore": 10,
                                    "goalScore": 9.805194805194805,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 43.4435318275154,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.8",
                                    "score": 3.831168831168831,
                                    "maxScore": 10,
                                    "goalScore": 9.805194805194805,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 43.44900752908967,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.8",
                                    "score": 3.831168831168831,
                                    "maxScore": 10,
                                    "goalScore": 9.805194805194805,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 43.48733744010951,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.8",
                                    "score": 3.831168831168831,
                                    "maxScore": 10,
                                    "goalScore": 9.805194805194805,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 43.49828884325804,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.8",
                                    "score": 3.831168831168831,
                                    "maxScore": 10,
                                    "goalScore": 9.805194805194805,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 43.709103353867214,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.8",
                                    "score": 3.831168831168831,
                                    "maxScore": 10,
                                    "goalScore": 9.805194805194805,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 43.74469541409994,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.8",
                                    "score": 3.831168831168831,
                                    "maxScore": 10,
                                    "goalScore": 9.805194805194805,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 43.747433264887064,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_MOVE_VOORDELEN",
                            "name": "Voordelen sport",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_MOVE_VOORDELEN_HDL",
                                    "name": "HDL en sporten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "weinig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL_LAAG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "weinig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL_LAAG",
                                                    "resultText": "Uit jouw DNA-onderzoek blijkt dat bewegen geen bijkomende invloed op jouw goede cholesterol (HDL) heeft.",
                                                    "keyWords": "weinig effect",
                                                    "advice": "Sowieso is bewegen goed voor je gezondheid Ã©n verlaagt het de kans op hart- en vaataandoeningen. Blijf dan ook bewegen! Doe wekelijks verspreid over diverse dagen minstens 150 minuten aan matig intensieve inspanning. Doe je dat langer, vaker en/of intensiever? Dan heb je een extra gezondheidsvoordeel. Doe ook minstens twee keer per week activiteiten die je spieren en botten versterken.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL",
                                            "name": "HDL cholesterol",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 94,
                                                    "intValue": 94,
                                                    "stringValue": "94",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 58,
                                                    "intValue": 58,
                                                    "stringValue": "58",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 83,
                                                    "intValue": 83,
                                                    "stringValue": "83",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL_NORMAAL",
                                                    "resultText": "Je HDL-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Je HDL-cholesterol kan je verder doen stijgen door een gezondere levensstijl aan te nemen. Denk bijvoorbeeld aan een veranderd voedingspatroon, met meer aandacht voor verse groenten en fruit. Deze bevatten veel gezonde vezels. Daarnaast is het ook belangrijk om gezonde, onverzadigde vetten te eten. Die vind je in noten en zaden of avocado, maar ook in vette vis in de vorm van omega 3. Probeer ook regelmatig te bewegen. Dat kan door simpelweg iedere dag een wandeling te maken. Ben je een roker? Dan stop je daar best mee, aangezien het een negatieve invloed heeft op de cholesterol.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_VOORDELEN_GEWICHT",
                                    "name": "Gewicht en sporten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "weinig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT_LAAG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "weinig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT_LAAG",
                                                    "resultText": "Op basis van jouw DNA-resultaten kunnen we afleiden dat extra bewegen weinig tot geen effect zal hebben wanneer je gewicht wil verliezen of behouden.",
                                                    "keyWords": "weinig effect",
                                                    "advice": "Extra beweging mag dan misschien weinig merkbaar effect op jouw gewicht hebben, toch raden we je aan om in functie van je algemene gezondheid voldoende actief te blijven bewegen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                            "name": "Gewicht uit bodyscan",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 83.2,
                                                    "stringValue": "83.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 66.3,
                                                    "stringValue": "66.3",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 83.4,
                                                    "stringValue": "83.4",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 63.4,
                                                    "stringValue": "63.4",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                                    "resultText": "Gewicht uit bodyscan",
                                                    "keyWords": "totaal gewicht",
                                                    "advice": "Je gewicht is maar Ã©Ã©n parameter van je lichaamsbouw en je gezondheid. Bekijk ook steeds je spiermassa en vetverdeling in je lichaam.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI",
                                            "name": "Body Mass Index",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normaal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normaal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116168810
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normaal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709124272513
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "overgewicht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_OVERGEWICHT_BAD",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709223914112
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normaal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normaal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normaal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normaal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normaal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BMI_NORMAAL_GOOD",
                                                    "resultText": "Je BMI - of Body Mass Index is de verhouding tussen je gewicht en je lichaamslengte. In jouw geval ligt die tussen 18,5 en 25. Dat betekent dat je ten opzichte van je lengte een gezond gewicht hebt.",
                                                    "keyWords": "normaal",
                                                    "advice": "Je gewicht valt binnen de gemiddelde grenzen. Dat betekent niet automatisch dat je evenwichtig eet en voldoende beweegt. Het omgekeerde geldt ook: mensen met (licht) overgewicht eten niet per definitie ongezond. Fixeer je dus niet op je BMI of het getal op de weegschaal.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1719837987002
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO",
                                            "name": "Buik-heupratio",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 1.2,
                                                    "stringValue": "1.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 0.79,
                                                    "stringValue": "0.79",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.89,
                                                    "stringValue": "0.89",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.99,
                                                    "stringValue": "0.99",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_GOOD",
                                                    "resultText": "Je middel-heupratio is goed",
                                                    "keyWords": "goed",
                                                    "advice": "Goed bezig! Een lage middel-heupratio betekent dat de hoeveelheid vet niet is opgeslagen rond je middel. Houden zo!",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "180.0",
                                            "score": 180,
                                            "maxScore": 210,
                                            "goalScore": 205,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 20.5,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "180.0",
                                            "score": 180,
                                            "maxScore": 210,
                                            "goalScore": 205,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 20.92250361244201,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 210,
                                            "goalScore": 205,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 28.97393776654557,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "130.0",
                                            "score": 130,
                                            "maxScore": 210,
                                            "goalScore": 205,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 28.98688990680777,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "180.0",
                                            "score": 180,
                                            "maxScore": 210,
                                            "goalScore": 205,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 20.994220092782722,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 210,
                                            "goalScore": 200,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 21.07675760242495,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 210,
                                            "goalScore": 200,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 21.079886574753107,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 210,
                                            "goalScore": 200,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 21.086144519409405,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 210,
                                            "goalScore": 200,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 21.129950132003522,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 210,
                                            "goalScore": 200,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 21.142466021316125,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 210,
                                            "goalScore": 200,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 21.38339689058375,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 210,
                                            "goalScore": 200,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 21.42407353084971,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "175.0",
                                            "score": 175,
                                            "maxScore": 210,
                                            "goalScore": 200,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 21.42720250317786,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_VOORDELEN_SPIERMASSA",
                                    "name": "Bijkomen in spiermassa",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke aanmaak",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke aanmaak",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke aanmaak",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "vlotte aanmaak",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA_LAAG",
                                                    "resultText": "Als jij op krachtoefeningen zou werken, dan zou dat volgens ons DNA-onderzoek een gunstig effect op jouw spiermassa hebben.",
                                                    "keyWords": "vlotte aanmaak",
                                                    "advice": "Jouw lichaam maakt op een normale wijze spiermassa aan. Als je net dat tikkeltje meer wil, is het aangeraden om krachtoefeningen met een gezond en gevarieerd eetpatroon te combineren.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                            "name": "Spiermassa",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 64,
                                                    "stringValue": "64.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 45.2,
                                                    "stringValue": "45.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 67.8,
                                                    "stringValue": "67.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 39.6,
                                                    "stringValue": "39.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                                    "resultText": "Spiermassa",
                                                    "keyWords": "magere spiermassa",
                                                    "advice": "Tot je spiermassa behoren je skeletspieren, je gladde spieren (zoals de hart- en spijsverteringsspieren) en het vocht in die spieren. Spieren fungeren als een motor die energie verbruikt. Wanneer je spiermassa toeneemt, stijgt de snelheid waarmee je energie verbrandt (calorieÃ«n), waardoor je basaalmetabolisme of ruststofwisseling (BMR) toeneemt. Daardoor kan je je vetgehalte verminderen en op een gezonde manier gewicht verliezen. Als je hard traint, zal je spiermassa toenemen, waardoor ook je totale lichaamsgewicht kan toenemen. Het is daarom belangrijk regelmatig je spiermassa te meten om te zien welk effect je trainingsprogramma op je spiermassa heeft.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_SPORT_BOTTEN_TESTOSTERON",
                                            "name": "Testosteron",
                                            "unit": "nmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.7,
                                                    "stringValue": "0.7",
                                                    "tag": "RESULT_BLOOD_SPORT_BOTTEN_TESTOSTERON_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 22.4,
                                                    "stringValue": "22.4",
                                                    "tag": "RESULT_BLOOD_SPORT_BOTTEN_TESTOSTERON_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<0.4",
                                                    "tag": "RESULT_BLOOD_SPORT_BOTTEN_TESTOSTERON_NORMAAL",
                                                    "resultText": "Je testosteronwaarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Je kunt zelf heel wat ondernemen om een tekort aan testosteron te vermijden wanneer je ouder wordt. Hieronder geven we je enkele praktische tips om de hoeveelheid van dit hormoon te verhogen.\n\n  * Slaap voldoende, want de productie van testosteron neemt vooral in de nacht toe wanneer je aan het slapen bent. Probeer elke dag netjes 7 Ã  8 uur te slapen en de kwaliteit van je nachtrust te verbeteren. Je kunt dat onder andere doen door in een donkere en niet te warme kamer te slapen, en vlak voor je naar bed gaat geen schermen meer te bekijken.\n\n  * Denk aan je voeding, want die kan veel invloed hebben op een testosterontekort. Drink bijvoorbeeld niet te veel alcohol. Alcohol heeft invloed op de cellen waarin het hormoon wordt geproduceerd, met als gevolg dat de productie afneemt. Eet juist wel een hoop groenten waarin diindolylmethane zit. Dat is een stof die zorgt voor een hogere productie van testosteron. Je vindt deze stof vooral in bloemkool, spruiten, broccoli en andere koolsoorten. Daarnaast kunnen Braziliaanse noten, avocado's, olijfolie, granaatappelpitten, (rode) ui... ook je productie van testosteron stimuleren.\n\n  * Zorg voor voldoende inname van proteÃ¯ne, zoân 1,4 tot 2,0 g/kilogram lichaamsgewicht per dag. Als je dit combineert met zware trainingen, dien je vaak je eiwitinname wat te verhogen.\n\n  * Houd stress onder controle. Langdurige stress heeft ook invloed op ons testosteronniveau. Bij stressklachten, zoals een burn-out, neemt vaak als eerste de productie van cortisol sterk af doordat de bijnier uitgeput raakt. In een later stadium wordt ook het hormoon DHEA, dat bescherming biedt wanneer je lichaam stress ervaart, niet meer goed aangemaakt. In een nog later stadium daalt het testosteronniveau, omdat testosteron uit DHEA wordt gemaakt.\n\n  * Houd je gewicht en buikomtrek onder controle. Vetcellen maken het vrouwelijke hormoon oestrogeen aan uit testosteron. Deze vrouwelijke hormonen hebben een sterk remmende werking op de productie van testosteron, waardoor er minder van wordt aangemaakt. Het gevolg hiervan is dat het testosteronniveau daalt. Als vrouw dient je buikomtrek lager te zijn dan 80cm, als man lager dan 94cm. Haal de lintmeter er alvast even bij.\n\n  * Misschien wel de leukste: heb regelmatig seks. Het zal je niet verbazen, maar seks zorgt er ook voor dat je productie van testosteron pijlsnel omhoogschiet. Mannen die regelmatig seks hebben, hebben over het algemeen een hoger gehalte van dit hormoon dan mannen die weinig seks hebben. Het kan dus zeker geen kwaad om actief te blijven op seksgebied.\n\n  * Neem extra vitamine B. Deze vitamine heeft niet direct veel invloed op je testosterongehalte, maar wel op je oestrogeengehalte. Oestrogeen wordt meestal gezien als het vrouwelijke hormoon, terwijl mannen het in mindere mate ook hebben. Mannen willen liever niet een te hoog gehalte aan oestrogeen in hun lichaam hebben, want dit hormoon heeft bij hen namelijk een dikmakende werking. Bij een vitamine B-tekort zorgt je lichaam ervoor dat je oestrogeenniveau stijgt, iets wat je als man dus niet wil. Let er daarom op dat je voldoende vitamine B binnenkrijgt.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 19.578947368421055,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 19.982468148468367,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.121212121212121,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 24.23766874918083,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.121212121212121,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 24.248503648040547,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 20.05096245061662,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.3",
                                    "score": 8.333333333333334,
                                    "maxScore": 10,
                                    "goalScore": 9.090909090909092,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 20.118723165951092,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 20.062874503164142,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 20.0688305294379,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 20.11052271335423,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 20.12243476590175,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 20.351741777441553,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 20.390455948220996,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.6",
                                    "score": 8.636363636363637,
                                    "maxScore": 10,
                                    "goalScore": 9.393939393939394,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 20.39343396135788,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_MOVE_VOEDING",
                            "name": "Voeding en sport",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_MOVE_VOEDING_CAFEINE",
                                    "name": "CafeÃ¯ne en sporten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE",
                                            "name": "DNA cafeÃ¯ne en sport",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "minder gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_LAAG",
                                                    "resultText": "Op basis van jouw DNA-analyse blijkt dat jij cafeÃ¯ne snel afbreekt.",
                                                    "keyWords": "gunstig effect",
                                                    "advice": "Omdat jij cafeÃ¯ne snel afbreekt, kan je een maximaal voordeel halen uit cafeÃ¯ne door die minder dan een uur voor de aanvang van jouw training of wedstrijd in te nemen. Afhankelijk van hoelang je sport, kan je tijdens de training of wedstrijd extra cafeÃ¯ne innemen.\n\nHet is heel simpel om te berekenen hoeveel cafeÃ¯ne je nodig hebt om effect te ervaren. De ondergrens ligt op 3 mg/kg lichaamsgewicht, de bovengrens op 6 mg/kg. Wanneer je die bovengrens overschrijdt, verdwijnen de voordelen en ervaar je nadelen.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_CAFEINE",
                                            "name": "CafeÃ¯negebruik",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed evenwicht",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_CAFEINE_ZEERGOED_1",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116232664
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed evenwicht",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_CAFEINE_ZEERGOED_1",
                                                    "resultText": "Op basis van je antwoorden blijkt dat je huidige inname van cafeÃ¯ne onder je persoonlijk aanvaardbare grens (5,7 mg x lichaamsgewicht) per dag ligt.",
                                                    "keyWords": "goed evenwicht",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125534944
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_VOEDING_HYDRATATIE",
                                    "name": "Belang van hydratatie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse leiden we af dat je tijdens het sporten last kan hebben van overmatig zweten.",
                                                    "keyWords": "verhoogde nood",
                                                    "advice": "Doordat jij van nature de neiging hebt om tijdens het sporten extra te zweten, raden we je aan om dagelijks minstens 1,5 liter water te drinken. Bij matige lichaamsbeweging zoals joggen of fietsen drink je beter wat extra. Ben je van plan om intensiever en langer te sporten? Drink dan voor, tijdens Ã©n na het sporten extra water om uitdroging te voorkomen. Per uur intensief sporten raden we een liter water aan.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER",
                                            "name": "Inname water",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "minder dan 3",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERSLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "minder dan 3",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERSLECHT",
                                                    "resultText": "Jij drinkt minder dan 3 glazen water doorheen de dag.",
                                                    "keyWords": "minder dan 3",
                                                    "advice": "Dat is te weinig. Probeer je aantal glazen per dag geleidelijk aan op te drijven. In het ideale geval zou je acht of meer glazen per dag drinken.",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_SPORT_HYDRATATIE_EGFR",
                                            "name": "eGFR",
                                            "unit": "ml/min",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 90,
                                                    "intValue": 90,
                                                    "stringValue": "90",
                                                    "tag": "RESULT_BLOOD_SPORT_HYDRATATIE_EGFR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 89,
                                                    "intValue": 89,
                                                    "stringValue": "89",
                                                    "tag": "RESULT_BLOOD_SPORT_HYDRATATIE_EGFR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 77,
                                                    "intValue": 77,
                                                    "stringValue": "77",
                                                    "tag": "RESULT_BLOOD_SPORT_HYDRATATIE_EGFR_NORMAAL",
                                                    "resultText": "Je eGFR-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Normale eGFR-waarden wijzen op een normale nierfunctie. Belangrijk is daarbij een algemene goede gezondheid. Denk bijvoorbeeld aan het vermijden van een hoge bloeddruk en het hebben van goede suikerspiegels in je bloed.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "150.0",
                                            "score": 150,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 160,
                                            "goalScore": 150,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_VOEDING_SPORTDRANKEN",
                                    "name": "Sportdranken met zout",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_LAAG",
                                                    "resultText": "Uit jouw DNA-analyse kunnen we opmaken dat je beschikt over een normale gevoeligheid voor zout. Er is voor jou geen grotere kans op verhoogde bloeddruk als je een normale hoeveelheid zout eet.",
                                                    "keyWords": "weinig gevoelig",
                                                    "advice": "Hou je aan de normale hoeveelheid zout. Voor een volwassene bedraagt die minder dan 5 gram zout (2000 milligram natrium), de aanbevolen hoeveelheid kalium per dag is 3510 milligram.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_VOEDING_IJZER",
                                    "name": "Ijzer",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_MATIG",
                                                    "resultText": "Op basis van je DNA-analyse merken we dat je een verhoogde gevoeligheid hebt voor een tekort aan transferrine en ijzerwaarden in jouw bloedplasma. ",
                                                    "keyWords": "licht verhoogde nood",
                                                    "advice": "Een tekort aan ijzer kan ertoe leiden dat je sneller vermoeid en buiten adem bent, last hebt van een bleke huid en rusteloze benen die je steeds het gevoel geven dat je ze moet bewegen. Als je wil voorkomen dat jouw lichaam met een ijzertekort kampt, raden wij jou aan om met de volgende zaken rekening te houden.\n\n- Eet genoeg vlees(vervangers) die voldoende ijzer bevatten.\n- Kies vooral voor volkorenbrood, volkorenpasta en peulvruchten.\n- Neem bij iedere maaltijd groenten en/of fruitsoorten die rijk zijn aan vitamine C.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER",
                                            "name": "Ijzer",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 107,
                                                    "intValue": 107,
                                                    "stringValue": "107",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 123,
                                                    "intValue": 123,
                                                    "stringValue": "123",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 100,
                                                    "intValue": 100,
                                                    "stringValue": "100",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "resultText": "Je ijzerwaarde is normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Idealiter bedragen je ijzerwaarden tussen de 70 en 125Î¼g/dl. Door gezond en gevarieerd te eten krijg je dat normaal binnen. VegetariÃ«rs krijgen over het algemeen alleen non-heemijzer binnen, waardoor de opname door het lichaam wat lager is. Wie geen vlees eet, heeft soms lagere ijzervoorraden dan anderen, maar dat niveau is nog steeds voldoende.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE",
                                            "name": "Ferritine",
                                            "unit": "Âµg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 22.3,
                                                    "stringValue": "22.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 186.3,
                                                    "stringValue": "186.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 60.6,
                                                    "stringValue": "60.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 40,
                                                    "intValue": 40,
                                                    "stringValue": "40",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_HOOG",
                                                    "resultText": "Je ferritinewaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een methode om je ferritinewaarden te verlagen is je voedselpatroon aan te passen aan het te hoge ferritinegehalte in je bloed. Een speciaal voedingspatroon kan een oplossing zijn om het overschot te beperken. Er zijn namelijk een aantal producten die je kunnen helpen om je ijzeroverschot naar beneden te brengen, zoals:\n\n  * Thee tijdens de maaltijd\n  * Vruchtensappen overdag\n  * Boter, kaas en eieren\n  * Vis\n  * Volkorenproducten\n\nVolgende producten kan je beter vermijden:\n\n  * Koffie\n  * Sla\n  * Gedroogd fruit\n  * Rundvlees en varkensvlees\n  * Groenten zoals broccoli, sperziebonen en andijvie\n  * Olijven, vooral zwarte\n  * Artisjokken\n\nEen belangrijke tip om de ferritinewaarden in je bloed te verlagen is om rekening te houden met je gewicht. Overgewicht werkt niet bevorderlijk om het ijzergehalte in je bloed te reduceren. Als je het terugdringen van je gewicht combineert met een regelmatig bezoek aan de sportschool en aan een aangepast dieet merk je al snel dat je lichaam daar positief op reageert.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "110.0",
                                            "score": 110,
                                            "maxScore": 110,
                                            "goalScore": 110,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 27.667351129363453,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 27.675564681724847,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 27.733059548254623,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 27.749486652977414,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 28.065708418891173,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 28.119096509240247,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "70.0",
                                            "score": 70,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 28.123203285420942,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_VOEDING_CALCIUM",
                                    "name": "Calcium",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_LAAG",
                                                    "resultText": "Op basis van jouw DNA-resultaten blijkt dat je geen verhoogde nood hebt aan calcium voor jouw botstevigheid.",
                                                    "keyWords": "geen extra nood",
                                                    "advice": "Doordat jij geen genetische aanleg hebt voor verlaagde calciumniveaus volstaat het voor jou om gezond en gevarieerd te blijven eten. Extra calcium innemen is voor jou dan ook niet noodzakelijk.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM",
                                            "name": "Calcium",
                                            "unit": "10^6/Âµl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.25,
                                                    "stringValue": "2.25",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.41,
                                                    "stringValue": "2.41",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 98,
                                                    "intValue": 98,
                                                    "stringValue": "98",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 45,
                                                    "intValue": 45,
                                                    "stringValue": "45",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "resultText": "Je calciumwaarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Wanneer je gezond en gevarieerd eet, krijgt je normaal gezien voldoende calcium binnen. \n\nCalciumrijke voedingsproducten zijn vooral zuivelproducten (bijvoorbeeld melk of yoghurt) of met calcium verrijkte plantaardige varianten van zuivel, zoals sojamelk en amandelmelk. \n\nDaarnaast zijn nog heel wat andere voedingsstoffen rijk aan calcium. Denk bijvoorbeeld aan noten, groene groenten (zoals broccoli, spinazie, Chinese kool of rammenas), bonen, zeewier, vis (zoals maatjes, zeebrasem of sardines) en zaden.\n\nOmdat vitamine D onmisbaar is voor de opname van calcium in je lichaam, is het belangrijk dat je er voldoende binnenkrijgt.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_VOEDING_SUIKERS",
                                    "name": "Suikers",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN_MATIG",
                                                    "resultText": "Op basis van jouw DNA-resultaten blijkt dat jouw lichaam koolhydraten matig verwerkt.",
                                                    "keyWords": "matige verwerking",
                                                    "advice": "Probeer je inname van vrije suikers tot slechts 5% van je dagelijkse energie-inname te beperken. Snelle suikers zijn voor jou goede energiebronnen tijdens het sporten. De laatste uren vÃ³Ã³r je van start gaat, moet je voorzichtig zijn met eten. \n\nAls je kort voor het sporten nog allerlei hapjes naar binnen werkt, kan je maag flink van streek raken. Bovendien krijgt je lichaam het dan te druk met het verteren van de voeding. Het is een goede richtlijn om twee tot drie uur vÃ³Ã³r de wedstrijd voor het laatst te eten. Na zoân anderhalf uur intensieve inspanning begint de voorraad koolhydraten in je lichaam op te raken. Om je spieren van voldoende energie te voorzien, moet je dus snel opneembare koolhydraten naar binnen werken. Dat kan bijvoorbeeld door een sportdrankje te drinken - zeer handig tijdens het hardlopen - of door wat te eten. Dat laatste is natuurlijk eenvoudiger als je op de fiets zit. In zoân geval kan je een stuk fruit, een mueslireep of een boterham met zoet beleg meenemen. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_VOEDING_BCAA",
                                    "name": "BCAA",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA_LAAG",
                                                    "resultText": "Volgens jouw DNA-analyse heeft jouw lichaam een normale verwerking van BCAA's.",
                                                    "keyWords": "normale verwerking",
                                                    "advice": "Als jij extra valine of leucine zou innemen zal jij weinig tot geen verschillen in jouw sportprestaties opmerken. Een gezond en gevarieerd voedingspatroon blijft voor jou uiterst belangrijk.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOVE_VOEDING_ANTIOXIDANTEN",
                                    "name": "Antioxidanten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse blijkt dat jij een verminderde weerbaarheid voor oxidatieve stress hebt.",
                                                    "keyWords": "zeer gevoelig",
                                                    "advice": "Iedereen ondervindt tijdens een inspanning enige mate van oxidatieve stress. Te veel oxidatieve stress kan leiden tot meer ontstekingen, spiervermoeidheid en -schade. Tijdens de inspanning heeft het lichaam meer zuurstof nodig, waardoor sporters meer vrije radicalen produceren. \n\nAls we onze oxidatieve stress willen verminderen is het belangrijk groenten en fruit rijk aan antioxidanten toe te voegen aan ons voedingspatroon. Die groenten en fruit kan je herkennen aan hun felle en diepgaande kleur, zoals het geval is bij blauwe bessen, bramen, veenbessen en frambozen. Ook mandarijnen, navelsinaasappels, pompelmoes, kiwi, abrikozen, mango, banaan en citroensap zijn ideaal! \n\nVoor groenten rijk aan antioxidanten kan je kijken naar rauwe gember, broccoli, rode sla, asperges, avocado, rode bieten, (rode) uien, groene sla, pepers, aubergine, bloemkool, wortels, tomaat en galangawortel.\n\nOok noten en peulvruchten (pistachenoten, pecannoten, walnoten, rode bonen, linzen ...) en kruiden zoals kurkuma, kaneel, oregano, tijm of chili zijn perfect om de oxidatieve stress te verminderen. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_TAS",
                                            "name": "Totale antioxidantstatus",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.56,
                                                    "stringValue": "1.56",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_TAS_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 1.81,
                                                    "stringValue": "1.81",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_TAS_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.75,
                                                    "stringValue": "1.75",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_TAS_NORMAAL",
                                                    "resultText": "Je totale antioxidantenstatus is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Wanneer je je lichaam goed wil beschermen tegen oxidatieve stress is het belangrijk dat je voldoende antioxidanten binnenkrijgt via je voeding. Tracht te streven naar een waarde tussen 1,5 en 1,77 mmol/L.\n\nAntioxidanten zitten in gangbare producten zoals verschillende groenten, fruit, noten en kruiden. Vooral felgekleurde groenten en fruit bevatten verschillende antioxidatieve vitamines en mineralen. Daarnaast bevatten ze flavonoÃ¯de antioxidanten, die zorgen voor de kleur van groenten en fruit. Dat niet alleen: ze hebben ook een heel belangrijke werking op het lichaam. Ze bieden namelijk bescherming tegen de vrije radicalen. Zo zorgen ze ervoor dat gezonde cellen en weefsels worden behouden. Daarnaast zijn flavonoÃ¯den van essentieel belang voor de stofwisseling van vitamine C. Ze versterken elkaars effect, want flavonoÃ¯den zorgen ervoor dat gezonde cellen en weefsels worden behouden.\n\nDoor middel van je levensstijl kan je ook de productie van vrije radicalen verminderen. Vrije radicalen kunnen toenemen door ongezonde voeding, stresshormonen, roken, alcohol, overmatig sporten of juist de verzuring van onvoldoende beweging.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.1",
                                    "score": 9.069767441860465,
                                    "maxScore": 10,
                                    "goalScore": 9.069767441860465,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.4",
                                    "score": 7.3584905660377355,
                                    "maxScore": 10,
                                    "goalScore": 9.245283018867925,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 23.0814861615683,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.4",
                                    "score": 7.3584905660377355,
                                    "maxScore": 10,
                                    "goalScore": 9.245283018867925,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 23.084926025377772,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.4",
                                    "score": 7.3584905660377355,
                                    "maxScore": 10,
                                    "goalScore": 9.245283018867925,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 23.095245616806192,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.0754716981132075,
                                    "maxScore": 10,
                                    "goalScore": 8.962264150943396,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 23.34966917636322,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.2",
                                    "score": 7.169811320754717,
                                    "maxScore": 10,
                                    "goalScore": 9.056603773584905,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 23.295363665838103,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.7924528301886795,
                                    "maxScore": 10,
                                    "goalScore": 9.339622641509434,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 25.36173853524983,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.7924528301886795,
                                    "maxScore": 10,
                                    "goalScore": 9.339622641509434,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 25.36926762491444,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.7924528301886795,
                                    "maxScore": 10,
                                    "goalScore": 9.339622641509434,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 25.421971252566735,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.7924528301886795,
                                    "maxScore": 10,
                                    "goalScore": 9.339622641509434,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 25.43702943189596,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.7924528301886795,
                                    "maxScore": 10,
                                    "goalScore": 9.339622641509434,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 25.72689938398357,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.7924528301886795,
                                    "maxScore": 10,
                                    "goalScore": 9.339622641509434,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 25.775838466803556,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.8",
                                    "score": 6.7924528301886795,
                                    "maxScore": 10,
                                    "goalScore": 9.339622641509434,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 25.779603011635864,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        }
                    ],
                    "results": [],
                    "scoreResult": [
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.5",
                            "score": 7.456998848808757,
                            "maxScore": 10,
                            "goalScore": 9.645028210751164,
                            "realAge": 27.211498973305954,
                            "leadlifeAge": 23.281552178495364,
                            "goalAge": 18,
                            "time": 1672613999000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.6",
                            "score": 7.556772459151459,
                            "maxScore": 10,
                            "goalScore": 9.680131326152656,
                            "realAge": 28.369609856262834,
                            "leadlifeAge": 23.532994827843023,
                            "goalAge": 18.3709787816564,
                            "time": 1709161199000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.3",
                            "score": 7.253742156121156,
                            "maxScore": 10,
                            "goalScore": 9.680131326152656,
                            "realAge": 28.372347707049965,
                            "leadlifeAge": 24.519756302818053,
                            "goalAge": 18.373716632443532,
                            "time": 1709247599000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.3",
                            "score": 7.253742156121156,
                            "maxScore": 10,
                            "goalScore": 9.680131326152656,
                            "realAge": 28.380561259411362,
                            "leadlifeAge": 24.530717302506392,
                            "goalAge": 18.38193018480493,
                            "time": 1709506799000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.2",
                            "score": 7.199726374254676,
                            "maxScore": 10,
                            "goalScore": 9.583578371314221,
                            "realAge": 28.432580424366872,
                            "leadlifeAge": 24.53748782981414,
                            "goalAge": 18.43394934976044,
                            "time": 1711148399000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.2",
                            "score": 7.157988238176918,
                            "maxScore": 10,
                            "goalScore": 9.54184023523646,
                            "realAge": 28.44079397672827,
                            "leadlifeAge": 24.584026425987815,
                            "goalAge": 18.442162902121833,
                            "time": 1711407599000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.2",
                            "score": 7.221044678591849,
                            "maxScore": 10,
                            "goalScore": 9.672037082414441,
                            "realAge": 28.4435318275154,
                            "leadlifeAge": 24.705533894907113,
                            "goalAge": 18.444900752908968,
                            "time": 1711493999000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.2",
                            "score": 7.221044678591849,
                            "maxScore": 10,
                            "goalScore": 9.672037082414441,
                            "realAge": 28.449007529089666,
                            "leadlifeAge": 24.71286817838489,
                            "goalAge": 18.45037645448323,
                            "time": 1711666799000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.1",
                            "score": 7.137711345258515,
                            "maxScore": 10,
                            "goalScore": 9.672037082414441,
                            "realAge": 28.487337440109513,
                            "leadlifeAge": 25.053332212965955,
                            "goalAge": 18.48870636550308,
                            "time": 1712872799000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.1",
                            "score": 7.137711345258515,
                            "maxScore": 10,
                            "goalScore": 9.672037082414441,
                            "realAge": 28.49828884325804,
                            "leadlifeAge": 25.06817203657796,
                            "goalAge": 18.49965776865161,
                            "time": 1713218399000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.1",
                            "score": 7.137711345258515,
                            "maxScore": 10,
                            "goalScore": 9.672037082414441,
                            "realAge": 28.709103353867214,
                            "leadlifeAge": 25.35383864110904,
                            "goalAge": 18.71047227926078,
                            "time": 1719871199000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.1",
                            "score": 7.137711345258515,
                            "maxScore": 10,
                            "goalScore": 9.672037082414441,
                            "realAge": 28.744695414099933,
                            "leadlifeAge": 25.402068067848052,
                            "goalAge": 18.746064339493497,
                            "time": 1720994399000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.1",
                            "score": 7.137711345258515,
                            "maxScore": 10,
                            "goalScore": 9.672037082414441,
                            "realAge": 28.747433264887064,
                            "leadlifeAge": 25.40577802375105,
                            "goalAge": 18.748802190280628,
                            "time": 1721080799000
                        }
                    ]
                },
                {
                    "tag": "DASHBOARD_SLEEP",
                    "name": "DASHBOARD_SLEEP",
                    "groups": [
                        {
                            "tag": "DASHBOARD_SLEEP_KWALITEIT",
                            "name": "Slaapkwaliteit",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_PSQI",
                                    "name": "Objectieve slaapkwaliteit",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_TOTAAL",
                                            "name": "Totale score",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_TOTAAL_ERROR",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130050303
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_SUBJECTIVE",
                                    "name": "Subjectieve slaapkwaliteit",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_SUBJECTIEF_SK",
                                            "name": "Subjectieve slaapkwaliteit",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "Slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_SUBJECTIEF_SK_BAD",
                                                    "resultText": "De kwaliteit van jouw slaap is redelijk slecht. ",
                                                    "keyWords": "Slecht",
                                                    "advice": "Je hebt aangegeven dat je slaapkwaliteit redelijk slecht is. Overweeg dus zeker onderstaande suggesties om je slaap te verbeteren:\nâ¢ Vermijd zware maaltijden twee uur voor bedtijd, maar probeer niet met honger naar bed te gaan.\nâ¢ Vermijd cafeÃ¯ne vier uur voor het slapengaan en vermijd het gebruik van alcohol als slaapmiddel.\nâ¢ Het is aan te raden om regelmatig te bewegen, maar vermijd intense lichaamsbeweging kort voor het slapengaan.\nâ¢ Vermijd activiteiten die stress veroorzaken voordat je gaat slapen. ",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130050303
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_QUALITY",
                                            "name": "Slaapkwaliteit",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "doubleValue": 61,
                                                    "intValue": 61,
                                                    "stringValue": "61",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_QUALITY_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 72,
                                                    "intValue": 72,
                                                    "stringValue": "72",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_QUALITY_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "doubleValue": 67,
                                                    "intValue": 67,
                                                    "stringValue": "67",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_QUALITY_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 71,
                                                    "intValue": 71,
                                                    "stringValue": "71",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_QUALITY_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 72,
                                                    "intValue": 72,
                                                    "stringValue": "72",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_QUALITY_GOOD",
                                                    "resultText": "Jouw slaapkwaliteit is goed. ",
                                                    "keyWords": "Goed",
                                                    "advice": "Een goede nachtrust is belangrijk om goed te kunnen functioneren gedurende de dag en om mentaal en fysiek gezond te blijven. Neem 's ochtends even de tijd om te evalueren hoe je je voelt na een nacht slaap en kijk of er nog verdere verbeteringen mogelijk zijn. Hier zijn enkele tips die kunnen helpen om je slaapkwaliteit te verbeteren:\n- Zorg voor een consistent slaapritme.\n- CreÃ«er een comfortabele, stille en donkere slaapomgeving.\n- Vermijd het gebruik van stimulerende middelen zoals cafeÃ¯ne, nicotine en alcohol voor het slapengaan.\n- Zorg voor voldoende lichaamsbeweging gedurende de dag.\n- Schakel elektronische apparaten minstens een uur voor het slapengaan uit.\n- Probeer stress en angst te verminderen door stressverlagende technieken te leren, zoals ademhalingsoefeningen, yoga of meditatie.",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_SLAAPLATENCY",
                                    "name": "Inslaaptijd",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_GEWOONTE_INSLAAPVALLEN",
                                            "name": "Inslaaptijd",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "Heel slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_GEWOONTE_INSLAAPVALLEN_VERYBAD",
                                                    "resultText": "Jij hebt heel veel tijd nodig om in slaap te vallen.",
                                                    "keyWords": "Heel slecht",
                                                    "advice": "De tijd om in slaap te vallen is heel lang bij jou. Een ontspannende routine voor het slapengaan is bijgevolg sterk aanbevolen. Dit kan activiteiten omvatten zoals het lezen van een boek of naar rustgevende muziek luisteren. Het doel van deze routine is om je lichaam en geest voor te bereiden op rust en slaap. \nHet is ook nuttig om regelmatig ontspanningstechnieken toe te passen; die kunnen jou in een meer ontspannen toestand brengen voordat je gaat slapen. ",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130050303
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_LATENCY",
                                            "name": "Gemiddeld aantal minuten nodig om in slaap te vallen",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "doubleValue": 20,
                                                    "intValue": 20,
                                                    "stringValue": "20",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_LATENCY_2_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 15,
                                                    "intValue": 15,
                                                    "stringValue": "15",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_LATENCY_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "doubleValue": 20,
                                                    "intValue": 20,
                                                    "stringValue": "20",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_LATENCY_2_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 16,
                                                    "intValue": 16,
                                                    "stringValue": "16",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_LATENCY_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "doubleValue": 21,
                                                    "intValue": 21,
                                                    "stringValue": "21",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_LATENCY_2_NEUTRAL",
                                                    "resultText": "Je inslaaptijd ligt tussen de 20 en 30 minuten.",
                                                    "keyWords": "Te lang",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_SLAAPEFFICIENCY",
                                    "name": "SlaapefficiÃ«ntie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_SLAAPEFFICIENCY",
                                            "name": "Jouw gerapporteerde slaapefficiÃ«ntie",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_SLAAPEFFICIENCY_ERROR",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130050303
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_EFFICIENCY",
                                            "name": "SlaapefficiÃ«ntie",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "doubleValue": 82,
                                                    "intValue": 82,
                                                    "stringValue": "82",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_EFFICIENCY_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 87,
                                                    "intValue": 87,
                                                    "stringValue": "87",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_EFFICIENCY_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 88,
                                                    "intValue": 88,
                                                    "stringValue": "88",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_EFFICIENCY_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 86,
                                                    "intValue": 86,
                                                    "stringValue": "86",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_EFFICIENCY_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 89,
                                                    "intValue": 89,
                                                    "stringValue": "89",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_EFFICIENCY_GOOD",
                                                    "resultText": "Jij brengt meer dan 85% van de tijd in bed slapend door.",
                                                    "keyWords": "Optimaal",
                                                    "advice": "Uitstekend! Jij hebt een hoge slaapefficiÃ«ntie! Dit betekent dat je bijna alle tijd die je in bed doorbrengt, slaapt. Het kan erop wijzen dat je een gezonde slaapkwaliteit hebt en dat je slaapbehoefte overeenkomt met de tijd die je in bed doorbrengt. Doe zo verder!",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_SLAAPVERSTORING",
                                    "name": "Slaapverstoring",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_SLAAPVERSTORING",
                                            "name": "Slaapverstoring",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_SLAAPVERSTORING_BAD",
                                                    "resultText": "Jij hebt de voorbije maand vaak slaapverstorende factoren ervaren.",
                                                    "keyWords": "slecht",
                                                    "advice": "Jij wordt 's nachts vaak geconfronteerd met slaapverstorende factoren wat ten koste gaat van jouw slaap. Overweeg manieren om slaapverstorende factoren te minimaliseren. Hierbij nog enkele tips: \nâ¢ CreÃ«er een omgeving die bevordelijk is voor de slaap d.w.z. zorg voor een aangename kamertemperatuur (tussen 16Â°C en 18Â°C), vermijd lawaai en fel licht. \nâ¢ Drink niet te veel voor het slapengaan om te voorkomen dat je 's nachts moet plassen.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130050303
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_MEDICATIE",
                                    "name": "Slaapmedicatie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_MEDICATIE",
                                            "name": "Gebruik van slaapbevorderende medicatie",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_MEDICATIE_NEUTRAL",
                                                    "resultText": "Gedurende de voorbije maand heb jij niet wekelijks slaapmedicatie genomen.",
                                                    "keyWords": "matig",
                                                    "advice": "Ook al heb je de voorbije maand niet wekelijks slaapmedicatie genomen, probeer toch om het gebruik van slaapmedicatie tot het uiterste minimum te beperken. Zoek indien nodig professionale hulp bij een arts om alternatieve strategieÃ«n te bespreken. Gebruik medicatie enkel onder toezicht van een arts en volg de voorgeschreven instructies. ",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130050303
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_DISFUNCTIE",
                                    "name": "Disfunctie overdag",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_DISFUNCTIEOVERDAG",
                                            "name": "Invloed op het dagelijkse functioneren",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_DISFUNCTIEOVERDAG_NEUTRAL",
                                                    "resultText": "Jij hebt een klein beetje moeite om overdag goed te functioneren. ",
                                                    "keyWords": "matig",
                                                    "advice": "Uit jouw antwoorden blijkt dat je enige moeite hebt om overdag goed te functioneren, maar het is niet ernstig. Het is van belang om jouw slaapgewoonten onder de loep te nemen om na te gaan of de impact op jouw dagelijkse functioneren verminderd wordt.\nZoek indien nodig professionele hulp bij een arts om de onderliggende oorzaken te onderzoeken en aan te pakken.  ",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130050303
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_MAGNESIUM",
                                    "name": "Magnesium",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM",
                                            "name": "Magnesium",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.84,
                                                    "stringValue": "0.84",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.8,
                                                    "stringValue": "0.80",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.81,
                                                    "stringValue": "0.81",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_HOOG",
                                                    "resultText": "Je magnesiumwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een overschot aan magnesium ontstaat enkel bij gebruik van tabletten waarin magnesium zit, magnesiumzouten of mineraalwater waarin veel magnesium zit. \n\nBij meer dan 250 milligram magnesium per dag extra, dus naast het magnesium in je eten, kunnen darmklachten zoals diarree ontstaan.\n",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_INTENSITY",
                                    "name": "Slaapintensiteit",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTENSITY",
                                            "name": "Slaapintensiteit",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 58.77775316567956,
                                                    "stringValue": "58.77775316567956",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTENSITY",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 61.81474920670362,
                                                    "stringValue": "61.81474920670362",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTENSITY",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 62.61479764668623,
                                                    "stringValue": "62.61479764668623",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTENSITY",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 59.7042798225536,
                                                    "stringValue": "59.7042798225536",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTENSITY",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 61.8393641144401,
                                                    "stringValue": "61.8393641144401",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTENSITY",
                                                    "resultText": "Slaapintensiteit",
                                                    "advice": "Een goede slaapintensiteit heeft een directe invloed op je energie, humeur en concentratie overdag. Het versterkt ook je immuunsysteem, bevordert een gezond metabolisme en vermindert je risico op chronische aandoeningen zoals diabetes en hart- en vaataandoeningen. Om je slaapintensiteit te verbeteren kun je volgende tips toepassen:\n- Zorg voor een koele, donkere en stille slaapkamer.\n- Vermijd stimulerende middelen zoals cafeÃ¯ne, nicotine en alcohol voor het slapengaan.\n- Beperk schermtijd minstens een uur voor het slapengaan om je slaapkwaliteit te verbeteren.\n- Zorg voor voldoende lichaamsbeweging gedurende de dag.\n- Gebruik ontspanningstechnieken zoals meditatie of yoga om stress te verminderen en je slaapkwaliteit te verbeteren.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_KWALITEIT_HR",
                                    "name": "Hartslag tijdens je slaap",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                            "name": "Gemiddelde hartslag ",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 76,
                                                    "intValue": 76,
                                                    "stringValue": "76",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 73,
                                                    "intValue": 73,
                                                    "stringValue": "73",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 73,
                                                    "intValue": 73,
                                                    "stringValue": "73",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 75,
                                                    "intValue": 75,
                                                    "stringValue": "75",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 76,
                                                    "intValue": 76,
                                                    "stringValue": "76",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "resultText": "Gemiddelde hartslag ",
                                                    "advice": "De gemiddelde hartslag gedurende de nacht is het aantal hartslagen per minuut terwijl je slaapt. Tijdens je slaap is je hartslag het laagst. Een normale nachtelijke hartslag varieert gewoonlijk tussen 40 en 60 slagen per minuut en kan variÃ«ren afhankelijk van factoren zoals leeftijd, conditie en gezondheid. Mensen met een goede cardiovasculaire gezondheid, waaronder fittere personen, hebben vaak een lagere nachtelijke hartslag. Om een gezonde nachtelijke hartslag te bevorderen, is het belangrijk om een regelmatig slaappatroon te behouden, stress te vermijden en een gezonde levensstijl te handhaven.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_LOWESTHEARTHRATE",
                                            "name": "Laagste hartslag 's nachts",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1,
                                                    "intValue": 1,
                                                    "stringValue": "1",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_LOWESTHEARTHRATE",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1,
                                                    "intValue": 1,
                                                    "stringValue": "1",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_LOWESTHEARTHRATE",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1,
                                                    "intValue": 1,
                                                    "stringValue": "1",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_LOWESTHEARTHRATE",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1,
                                                    "intValue": 1,
                                                    "stringValue": "1",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_LOWESTHEARTHRATE",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1,
                                                    "intValue": 1,
                                                    "stringValue": "1",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_LOWESTHEARTHRATE",
                                                    "resultText": "Laagste hartslag 's nachts",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.6363636363636362,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 43.369609856262834,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.6363636363636362,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 43.37234770704997,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.6363636363636362,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 43.380561259411365,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.3",
                                    "score": 5.294117647058823,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 34.81968210510305,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.7",
                                    "score": 4.705882352941177,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 39.189596167008894,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.3",
                                    "score": 4.294117647058823,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 42.95387846567842,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.3",
                                    "score": 4.294117647058823,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 42.9666300994815,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.6",
                                    "score": 4.588235294117647,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 40.295898488916976,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.6",
                                    "score": 4.588235294117647,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 40.31976693167658,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.6",
                                    "score": 4.588235294117647,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 40.77923445479914,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.6",
                                    "score": 4.588235294117647,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 40.85680689376788,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.6",
                                    "score": 4.588235294117647,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 40.86277400445778,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SLEEP_KWANTITEIT",
                            "name": "Slaapkwantiteit",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_SLEEP_KWANTITEIT_HOEVEEL",
                                    "name": "Hoeveel slaap",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "hoge nood",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR_LANG",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen verhoogde nood",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR_GEEN",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "hoge nood",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR_LANG",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "weinig nood",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR_KORT",
                                                    "resultText": "Uit jouw DNA-analyse kunnen we afleiden dat jij minder uren slaap nodig hebt dan de gemiddelde persoon. Toch is en blijft slaap wel degelijk belangrijk!",
                                                    "keyWords": "weinig nood",
                                                    "advice": "Het onderzoek naar jouw genen wijst uit dat 7 uur slaap per nacht in jouw geval voldoende is. Doordat je minder nood aan slaap hebt, ben je vatbaarder om een slaaptekort op te bouwen. Dat kan op zijn beurt een effect op jouw immuunsysteem hebben, waardoor je sneller infecties kan oplopen. Probeer daar dus op te letten!",
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_GEWOONTE_EFFECTIEVESLAAP",
                                            "name": "Effectieve slaap",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "Goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_PSQI_GEWOONTE_EFFECTIEVESLAAP_GOOD",
                                                    "resultText": "Jij slaapt gewoonlijk meer dan zeven uren. ",
                                                    "keyWords": "Goed",
                                                    "advice": "Op basis van je antwoord zien we dat je voldoende uren slaapt per nacht. Doe zo voort! Hoeveel slaap we nodig hebben kan wel van persoon tot persoon verschillen, maar de meeste volwassenen hebben ongeveer zeven tot acht uur kwaliteitsvolle slaap per nacht nodig.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130050303
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION",
                                            "name": "Gemiddelde slaapduur",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "6h 0m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_1_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "7h 14m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "7h 14m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "7h 38m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "7h 25m",
                                                    "tag": "RESULT_WEARABLES_INTERPRET_SLEEP_DAILY_DURATION_GOOD",
                                                    "resultText": "Je slaapt dagelijks tussen de 7 en 9 uur.",
                                                    "keyWords": "Optimaal",
                                                    "advice": "Goed bezig! Probeer dit slaappatroon vast te houden. Voldoende slaap is belangrijk voor een goede gezondheid, een goed welzijn en een hoge productiviteit. Blijf aandacht besteden aan een consistente slaap-waakritme en vermijd stimulerende middelen voor het slapengaan.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 18.3709787816564,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 18.373716632443532,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 18.38193018480493,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 18.43394934976044,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 18.442162902121833,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 18.444900752908968,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 18.45037645448323,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 18.48870636550308,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 18.49965776865161,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 18.71047227926078,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 18.746064339493497,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 18.748802190280628,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SLEEP_HYGIENE",
                            "name": "SlaaphygiÃ«ne",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_SLEEP_HYGIENE_CAFEINE",
                                    "name": "Impact cafeÃ¯ne",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE",
                                            "name": "DNA cafeÃ¯ne en slaap",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_LAAG",
                                                    "resultText": "Volgens jouw DNA-analyse breek jij cafeÃ¯ne zeer snel af. Daarom zal jij weinig tot geen effect ervaren als je vlak voor het slapen cafeÃ¯ne inneemt.",
                                                    "keyWords": "weinig hinder",
                                                    "advice": "Als slaapmutsje kan een koffie of een ander drankje dat cafeÃ¯ne bevat in jouw geval geen kwaad. Het zal jou niet nodeloos wakker houden, maar overdrijf er ook niet mee.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_HYGIENE_RITUALS",
                                    "name": "Slaaprituelen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HYGIENE",
                                            "name": "Huidige slaaphygiÃ«ne",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HYGIENE_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HYGIENE_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116315184
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HYGIENE_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125621844
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HYGIENE_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HYGIENE_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HYGIENE_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HYGIENE_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "slecht",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HYGIENE_BAD",
                                                    "resultText": "Uit je antwoorden blijkt dat je een slechte slaaphygiÃ«ne hebt. ",
                                                    "keyWords": "slecht",
                                                    "advice": "Dat wil zeggen dat je veel te weinig aandacht schenkt aan handelingen die je slaap bevorderen, zoals een rustgevende slaapomgeving en een vast slaapritueel opbouwen. Daarnaast mijd je onvoldoende handelingen die je slaap negatief kunnen beÃ¯nvloeden, zoals schermgebruik of nicotine, alcohol of koffie voor het slapengaan. ",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1721056754687
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 36,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_HYGIENE_ASLEEP",
                                    "name": "Gemiddeld tijdstip in slaap vallen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_START",
                                            "name": "Gemiddeld tijdstip in slaap vallen",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "22:46",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_START",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "23:21",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_START",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "23:27",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_START",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "23:06",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_START",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "23:07",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_START",
                                                    "resultText": "Gemiddeld tijdstip in slaap vallen",
                                                    "advice": "Dit is het moment waarop je daadwerkelijk in slaap valt nadat je in bed bent gaan liggen. Probeer elke dag op hetzelfde tijdstip naar bed te gaan. Dit kan helpen om je slaapkwaliteit te verbeteren en een gezond slaap-waakritme te behouden, wat belangrijk is voor je gezondheid en welzijn.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_HYGIENE_AWAKE",
                                    "name": "Gemiddelde tijd wakker worden",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_END",
                                            "name": "Gemiddeld tijdstip van ontwaken",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "05:00",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_END",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "07:05",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_END",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "07:04",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_END",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "07:16",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_END",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "06:52",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_END",
                                                    "resultText": "Gemiddeld tijdstip van ontwaken",
                                                    "advice": "De laatste keer dat je wakker wordt voordat je definitief ontwaakt, is vaak het moment voordat je begint aan de laatste slaapcyclus van je slaap. Om te voorkomen dat je onnodig wakker wordt, is het belangrijk om een rustige, stille en donkere slaapomgeving te hebben. Vermijd een uur voor het slapen schermtijd en beperk de consumptie van cafeÃ¯ne en alcohol, vooral in de late avonduren.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.5",
                                    "score": 5.454545454545454,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 33,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 43.369609856262834,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 43.37234770704997,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 43.380561259411365,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "2.7",
                                    "score": 2.727272727272727,
                                    "maxScore": 10,
                                    "goalScore": 9.545454545454545,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 43.432580424366876,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 43.44079397672827,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 43.4435318275154,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 43.44900752908967,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 43.48733744010951,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 43.49828884325804,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 43.709103353867214,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 43.74469541409994,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.2",
                                    "score": 3.1818181818181817,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 43.747433264887064,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SLEEP_STADIA",
                            "name": "Slaapstadia",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_INTERRUPTIONS",
                                    "name": "Onderbrekingen in je slaap",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTERRUPTIONS",
                                            "name": "Gemiddeld aantal onderbrekingen tijdens de slaap",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 121,
                                                    "intValue": 121,
                                                    "stringValue": "121",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTERRUPTIONS",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 114,
                                                    "intValue": 114,
                                                    "stringValue": "114",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTERRUPTIONS",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 124,
                                                    "intValue": 124,
                                                    "stringValue": "124",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTERRUPTIONS",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 111,
                                                    "intValue": 111,
                                                    "stringValue": "111",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTERRUPTIONS",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 142,
                                                    "intValue": 142,
                                                    "stringValue": "142",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INTERRUPTIONS",
                                                    "resultText": "Gemiddeld aantal onderbrekingen tijdens de slaap",
                                                    "advice": "Dit is het totaal aantal keren dat je 's nachts wakker wordt. Het is normaal om af en toe 's nachts wakker te worden. Af en toe wakker worden tijdens je slaap helpt je lichaam zich aan te passen aan nieuwe omgevingsprikkels en dreigingen te controleren. Als je vaak wakker wordt en dit je slaapkwaliteit op een negatieve manier beÃ¯nvloedt, kunnen volgende tips helpen om het aantal slaaponderbrekingen te verminderen:\n- Zorg voor een comfortabele slaapomgeving door een koele, donkere en stille slaapkamer te creÃ«ren.\n- Vermijd stimulerende middelen zoals cafeÃ¯ne, nicotine en alcohol voor het slapengaan.\n- Beperk schermtijd minstens een uur voor het slapengaan om de slaapkwaliteit te verbeteren.\n- Zorg voor voldoende lichaamsbeweging gedurende de dag, maar vermijd intensieve trainingen vlak voor het slapengaan.\n- Vermijd zware, vette maaltijden en grote maaltijden vlak voor het slapengaan.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_LIGHTSLEEP",
                                    "name": "Lichte slaap",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_LIGHT",
                                            "name": "Gemiddelde duur lichte slaap",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "3h 48m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_LIGHT",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "4h 31m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_LIGHT",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "4h 33m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_LIGHT",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "5h 9m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_LIGHT",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "4h 44m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_LIGHT",
                                                    "resultText": "Gemiddelde duur lichte slaap",
                                                    "advice": "Tijdens de slaap doorloop je verschillende fasen: lichte, diepe en REM-slaap. De eerste fase is de lichte slaap. Je spieren ontspannen en je ademhaling wordt regelmatiger. In deze fase kun je gemakkelijk wakker worden door externe prikkels. Om je lichte slaap te bevorderen, is het aan te raden een comfortabele slaapomgeving te creÃ«ren waar het donker, rustig en stil is. Probeer ook schermtijd en zware maaltijden te vermijden voor het slapengaan.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_REM",
                                    "name": "REM-slaap",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_REM",
                                            "name": "Gemiddelde duur REM-slaap",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 22m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_REM",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 29m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_REM",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 26m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_REM",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 26m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_REM",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 36m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_REM",
                                                    "resultText": "Gemiddelde duur REM-slaap",
                                                    "advice": "Tijdens de slaap doorloop je verschillende fasen: lichte, diepe en REM-slaap. Tijdens de REM-slaap, wat staat voor ârapid eye movementâ, maken je gesloten ogen snelle bewegingen en zijn je spieren volledig ontspannen. Je ademhaling en pols worden onregelmatig. In deze fase heb je vaak levendige dromen. Als je op dat moment gewekt wordt, kun je ze vaak nog navertellen. Deze slaap helpt bij het verwerken van de gebeurtenissen van de dag. Een gezonde levensstijl met regelmatige lichaamsbeweging en voldoende ontspanning kan bijdragen aan goede REM-slaap. Vermijd cafeÃ¯ne en zware maaltijden voor het slapengaan, omdat ze je REM-slaap kunnen verstoren.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_DEEPSLEEP",
                                    "name": "Diepe slaap",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_DEEP",
                                            "name": "Gemiddelde duur diepe slaap",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 3m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_DEEP",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 14m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_DEEP",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 16m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_DEEP",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 4m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_DEEP",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 6m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_DEEP",
                                                    "resultText": "Gemiddelde duur diepe slaap",
                                                    "advice": "Tijdens de slaap doorloop je verschillende fasen: lichte, diepe en REM-slaap. In de diepe slaapfase bereikt het lichaam zijn diepste staat van ontspanning wat zorgt voor fysieke recuperatie. Je spieren zijn volledig ontspannen, je ademhaling is zeer regelmatig en je hartritme daalt. Tijdens deze fase ben je het meest afgesloten van de buitenwereld. Probeer een regelmatig slaappatroon aan te houden om voldoende diepe slaap te krijgen.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_TIMEAWAKE",
                                    "name": "Tijd wakker",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_AWAKE",
                                            "name": "Gemiddelde tijd wakker",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 58m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_AWAKE",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 4m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_AWAKE",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 4m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_AWAKE",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 15m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_AWAKE",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "1h 0m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_AWAKE",
                                                    "resultText": "Gemiddelde tijd wakker",
                                                    "advice": "Tijdens de slaap is het normaal om tussen elke slaapfase kort even wakker te worden, vaak herinner je dit niet. Dit maakt deel uit van de natuurlijke slaapcyclus. Als je moeite hebt om tijdens deze wakkere periodes weer in slaap te vallen, kunnen volgende tips helpen:\n- Investeer in een goede matras en een goed kussen en zorg voor een koele, donkere en stille slaapkamer.\n- Ervaar je piekergedachten of heb je last van stress? Focus op langzame, diepe ademhalingen en schrijf eventueel je zorgen op in een notitieboekje om je geest leeg te maken.\n- Als het na twintig minuten niet lukt om opnieuw in slaap te vallen, sta dan op en ontspan door bijvoorbeeld te lezen tot je je weer moe genoeg voelt om weer naar bed te gaan.\n- Richt je aandacht op iets rustgevends, zoals het geluid van je ademhaling of een rustgevende geur.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_AWAKEWAKEUP",
                                    "name": "Tijd in bed na ontwaken",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_AWAKEWAKEUP",
                                            "name": "Gemiddelde tijd in bed na ontwaken",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 24m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_AWAKEWAKEUP",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 19m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_AWAKEWAKEUP",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 21m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_AWAKEWAKEUP",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 28m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_AWAKEWAKEUP",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "0h 18m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_AWAKEWAKEUP",
                                                    "resultText": "Gemiddelde tijd in bed na ontwaken",
                                                    "advice": "Gebruik de tijd tussen ontwaken en opstaan om rustig wakker te worden en jezelf voor te bereiden op de dag. Grijp niet direct naar je telefoon als je wakker wordt, want dit stelt je bloot aan verschillende prikkels. Het is beter om de eerste minuten van de dag aan jezelf te besteden. Neem de tijd om langzaam wakker te worden, haal diep adem en drink wat water. Dit kan helpen om de dag met een kalme en positieve mindset te starten.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_TIMEINBED",
                                    "name": "Totale tijd in bed",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INBED",
                                            "name": "Gemiddelde tijd in bed",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "6h 58m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INBED",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "8h 17m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INBED",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "8h 18m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INBED",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "8h 54m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INBED",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "8h 24m",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_INBED",
                                                    "resultText": "Gemiddelde tijd in bed",
                                                    "advice": "Het is verstandig om je bed uitsluitend te gebruiken voor slaap en intimiteit. Vermijd het gebruik van elektronische apparaten in bed en beperk andere activiteiten zoals werken of eten in je slaapkamer. Zorg daarnaast voor een rustgevende slaapomgeving die koel, donker en stil is om de kwaliteit van je slaap te optimaliseren.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_REGULARITY",
                                    "name": "Regelmaat slaap",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_STAGES_REGULARITY",
                                            "name": "Regelmaat slaap",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_RESPIRATION",
                                    "name": "Ademhalingsfrequentie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                            "name": "Gemiddeld ademhalingsritme tijdens slaap",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 18,
                                                    "intValue": 18,
                                                    "stringValue": "18",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "resultText": "Gemiddeld ademhalingsritme tijdens slaap",
                                                    "advice": "De ademhalingsfrequentie geeft het gemiddelde aantal ademhalingen per minuut aan tijdens je slaap. Het bepaalt hoe efficiÃ«nt en rustig je ademt terwijl je slaapt. Een normale ademhalingsfrequentie in rust is meestal tussen de twaalf en twintig ademhalingen per minuut voor volwassenen. Om een optimale ademhalingsfrequentie te bereiken, is het belangrijk om een goede slaapomgeving te creÃ«ren en stimulerende middelen zoals cafeÃ¯ne, nicotine en alcohol voor het slapengaan te vermijden. Bovendien is regelmatige lichaamsbeweging en het beheersen van stress belangrijk voor een gezonde ademhaling.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_SLEEP_STADIA_BREATHINGDIS",
                                    "name": "Onderbrekingen in je ademhaling",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_BREATHINGDIST",
                                            "name": "Onderbrekingen in je ademhaling",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 18.3709787816564,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 18.373716632443532,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 18.38193018480493,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 18.43394934976044,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 18.442162902121833,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 18.444900752908968,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 18.45037645448323,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 18.48870636550308,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 18.49965776865161,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 18.71047227926078,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 18.746064339493497,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 18.748802190280628,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_SLEEP_CHRONOTYPE",
                            "name": "Chronotype",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_SLEEP_CHRONOTYPE_CHRONOTYPE",
                                    "name": "Jouw chronotype",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_GEENVOORKEUR",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_GEENVOORKEUR",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_AVOND",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_GEENVOORKEUR",
                                                    "resultText": "Uit jouw DNA-resultaten leiden we af dat jouw lichaam geen voorkeur voor ochtenden of avonden heeft.",
                                                    "keyWords": "geen specifieke voorkeur",
                                                    "advice": "Jij presteert zowel vroeg in de ochtend als laat op de avond. Ideaal, want zo heb je heel wat ruimte bij het inplannen van taken, opdrachten, evenementen en prestaties. Let wel op dat je jouw lichaam voldoende rust en regelmaat geeft. Als je te flexibel omspringt met die 'vrijheid in planningsmogelijkheden' zou dat kunnen leiden tot een onregelmatig slaap- en eetpatroon.",
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE",
                                            "name": "Huidige situatie",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "dagmens",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_DAGMENS",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1709116315184
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1709125621844
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "resultText": "Je geeft zelf aan eerder een vroege vogel te zijn.",
                                                    "keyWords": "vroege vogel",
                                                    "advice": "Vroege vogels genieten vaak van verhoogde productiviteit en betere concentratie door taken aan te pakken voordat dagelijkse afleidingen beginnen. Ze hebben vaak een consistenter slaapschema dat bijdraagt aan betere algehele gezondheid en kunnen profiteren van ochtendlicht voor verbeterde mentale gezondheid. \n\n\n\n\n\n",
                                                    "time": 1721056754687
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEQ",
                                            "name": "Jouw chronotype",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "neutraal type",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEQ_DAG",
                                                    "time": 1709117135744
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "neutraal type",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEQ_DAG",
                                                    "resultText": "Uit je antwoorden blijkt dat je een neutraal type bent. Jij valt doorgaans tussen 22:45 uur en 00:45 uur in slaap en ontwaakt normaal gezien tussen 6:30 uur en 8:30 uur.",
                                                    "keyWords": "neutraal type",
                                                    "advice": "Je wordt als neutraal type niet extreem vroeg of heel laat wakker. Ga steeds naar bed als je slaapdruk voelt. Als je over het algemeen vroeger in slaap valt dan 21:00 uur of later dan 3:00 uur, of als je normale tijdstip van wakker worden vroeger is dan 4:00 uur of later dan 11:30 uur, dan kan je best langsgaan bij je huisarts of een therapeut. Hou er ook rekening mee dat je chronotype niets zegt over de duur van slaap die jij nodig hebt om uitgerust wakker te worden.",
                                                    "time": 1709129465992
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        }
                    ],
                    "results": [],
                    "scoreResult": [
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "7.7",
                            "score": 7.727272727272727,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 27.211498973305954,
                            "leadlifeAge": 23.294117647058822,
                            "goalAge": 18,
                            "time": 1672613999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.6",
                            "score": 5.606060606060606,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.369609856262834,
                            "leadlifeAge": 32.769854042954655,
                            "goalAge": 18.3709787816564,
                            "time": 1709161199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.6",
                            "score": 5.606060606060606,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.372347707049965,
                            "leadlifeAge": 32.77473777679116,
                            "goalAge": 18.373716632443532,
                            "time": 1709247599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.6",
                            "score": 5.606060606060606,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.380561259411362,
                            "leadlifeAge": 32.78938897830068,
                            "goalAge": 18.38193018480493,
                            "time": 1709506799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.0",
                            "score": 6.007130124777183,
                            "maxScore": 10,
                            "goalScore": 9.84848484848485,
                            "realAge": 28.432580424366872,
                            "leadlifeAge": 30.2218309072482,
                            "goalAge": 18.43394934976044,
                            "time": 1711148399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.0",
                            "score": 5.962566844919787,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.44079397672827,
                            "leadlifeAge": 30.9299054950384,
                            "goalAge": 18.442162902121833,
                            "time": 1711407599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.8",
                            "score": 5.825311942959002,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.4435318275154,
                            "leadlifeAge": 31.663370019528553,
                            "goalAge": 18.444900752908968,
                            "time": 1711493999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.8",
                            "score": 5.825311942959002,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.449007529089666,
                            "leadlifeAge": 31.672769862194286,
                            "goalAge": 18.45037645448323,
                            "time": 1711666799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.923351158645276,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.487337440109513,
                            "leadlifeAge": 31.21325390023241,
                            "goalAge": 18.48870636550308,
                            "time": 1712872799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.923351158645276,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.49828884325804,
                            "leadlifeAge": 31.231742426161762,
                            "goalAge": 18.49965776865161,
                            "time": 1713218399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.923351158645276,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.709103353867214,
                            "leadlifeAge": 31.587646550301834,
                            "goalAge": 18.71047227926078,
                            "time": 1719871199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.923351158645276,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.744695414099933,
                            "leadlifeAge": 31.647734259572232,
                            "goalAge": 18.746064339493497,
                            "time": 1720994399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.923351158645276,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.747433264887064,
                            "leadlifeAge": 31.652356391054568,
                            "goalAge": 18.748802190280628,
                            "time": 1721080799000
                        }
                    ]
                },
                {
                    "tag": "DASHBOARD_STRESS",
                    "name": "DASHBOARD_STRESS",
                    "groups": [
                        {
                            "tag": "DASHBOARD_STRESS_NIVEAU",
                            "name": "Stressniveau",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_GRAPH",
                                    "name": "Cortisolprofiel",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_0800",
                                            "name": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_0800",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.5,
                                                    "stringValue": "0.5",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_0800",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1664089200000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.58,
                                                    "stringValue": "0.58",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_0800",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1670914800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.37,
                                                    "stringValue": "0.37",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_0800",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1677740400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1030",
                                            "name": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1030",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.1,
                                                    "stringValue": "0.1",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1030",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1664098200000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.44,
                                                    "stringValue": "1.44",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1030",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1670923800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.15,
                                                    "stringValue": "0.15",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1030",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1677749400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1530",
                                            "name": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1530",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.05,
                                                    "stringValue": "0.05",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1530",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1664116200000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.63,
                                                    "stringValue": "1.63",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1530",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1670941800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.08,
                                                    "stringValue": "0.08",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_1530",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1677767400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_2200",
                                            "name": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_2200",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.02,
                                                    "stringValue": "0.02",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_2200",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1664139600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.3,
                                                    "stringValue": "1.3",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_2200",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1670965200000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.02,
                                                    "stringValue": "0.02",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MEASUREMENT_2200",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1677790800000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_THUIS",
                                    "name": "Stress thuis",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS",
                                            "name": "Huidig stressniveau thuis",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116286347
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125604515
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_THUIS_BAD",
                                                    "resultText": "Jouw stressniveau ligt te hoog.",
                                                    "keyWords": "hoog",
                                                    "advice": "Iemand van wie het lichaam in de doorlopende stressstand staat, gaat negatieve effecten ervaren op het brein en andere organen. Wees aandachtig om je stressniveau onder controle te houden. Hieronder enkel kleine tips:\n\n- Hou zorgen niet voor morgen, praat. Blijf niet alleen zitten kniezen. Zoek iemand met wie je over je problemen kan praten.\n- Vraag hulp. Denk niet dat je zwak overkomt door hulp te vragen. Iemand die met je meedenkt of meewerkt, haalt veel stress voor je weg.\n- Beweeg. Bewegen vraagt energie, maar je krijgt er ook heel veel energie voor terug. Het vraagt niet zo heel veel tijd om elke dag een beetje meer te bewegen.\n- Neem tijdig een time-out. Neem op tijd en stond een beetje 'me-time'. Dan kan je er erna weer nog zo hard tegenaan.\n- Maak keuzes. Je kan niet alle taken aannemen die op je weg komen. Schrap zo veel mogelijk taken die te veel energie kosten en niets opleveren.\n- Eet gezond. Te veel vet, suiker en alcohol zijn niet goed voor je lichaam. Gezonde voeding met veel vezels, groenten en fruit geeft extra energie.\n\nHeb je ernstige klachten of wil je graag advies over positieve ontspanning? Neem dan contact op met je huisarts of een psycholoog.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1721051562556
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 36,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_WERK",
                                    "name": "Stress op het werk",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK",
                                            "name": "Huidig stressniveau op het werk",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116286347
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125604515
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_WERK_NEUTRAL",
                                                    "resultText": "Jouw stressniveau op het werk ligt af en toe wat te hoog.",
                                                    "keyWords": "matig",
                                                    "advice": "Stress continu vermijden is haast onmogelijk. Maar waar je wel kan aan werken is hoe je met werkgerelateerde stress omgaat.\nEnkele praktische tips:\n- Vind je stressoren.\n- Leer jezelf gezonde stressreacties aan.\n- Leer relaxen.\n- Trek grenzen.\n- Neem afstand.\n- Praat met je baas.\n-Laat je ondersteunen.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1721051562556
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 36,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_GELD",
                                    "name": "Stress wegens geldproblemen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN",
                                            "name": "Huidig stressniveau wegens geldproblemen",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116286347
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125604515
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_GELDPROBLEMEN_NEUTRAL",
                                                    "keyWords": "matig",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1721051562556
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 36,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_GLUTH",
                                    "name": "Glutathion Peroxidase",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_GLUTATHIONPEROXIDASE",
                                            "name": "Glutathion Peroxidase",
                                            "unit": "IU/l",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 76,
                                                    "intValue": 76,
                                                    "stringValue": "76",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_GLUTATHIONPEROXIDASE_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 75,
                                                    "intValue": 75,
                                                    "stringValue": "75",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_GLUTATHIONPEROXIDASE_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 117,
                                                    "intValue": 117,
                                                    "stringValue": "117",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_GLUTATHIONPEROXIDASE_HOOG",
                                                    "resultText": "Je GPx-waarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Verhoogde waarden van glutathionperoxidase kunnen komen door selenium rijke supplementen of voedsel.\nDit essentieel mineraal is een belangrijke co-factor voor de aanmaak van glutathion. Bronnen van selenium zijn rundvlees, kip, orgaanvlees, hÃ¼ttenkÃ¤se, bruine rijst en paranoten. Door de inname van selenium te verhogen, verhoog je indirect ook de glutathionspiegel. Volwassenen mikken best op 55 microgram selenium per dag, want zoveel heb je nodig om de aanmaak van het enzym glutathionperoxidase te maximaliseren. De meeste gezonde volwassenen zullen niet direct supplementen nodig hebben als ze seleniumrijke voeding consumeren.\n\n",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_CORTISOL",
                                    "name": "Cortisol",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_CORTISOL",
                                            "name": "Cortisol",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "doubleValue": 23.45,
                                                    "stringValue": "23.45",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_CORTISOL_HOOGHOOG",
                                                    "score": 0,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 10.78,
                                                    "stringValue": "10.78",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_CORTISOL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 8.36,
                                                    "stringValue": "8.36",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_CORTISOL_NORMAAL",
                                                    "resultText": "Je cortisolwaarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Voor we verdergaan is het belangrijk dat je weet dat cortisol op zich niet ongezond is. Het is, net als bijvoorbeeld adrenaline, een bij momenten zeer nuttig hormoon. Zonder cortisol zou je âs ochtends bijvoorbeeld minder energie hebben wanneer je uit bed stapt. Optimaal trachten we te streven naar cortisolwaarden tussen de 2.3 en 19.4 Âµg/dl. Enkele tips die kunnen helpen je cortisolniveau op peil te houden:\n\n\n * Eet gezond, want ongezond eten functioneert als een stressfactor voor je lichaam. Bepaalde voedingsstoffen kunnen voor jouw lichaam van extra nut zijn. Denk bijvoorbeeld aan vitamine C, vitamine B, foliumzuur, magnesium en omega 3-vetten.\n  * Beperk koffie en probeer alcohol te vermijden.\n  * Vermijd snelle suikers en ga liever voor trage koolhydraten zoals volkoren granen, groenten en fruit.\n  * Beweeg genoeg, maar overdrijf niet.\n  * Slaap voldoende en let op je slaapkwaliteit.\n  * Meditatie en ademhalingsoefeningen hebben nog steeds een beetje een zweverig imago. Toch kunnen ze je enorm helpen om tot rust te komen!\n  * Knuffel eens wat meer (en neen, dit is geen grapje). Bij het knuffelen wordt het hormoon oxytocine aangemaakt. Dat is hÃ©t hormoon dat cortisol reguleert. Meer oxytocine hebben is dus goed tegen te veel stress.\n  * Plan je rust in.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_SALIVA",
                                            "name": "Jouw cortisolprofiel",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "overspanning",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_SALIVA_ELEVATEDALLDAY_BAD",
                                                    "score": 0,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig cortisol",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_SALIVA_EXHAUSTION_BAD",
                                                    "resultText": "Het lijkt erop dat je te weinig cortisol aanmaakt.",
                                                    "keyWords": "te weinig cortisol",
                                                    "advice": "Wanneer je cortisollevels te laag zijn kan je het gevoel hebben continu moe te zijn. Jouw bijnieren kunnen dus een boost gebruiken! Ondersteun je bijnieren door vitamine B (zoals vlees, eieren, vis, graanproducten, aardappelen en peulvruchten,..) en vitamine C-rijke voeding (broccoli en avocado, kiwi, aardbeien, sinaasappel, citroen, pompelmoes,...) te eten. Bouw voldoende rust en ontspanning in zodat je bijnieren terug kunnen opladen. Beweeg voldoende maar vermijd intensieve sporten en duursporten, deze zouden te belastend voor je kunnen zijn. Kies voor wandelen, fietsen, zwemmen, yoga of pilates. Zorg ervoor dat je veel in de buitenlucht komt. Doe ontspannende activiteiten die je energie geven. Vermijd snelle suikers, alcohol, koffie en chocolade. Sla geen maaltijden over en eet regelmatig - elke 3 Ã  4 uren.",
                                                    "score": 0,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711641908053
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 36,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_TOTAAL",
                                    "name": "Totaal stressniveau",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_STRESS_DAILY_OVERALL",
                                            "name": "Gemiddeld stressniveau",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_HORMONAAL",
                                    "name": "Hormonale balans",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS",
                                            "name": "DHEA-S",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 365,
                                                    "intValue": 365,
                                                    "stringValue": "365",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 410,
                                                    "intValue": 410,
                                                    "stringValue": "410",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 16,
                                                    "intValue": 16,
                                                    "stringValue": "16",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_LAAG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 89,
                                                    "intValue": 89,
                                                    "stringValue": "89",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_LAAG",
                                                    "resultText": "Je DHEAS-waarden zijn licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Lage DHEAS-niveaus gaan vaak gepaard met onverklaarbaar gewichtsverlies, duizeligheid of misselijkheid. DHEAS-waarden nemen normaal gesproken af.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL",
                                            "name": "Verhouding cortisol en DHEA-S",
                                            "unit": "index",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.0642466,
                                                    "stringValue": "0.0642466",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.0262927,
                                                    "stringValue": "0.0262927",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.512883,
                                                    "stringValue": "0.512883",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 18,
                                                    "intValue": 18,
                                                    "stringValue": "18",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 6,
                                                    "intValue": 6,
                                                    "stringValue": "6",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "resultText": "Je cortisol/DHEAS-waarde is een berekende waarde.",
                                                    "keyWords": "berekende waarde",
                                                    "advice": "Goede cortisol/DHEAS-waarden duiden op een goed functionerend stress-systeem in het lichaam. Ideale waarden zijn lager of gelijk aan 0,2. \n\nOm de balans tussen cortisol en DHEAS weer te normaliseren kan je verschillende zaken doen. Zo zijn er studies die aantonen dat DHEAS blijkt toe te nemen als reactie op actieve inspanning.\n\nHet hangt wel af van de inspanning: weerstandstraining vertoont een sterkere toename in vergelijking met duurtraining. Uiteraard hangt je hormonale reactie ook af van hoe getraind je bent. Ongetrainde mensen ervaren een significantere stijging van de DHEAS- en cortisolspiegels. Dat effect werd zowel bij jongeren als bij mensen ouder dan zestig waargenomen.\n\nIn sommige gevallen kan het aangewezen zijn zoethoutextract te nemen. Dat komt omdat zoethout de bijnieren helpt de afbraak van cortisol te voorkomen. Pas wel op, want zoethout werkt bloeddrukverhogend. Als je al last hebt van een verhoogde bloeddruk moet je hier dus zeker niet mee overdrijven.\n\nWat voeding betreft: probeer je inname van eiwitten, gezonde vetten en koolhydraten in evenwicht te brengen. Het helpt ook om je groente-inname te verhogen om zo de benodigde hoeveelheid vitamines en mineralen binnen te krijgen. Daarnaast zullen voedingsmiddelen met veel vitamine C, B5, B6 en magnesium helpen bij het handhaven van de gezondheid van de bijnieren.",
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_HRV",
                                    "name": "Hartritmevariabiliteit",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_STRESS_DAILY_HRV",
                                            "name": "Gemiddelde HRV",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 13.333333333333334,
                                                    "stringValue": "13.333333333333334",
                                                    "tag": "RESULT_WEARABLES_DIRECT_STRESS_DAILY_HRV",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 18,
                                                    "stringValue": "18.0",
                                                    "tag": "RESULT_WEARABLES_DIRECT_STRESS_DAILY_HRV",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 15.714285714285714,
                                                    "stringValue": "15.714285714285714",
                                                    "tag": "RESULT_WEARABLES_DIRECT_STRESS_DAILY_HRV",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 14,
                                                    "stringValue": "14.0",
                                                    "tag": "RESULT_WEARABLES_DIRECT_STRESS_DAILY_HRV",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 12,
                                                    "stringValue": "12.0",
                                                    "tag": "RESULT_WEARABLES_DIRECT_STRESS_DAILY_HRV",
                                                    "resultText": "Gemiddelde HRV",
                                                    "advice": "Hartritmevariabiliteit (HRV) meet de variatie in de tijd tussen opeenvolgende hartslagen. Het geeft informatie over je autonome zenuwstelsel, stressniveaus, herstel en algemene gezondheid. Een hogere HRV wordt over het algemeen geassocieerd met een betere gezondheid van het autonome zenuwstelsel en een verminderd risico op hart- en vaatziekten. Een lagere HRV kan wijzen op een verminderde veerkracht en een verhoogd risico op gezondheidsproblemen. Om je HRV te verbeteren, is het belangrijk om een gezonde levensstijl te volgen. Zorg voor voldoende rust, slaap, gezonde voeding en ontspanningstechnieken, zoals meditatie, in je dagelijkse routine.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_NIVEAU_HEARTHRATE",
                                    "name": "Hartslag",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESTINGHEARTHRATE",
                                            "name": "Gemiddelde rusthartslag",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.6",
                                    "score": 4.6,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 39.130434782608695,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.6",
                                    "score": 5.6,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 32.805319252957865,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.6",
                                    "score": 5.6,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 32.8102082722206,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.6",
                                    "score": 5.6,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 32.82487533000881,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.1",
                                    "score": 4.1,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 43.432580424366876,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.1",
                                    "score": 4.1,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 43.44079397672827,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.1",
                                    "score": 4.1,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 43.4435318275154,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.1",
                                    "score": 4.1,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 43.44900752908967,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.1",
                                    "score": 4.1,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 43.48733744010951,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.1",
                                    "score": 4.1,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 43.49828884325804,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.1",
                                    "score": 4.1,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 43.709103353867214,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.1",
                                    "score": 4.1,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 43.74469541409994,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.1",
                                    "score": 4.1,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 43.747433264887064,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_STRESS_VEERKRACHT",
                            "name": "Veerkracht",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_STRESS_VEERKRACHT_RESPONS",
                                    "name": "Stressrespons",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wisselend positief/negatief",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "eerder negatief",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wisselend positief/negatief",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wisselend positief/negatief",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS_MATIG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat jij wisselend met stress en emotie omgaat. In sommige situaties maken stress en emoties het jou niet makkelijk, maar er is niet altijd een negatieve impact op jouw lichaam.",
                                                    "keyWords": "wisselend positief/negatief",
                                                    "advice": "Een goede balans tussen stress en ontspanning vinden is belangrijk voor jou. Besteed dan ook voldoende aandacht aan activiteiten die je kunnen helpen bij het omgaan met stress als het je even te veel wordt. Denk bijvoorbeeld aan mindfulness, meditatie, yoga of hartcoherentie. Het zijn voorbeelden van zogenaamde âcopingtechniekenâ, activiteiten rond stressmanagement die jou in lastige situaties kunnen ondersteunen. Ook sociaal contact en sporten kunnen je daarbij helpen. Zodra je weet welke situaties jou extra stress bezorgen, is het zaak die in de mate van het mogelijke te mijden.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_VEERKRACHT_WORRIER",
                                    "name": "Worrier versus warrior",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wisselende stressbeleving",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "eerder worrier",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER_LAAG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "eerder warrior",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER_HOOG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "eerder worrier",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER_LAAG",
                                                    "resultText": "Uit jouw resultaten blijkt dat jij een worrier bent: stress maakt bij jou vaak heel wat angsten los. Die innerlijke onrust en angst kunnen ertoe leiden dat je minder goed presteert doordat je vertrouwen in een situatie door stress afzwakt. Als je met depressieve gevoelens kampt of hoge en langdurige stress ervaart, is het aangeraden om extra hulp te zoeken die je kan ondersteunen.",
                                                    "keyWords": "eerder worrier",
                                                    "advice": "In situaties waarin weinig stressfactoren zijn, presteer jij goed en slaag je erin je focus te behouden. Als de zaken plots niet meer zoals gepland lopen, stapelt de stress zich op. Op basis van je DNA-analyse kunnen we opmaken dat jouw lichaam in zoân geval de neiging heeft de controle te verliezen. Het is belangrijk dat je je daarvan bewust bent en de stressvolle situaties zo veel mogelijk probeert te vermijden. Dat is uiteraard niet altijd haalbaar - ga daarom op zoek naar technieken die jou kunnen helpen om de stress onder controle te houden. Denk bijvoorbeeld aan yoga en meditatie. Als je die onder de knie hebt, zal je ondanks de stress beter kunnen presteren!",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_VEERKRACHT_BINGE",
                                    "name": "Binge eating",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig kans",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte kans",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING_HOOG",
                                                    "resultText": "Uit jouw DNA-onderzoek blijkt dat jij aanleg tot binge-eten hebt, wat betekent dat jouw lichaam bij voorkeur emotionele eetbuien verkiest om stresserende situaties te verwerken. Probeer je daarvan bewust te zijn en schakel indien nodig zeker hulp in.",
                                                    "keyWords": "verhoogde kans",
                                                    "advice": "Het kan altijd dat jouw lichaam het wat moeilijker heeft met stress of een tekort aan zelfvertrouwen. Die ervaringen kunnen zeer rot zijn, maar de drang naar eten tijdens die emotionele periodes kan onder controle gehouden worden. Probeer dat soort situaties te mijden en ga op zoek naar alternatieve manieren om met emoties om te gaan. Denk bijvoorbeeld aan yoga, meditatie of mindfulness. Nood aan extra ondersteuning? Aarzel niet om die in te schakelen! Binge-eten is niet iets waar je heel je leven mee moet kampen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "10.0",
                                            "score": 10,
                                            "maxScore": 10,
                                            "goalScore": 10,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_VEERKRACHT_MENTAL",
                                    "name": "Mentale weerbaarheid",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_LIFE",
                                            "name": "Levensbeheersing",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "eerder hoog",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_LIFE_EERDER_HOOG_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_LIFE_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130159109
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_LIFE_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_LIFE_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op 'levensbeheersing' niet berekenen omdat je deze vragen niet hebt beantwoord of omdat je op dit moment niet aan het werk bent.",
                                                    "keyWords": "onberekend",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1720965015795
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_EMOTIONAL",
                                            "name": "Emotionele controle",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "eerder laag",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_EMOTIONAL_EERDER_LAAG_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_EMOTIONAL_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130159109
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_EMOTIONAL_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_EMOTIONAL_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op 'emotionele controle' niet berekenen omdat je deze vragen niet hebt beantwoord of omdat je op dit moment niet aan het werk bent.",
                                                    "keyWords": "onberekend",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1720965015795
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_GOAL",
                                            "name": "Doelgericht",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "eerder laag",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_GOAL_EERDER_LAAG_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_GOAL_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130159109
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_GOAL_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_GOAL_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op doelgericht niet berekenen omdat je deze vragen niet hebt beantwoord of omdat je op dit moment niet aan het werk bent.",
                                                    "keyWords": "onberekend",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1720965015795
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_ACHIEVEMENT",
                                            "name": "Prestatiegericht",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "eerder laag",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_ACHIEVEMENT_EERDER_LAAG_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_ACHIEVEMENT_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130159109
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_ACHIEVEMENT_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_ACHIEVEMENT_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op 'prestatiegericht' niet berekenen omdat je deze vragen niet hebt beantwoord of omdat je op dit moment niet aan het werk bent.",
                                                    "keyWords": "onberekend",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1720965015795
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_ABILITY",
                                            "name": "Zelfzekerheid",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "eerder hoog",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_ABILITY_EERDER_HOOG_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_ABILITY_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130159109
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_ABILITY_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_ABILITY_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op 'zelfzekerheid' niet berekenen omdat je deze vragen niet hebt beantwoord of omdat je op dit moment niet aan het werk bent.",
                                                    "keyWords": "onberekend",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1720965015795
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_INTERPERSONAL",
                                            "name": "Interpersoonlijk vertrouwen",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "eerder hoog",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_INTERPERSONAL_EERDER_HOOG_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_INTERPERSONAL_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130159109
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_INTERPERSONAL_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CONFIDENCE_INTERPERSONAL_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op 'interpersoonlijk' vertrouwen niet berekenen omdat je deze vragen niet hebt beantwoord of omdat je op dit moment niet aan het werk bent.",
                                                    "keyWords": "onberekend",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1720965015795
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CHALLENGE",
                                            "name": "Uitdaging",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "eerder hoog",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CHALLENGE_EERDER_HOOG_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CHALLENGE_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130159109
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CHALLENGE_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_MENTAL_CHALLENGE_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op uitdaging niet berekenen omdat je deze vragen niet hebt beantwoord of omdat je op dit moment niet aan het werk bent.",
                                                    "keyWords": "onberekend",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1720965015795
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "450.0",
                                            "score": 450,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 27.999999999999996,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_VEERKRACHT_COPING",
                                    "name": "Coping",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_COPING_WERK",
                                            "name": "Coping op het werk",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_COPING_WERK_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_COPING_WERK_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709130190241
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_COPING_WERK_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_COPING_WERK_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat voor 'coping op het werk' niet berekenen omdat je deze vragen niet hebt beantwoord of omdat je op dit moment niet aan het werk bent.",
                                                    "keyWords": "onberekend",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1721059455901
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_COPING_PRIVE",
                                            "name": "Coping in de privÃ©sfeer",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_COPING_PRIVE_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_COPING_PRIVE_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130190241
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_COPING_PRIVE_NOTAVAILABLE",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_COPING_PRIVE_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat voor 'coping in de privÃ©sfeer' niet berekenen omdat je deze vragen niet hebt beantwoord.",
                                                    "keyWords": "onberekend",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1721059455901
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "SALIVA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.860215053763441,
                                    "maxScore": 10,
                                    "goalScore": 9.89247311827957,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 30.385321100917434,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 9.23076923076923,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 31.493106482839536,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 9.23076923076923,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 31.49779994133176,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 9.23076923076923,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 31.51188031680844,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.8",
                                    "score": 3.8461538461538463,
                                    "maxScore": 10,
                                    "goalScore": 7.6923076923076925,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 36.86789869952088,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 9.23076923076923,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 31.61513640363742,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.2",
                                    "score": 4.230769230769231,
                                    "maxScore": 10,
                                    "goalScore": 8.076923076923077,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 35.21299234646257,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "1.7",
                                    "score": 1.6666666666666667,
                                    "maxScore": 10,
                                    "goalScore": 1.6666666666666667,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 18.45037645448323,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "1.7",
                                    "score": 1.6666666666666667,
                                    "maxScore": 10,
                                    "goalScore": 1.6666666666666667,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 18.48870636550308,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "1.7",
                                    "score": 1.6666666666666667,
                                    "maxScore": 10,
                                    "goalScore": 1.6666666666666667,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 18.49965776865161,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "1.7",
                                    "score": 1.6666666666666667,
                                    "maxScore": 10,
                                    "goalScore": 1.6666666666666667,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 18.71047227926078,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "1.7",
                                    "score": 1.6666666666666667,
                                    "maxScore": 10,
                                    "goalScore": 1.6666666666666667,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 18.746064339493497,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "1.7",
                                    "score": 1.6666666666666667,
                                    "maxScore": 10,
                                    "goalScore": 1.6666666666666667,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 18.748802190280628,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_STRESS_PERFORMANTIE",
                            "name": "Performantie",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_STRESS_PERFORMANTIE_CHRONOTYPE",
                                    "name": "Chronotype",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_GEENVOORKEUR",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_GEENVOORKEUR",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_AVOND",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_GEENVOORKEUR",
                                                    "resultText": "Uit jouw DNA-resultaten leiden we af dat jouw lichaam geen voorkeur voor ochtenden of avonden heeft.",
                                                    "keyWords": "geen specifieke voorkeur",
                                                    "advice": "Jij presteert zowel vroeg in de ochtend als laat op de avond. Ideaal, want zo heb je heel wat ruimte bij het inplannen van taken, opdrachten, evenementen en prestaties. Let wel op dat je jouw lichaam voldoende rust en regelmaat geeft. Als je te flexibel omspringt met die 'vrijheid in planningsmogelijkheden' zou dat kunnen leiden tot een onregelmatig slaap- en eetpatroon.",
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE",
                                            "name": "Huidige situatie",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "dagmens",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_DAGMENS",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1709116315184
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1709125621844
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "vroege vogel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_CHRONOTYPE_VROEGEVOGEL",
                                                    "resultText": "Je geeft zelf aan eerder een vroege vogel te zijn.",
                                                    "keyWords": "vroege vogel",
                                                    "advice": "Vroege vogels genieten vaak van verhoogde productiviteit en betere concentratie door taken aan te pakken voordat dagelijkse afleidingen beginnen. Ze hebben vaak een consistenter slaapschema dat bijdraagt aan betere algehele gezondheid en kunnen profiteren van ochtendlicht voor verbeterde mentale gezondheid. \n\n\n\n\n\n",
                                                    "time": 1721056754687
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEQ",
                                            "name": "Jouw chronotype",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "neutraal type",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEQ_DAG",
                                                    "time": 1709117135744
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "neutraal type",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEQ_DAG",
                                                    "resultText": "Uit je antwoorden blijkt dat je een neutraal type bent. Jij valt doorgaans tussen 22:45 uur en 00:45 uur in slaap en ontwaakt normaal gezien tussen 6:30 uur en 8:30 uur.",
                                                    "keyWords": "neutraal type",
                                                    "advice": "Je wordt als neutraal type niet extreem vroeg of heel laat wakker. Ga steeds naar bed als je slaapdruk voelt. Als je over het algemeen vroeger in slaap valt dan 21:00 uur of later dan 3:00 uur, of als je normale tijdstip van wakker worden vroeger is dan 4:00 uur of later dan 11:30 uur, dan kan je best langsgaan bij je huisarts of een therapeut. Hou er ook rekening mee dat je chronotype niets zegt over de duur van slaap die jij nodig hebt om uitgerust wakker te worden.",
                                                    "time": 1709129465992
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_PERFORMANTIE_PERSONALITY",
                                    "name": "Persoonlijkheid",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_OPENHEID",
                                            "name": "Openheid",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "eerder open",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_OPENHEID_EERDER_OPEN",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "eerder open",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_OPENHEID_EERDER_OPEN",
                                                    "time": 1709130154042
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_OPENHEID_NOTAVAILABLE",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_OPENHEID_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op 'openheid' niet berekenen omdat je deze vragen niet hebt beantwoord.",
                                                    "keyWords": "onberekend",
                                                    "time": 1721059458567
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_ORDELIJKHEID",
                                            "name": "Ordelijkheid",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "eerder ordelijk",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_ORDELIJKHEID_EERDER_ORDELIJK",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "eerder spontaan",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_ORDELIJKHEID_EERDER_SPONTAAN",
                                                    "time": 1709130154042
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_ORDELIJKHEID_NOTAVAILABLE",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_ORDELIJKHEID_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op 'ordelijkheid' niet berekenen omdat je deze vragen niet hebt beantwoord.",
                                                    "keyWords": "onberekend",
                                                    "time": 1721059458567
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EXTRAVERSIE",
                                            "name": "Extraversie",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "extravert",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EXTRAVERSIE_EXTRAVERT",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "eerder introvert",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EXTRAVERSIE_EERDER_INTROVERT",
                                                    "time": 1709130154042
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EXTRAVERSIE_NOTAVAILABLE",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EXTRAVERSIE_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op extraversie niet berekenen omdat je deze vragen niet hebt beantwoord.",
                                                    "keyWords": "onberekend",
                                                    "time": 1721059458567
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_VRIENDELIJKHEID",
                                            "name": "Vriendelijkheid",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "eerder vriendelijk",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_VRIENDELIJKHEID_EERDER_VRIENDELIJK",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "eerder competitief",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_VRIENDELIJKHEID_EERDER_COMPETITIEF",
                                                    "time": 1709130154042
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_VRIENDELIJKHEID_NOTAVAILABLE",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_VRIENDELIJKHEID_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op 'vriendelijkheid' niet berekenen omdat je deze vragen niet hebt beantwoord.",
                                                    "keyWords": "onberekend",
                                                    "time": 1721059458567
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "SALIVA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EMOTIONEEL",
                                            "name": "Emotionele stabiliteit",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "eerder stabiel",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EMOTIONEEL_EERDER_STABIEL",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "eerder bezorgd",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EMOTIONEEL_EERDER_BEZORGD",
                                                    "time": 1709130154042
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EMOTIONEEL_NOTAVAILABLE",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onberekend",
                                                    "tag": "RESULT_LEADLIFE_CORTISOL_PERSOON_EMOTIONEEL_NOTAVAILABLE",
                                                    "resultText": "We konden je resultaat op 'emotionele stabiliteit' niet berekenen omdat je deze vragen niet hebt beantwoord.",
                                                    "keyWords": "onberekend",
                                                    "time": 1721059458567
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "SALIVA"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        },
                        {
                            "tag": "DASHBOARD_STRESS_VITAMINES",
                            "name": "Vitamines en mineralen",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_STRESS_VITAMINES_MAGNESIUM",
                                    "name": "Magnesium",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM",
                                            "name": "Magnesium",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.84,
                                                    "stringValue": "0.84",
                                                    "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.8,
                                                    "stringValue": "0.80",
                                                    "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.81,
                                                    "stringValue": "0.81",
                                                    "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_HOOG",
                                                    "resultText": "Je magnesiumwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een overschot aan magnesium ontstaat enkel bij gebruik van tabletten waarin magnesium zit, magnesiumzouten of mineraalwater waarin veel magnesium zit. \n\nBij meer dan 250 milligram magnesium per dag extra, dus naast het magnesium in je eten, kunnen darmklachten zoals diarree ontstaan.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_STRESS_VITAMINES_VITB12",
                                    "name": "Vitamine B12",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_HOOG",
                                                    "resultText": "Op basis van de resultaten van je DNA-analyse blijkt dat jouw lichaam een sterk verhoogde nood aan vitamine B12 heeft.",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Probeer in jouw voedingspatroon wat meer te variÃ«ren, zodat jouw lichaam over voldoende vitamine B12 beschikt. Je vindt die vitamine bijvoorbeeld in dierlijke producten zoals melk, melkproducten, vlees, vleeswaren, vis en eieren. Daarnaast kan vitamine B12 ook voorkomen in plantaardige producten, zoals zeewier en algen. Let uiteraard op mogelijke intoleranties. Met het DNA-onderzoek bepalen we zoals gezegd niet of je nu een tekort hebt aan vitamine B12. Om dat te weten te komen, moet je een bloedonderzoek laten doen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12",
                                            "name": "Vitamine B12",
                                            "unit": "ng/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 476,
                                                    "intValue": 476,
                                                    "stringValue": "476",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 436,
                                                    "intValue": 436,
                                                    "stringValue": "436",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 355,
                                                    "intValue": 355,
                                                    "stringValue": "355",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 48,
                                                    "intValue": 48,
                                                    "stringValue": "48",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "resultText": "Je vitamine B12-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Voor mannen en vrouwen boven de 14 is het aanbevolen om dagelijks 2,8 microgram vitamine B12 binnen te krijgen. Als je gezond en gevarieerd eet, krijg je voldoende vitamine B12 binnen. Tracht te streven naar waarden boven de 500ng/l.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.5",
                                    "score": 9.545454545454545,
                                    "maxScore": 10,
                                    "goalScore": 9.545454545454545,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.5",
                                    "score": 9.545454545454545,
                                    "maxScore": 10,
                                    "goalScore": 9.545454545454545,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 18.3709787816564,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.5",
                                    "score": 9.545454545454545,
                                    "maxScore": 10,
                                    "goalScore": 9.545454545454545,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 18.373716632443532,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.5",
                                    "score": 9.545454545454545,
                                    "maxScore": 10,
                                    "goalScore": 9.545454545454545,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 18.38193018480493,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.5",
                                    "score": 9.545454545454545,
                                    "maxScore": 10,
                                    "goalScore": 9.545454545454545,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 18.43394934976044,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.1",
                                    "score": 9.090909090909092,
                                    "maxScore": 10,
                                    "goalScore": 9.090909090909092,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 18.442162902121833,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.909090909090909,
                                    "maxScore": 10,
                                    "goalScore": 9.090909090909092,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 28.376770389090723,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.909090909090909,
                                    "maxScore": 10,
                                    "goalScore": 9.090909090909092,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 28.385194545358818,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.909090909090909,
                                    "maxScore": 10,
                                    "goalScore": 9.090909090909092,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 28.444163639235512,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.909090909090909,
                                    "maxScore": 10,
                                    "goalScore": 9.090909090909092,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 28.46101195177171,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.909090909090909,
                                    "maxScore": 10,
                                    "goalScore": 9.090909090909092,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 28.785341968093512,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.909090909090909,
                                    "maxScore": 10,
                                    "goalScore": 9.090909090909092,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 28.840098983836153,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.909090909090909,
                                    "maxScore": 10,
                                    "goalScore": 9.090909090909092,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 28.844311061970203,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        }
                    ],
                    "results": [],
                    "scoreResult": [
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.7",
                            "score": 6.668556533072663,
                            "maxScore": 10,
                            "goalScore": 9.812642554578039,
                            "realAge": 27.211498973305954,
                            "leadlifeAge": 26.486626469524765,
                            "goalAge": 18,
                            "time": 1672613999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.8",
                            "score": 6.843356643356643,
                            "maxScore": 10,
                            "goalScore": 9.59207459207459,
                            "realAge": 28.369609856262834,
                            "leadlifeAge": 25.74990724385724,
                            "goalAge": 18.3709787816564,
                            "time": 1709161199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.8",
                            "score": 6.843356643356643,
                            "maxScore": 10,
                            "goalScore": 9.59207459207459,
                            "realAge": 28.372347707049965,
                            "leadlifeAge": 25.753744785920407,
                            "goalAge": 18.373716632443532,
                            "time": 1709247599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.8",
                            "score": 6.843356643356643,
                            "maxScore": 10,
                            "goalScore": 9.59207459207459,
                            "realAge": 28.380561259411362,
                            "leadlifeAge": 25.76525741210991,
                            "goalAge": 18.38193018480493,
                            "time": 1709506799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.8",
                            "score": 5.830536130536131,
                            "maxScore": 10,
                            "goalScore": 9.07925407925408,
                            "realAge": 28.432580424366872,
                            "leadlifeAge": 28.705166400398554,
                            "goalAge": 18.43394934976044,
                            "time": 1711148399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.2",
                            "score": 6.191841491841491,
                            "maxScore": 10,
                            "goalScore": 9.44055944055944,
                            "realAge": 28.44079397672827,
                            "leadlifeAge": 28.118344973682724,
                            "goalAge": 18.442162902121833,
                            "time": 1711407599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.7",
                            "score": 4.746620046620047,
                            "maxScore": 10,
                            "goalScore": 9.055944055944055,
                            "realAge": 28.4435318275154,
                            "leadlifeAge": 35.19051192115666,
                            "goalAge": 18.444900752908968,
                            "time": 1711493999000
                        },
                        {
                            "riskLevel": "BAD",
                            "stringValue": "3.9",
                            "score": 3.891919191919192,
                            "maxScore": 10,
                            "goalScore": 6.91919191919192,
                            "realAge": 28.449007529089666,
                            "leadlifeAge": 32.8017333800182,
                            "goalAge": 18.45037645448323,
                            "time": 1711666799000
                        },
                        {
                            "riskLevel": "BAD",
                            "stringValue": "3.9",
                            "score": 3.891919191919192,
                            "maxScore": 10,
                            "goalScore": 6.91919191919192,
                            "realAge": 28.487337440109513,
                            "leadlifeAge": 32.86987765473556,
                            "goalAge": 18.48870636550308,
                            "time": 1712872799000
                        },
                        {
                            "riskLevel": "BAD",
                            "stringValue": "3.9",
                            "score": 3.891919191919192,
                            "maxScore": 10,
                            "goalScore": 6.91919191919192,
                            "realAge": 28.49828884325804,
                            "leadlifeAge": 32.889347447511945,
                            "goalAge": 18.49965776865161,
                            "time": 1713218399000
                        },
                        {
                            "riskLevel": "BAD",
                            "stringValue": "3.9",
                            "score": 3.891919191919192,
                            "maxScore": 10,
                            "goalScore": 6.91919191919192,
                            "realAge": 28.709103353867214,
                            "leadlifeAge": 33.264140958457396,
                            "goalAge": 18.71047227926078,
                            "time": 1719871199000
                        },
                        {
                            "riskLevel": "BAD",
                            "stringValue": "3.9",
                            "score": 3.891919191919192,
                            "maxScore": 10,
                            "goalScore": 6.91919191919192,
                            "realAge": 28.744695414099933,
                            "leadlifeAge": 33.32741778498065,
                            "goalAge": 18.746064339493497,
                            "time": 1720994399000
                        },
                        {
                            "riskLevel": "BAD",
                            "stringValue": "3.9",
                            "score": 3.891919191919192,
                            "maxScore": 10,
                            "goalScore": 6.91919191919192,
                            "realAge": 28.747433264887064,
                            "leadlifeAge": 33.332285233174744,
                            "goalAge": 18.748802190280628,
                            "time": 1721080799000
                        }
                    ]
                },
                {
                    "tag": "DASHBOARD_BODY",
                    "name": "DASHBOARD_BODY",
                    "groups": [
                        {
                            "tag": "DASHBOARD_BODY_SAMENSTELLING",
                            "name": "Lichaamssamenstelling",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_GEWICHT",
                                    "name": "Gewicht",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                            "name": "Gewicht uit bodyscan",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 83.2,
                                                    "stringValue": "83.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 66.3,
                                                    "stringValue": "66.3",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 83.4,
                                                    "stringValue": "83.4",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 63.4,
                                                    "stringValue": "63.4",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_TOTAALGEWICHT",
                                                    "resultText": "Gewicht uit bodyscan",
                                                    "keyWords": "totaal gewicht",
                                                    "advice": "Je gewicht is maar Ã©Ã©n parameter van je lichaamsbouw en je gezondheid. Bekijk ook steeds je spiermassa en vetverdeling in je lichaam.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                            "name": "Jouw gerapporteerd gewicht",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 70,
                                                    "intValue": 70,
                                                    "stringValue": "70",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 70,
                                                    "intValue": 70,
                                                    "stringValue": "70",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 70,
                                                    "intValue": 70,
                                                    "stringValue": "70",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 70,
                                                    "intValue": 70,
                                                    "stringValue": "70",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_GEWICHT",
                                                    "resultText": "Jouw gerapporteerd gewicht",
                                                    "advice": "Een gezond gewicht vermindert het risico op diverse gezondheidsproblemen zoals obesitas, diabetes type 2, hart- en vaatziekten, gewrichtsproblemen en meer. Het is echter belangrijk om op te merken dat gewicht slechts Ã©Ã©n aspect is van gezondheid en dat andere factoren zoals lichamelijke fitheid, voedingspatroon, stressniveaus en genetica ook een rol spelen. Daarom is het altijd raadzaam om een holistische benadering van gezondheid te hanteren en niet alleen te focussen op gewicht maar ook op andere aspecten van een gezonde levensstijl.",
                                                    "time": 1711641908053
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_BMI",
                                    "name": "BMI",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI",
                                            "name": "BMI uit bodyscan",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 28.78892733564014,
                                                    "stringValue": "28.78892733564014",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI_OVERGEWICHT_BAD",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 23.4906462585034,
                                                    "stringValue": "23.4906462585034",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI_NORMAAL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 21.489860599345512,
                                                    "stringValue": "21.489860599345512",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI_NORMAAL_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 24.157902758725804,
                                                    "stringValue": "24.157902758725804",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMI_NORMAAL_GOOD",
                                                    "resultText": "Je BMI - of Body Mass Index - is de verhouding tussen je gewicht en je lichaamslengte. In jouw geval ligt die tussen 18,5 en 25. Dit betekent dat je ten opzichte van je lengte een gezond gewicht hebt.",
                                                    "keyWords": "normaal",
                                                    "advice": "Je gewicht valt binnen de gemiddelde grenzen. Dat betekent niet automatisch dat je evenwichtig eet en voldoende beweegt. Het omgekeerde geldt ook: mensen met (licht) overgewicht eten niet per definitie ongezond. Fixeer je dus niet op je BMI of het getal op de weegschaal.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_BMR",
                                    "name": "BMR",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMR",
                                            "name": "BMR",
                                            "unit": "cal/day",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1817,
                                                    "stringValue": "1817.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMR",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1421,
                                                    "stringValue": "1421.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMR",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1961,
                                                    "stringValue": "1961.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMR",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1299,
                                                    "stringValue": "1299.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BMR",
                                                    "resultText": "BMR",
                                                    "keyWords": "rustmetabolisme",
                                                    "advice": "De hoeveelheid vet- en spierweefsel in je lichaam bepalen hoeveel energie je verbruikt. Het energieverbruik van spierweefsel is hoog, dat van vetweefsel laag. Iemand met veel spierweefsel heeft dus een hogere ruststofwisseling dan iemand met weinig spierweefsel. In de loop der jaren krijgen zowel mannen als vrouwen meer vetweefsel en minder spierweefsel. Op hoge leeftijd is de ruststofwisseling dus lager dan op jonge leeftijd.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_SPIERMASSA",
                                    "name": "Spiermassa",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                            "name": "Spiermassa",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 64,
                                                    "stringValue": "64.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 45.2,
                                                    "stringValue": "45.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 67.8,
                                                    "stringValue": "67.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 39.6,
                                                    "stringValue": "39.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIERMASSA",
                                                    "resultText": "Spiermassa",
                                                    "keyWords": "magere spiermassa",
                                                    "advice": "Tot je spiermassa behoren je skeletspieren, je gladde spieren (zoals de hart- en spijsverteringsspieren) en het vocht in die spieren. Spieren fungeren als een motor die energie verbruikt. Wanneer je spiermassa toeneemt, stijgt de snelheid waarmee je energie verbrandt (calorieÃ«n), waardoor je basaalmetabolisme of ruststofwisseling (BMR) toeneemt. Daardoor kan je je vetgehalte verminderen en op een gezonde manier gewicht verliezen. Als je hard traint, zal je spiermassa toenemen, waardoor ook je totale lichaamsgewicht kan toenemen. Het is daarom belangrijk regelmatig je spiermassa te meten om te zien welk effect je trainingsprogramma op je spiermassa heeft.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_VERDELINGSPIERMASSA",
                                    "name": "Verdeling spiermassa",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMLINKS",
                                            "name": "Linkerarm",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 3.8,
                                                    "stringValue": "3.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMLINKS",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2.3,
                                                    "stringValue": "2.3",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMLINKS",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 4.4,
                                                    "stringValue": "4.4",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMLINKS",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.9,
                                                    "stringValue": "1.9",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMLINKS",
                                                    "resultText": "Linkerarm",
                                                    "keyWords": "linkerarm",
                                                    "advice": "Idealiter is de spiermassa van je linkerarm nagenoeg gelijk aan die van je rechterarm.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMRECHTS",
                                            "name": "Rechterarm",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 3.8,
                                                    "stringValue": "3.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMRECHTS",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2.6,
                                                    "stringValue": "2.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMRECHTS",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 5,
                                                    "stringValue": "5.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMRECHTS",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2.1,
                                                    "stringValue": "2.1",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ARMRECHTS",
                                                    "resultText": "Rechterarm",
                                                    "keyWords": "rechterarm",
                                                    "advice": "Idealiter is de spiermassa van je rechterarm nagenoeg gelijk aan die van je linkerarm.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENLINKS",
                                            "name": "Linkerbeen",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 11.7,
                                                    "stringValue": "11.7",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENLINKS",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 7.9,
                                                    "stringValue": "7.9",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENLINKS",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 12.1,
                                                    "stringValue": "12.1",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENLINKS",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 6.7,
                                                    "stringValue": "6.7",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENLINKS",
                                                    "resultText": "Linkerbeen",
                                                    "keyWords": "linkerbeen",
                                                    "advice": "Idealiter is de spiermassa in je linkerbeen nagenoeg gelijk aan die van je rechterbeen.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENRECHTS",
                                            "name": "Rechterbeen",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 12,
                                                    "stringValue": "12.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENRECHTS",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 8.3,
                                                    "stringValue": "8.3",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENRECHTS",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 11.7,
                                                    "stringValue": "11.7",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENRECHTS",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 6.7,
                                                    "stringValue": "6.7",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_BEENRECHTS",
                                                    "resultText": "Rechterbeen",
                                                    "keyWords": "rechterbeen",
                                                    "advice": "Idealiter is de spiermassa in je rechterbeen nagenoeg gelijk aan die van je linkerbeen.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ROMP",
                                            "name": "Romp",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 29,
                                                    "stringValue": "29.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ROMP",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 21,
                                                    "stringValue": "21.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ROMP",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 30.6,
                                                    "stringValue": "30.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ROMP",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 19,
                                                    "stringValue": "19.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_SPIER_ROMP",
                                                    "resultText": "Romp",
                                                    "keyWords": "romp",
                                                    "advice": "Door het trainen van je rompspieren wordt je hele lichaam sterker. Je krijgt hierdoor een goede houding en er komt veel minder druk op je wervelkolom te staan. Dit vermindert rugklachten aanzienlijk of kan rugklachten voorkomen.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_VETPERCENTAGE",
                                    "name": "Vetpercentage",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VETPERCENTAGE",
                                            "name": "Vetpercentage",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "doubleValue": 19.6,
                                                    "stringValue": "19.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VETPERCENTAGE_NEUTRAL",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 29.1,
                                                    "stringValue": "29.1",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VETPERCENTAGE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 15,
                                                    "stringValue": "15.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VETPERCENTAGE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 35.3,
                                                    "stringValue": "35.3",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VETPERCENTAGE_BAD",
                                                    "resultText": "Je vetpercentage is licht verhoogd",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een te hoog lichaamsvetpercentage leidt tot een verhoogde kans op welvaartsziekten en allerlei andere aandoeningen, zoals hart- en vaatziekten en diabetes type 2. Daarnaast vergroot een teveel aan subcutaan lichaamsvet (buikvet, heupvet e.a.) je kans op blessures tijdens lichaamsbeweging. Visceraal lichaamsvet (vet rond je organen) vergroot bovendien je kans op allerlei ontstekingsreacties.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "FATPERCENTAGE",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_VERDELINGVETMASSA",
                                    "name": "Verdeling vetpercentage",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMLINKS",
                                            "name": "Linkerarm",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 15.8,
                                                    "stringValue": "15.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMLINKS",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 33.8,
                                                    "stringValue": "33.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMLINKS",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 14.6,
                                                    "stringValue": "14.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMLINKS",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 40.2,
                                                    "stringValue": "40.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMLINKS",
                                                    "resultText": "Linkerarm",
                                                    "keyWords": "linkerarm",
                                                    "advice": "Het onderhuids vetweefsel in je rechterarm en je linkerarm is het best zo gelijk mogelijk.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMRECHTS",
                                            "name": "Rechterarm",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 16.3,
                                                    "stringValue": "16.3",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMRECHTS",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 28.3,
                                                    "stringValue": "28.3",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMRECHTS",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 13.8,
                                                    "stringValue": "13.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMRECHTS",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 38.9,
                                                    "stringValue": "38.9",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ARMRECHTS",
                                                    "resultText": "Rechterarm",
                                                    "keyWords": "rechterarm",
                                                    "advice": "Het onderhuids vetweefsel in je rechterarm en je linkerarm is het best zo gelijk mogelijk.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENLINKS",
                                            "name": "Linkerbeen",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 17.6,
                                                    "stringValue": "17.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENLINKS",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 29.8,
                                                    "stringValue": "29.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENLINKS",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 12.2,
                                                    "stringValue": "12.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENLINKS",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 33.3,
                                                    "stringValue": "33.3",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENLINKS",
                                                    "resultText": "Linkerbeen",
                                                    "keyWords": "linkerbeen",
                                                    "advice": "Het onderhuids vetweefsel in je rechterbeen en je linkerbeen is het best zo gelijk mogelijk.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENRECHTS",
                                            "name": "Rechterbeen",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 16.1,
                                                    "stringValue": "16.1",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENRECHTS",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 30.5,
                                                    "stringValue": "30.5",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENRECHTS",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 13.2,
                                                    "stringValue": "13.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENRECHTS",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 32.6,
                                                    "stringValue": "32.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_BEENRECHTS",
                                                    "resultText": "Rechterbeen",
                                                    "keyWords": "rechterbeen",
                                                    "advice": "Het onderhuids vetweefsel in je rechterbeen en je linkerbeen is het best zo gelijk mogelijk.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ROMP",
                                            "name": "Romp",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 22.5,
                                                    "stringValue": "22.5",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ROMP",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 28.7,
                                                    "stringValue": "28.7",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ROMP",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 16.1,
                                                    "stringValue": "16.1",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ROMP",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 37.6,
                                                    "stringValue": "37.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_VET_ROMP",
                                                    "resultText": "Romp",
                                                    "keyWords": "romp",
                                                    "advice": "Deze waarde duidt op het onderhuids vetpercentage in je romp.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_HEUPVET",
                                    "name": "Heupvet",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                            "name": "Heupvet",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2.4,
                                                    "stringValue": "2.4",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 3.6,
                                                    "stringValue": "3.6",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2.2,
                                                    "stringValue": "2.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 3.8,
                                                    "stringValue": "3.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_HEUPVET",
                                                    "resultText": "Heupvet",
                                                    "keyWords": "heupvet",
                                                    "advice": "Je heupen en dijen zijn een veilige opslagplaats voor vet. Als je op een gezond gewicht zit en als vet op je heupen het enige is dat je stoort, hoef je jezelf zeker geen zorgen te maken over dit laagje.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_BUIKVET",
                                    "name": "Buikvet",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                            "name": "Buikvet",
                                            "unit": "kg",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.3,
                                                    "stringValue": "1.3",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1,
                                                    "stringValue": "1.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.8,
                                                    "stringValue": "0.8",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.7,
                                                    "stringValue": "1.7",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BUIKVET",
                                                    "resultText": "Buikvet",
                                                    "keyWords": "buikvet",
                                                    "advice": "Zelfs als je gewicht en lichaamsvet constant blijven, verandert de vetverdeling over je lichaam naarmate je ouder wordt en zal vet eerder naar je buikgebied verschuiven. Door ervoor te zorgen dat je een gezond visceraal vetniveau hebt, neemt de kans op bepaalde aandoeningen, zoals hartziekten en hoge bloeddruk, af en kan het ontstaan van diabetes type 2 worden vertraagd.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_RATIO",
                                    "name": "Buik-heupratio",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO",
                                            "name": "Buik-heupratio",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 1.2,
                                                    "stringValue": "1.2",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "doubleValue": 0.79,
                                                    "stringValue": "0.79",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.89,
                                                    "stringValue": "0.89",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.99,
                                                    "stringValue": "0.99",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_AGRATIO_GOOD",
                                                    "resultText": "Je middel-heupratio is goed",
                                                    "keyWords": "goed",
                                                    "advice": "Goed bezig! Een lage middel-heupratio betekent dat de hoeveelheid vet niet is opgeslagen rond je middel. Houden zo!",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "DXA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK",
                                            "name": "Buikomtrek",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116168810
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709124272513
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709223914112
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "resultText": "Uit jouw antwoorden blijkt dat je buikomtrek licht verhoogd is. Als vrouw is dat tussen de 80 en 88 centimeter.",
                                                    "keyWords": "licht te hoog",
                                                    "advice": "Wat sommige coaches en influencers ook mogen beweren: er bestaat helaas geen miraculeus crashdieet om snel die buik kwijt te raken. Toch helpen alle beetjes. Als je erin slaagt om 5 Ã  10% van je gewicht te verliezen, dan heeft dat een heilzaam effect op je buikvet. Met de nodige deskundige hulp lukt het zelfs om bij veel overgewicht de gezonde balans terug te vinden.\n\nIn een ideaal scenario vind je een gezond voedingspatroon dat je je eigen maakt om ook op lange termijn een gezond gewicht Ã©n je buikomtrek te behouden. Het klassieke jojo-effect dat ervoor zorgt dat je continu afvalt en vervolgens weer bijkomt, is namelijk erg slecht voor je gezondheid. Bij deze nog wat inspiratie:\n\n* Ga fietsen, zwemmen, wandelen, dansen, trappen lopen: maak zelf een keuze waar je je goed en gemotiveerd bij voelt.\n* Probeer elke dag twintig minuten intensief - zodat je bijna buiten adem bent - te bewegen.\n* Lukt het niet om elke dag te bewegen? Probeer dan minstens vier keer per week beweging (maar dan wel 30 Ã  45 minuten) in te plannen.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1719837987002
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP",
                                            "name": "Middel-heupverhouding",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_MAN_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116168810
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709124272513
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_MAN_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709223914112
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKHEUP_VROUW_VERYBAD",
                                                    "resultText": "Jouw middel-heup verhouding is sterk verhoogd. Dit betekent dat de verhouding hoger is dan 0.85.",
                                                    "keyWords": "sterk verhoogd",
                                                    "advice": "Je middel-heupratio zou best wat lager liggen. Gewicht verliezen is hier vaak noodzakelijk en dan meer specifiek ter hoogte van de buik. Een gezondheidsprofessional kan je daarbij helpen.",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1719837987002
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "200.0",
                                            "score": 200,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 27,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "275.0",
                                            "score": 275,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 20.04405450812022,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "275.0",
                                            "score": 275,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 20.053014747059922,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 300,
                                            "goalScore": 300,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BODY_SAMENSTELLING_BOTMASSA",
                                    "name": "Botmassa",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BOTTEN_BMCTOTAAL",
                                            "name": "Totaal gewicht botten",
                                            "unit": "g",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 3586,
                                                    "stringValue": "3586.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BOTTEN_BMCTOTAAL",
                                                    "time": 1623937440000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2644,
                                                    "stringValue": "2644.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BOTTEN_BMCTOTAAL",
                                                    "time": 1623939540000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 3618,
                                                    "stringValue": "3618.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BOTTEN_BMCTOTAAL",
                                                    "time": 1638437400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 2210,
                                                    "stringValue": "2210.0",
                                                    "tag": "RESULT_LEADLIFE_MEASUREMENT_DXA_BOTTEN_BMCTOTAAL",
                                                    "resultText": "Totaal gewicht botten",
                                                    "keyWords": "botmassa",
                                                    "advice": "Het is belangrijk om je botten goed te blijven verzorgen om eventuele problemen te voorkomen. Je kan je botten verzorgen door een evenwichtig voedingspatroon dat rijk is aan calcium, aan te houden en door veel te bewegen en daarbij je hele lichaam te belasten.",
                                                    "time": 1639648080000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "DXA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.5",
                                    "score": 6.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 27.69230769230769,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 40.82439729256978,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.0",
                                    "score": 8,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 22.967145790554415,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.0",
                                    "score": 8,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 22.97741273100616,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 40.96433188835653,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 40.982584226937405,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 40.988668339797705,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 41.00083656551829,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 41.0860141455624,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 41.110350597003574,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 41.57882728724618,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 41.657920754429995,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.5,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 41.66400486729028,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        }
                    ],
                    "results": [],
                    "scoreResult": [
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.5",
                            "score": 6.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 27.211498973305954,
                            "leadlifeAge": 27.69230769230769,
                            "goalAge": 18,
                            "time": 1672613999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.369609856262834,
                            "leadlifeAge": 40.82439729256978,
                            "goalAge": 18.3709787816564,
                            "time": 1709161199000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "8.0",
                            "score": 8,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.372347707049965,
                            "leadlifeAge": 22.967145790554415,
                            "goalAge": 18.373716632443532,
                            "time": 1709247599000
                        },
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "8.0",
                            "score": 8,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.380561259411362,
                            "leadlifeAge": 22.97741273100616,
                            "goalAge": 18.38193018480493,
                            "time": 1709506799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.432580424366872,
                            "leadlifeAge": 40.96433188835653,
                            "goalAge": 18.43394934976044,
                            "time": 1711148399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.44079397672827,
                            "leadlifeAge": 40.982584226937405,
                            "goalAge": 18.442162902121833,
                            "time": 1711407599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.4435318275154,
                            "leadlifeAge": 40.988668339797705,
                            "goalAge": 18.444900752908968,
                            "time": 1711493999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.449007529089666,
                            "leadlifeAge": 41.00083656551829,
                            "goalAge": 18.45037645448323,
                            "time": 1711666799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.487337440109513,
                            "leadlifeAge": 41.0860141455624,
                            "goalAge": 18.48870636550308,
                            "time": 1712872799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.49828884325804,
                            "leadlifeAge": 41.110350597003574,
                            "goalAge": 18.49965776865161,
                            "time": 1713218399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.709103353867214,
                            "leadlifeAge": 41.57882728724618,
                            "goalAge": 18.71047227926078,
                            "time": 1719871199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.744695414099933,
                            "leadlifeAge": 41.657920754429995,
                            "goalAge": 18.746064339493497,
                            "time": 1720994399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "4.5",
                            "score": 4.5,
                            "maxScore": 10,
                            "goalScore": 10,
                            "realAge": 28.747433264887064,
                            "leadlifeAge": 41.66400486729028,
                            "goalAge": 18.748802190280628,
                            "time": 1721080799000
                        }
                    ]
                },
                {
                    "tag": "DASHBOARD_HEALTH",
                    "name": "DASHBOARD_HEALTH",
                    "groups": [
                        {
                            "tag": "DASHBOARD_HEALTH_OVERALLHEALTH",
                            "name": "Algemene gezondheid",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_HEALTH_OVERALLHEALTH_RESPIRATORYRATE",
                                    "name": "Gemiddelde ademhalingsfrequentie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATE",
                                            "name": "Gemiddeld ademhalingsritme",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 18,
                                                    "intValue": 18,
                                                    "stringValue": "18",
                                                    "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESPIRATORYRATESLEEP",
                                                    "resultText": "Gemiddeld ademhalingsritme tijdens slaap",
                                                    "advice": "De ademhalingsfrequentie geeft het gemiddelde aantal ademhalingen per minuut aan tijdens je slaap. Het bepaalt hoe efficiÃ«nt en rustig je ademt terwijl je slaapt. Een normale ademhalingsfrequentie in rust is meestal tussen de twaalf en twintig ademhalingen per minuut voor volwassenen. Om een optimale ademhalingsfrequentie te bereiken, is het belangrijk om een goede slaapomgeving te creÃ«ren en stimulerende middelen zoals cafeÃ¯ne, nicotine en alcohol voor het slapengaan te vermijden. Bovendien is regelmatige lichaamsbeweging en het beheersen van stress belangrijk voor een gezonde ademhaling.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_OVERALLHEALTH_RESPIRATORYRATEREST",
                                    "name": "Ademhalingsfrequentie in rust",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_INTERPRET_HEALTH_DAILY_RESPIRATORYRATEREST",
                                            "name": "Gemiddeld ademhalingsritme in rust",
                                            "values": [],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_OVERALLHEALTH_TEMPERATURE",
                                    "name": "Gemiddelde lichaamstemperatuur",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_TEMP_BODY",
                                            "name": "Gemiddelde lichaamstemperatuur",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_OVERALLHEALTH_HRREST",
                                    "name": "Gemiddelde hartslag in rust",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_RESTINGHEARTHRATE",
                                            "name": "Gemiddelde rusthartslag",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_OVERALLHEALTH_HRMEAN",
                                    "name": "Totale gemiddelde hartslag",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                            "name": "Gemiddelde hartslag ",
                                            "unit": "",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 76,
                                                    "intValue": 76,
                                                    "stringValue": "76",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "time": 1710288000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 73,
                                                    "intValue": 73,
                                                    "stringValue": "73",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "time": 1710720000000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 73,
                                                    "intValue": 73,
                                                    "stringValue": "73",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "time": 1711324800000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 75,
                                                    "intValue": 75,
                                                    "stringValue": "75",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "time": 1712361600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 76,
                                                    "intValue": 76,
                                                    "stringValue": "76",
                                                    "tag": "RESULT_WEARABLES_DIRECT_SLEEP_DAILY_HEARTHRATE",
                                                    "resultText": "Gemiddelde hartslag ",
                                                    "advice": "De gemiddelde hartslag gedurende de nacht is het aantal hartslagen per minuut terwijl je slaapt. Tijdens je slaap is je hartslag het laagst. Een normale nachtelijke hartslag varieert gewoonlijk tussen 40 en 60 slagen per minuut en kan variÃ«ren afhankelijk van factoren zoals leeftijd, conditie en gezondheid. Mensen met een goede cardiovasculaire gezondheid, waaronder fittere personen, hebben vaak een lagere nachtelijke hartslag. Om een gezonde nachtelijke hartslag te bevorderen, is het belangrijk om een regelmatig slaappatroon te behouden, stress te vermijden en een gezonde levensstijl te handhaven.",
                                                    "time": 1712534400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_OVERALLHEALTH_SMOKING",
                                    "name": "Roken",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING",
                                            "name": "DNA rookverslaving",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING_MATIG",
                                                    "resultText": "De kans dat jij een rookverslaving ontwikkelt, is een beetje hoger in vergelijking met anderen. Dat betekent dat als jij begint te roken - op basis van jouw DNA - de kans op afhankelijkheid van een sigaret wel degelijk aanwezig is. Pas daar dus mee op, want roken is verslavend Ã©n schadelijk voor de gezondheid.",
                                                    "keyWords": "verhoogde kans",
                                                    "advice": "Mocht het zo zijn dat je rookt, is het zeer belangrijk dat je stopt. Daarvoor kan je uiteraard altijd hulp inschakelen. Wist je dat dat je slaagkansen vergroot? Van de mensen die zonder hulp afkicken, is 3 tot 5 procent langer dan 1 jaar gestopt, terwijl 23% van mensen onder begeleiding gemiddeld langer dan 1 jaar gestopt is. Ben je een niet-roker? Houden zo!",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL",
                                            "name": "DNA kettingroker",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL_LAAG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat jij - als je rookt - geen verhoogd risico hebt om een zware roker te zijn of te worden. Dat betekent natuurlijk niet dat jij zonder gevaar kan roken, want het blijft verslavend Ã©n ongezond!",
                                                    "keyWords": "weinig kans",
                                                    "advice": "Stoppen met roken is belangrijk voor jou. Als dat niet meteen lukt, probeer dan af te bouwen en indien nodig externe hulp in te schakelen. Rook je niet? Ideaal!",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP",
                                            "name": "DNA rookstop",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "mogelijk minder vlot",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "mogelijk vlot",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "mogelijk minder vlot",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "mogelijk vlot",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP_LAAG",
                                                    "resultText": "Op basis van jouw DNA-analyse kunnen we afleiden dat bij jou - als je rookt of zou roken - de kans groot is dat je erin zal slagen te stoppen met roken.",
                                                    "keyWords": "mogelijk vlot",
                                                    "advice": "Als jij rookt, zou een rookstop voor jou vrij 'eenvoudig' moeten zijn. Dat blijkt uit jouw DNA-analyse. Toch vraagt het stoppen met roken van iedereen een inspanning. Veel rokers trachten het op eigen houtje te doen, maar dat is niet voor iedereen evident. Wanneer je wil stoppen, probeer dan uit elke poging een les te trekken. Het is geen schande eventueel extra hulp in te schakelen om jouw slaagkansen te vergroten!",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_TABAK",
                                            "name": "Tabaksgebruik",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_TABAK_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116232664
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_TABAK_ZEERGOED",
                                                    "resultText": "Niet roken is heel goed voor je gezondheid! Doe zo verder.  ",
                                                    "keyWords": "niet-roker",
                                                    "advice": "Het niet gebruiken van een damper of tabaksproduct is heel goed voor je gezondheid. Goeie keuze! Doe dus zeker zo verder.  ",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125534944
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 30,
                                            "goalScore": 15,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "115.0",
                                            "score": 115,
                                            "maxScore": 130,
                                            "goalScore": 115,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "115.0",
                                            "score": 115,
                                            "maxScore": 130,
                                            "goalScore": 115,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "115.0",
                                            "score": 115,
                                            "maxScore": 130,
                                            "goalScore": 115,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "115.0",
                                            "score": 115,
                                            "maxScore": 130,
                                            "goalScore": 115,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 130,
                                            "goalScore": 105,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 130,
                                            "goalScore": 125,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 130,
                                            "goalScore": 125,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 130,
                                            "goalScore": 125,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 130,
                                            "goalScore": 125,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 130,
                                            "goalScore": 125,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 130,
                                            "goalScore": 125,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "125.0",
                                            "score": 125,
                                            "maxScore": 130,
                                            "goalScore": 125,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "5.0",
                                    "score": 5,
                                    "maxScore": 10,
                                    "goalScore": 5,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.8",
                                    "score": 8.846153846153847,
                                    "maxScore": 10,
                                    "goalScore": 8.846153846153847,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 18.3709787816564,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.8",
                                    "score": 8.846153846153847,
                                    "maxScore": 10,
                                    "goalScore": 8.846153846153847,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 18.373716632443532,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.8",
                                    "score": 8.846153846153847,
                                    "maxScore": 10,
                                    "goalScore": 8.846153846153847,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 18.38193018480493,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.8",
                                    "score": 8.846153846153847,
                                    "maxScore": 10,
                                    "goalScore": 8.846153846153847,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 18.43394934976044,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.1",
                                    "score": 8.076923076923077,
                                    "maxScore": 10,
                                    "goalScore": 8.076923076923077,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 18.442162902121833,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.6",
                                    "score": 9.615384615384615,
                                    "maxScore": 10,
                                    "goalScore": 9.615384615384615,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 18.444900752908968,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.6",
                                    "score": 9.615384615384615,
                                    "maxScore": 10,
                                    "goalScore": 9.615384615384615,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 18.45037645448323,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.6",
                                    "score": 9.615384615384615,
                                    "maxScore": 10,
                                    "goalScore": 9.615384615384615,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 18.48870636550308,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.6",
                                    "score": 9.615384615384615,
                                    "maxScore": 10,
                                    "goalScore": 9.615384615384615,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 18.49965776865161,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.6",
                                    "score": 9.615384615384615,
                                    "maxScore": 10,
                                    "goalScore": 9.615384615384615,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 18.71047227926078,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.6",
                                    "score": 9.615384615384615,
                                    "maxScore": 10,
                                    "goalScore": 9.615384615384615,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 18.746064339493497,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.6",
                                    "score": 9.615384615384615,
                                    "maxScore": 10,
                                    "goalScore": 9.615384615384615,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 18.748802190280628,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_HEALTH_HART",
                            "name": "Hart- en vaatziekten",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_HEALTH_HART_LDL",
                                    "name": "LDL of slechte cholesterol",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL_HOOG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat je lichaam de neiging heeft om verhoogde LDL-cholesterolwaarden te hebben. LDL is de 'slechte' cholesterol in jouw bloed. Dit resultaat betekent niet dat jouw LDL-waarden op dit moment verhoogd zijn of dat ze sowieso verhoogd zullen worden, want jouw genen zijn maar Ã©Ã©n van de factoren die een impact hebben. Hoe je leeft, heeft een veel grotere impact. Een gezonde levensstijl kan ertoe leiden dat jouw LDL-waarden minder de neiging hebben om de lucht in te gaan.",
                                                    "keyWords": "verhoogde waarden",
                                                    "advice": "Voor jou is het heel belangrijk de factoren die een impact hebben op je LDL-cholesterol zo goed mogelijk onder controle te houden. Er zijn verschillende manieren om je LDL-waarden zo laag mogelijk te houden, waarvan dit de belangrijkste zijn. Ga voor een gezond dieet, door bijvoorbeeld minder verzadigde vetten te gebruiken en veel groenten, fruit en voedingsvezels te eten. Beperk het gebruik van zout, rook niet en beweeg minimaal 2,5 uur per week.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL",
                                            "name": "LDL Cholesterol",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 67,
                                                    "intValue": 67,
                                                    "stringValue": "67",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 96,
                                                    "intValue": 96,
                                                    "stringValue": "96",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 124,
                                                    "intValue": 124,
                                                    "stringValue": "124",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 67,
                                                    "intValue": 67,
                                                    "stringValue": "67",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL_NORMAAL",
                                                    "resultText": "Je LDL-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Wil je je cholesterolniveau goed onder controle houden? Topplan! Tracht te streven naar waarden lager dan 100 mg/dl. Het belangrijkste is om te beginnen of blijven bewegen. Probeer dat ongeveer dagelijks een halfuurtje te doen, om zo wekelijks aan 2,5 uur beweging te komen. Hoe meer je dat doet, hoe lager je LDL-waarden en hoe hoger je HDL-waarden zullen zijn. Wat soms ook kan helpen is gewicht verliezen, al hangt het niet alleen daarvan af. Slechts 5 tot 10 procent van je lichaamsgewicht kan een grote invloed hebben op het verlagen van je cholesterol.\n\nZoals steeds speelt een gezond dieet een belangrijke rol. Probeer verzadigde vetten te mijden, want zij bedekken je lichaam met cholesterol. Je vindt deze vetten onder andere in zuivel en vet vlees. Die kan je vervangen door mager, âhuidloosâ vlees. Vermijd daarnaast ook transvetten, die onder andere in commercieel verpakte bakkerijproducten zoals koekjes en crackers zitten. Betere tussendoortjes zijn hele granen, fruit, noten en groenten.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "15.0",
                                            "score": 15,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_HART_HDL",
                                    "name": "HDL of goede cholesterol",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "lagere waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "hogere waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "hogere waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "lagere waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL_HOOG",
                                                    "resultText": "We kunnen uit jouw DNA-resultaten afleiden dat je lichaam van nature de neiging heeft om wat lagere HDL-waarden in het bloed te hebben. HDL is de goede cholesterol en helpt je te beschermen tegen hart- en vaatziekten. Het is dan ook belangrijk die waarden zo hoog mogelijk te houden. Met de juiste voeding en een gezonde levensstijl kan je alvast een stap in de juiste richting zetten.",
                                                    "keyWords": "lagere waarden",
                                                    "advice": "Wil jij je HDL-waarden verhogen? Laat dan het roken zeker links liggen, omdat de HDL-waarden daardoor sterk afnemen. De verhouding tussen goede en slechte cholesterol kan grondig verstoord worden als je te veel verzadigde vetten eet. Probeer die verhouding te verbeteren door enkelvoudige onverzadigde vetten te kiezen, waardoor de HDL-cholesterol stijgt. \n\nVoldoende lichaamsbeweging heeft ook een gunstig effect op de HDL-waarden: doorgaans is meer bewegen ook beter. Heb je een chronische aandoening en/of verschillende risicofactoren voor hart- en vaatziekten? Hou dan rekening met speciale voorzorgsmaatregelen bij het opstarten van een trainingsprogramma. Raadpleeg in dat geval zeker een arts om jou te begeleiden!",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL",
                                            "name": "HDL cholesterol",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 94,
                                                    "intValue": 94,
                                                    "stringValue": "94",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 58,
                                                    "intValue": 58,
                                                    "stringValue": "58",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 83,
                                                    "intValue": 83,
                                                    "stringValue": "83",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL_NORMAAL",
                                                    "resultText": "Je HDL-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Je HDL-cholesterol kan je verder doen stijgen door een gezondere levensstijl aan te nemen. Denk bijvoorbeeld aan een veranderd voedingspatroon, met meer aandacht voor verse groenten en fruit. Deze bevatten veel gezonde vezels. Daarnaast is het ook belangrijk om gezonde, onverzadigde vetten te eten. Die vind je in noten en zaden of avocado, maar ook in vette vis in de vorm van omega 3. Probeer ook regelmatig te bewegen. Dat kan door simpelweg iedere dag een wandeling te maken. Ben je een roker? Dan stop je daar best mee, aangezien het een negatieve invloed heeft op de cholesterol.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 60,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_HART_CHOLTOTAAL",
                                    "name": "Totale cholesterol",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL_MATIG",
                                                    "resultText": "Als het aankomt op je totale cholesterol, blijkt uit jouw DNA-analyse dat jij van nature de neiging hebt om licht verhoogde waarden te hebben in vergelijking met de algemene bevolking. Dat betekent natuurlijk niet dat die waarden nu al verhoogd zijn of dat ze sowieso zullen verhogen. Jouw genen zijn maar Ã©Ã©n factor binnen het grotere geheel hoe je jouw cholesterol kan regelen, want ook jouw levensstijl speelt mee!",
                                                    "keyWords": "licht verhoogde waarden",
                                                    "advice": "Het is aangeraden voor een gezonde levensstijl te kiezen om jouw totale cholesterol zo laag mogelijk te houden. Heel wat zaken kunnen een toename van het totale cholesterolgehalte vermijden. Denk bijvoorbeeld aan gezonde voeding, voldoende bewegen, niet roken, een gezond gewicht...",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL",
                                            "name": "Totale cholesterol",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 173,
                                                    "intValue": 173,
                                                    "stringValue": "173",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 170,
                                                    "intValue": 170,
                                                    "stringValue": "170",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 224,
                                                    "intValue": 224,
                                                    "stringValue": "224",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_HOOG",
                                                    "resultText": "Je totale cholesterolwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Wil je je âslechteâ LDL-cholesterol verlagen en de âgoedeâ HDL-cholesterol verhogen? Trek dan je sportkleren maar aan! Door voldoende te bewegen en gevarieerd te eten kom je al een heel eind. Dat laatste doe je onder andere door veel groenten, fruit en voedingsvezels te eten en je zoutgebruik te minderen. Probeer daarnaast ook zo veel mogelijk verzadigd vet in je eten te vervangen door onverzadigd vet.\n\nDoor je voeding aan te passen kun je je cholesterolgehalte met zoân 10 procent verlagen! Door daarnaast ook plantensterolen te gebruiken kun je het nog eens met 10 procent doen dalen. Die plantensterolen zijn vetachtige stoffen die je, uiteraard, in planten vindt. Qua structuur lijken ze heel erg op cholesterol, maar ze zorgen ervoor dat cholesterol minder opgenomen wordt in de darmen. Door dagelijks 1,5 Ã  3 gram plantensterolen uit verrijkte voedingsmiddelen te gebruiken kun je je cholesterolgehalte met ongeveer 10 procent verlagen. Probeer daar ook niet mee te overdrijven, want als je meer dan 3 gram plantensterolen per dag gebruikt, daalt je cholesterolgehalte niet verder.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 42.21149897330595,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "20.0",
                                            "score": 20,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_HART_RATIO",
                                    "name": "Verhouding cholesterol",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING",
                                            "name": "Cholesterol verhouding",
                                            "unit": "ratio",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.85,
                                                    "stringValue": "1.85",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.92,
                                                    "stringValue": "2.92",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.69,
                                                    "stringValue": "2.69",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING_NORMAAL",
                                                    "resultText": "Je verhouding totale cholesterol/HDL-cholesterol is normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Cholesterol wordt voor grotendeels in de lever aangemaakt. Door een gezonde levensstijl kun je de cholesterol blijvend positief beÃ¯nvloeden. Een optimale cholesterolratio is lager dan 4. Onder een gezonde levensstijl verstaan we een gezond gewicht, gezonde voeding, voldoende beweging en niet roken.\n\n  * Gezond gewicht. Het risico op een te hoge cholesterol is al veel lager bij een gezond gewicht. Een paar kiloâs eraf heeft al een gunstig effect!\n\n\n  * Gezond eten. Cholesterol in voeding wordt via de darmen opgenomen in het bloed en naar de lever gebracht, maar daarnaast kan de cholesterol ook beÃ¯nvloed worden door andere voedingsstoffen. Zo zorgen verzadigde (verkeerde) vetten en transvetten voor een stijging van de slechte LDL-cholesterol. Verzadigde vetten zitten vooral in dierlijke producten als volle melkproducten, worstsoorten en vette vlees(waren). Transvetten zitten met name in de lekkere extraâs zoals koek, gebak, chocolade, chips, zoutjes en andere snacks. Voedingsvezels en onverzadigde (okÃ©) vetten zorgen juist voor een daling van de slechte LDL-cholesterol. Voedingsvezels zitten in volkoren graanproducten, fruit en groenten. Denk bij onverzadigde vetten aan plantaardige olie, noten, avocado en vis. Vis bevat echter ook weer DHA, een omega 3-vetzuur dat de LDL-cholesterol doet stijgen. Het is daarom belangrijk vis met mate te nemen.\n\n\n  * Voldoende lichaamsbeweging zorgt voor een verlaging van de LDL-cholesterol, doordat de HDL-cholesterol verhoogd wordt. De verhoging van de HDL-cholesterol is een voordeel dat de meeste medicatie niet eens heeft! Dagelijks een halfuur matig intensief bewegen is voldoende.\n\n\n  * Niet roken. Roken leidt tot vernauwing en beschadigingen van de bloedvaten, waardoor de LDL-cholesterol zich beter kan hechten aan de wand. Daarnaast verlaagt roken de hoeveelheid HDL-cholesterol, waardoor de LDL-cholesterol niet voldoende afgevoerd kan worden.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_HART_TRIGLYC",
                                    "name": "Triglyceriden",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN_MATIG",
                                                    "resultText": "Uit jouw DNA-resultaten konden we afleiden dat jouw lichaam de neiging heeft om licht verhoogde triglyceridelevels in jouw bloed te hebben. Die uitkomst betekent niet dat je nooit verhoogde waarden zal hebben, want jouw genen vormen maar Ã©Ã©n factor in het grotere geheel. Een gezonde levensstijl kan helpen om jouw triglyceridelevels onder controle te houden.",
                                                    "keyWords": "licht verhoogde waarden",
                                                    "advice": "Wil jij de triglyceridenwaarden in je bloed verlagen? Kies dan zeker voor een gezonde levensstijl. Begin alvast met een gezond gewicht te bereiken en/of te behouden. Als je overgewicht hebt, helpt gewichtsverlies via een dieet om je triglyceridenwaarden te verminderen. Ook voldoende bewegen heeft een positief effect op die waarden. Ga voor minstens 30 minuten beweging per dag, minstens vijf dagen per week.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN",
                                            "name": "Triglyceriden",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 62,
                                                    "intValue": 62,
                                                    "stringValue": "62",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 77,
                                                    "intValue": 77,
                                                    "stringValue": "77",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 85,
                                                    "intValue": 85,
                                                    "stringValue": "85",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN_NORMAAL",
                                                    "resultText": "Je triglyceridenwaarden zijn neutraal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Zoals wel vaker in dit rapport is het ook voor je triglyceridenwaarden belangrijk om een gezonde levensstijl te hanteren. Tracht steeds te streven naar triglyceridewaarden lager dan 100 mg/dl. Matig de verzadigde vetten die je binnenkrijgt en zorg vooral dat je voldoende groenten eet. Beperk ook je alcoholverbruik en probeer 30 minuten per dag te bewegen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "60.0",
                                            "score": 60,
                                            "maxScore": 60,
                                            "goalScore": 60,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "55.0",
                                            "score": 55,
                                            "maxScore": 60,
                                            "goalScore": 55,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_HART_CORONAIR",
                                    "name": "Coronaire aandoeningen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD_MATIG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat er een kans bestaat dat jij coronaire aandoeningen ontwikkelt. Dat betekent niet dat je nu ziek bent of dat je die aandoening met zekerheid zal krijgen. Het goede nieuws is dat je jouw algemeen risico op die aandoeningen kan beÃ¯nvloeden omdat de genen maar Ã©Ã©n factor zijn binnen het geheel van elementen die de oorzaak vormen voor het ontwikkelen ervan. Jouw levensstijl heeft de grootste impact.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Omdat jouw lichaam de neiging heeft om aandoeningen ter hoogte van de kransslagaders te ontwikkelen, is een gezonde levensstijl voor jou enorm belangrijk. Verschillende zaken kunnen je helpen om aandoeningen te vermijden. Denk maar aan regelmatig bewegen en gezonde voeding, of het vermijden van overgewicht en niet roken.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 10,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 10,
                                            "goalScore": 5,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_HART_BLOEDDRUK",
                                    "name": "Verhoogde bloeddruk",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION_HOOG",
                                                    "resultText": "Uit de resultaten van je DNA-analyse blijkt dat jouw lichaam de neiging heeft om een verhoogde bloeddruk te ontwikkelen. Dat betekent niet dat jij nu al een verhoogde bloeddruk hebt of die zeker zal krijgen: jouw genen vormen maar Ã©Ã©n factor. Naarmate we ouder worden, neemt onze bloeddruk automatisch toe. Een gezonde levensstijl is heel belangrijk om een verhoogde bloeddruk te vermijden. ",
                                                    "keyWords": "verhoogde waarden",
                                                    "advice": "Omdat het ontwikkelen van een verhoogde bloeddruk in de aard van jouw lichaam ligt, is het aanbevolen om rekening te houden met bepaalde factoren. Beweeg voldoende en streef naar een gezond gewicht, bijvoorbeeld. Laat daarnaast sigaretten, vet, suiker en zout links liggen. Zout zit in heel veel voedingswaren verwerkt zonder dat we er ons bewust van zijn. Een groot brood bevat bijvoorbeeld 4 gram zout. Bouillonblokjes en bereide vleeswaren kunnen ook heel veel zout bevatten. Je hoeft dus niet altijd extra zout toe te voegen aan gewone voeding!",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP",
                                            "name": "Hoge bloeddruk",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "geen hoge bloeddruk",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "hoge bloeddruk",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116321992
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "hoge bloeddruk",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125631427
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "hoge bloeddruk",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "hoge bloeddruk",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "hoge bloeddruk",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "hoge bloeddruk",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "hoge bloeddruk",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_BP_VERYBAD",
                                                    "resultText": "Je hebt een hoge bloeddruk.",
                                                    "keyWords": "hoge bloeddruk",
                                                    "advice": "Er zijn enkele zaken waarme je rekening kan houden in je levensstijl voor je hoge bloeddruk:\n- Beperk je zoutinname: verminder je consumptie van zoute voedingsmiddelen, zoals bewerkte snacks, fastfood en ingeblikt voedsel.\n- Focus op gezonde voeding: richt je vooral op het eten van groenten, fruit, volkoren granen en gezonde vetten (zoals noten, vette vis en olijfolie).\n- Beheers je gewicht: streef naar een gezond gewicht.\n- Let op met alcoholgebruik: consumeer alcohol met mate.\n- Rook niet.\n- Laat je regelmatig opvolgen door een zorgverlener.",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1721056884600
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_HART_GLOBAAL",
                                    "name": "Globaal risico",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN",
                                            "name": "Hart- en vaataandoeningen",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale kans",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_GOED_1_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116321992
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125631427
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_CARDIO_ALGEMEEN_SLECHT_1_BAD",
                                                    "resultText": "Je risico op hart- en vaatziekten is verhoogd omdat bij jou al een hart- en vaatziekte werd vastgesteld.",
                                                    "keyWords": "aandoening aanwezig",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1721056884600
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.8",
                                    "score": 7.8431372549019605,
                                    "maxScore": 10,
                                    "goalScore": 9.215686274509803,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 21.15,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.9",
                                    "score": 3.9215686274509802,
                                    "maxScore": 10,
                                    "goalScore": 9.215686274509803,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 43.17180013689254,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.9",
                                    "score": 3.9215686274509802,
                                    "maxScore": 10,
                                    "goalScore": 9.215686274509803,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 43.1782340862423,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.9",
                                    "score": 3.9215686274509802,
                                    "maxScore": 10,
                                    "goalScore": 9.215686274509803,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 43.19753593429159,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.3",
                                    "score": 4.313725490196078,
                                    "maxScore": 10,
                                    "goalScore": 9.607843137254902,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 41.05743264264825,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.4",
                                    "score": 4.411764705882353,
                                    "maxScore": 10,
                                    "goalScore": 9.705882352941176,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 40.57275838466803,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.509803921568627,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 37.29077760914204,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.509803921568627,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 37.30184804928131,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.509803921568627,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 37.37934113025623,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.509803921568627,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 37.40148201053477,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.509803921568627,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 37.8276939558968,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.509803921568627,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 37.89965181680207,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "4.5",
                                    "score": 4.509803921568627,
                                    "maxScore": 10,
                                    "goalScore": 9.117647058823529,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 37.9051870368717,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_HEALTH_DIABETES",
                            "name": "Diabetes type 2",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_HEALTH_DIABETES_DIABETES",
                                    "name": "Diabetes types 2",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_DIABETES",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DIABETES_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DIABETES_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DIABETES_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DIABETES_MATIG",
                                                    "resultText": "Als we jou met anderen vergelijken, kunnen we op basis van jouw DNA-analyse afleiden dat jij een licht verhoogde vatbaarheid hebt om diabetes type 2 te ontwikkelen. Dat betekent niet dat jij momenteel ziek bent of dat jij die aandoening met zekerheid zal ontwikkelen. Jouw genen vormen namelijk maar een deel van je vatbaarheid, ook je levensstijl kan daar een beschermende of risicoverhogende rol in spelen. Het is belangrijk die factoren zo goed mogelijk onder controle te houden.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een gezonde levensstijl is zeer belangrijk als je de ontwikkeling van diabetes type 2 wil verminderen of voorkomen. Zorg voor voldoende beweging, hou je gewicht onder controle, eet gezond, rook niet of stop met roken. Probeer daar rekening mee te houden, omdat je volgens jouw DNA een licht verhoogde vatbaarheid hebt.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES",
                                            "name": "Diabetes type 2",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale kans",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_GOED_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116325923
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125636410
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aandoening aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_HEALTH_DIABETES_AANWEZIG_BAD",
                                                    "resultText": "Je gaf aan dat bij jou diabetes type 2 werd vastgesteld. Een gezonde levensstijl is voor jou van groot belang.",
                                                    "keyWords": "aandoening aanwezig",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1721056886864
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "105.0",
                                            "score": 105,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 110,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NEUTRAL",
                                            "stringValue": "5.0",
                                            "score": 5,
                                            "maxScore": 110,
                                            "goalScore": 105,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_DIABETES_HBA1C",
                                    "name": "HbA1c",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C",
                                            "name": "HbA1c",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5.4,
                                                    "stringValue": "5.4",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5,
                                                    "stringValue": "5.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5.5,
                                                    "stringValue": "5.5",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                                    "resultText": "Je HbA1c-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Door je levensstijl hier en daar bij te sturen kan je al heel wat doen om je bloedsuikerspiegel stabiel te houden:\n \n  * Verminder je suikerinname uit zoetigheden, koekjes en bewerkt voedsel.\n  * Vervang de snelle koolhydraten door complexe koolhydraten zoals in granen, bonen en noten.\n  * Afwisselend vasten of je maaltijdfrequentie verlagen wordt steeds belangrijker. Een studie in het World Journal of Diabetes claimt dat afwisselend vasten helpt om het bloedsuikerniveau te verbeteren en gewicht te verliezen. De lange periode van vasten fixeert de bloedsuiker en de stofwisseling (het metabolisme) gaat over op het verbranden van vetreserves.\n  * Eet minder verzadigde vetten. Een teveel aan verzadigde vetten kan leiden tot overgewicht, en dat alleen al heeft een heel grote invloed op je bloedsuikerspiegel.\n  * Eet geen transvetten. Niet alleen neemt de kans op overgewicht toe bij consumptie van te veel transvetten, ook krijg je last van inflammatie, zoals bij kunstmatige suikers. Deze ontstekingen in je lichaam hebben een grote invloed op je bloedsuikerspiegel.\n  * Eet wel meer onverzadigde vetten. Die vetten hebben precies de tegenovergestelde effecten op je gezondheid in vergelijking met transvetten. Onverzadigde vetten zorgen ervoor dat je hart- en vaatstelsel gezond en soepel blijft. Daarnaast werken ze ontstekingsremmend. Ontstekingen leiden tot een hoge bloedsuikerspiegel en dat is precies datgene wat door onverzadigde vetten te eten wordt voorkomen.\n  * Eet meer eiwitten. Van alle voedingsgroepen hebben eiwitten de minste invloed op je bloedsuikerspiegel. Door een groter deel van je dieet uit eiwitten te laten bestaan heb je dus wel de energie, maar niet de stijging van je bloedsuikerspiegel.\n  * Drink minder cafeÃ¯ne.\n  * Laat ook alcohol links liggen. Zoals je misschien wel weet, is je alvleesklier verantwoordelijk voor de aanmaak van insuline. Diezelfde alvleesklier maakt ook deel uit van de groep organen die belast is met het verwijderen van alcohol uit je systeem. Als je dus regelmatig alcohol drinkt, belast je de alvleesklier onnodig.\n  * Beweeg voldoende en op regelmatige basis. Meer bewegen vermindert de insulineresistentie en heeft tot gevolg dat je meer calorieÃ«n verbrandt. Er zit wel een addertje onder het gras: je moet consistent bewegen om een effect te hebben.\n  * Slaap voldoende. Wanneer je te weinig slaapt, kan je problemen krijgen met je cellen voor insuline. Tracht minimaal 6 Ã  7 uur per nacht te slapen.\n  * Wees stress de baas. Stresshormonen jagen je bloedsuikerspiegel omhoog. Op het moment dat jouw hersenen een potentiÃ«le noodsituatie detecteren, schakelt dit mechanisme in en je kunt het niet stoppen. Wat je wel kan doen, is stresssituaties leren beheersen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_WEARABLES_DIRECT_HEALTH_DAILY_DIABETES_HBA1C",
                                            "name": "Gemiddelde HbA1c",
                                            "values": [],
                                            "visualization": "TEXTUAL",
                                            "source": "WEARABLE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_DIABETES_GLUCOSE",
                                    "name": "Glucose",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_GEWICHT_DIABETES_GLUCOSE",
                                            "name": "Glucose",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 90,
                                                    "intValue": 90,
                                                    "stringValue": "90",
                                                    "tag": "RESULT_BLOOD_GEWICHT_DIABETES_GLUCOSE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 80,
                                                    "intValue": 80,
                                                    "stringValue": "80",
                                                    "tag": "RESULT_BLOOD_GEWICHT_DIABETES_GLUCOSE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 87,
                                                    "intValue": 87,
                                                    "stringValue": "87",
                                                    "tag": "RESULT_BLOOD_GEWICHT_DIABETES_GLUCOSE_NORMAAL",
                                                    "resultText": "Je glucosewaarden nuchter zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Iedereen heeft een andere energiebehoefte. Als je veel beweegt, heb je uiteraard meer energie nodig dan iemand die weinig beweegt. Bovendien hebben we allemaal een bepaalde glucosetolerantie. Dat is de mate waarin je lichaam glucose uit het bloed kan verwerken. Als je gezond en gevarieerd eet, krijg je dagelijks voldoende koolhydraten en dus glucose binnen. Als je een gezonde glucosetolerantie hebt, is de bloedsuiker binnen twee uur na een maaltijd weer op peil. Sommige mensen hebben een verminderde glucosetolerantie. Alles werkt dan net iets trager. De bloedsuiker is dan veel te hoog, maar dat wordt snel gecorrigeerd door het lichaam.\n\nProbeer te streven naar nuchtere glucosewaarden tussen de 70 mg/dl en 95 mg/dl.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_DIABETES_INSULINE",
                                    "name": "Insuline",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE",
                                            "name": "Insuline",
                                            "unit": "mU/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 8.7,
                                                    "stringValue": "8.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4,
                                                    "stringValue": "4.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 3.7,
                                                    "stringValue": "3.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "doubleValue": 4,
                                                    "intValue": 4,
                                                    "stringValue": "4",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE_LAAGLAAG",
                                                    "resultText": "Je insulinewaarden nuchter zijn sterk verlaagd.",
                                                    "keyWords": "sterk verlaagd",
                                                    "advice": "Insuline wordt aangemaakt in de alvleesklier of pancreas en zorgt ervoor dat suiker vanuit je bloed wordt opgenomen in je cellen. Wanneer je lichaam onvoldoende insuline aanmaakt, verloopt die opname van suiker dus minder vlot en stijgt het suikergehalte in je bloed. Te veel suiker in je bloed kan je bloedvaten beschadigen. De productie van insuline wordt gestimuleerd door voedingsproducten met een hoge glycemische lading. Denk bijvoorbeeld aan 120 gram rozijnen of een portie aardappelen.",
                                                    "score": 0,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                }
                                            ],
                                            "visualization": "SLIDER_REVERSE",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_DIABETES_INSULINERESISTENTIE",
                                    "name": "Insulineresistentie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR",
                                            "name": "HOMA-IR",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.13,
                                                    "stringValue": "1.13",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.51,
                                                    "stringValue": "0.51",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.48,
                                                    "stringValue": "0.48",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 16,
                                                    "intValue": 16,
                                                    "stringValue": "16",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 96,
                                                    "intValue": 96,
                                                    "stringValue": "96",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "resultText": "Je HOMA-IR-waarde is een berekende waarde.",
                                                    "keyWords": "berekende waarde",
                                                    "advice": "Een ideale HOMA-IR-index is rond 1%. Wees insulineresistentie steeds een stap voor en houd rekening met deze aspecten: \n\n  * Eet langzaam verterend voedsel\n  * Sport kort, maar krachtig\n  * Eet minder koolhydraten\n  * Slaap voldoende\n  * Drink groene thee\n  * Streef naar een gezond gewicht\n  * Gebruik kruiden zoals gember, kaneel, ginseng, appelazijn of kurkuma\n\nIs je waarde hoger dan 1%? Weet dan dat insulineresistentie meerdere oorzaken kan hebben. Vaak is het dan ook een combinatie van meerdere factoren. Zoals bij iedere lichamelijke klacht is er een genetische component, maar hoe je leeft kan ervoor zorgen dat bepaalde genen tot uiting komen. Als we kijken naar levensstijl dan zien we een aantal dingen die de kans verhogen op insulineresistentie:\n\n  * Overgewicht en veel buikvet of orgaanvet\n  * Een hoge inname van sterk bewerkte (geraffineerde) voedingsmiddelen met toegevoegde suikers die de bloedsuiker snel laten stijgen\n  * Inactief leven \n  * Chronische stress \n  * Laaggradige ontstekingen door bijvoorbeeld voedselovergevoeligheden, âlekkende darmsyndroomâ, onbalans in de darmbacteriÃ«n, hoge suikerinname en stress.\n  * Roken\n  * Hoge alcohol- en fructoseconsumptie (alcoholische en niet-alcoholische leververvetting) \n  * Zwangerschap (zwangerschapsresistentie en zwangerschapsdiabetes) \n  * Slaaptekort (slaapgebrek) \n  * Gebruik van bepaalde medicijnen zoals corticosteroÃ¯den \n\nMaak voor jezelf even de balans op. Aan welke factoren kan je werken?",
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIS",
                                            "name": "HOMA %S",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 88.7,
                                                    "stringValue": "88.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIS_NORMAAL",
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 197.3,
                                                    "stringValue": "197.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIS_NORMAAL",
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 208.6,
                                                    "stringValue": "208.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIS_NORMAAL",
                                                    "resultText": "Je HOMA-IS-waarde is een berekende waarde.",
                                                    "keyWords": "berekende waarde",
                                                    "advice": "HOMA-IS geeft een indicatie van de insulinegevoeligheid van je lichaam. Hoe hoger deze waarde is, hoe gevoeliger je cellen zijn voor insuline en dus hoe beter jouw lichaam suikers verwerkt. Lagere waarden worden geassocieerd met verminderde insulinegevoeligheid, wat kan wijzen op insulineresistentie. Idealiter heb je een HOMA-IS die 100 is (of hoger). Over het algemeen wordt een hogere HOMA-IS-waarde geassocieerd met een betere bÃ¨tacelfunctie. Of omgekeerd: als de insulinegevoeligheid is gedaald, zullen de bÃ¨tacellen meer actief moeten zijn om een normale nuchtere bloedsuikerspiegel te kunnen blijven behouden.",
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB",
                                            "name": "HOMA %B",
                                            "unit": "10^6/Âµl",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 103.5,
                                                    "stringValue": "103.5",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB_NORMAAL",
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 63.2,
                                                    "stringValue": "63.2",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB_NORMAAL",
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 74,
                                                    "intValue": 74,
                                                    "stringValue": "74",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB_NORMAAL",
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 22,
                                                    "intValue": 22,
                                                    "stringValue": "22",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB_NORMAAL",
                                                    "resultText": "Je HOMA-IB-waarde is een berekende waarde.",
                                                    "keyWords": "berekende waarde",
                                                    "advice": "HOMA-IB geeft een indicatie van de bÃ¨tacelactiviteit van je pancreas. De bÃ¨tacellen van je pancreas zijn de cellen die insuline aanmaken. Als je HOMA-IB-waarde verhoogd is, wijst dit op het feit dat jouw pancreas âoverurenâ aan het draaien is om een normale suikerstofwisseling te kunnen blijven behouden en dat je lichaam het lastig heeft om suiker te verwerken. Idealiter is de HOMA-IB-waarde rond de 100. Waarden boven de 100 tonen aan dat jouw pancreas het lastig heeft met de suikerstofwisseling.",
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_DIABETES_BUIKOMTREK",
                                    "name": "Buikomtrek",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK",
                                            "name": "Buikomtrek",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116168810
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709124272513
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_MAN_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709223914112
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht te hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_BUIKOMTREK_VROUW_NEUTRAL",
                                                    "resultText": "Uit jouw antwoorden blijkt dat je buikomtrek licht verhoogd is. Als vrouw is dat tussen de 80 en 88 centimeter.",
                                                    "keyWords": "licht te hoog",
                                                    "advice": "Wat sommige coaches en influencers ook mogen beweren: er bestaat helaas geen miraculeus crashdieet om snel die buik kwijt te raken. Toch helpen alle beetjes. Als je erin slaagt om 5 Ã  10% van je gewicht te verliezen, dan heeft dat een heilzaam effect op je buikvet. Met de nodige deskundige hulp lukt het zelfs om bij veel overgewicht de gezonde balans terug te vinden.\n\nIn een ideaal scenario vind je een gezond voedingspatroon dat je je eigen maakt om ook op lange termijn een gezond gewicht Ã©n je buikomtrek te behouden. Het klassieke jojo-effect dat ervoor zorgt dat je continu afvalt en vervolgens weer bijkomt, is namelijk erg slecht voor je gezondheid. Bij deze nog wat inspiratie:\n\n* Ga fietsen, zwemmen, wandelen, dansen, trappen lopen: maak zelf een keuze waar je je goed en gemotiveerd bij voelt.\n* Probeer elke dag twintig minuten intensief - zodat je bijna buiten adem bent - te bewegen.\n* Lukt het niet om elke dag te bewegen? Probeer dan minstens vier keer per week beweging (maar dan wel 30 Ã  45 minuten) in te plannen.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1719837987002
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "25.0",
                                            "score": 25,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "9.9",
                                    "score": 9.86111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.0",
                                    "score": 5,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 36.23165259715568,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.083333333333333,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 25.579095703990014,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "7.1",
                                    "score": 7.083333333333333,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 25.59053025727745,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.5",
                                    "score": 3.4722222222222223,
                                    "maxScore": 10,
                                    "goalScore": 9.722222222222221,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 43.432580424366876,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.611111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 43.44079397672827,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.611111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 43.4435318275154,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.611111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 43.44900752908967,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.611111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 43.48733744010951,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.611111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 43.49828884325804,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.611111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 43.709103353867214,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.611111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 43.74469541409994,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "BAD",
                                    "stringValue": "3.6",
                                    "score": 3.611111111111111,
                                    "maxScore": 10,
                                    "goalScore": 9.86111111111111,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 43.747433264887064,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_HEALTH_ORALHEALTH",
                            "name": "Mondgezondheid",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_HEALTH_ORALHEALTH_BRUSHING",
                                    "name": "Poetsgedrag",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYBRUSHING",
                                            "name": "Frequentie van tandenpoetsen",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "heel goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYBRUSHING_VERYGOOD",
                                                    "resultText": "Je poetst je tanden twee keer of meer per dag.",
                                                    "keyWords": "heel goed",
                                                    "advice": "Je bent goed bezig, blijf je tanden twee keer per dag poetsen. Maar let op: poets je tanden niet vaker dan drie keer per dag. Wanneer je je tanden te vaak poetst, kan je het tandglazuur of je tandvlees beschadigen.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_DURATIONBRUSHING",
                                            "name": "Duur tandenpoetsen",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "tussen 1 en 2 minuten",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_DURATIONBRUSHING_NEUTRAL",
                                                    "resultText": "Je poetst jouw tanden niet lang genoeg.",
                                                    "keyWords": "tussen 1 en 2 minuten",
                                                    "advice": "Poets je tanden twee minuten. Doe dit twee keer per dag. Fluoride heeft minstens twee minuten nodig om goed op je gebit te kunnen inwerken. Door twee minuten te poetsen verhoog je dus ook de effectiviteit van fluoride. Het resultaat is dat je gebit sterker en gezonder wordt.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FLUORIDETOOTHPASTE",
                                            "name": "Tandpasta met fluoride",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "fluoride",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FLUORIDETOOTHPASTE_VERYGOOD",
                                                    "resultText": "Je gebruikt (voornamelijk) tandpaste met fluoride. De fluoride zorgt ervoor dat tandbederf voorkomen wordt en dat het tandglazuur minder snel oplosbaar is.",
                                                    "keyWords": "fluoride",
                                                    "advice": "Dat is de beste keuze! De ideale hoeveelheid fluoride in tandpasta voor een volwassene is 1450 ppm. Dat gehalte kan je aflezen op de verpakkking van je tandpasta.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_TYPETOOTHBRUSH",
                                            "name": "Soort tandenborstel",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "manueel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_TYPETOOTHBRUSH_NEUTRAL",
                                                    "resultText": "Je poetst hoofdzakelijk manueel. ",
                                                    "keyWords": "manueel",
                                                    "advice": "Het is beter om elektrisch te poetsen. Elektrisch tandenpoetsen haalt iets meer tandplaque weg en vermindert je risico op tandvleesontsteking in vergelijking met manueel poetsen.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_REPLACEMENTTOOTHBRUSH",
                                            "name": "Vervangen tandenborstel",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "bij slijtage",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_REPLACEMENTTOOTHBRUSH_BAD2",
                                                    "resultText": "Jij vervangt je tandenborstel(kop - indien elektrisch) pas als hij versleten is.",
                                                    "keyWords": "bij slijtage",
                                                    "advice": "Vervang je tandborstel(kop - indien elektrisch) iedere drie maanden. Doe dit vroeger als de borstelharen eerder versleten zijn, want naarmate de borstelharen verslijten, neemt het reinigend vermogen van de tandenborstel af en wordt tandplak minder effectief verwijderd. ",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYMOUTHWASH",
                                            "name": "Mondspoeling",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zelden",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYMOUTHWASH_BAD",
                                                    "resultText": "Je gebruikt zelden mondspoelmiddel. Mondwater doodt de slechte bacteriÃ«n in je mond die na het poetsen blijven zitten.",
                                                    "keyWords": "zelden",
                                                    "advice": "Gebruik een mondspoelmiddel na iedere poetsbeurt. Ga langs bij je apotheker en vraag advies naar een voor jou geschikt mondspoelmiddel. Let er ook op dat een mondspoelmiddel een aanvulling is op het tandenpoetsen en niet als vervanging ervan dient.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYFLOSSING",
                                            "name": "Flossen",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zelden",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYFLOSSING_BAD",
                                                    "resultText": "Je flost zelden. Het flossen van je tanden is niet alleen belangrijk om etensresten weg te halen, maar ook om tandplak en ander vuil te verwijderen en de opbouw hiervan tegen te gaan.  Het is belangrijk een juiste techniek te hanteren om tandplak te verwijderen en tegelijkertijd de conditie van je tandvlees op peil te houden.",
                                                    "keyWords": "zelden",
                                                    "advice": "Flos je tanden na iedere poetsbeurt. Gebruik hiervoor de correcte techniek: laat de flosdraad in een zigzagbeweging tussen je tanden glijden. Wanneer de flosdraad je tandvlees bereikt, druk je de draad in een C-vorm tegen de tand en schraap je voorzichtig de tandplak weg van het tandvlees. Herhaal het proces voor iedere tand.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYTONGUECLEANING",
                                            "name": "Tongreiniging",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "1 tot 2 keer per week",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYTONGUECLEANING_NEUTRAL",
                                                    "resultText": "Je reinigt jouw tong Ã©Ã©n Ã  twee keer per week. Het reinigen van je tong zorgt voor een frissere adem, betere smaakbeleving, minder gaatjes en tandplak, sterker tandvlees, schonere amandelen en een verzorgde look als je lacht.",
                                                    "keyWords": "1 tot 2 keer per week",
                                                    "advice": "Reinig je tong dagelijks met een tongreiniger. Een tandenborstel kan namelijk je tong beschadigen.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYDENTIST",
                                            "name": "Jaarlijks tandartsbezoek",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "minstens jaarlijks",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_FREQUENCYDENTIST_VERYGOOD",
                                                    "resultText": "Je gaat minstens Ã©Ã©n keer per jaar naar de tandarts op controle.",
                                                    "keyWords": "minstens jaarlijks",
                                                    "advice": "Blijf jaarlijks op controle gaan bij de tandarts. Door geregeld naar de tandarts te gaan blijft je gebit netjes onderhouden en kunnen problemen voorkomen worden.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_TABAK",
                                            "name": "Tabaksgebruik",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_TABAK_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116232664
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_MIDDELEN_TABAK_ZEERGOED",
                                                    "resultText": "Niet roken is heel goed voor je gezondheid! Doe zo verder.  ",
                                                    "keyWords": "niet-roker",
                                                    "advice": "Het niet gebruiken van een damper of tabaksproduct is heel goed voor je gezondheid. Goeie keuze! Doe dus zeker zo verder.  ",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125534944
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 27.556468172484603,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 27.560574948665298,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 27.572895277207394,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 27.65092402464066,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 27.66324435318275,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 27.667351129363453,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 27.675564681724847,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 27.733059548254623,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 27.749486652977414,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 28.065708418891173,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 28.119096509240247,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "600.0",
                                            "score": 600,
                                            "maxScore": 900,
                                            "goalScore": 900,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 28.123203285420942,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_ORALHEALTH_VALUES",
                                    "name": "Belang mondgezondheid",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_VALUES",
                                            "name": "Waarden voor mondgezondheid",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_VALUES_NEUTRAL",
                                                    "resultText": "Jij hecht matig belang aan of investeert matig in het verbeteren of behouden van jouw mondgezondheid. Mondgezondheid heeft een grote invloed op je kwaliteit van leven. Een slechte mondhygiÃ«ne kan resulteren in pijn, een verminderde kauw- en spreekfunctie, een slechtruikende adem en esthetische klachten. Niet alleen fysiek, maar ook mentaal speelt mondgezondheid een rol.",
                                                    "keyWords": "matig",
                                                    "advice": "Jij kan nog wel een tandje bijsteken wat betreft het verbeteren of behouden van jouw mondgezondheid. Het is belangrijk om voor de volgende handelingen aandacht te hebben in functie van een goede mondhygiÃ«ne:\n- Flos steeds na het poetsen en sla geen dag over, ook als je eens geen zin of weinig tijd hebt. Heb steeds flosdraad bij de hand voor wanneer je het nodig hebt.\n- Ga jaarlijks minstens Ã©Ã©n keer langs bij je tandarts ter controle van je gebit. Ga bij tandpijn of pijn aan je tandvlees meteen naar je tandarts en wacht niet tot dit vanzelf over gaat.\n- Investeer in preventieve mondgezondheid door je tanden correct te poetsen, door een mondspoelmiddel te gebruiken en door je tanden te flossen. Op die manier spaar je jezelf - soms zeer hoge - kosten uit aan behandelingen die mogelijks nodig zijn in de toekomst als je je gebit niet goed verzorgt.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128022507
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_ORALHEALTH_CARIES",
                                    "name": "Gaatjes",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_FLUORIDE",
                                            "name": "Gebruik fluoride",
                                            "values": [],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_WHENSUGAR",
                                            "name": "Gebruik van suiker tussen de maaltijden",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "nooit tussendoor",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_WHENSUGAR_GOOD",
                                                    "resultText": "Jij eet nooit suiker- of zetmeelrijk voedsel en/of drinkt nooit gezoete dranken, ofwel doe je dit tijdens de maaltijd.",
                                                    "keyWords": "nooit tussendoor",
                                                    "advice": "Blijf suiker- of zetmeelrijk voedsel en gezoete dranken tussendoor vermijden, want snacken gedurende de dag zorgt ervoor dat je mond zich meestal in een zure omgeving bevindt. Hoewel ons speeksel de effecten van het zuur helpt neutraliseren zodra we klaar zijn met eten, kan te vaak tussendoortjes je tanden overweldigen, waardoor de kans groter wordt dat je tandbederf en gaatjes krijgt.",
                                                    "time": 1709128536949
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_DRYMOUTH",
                                            "name": "Droge mond",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "soms",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_DRYMOUTH_NEUTRAL",
                                                    "resultText": "Je geeft aan soms last te hebben van een extreem droge mond. Een droge mond kan onder andere leiden tot een verminderde of zelfs vieze smaak. Daarnaast kan het problemen opleveren met kauwen, slikken, spreken en slapen. Bovendien is de kans op tandbederf, tandslijtage en slijmvliesontstekingen vergroot.",
                                                    "keyWords": "soms",
                                                    "advice": "Weet dat verschillende factoren aan de basis kunnen liggen van een droge mond, waardoor de behandeling heel uiteenlopend kan zijn: drink kleine hoeveelheden water tijdens de dag, vermijd cafeÃ¯nehoudende dranken, vermijd mondspoelingen die alcohol bevatten ... Raadpleeg jouw huisarts voor gespecialiseerd advies.",
                                                    "time": 1709128536949
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_DENTURESORBRACES",
                                            "name": "Kunstgebit of beugel",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "aanwezig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_DENTURESORBRACES_NEUTRAL",
                                                    "resultText": "Jij draagt een uitneembaar kunstgebit of een beugel, waardoor jij vatbaarder bent voor gaatjes. Als je een beugel hebt is het een stuk lastiger om je tanden goed te poetsen en aan een beugel blijft veel meer viezigheid vastzitten. Daarom ontstaan gaatjes en ontstoken tandvlees veel sneller wanneer je een beugel hebt. Als je een kunstgebit hebt, dan kunnen gemakkelijk voedselresten op en onder je kunstgebit maar ook op de wortels en het slijmvlies waarop je gebit rust, gemakkelijk voedselresten en tandplak achterblijven. Als je die voedselresten en dat tandplak niet verwijdert, ontstaan gaatjes in de wortels en gaat het tandvlees rondom je wortels ontsteken.",
                                                    "keyWords": "aanwezig",
                                                    "advice": "Een goede mondhygiÃ«ne moet extra benadrukt worden, zoals het gebruik van fluoridetandpasta en minstens twee keer twee minuten per dag jouw tanden poetsen.",
                                                    "time": 1709128536949
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_SALIVAREDUCINGMEDICATION",
                                            "name": "Medicatie voor speekselproductie",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_SALIVAREDUCINGMEDICATION_GOOD",
                                                    "resultText": "Je neemt geen medicijnen die de speekselproductie verminderen.",
                                                    "keyWords": "geen",
                                                    "advice": "Het is goed dat je geen medicatie die de speekselproductie vermindert, dient te nemen, want een aanhoudend verminderde speekselproductie kan de kans op een schimmelinfectie in de mondholte vergroten, evenals de kans op een bacteriÃ«le speekselklierontsteking, het ontstaan van gaatjes en de kans op luchtweginfecties. Door een droge mond kunnen ook spraakproblemen ontstaan.",
                                                    "time": 1709128536949
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_LAST3YEARS",
                                            "name": "Gaatjes laatste 3 jaar",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "een of twee",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_LAST3YEARS_NEUTRAL",
                                                    "resultText": "Je hebt in de afgelopen drie jaar Ã©Ã©n of twee nieuwe gaatjes gekregen. Dat kan beter!",
                                                    "keyWords": "een of twee",
                                                    "advice": "De aanwezigheid van gaatjes in het verleden zijn namelijk een goede voorspeller van nieuwe gaatjes. Dit duidt nogmaals het belang van een goede mondhygiÃ«ne aan. Raadpleeg indien nodig jouw tandarts voor een algemeen klinisch oordeel. ",
                                                    "time": 1709128536949
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_TOOTHEXTRACTION",
                                            "name": "Tanden getrokken",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "1 of meerdere",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_TOOTHEXTRACTION_BAD",
                                                    "resultText": "Je hebt in de afgelopen drie jaar een of meerdere tanden moeten laten trekken vanwege tandbederf, abscessen of gaatjes. ",
                                                    "keyWords": "1 of meerdere",
                                                    "advice": "Vermijd zaken die de kans op gaatjes vergroten zoals roken, suikerrijke voeding, medicatie die de speekselproductie verminderen ... Raadpleeg indien nodig jouw tandarts voor gepersonaliseerd advies en persoonlijke ondersteuning.",
                                                    "time": 1709128536949
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_TOTAL",
                                            "name": "Risico op gaatjes",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_CARIES_TOTAL_BAD",
                                                    "resultText": "Op basis van jouw antwoorden zien we dat jouw vatbaarheid voor gaatjes hoog is. Dat moet beter!",
                                                    "keyWords": "hoog",
                                                    "advice": "Zorg voor een goede mondhygiÃ«ne om gaatjes te voorkomen. Poets dagelijks twee keer je tanden en gebruik hiervoor een fluoridetandpasta. Gebruik een mondspoelmiddel zonder alcohol. Flos je tanden na iedere poetsbeurt. Eet geen suiker- of zetmeelrijk voedsel en/of drink geen gezoete dranken, behalve tijdens een maaltijd. Raadpleeg jouw tandarts voor advies en ondersteuning. ",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128536949
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "BAD",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_ORALHEALTH_SENSITIVE",
                                    "name": "Gevoelige tanden en tandvlees",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_SENSITIVETEETH",
                                            "name": "Gevoelige tanden",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht gevoelige tanden",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_SENSITIVETEETH_DENTINHYPERSENSITIVITY_NEUTRAL",
                                                    "resultText": "Je hebt in beperkte mate last van gevoelige tanden. ",
                                                    "keyWords": "licht gevoelige tanden",
                                                    "advice": "Je kan enkele zaken aanpassen in je mondverzorgingsgedrag om je symptomen van gevoelige tanden te verminderen: \n- Gebruik tandpasta voor gevoelige tanden.\n- Gebruik een zachte tandenborstel.\n- Verzorg je gebit door minstens twee keer per dag je tanden te poetsen en minstens Ã©Ã©n keer per dag te flossen.\n- Ga regelmatig naar de tandarts om je mondgezondheid te laten controleren.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128536949
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_SIGNSOFPERIODONTALDISEASE",
                                            "name": "Symptomen van ontstoken tandvlees",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "heel veel symptomen",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_ORALHEALTH_SIGNSOFPERIODONTALDISEASE_VERYBAD",
                                                    "resultText": "Je hebt heel veel symptomen van ontstoken tandvlees. ",
                                                    "keyWords": "heel veel symptomen",
                                                    "advice": "Een goede mondgezondheid is van essentieel belang, want een slechte mondgezondheid vergroot de kans op bepaalde aandoeningen. Denk hierbij aan longontsteking, hart- en vaatziekten en aderverkalking. Ook je tandvlees maakt onderdeel uit van je mondgezondheid. Maak een afspraak bij je tandarts om je gebit te laten controlen. Vergeet daarnaast niet dat het belangrijk is om jaarlijks langs te gaan bij je tandarts om je mondgezondheid te laten controlen.",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128536949
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "NOT_AVAILABLE",
                                    "stringValue": "0.0",
                                    "score": 0,
                                    "maxScore": 10,
                                    "goalScore": 0,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 34.117532023076166,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 34.122616603109414,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 34.13787034320915,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 34.23447736384081,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 34.24973110394054,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 34.25481568397379,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 34.26498484404028,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 34.33616896450572,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 34.356507284638695,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 34.748019947198586,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 34.81411948763078,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.4",
                                    "score": 5.384615384615385,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 34.81920406766402,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_HEALTH_SKIN",
                            "name": "Huid",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_HEALTH_SKIN_YOURSKIN",
                                    "name": "Jouw huid",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_SKINTYPE",
                                            "name": "Huidtype",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "huidtype 3",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_SKINTYPE_TYPE3",
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "huidtype 3",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_SKINTYPE_TYPE3",
                                                    "resultText": "Jij hebt huidtype 3",
                                                    "keyWords": "huidtype 3",
                                                    "advice": "Gebruik altijd een zonneproduct met factor 15 of hoger en draag beschermende kledij, want je bent vatbaar voor huidbeschadiging en huidkanker. Zoek de schaduw op, zeker wanneer de zonkracht het sterkst is (tussen 11 uur en 15 uur). Ga een keer per jaar op controle bij een arts voor je vlekken.",
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_OILINESS",
                                            "name": "Vettigheid van de huid",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "enigszins droge huid",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_OILINESS_SLIGHTLYDRY",
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "enigszins droge huid",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_OILINESS_SLIGHTLYDRY",
                                                    "resultText": "Je hebt een ietwat droge huid.",
                                                    "keyWords": "enigszins droge huid",
                                                    "advice": "Ga niet te vaak en te lang onder de douche of in bad en gebruik hierbij lauw of warm water. Gebruik weinig zeep, want dat droogt de huid uit. Smeer je huid regelmatig in met een vette zalf of crÃ¨me.",
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_SENSITIVITY",
                                            "name": "Gevoeligheid van de huid",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "zeer gevoelige huid",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_SENSITIVITY_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "zeer gevoelige huid",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_SENSITIVITY_VERYBAD",
                                                    "resultText": "Je hebt een zeer gevoelige huid.",
                                                    "keyWords": "zeer gevoelige huid",
                                                    "advice": "Reinig je huid twee keer per dag met een gezichtsreiniger speciaal voor de gevoelige huid. Hydrateer en kalmeer je huid met een serum. Voor je gevoelige huid is het belangrijk dat het serum geen ingrediÃ«nten bevat die irritatie kunnen veroorzaken. Naast een serum kan je ook een oogcrÃ¨me gebruiken om de dunne huid rondom je ogen mee te herstellen. Verzorg je huid met een dagcrÃ¨me die speciaal ontwikkeld is voor de gevoelige huid. Verzorgingsproducten met het ingrediÃ«nt niacinamide kunnen helpen om je huid te kalmeren.",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_LIPS",
                                            "name": "Lippen",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "droge lippen",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_LIPS_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "droge lippen",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_LIPS_NEUTRAL",
                                                    "resultText": "Je hebt vaak last van droge en gesprongen lippen.",
                                                    "keyWords": "droge lippen",
                                                    "advice": "Eet elke dag gezond en gevarieerd om droge, gesprongen lippen te voorkomen. \nGebruik dagelijks een neutrale lippenbalsem zonder kleurtje, geurtje of smaakje en met uv-factor als het zonnig is. Kies een onschadelijke lippenbalsem, want een deel hiervan slik je ongewild in. Let hierbij op voor de volgende stoffen: allergenen (namelijk geurstoffen zoals Limonene, Linalool en Butylphenyl methylpropional (BMHCA)), mogelijke kankerverwekkende stoffen (namelijk koolwaterstoffen zoals MOSH en MOAH) en mogelijke hormoonverstorende stoffen (zoals conserveermiddelen).",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 43.369609856262834,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 43.37234770704997,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 43.380561259411365,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 43.432580424366876,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 43.44079397672827,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 43.4435318275154,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 43.44900752908967,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 43.48733744010951,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 43.49828884325804,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 43.709103353867214,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 43.74469541409994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 200,
                                            "goalScore": 200,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 43.747433264887064,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_SKIN_LIFESTYLE",
                                    "name": "Huid en levensstijl",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN",
                                            "name": "Rookgedrag",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116168810
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709124272513
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709223914112
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "resultText": "Je hebt aangegeven dat je op dit moment een niet-roker bent.",
                                                    "keyWords": "niet-roker",
                                                    "advice": "Niet roken is heel goed voor je gezondheid! Doe zo verder.  ",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1719837987002
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_SCREENTIME",
                                            "name": "Schermtijd",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_SCREENTIME_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "veel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_SCREENTIME_BAD",
                                                    "resultText": "Je wordt dagelijks gemiddeld tussen vijf en acht uren blootgesteld aan een scherm.",
                                                    "keyWords": "veel",
                                                    "advice": "Je brengt veel tijd door achter een scherm. Bescherm je huid door ze te verzorgen met producten die antioxidanten en Omega 3-vetzuren bevatten om de schade van vrije radicalen te beperken. Zoek naar huidverzorgingsproducten verrijkt met vitamine A, B3, B5, C of E. Deze bevatten hoge concrentraties antioxidanten. Kijk voor een omega-rijke crÃ¨me of een omega-rijk serum. Het is ook belangrijk om voldoende antioxidanten (bijvoorbeeld in blauwe bessen, frambozen en granaatappel) en Omega 3-vetzuren (bijvoorbeeld in vette vis) uit je voeding te halen. Probeer daarnaast je schermtijd te verminderen.",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_FREESUGAR",
                                            "name": "Vrije suikers",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_FREESUGAR_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_FREESUGAR_BAD",
                                                    "resultText": "Je inname van vrije suikers is hoog.",
                                                    "keyWords": "hoog",
                                                    "advice": "Je kan best je suikerinname verminderen. Heb aandacht voor voedingsmiddelen met veel vrije suikers en vervang ze door gezonde alternatieven. Vermijd frisdranken en vruchtensappen en kies voor water met eventueel wat fruit toegevoegd. Laat koeken, snoep en gebak aan de kant liggen en ga voor een handje noten en een stuk fruit. ",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_WASH",
                                            "name": "Gezichtsreiniging",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "heel goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_WASH_GOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_WASH_NEUTRAL",
                                                    "resultText": "Je wast jouw gezicht Ã©Ã©n keer per dag; dat is weinig.",
                                                    "keyWords": "weinig",
                                                    "advice": "Reinig je gezicht liefst twee keer per dag met lauw water en een reinigingsproduct dat past bij je huid.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_PROTECTION",
                                            "name": "Huidbescherming",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_PROTECTION_NOWORK_11AMTO3PM_SUNSCREEN15_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_PROTECTION_WORK_NOTOUTSIDE_SUNSCREEN15_GOOD",
                                                    "resultText": "Je beschermt jouw huid goed tegen de zon.",
                                                    "keyWords": "goed",
                                                    "advice": "Je draagt soms zonnecrÃ¨me met minstens factor 15 als je naar buiten gaat. Dat is al goed, maar kan beter! Het is namelijk aanbevolen om je huid altijd in te smeren als je naar buiten gaat voor een optimale bescherming tegen uv-straling. \nJe geeft ook aan dat je voornamelijk binnen werkt, waardoor je niet rechtstreeks blootgesteld wordt aan de zon tijdens de piekuren. Weet wel dat meer dan 50% van de uv-A-straling zich niet laat tegenhouden door glas. Als je binnen in de buurt van een raam werkt, vergeet dan ook niet om je huid in te smeren. \nGa naar je apotheek om een kwalitatief zonnebeschermingsproduct te kopen dat past bij jouw huidtype en beschermt tegen zowel uv-A- als uv-B-stralen.",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_TANNINGBED",
                                            "name": "Zonnebank",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "niet goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_TANNINGBED_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_TANNINGBED_VERYGOOD",
                                                    "resultText": "Je hebt nog nooit een zonnebank gebruikt.",
                                                    "keyWords": "goed",
                                                    "advice": "Blijf de zonnebank vermijden.",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_DERMATOLOGIST",
                                            "name": "Dermatoloog",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "heel goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_DERMATOLOGIST_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709130808804
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "niet goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESIS_SKIN_DERMATOLOGIST_BAD",
                                                    "resultText": "Je bezoekt de dermatoloog niet jaarlijks.",
                                                    "keyWords": "niet goed",
                                                    "advice": "Dat is niet goed! Een jaarlijks huidonderzoek door een dermatoloog zou prioritair moeten zijn. Je huid kan in 12 maanden tijd veel veranderen. Daarnaast zou je de dermatoloog vaker moeten bezoeken indien je last hebt van huiduitslag, verdachte gezwellen of acne.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709465469016
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "450.0",
                                            "score": 450,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 28.577078104798844,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "450.0",
                                            "score": 450,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 28.581336983801048,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 30.27612030438459,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 30.361798929017198,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 30.375327132906552,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 30.379836534203008,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 30.38885533679591,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 30.451986954946253,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 30.470024560132064,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 30.817248459958936,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 30.87587067681282,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "425.0",
                                            "score": 425,
                                            "maxScore": 700,
                                            "goalScore": 700,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 30.880380078109273,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_SKIN_NUTRITION",
                                    "name": "Huid en voeding",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK",
                                            "name": "Zink",
                                            "unit": "pg",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 76.7,
                                                    "stringValue": "76.7",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 71.7,
                                                    "stringValue": "71.7",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 25,
                                                    "intValue": 25,
                                                    "stringValue": "25",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 46,
                                                    "intValue": 46,
                                                    "stringValue": "46",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "resultText": "Je zinkwaarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "De belangrijkste leverancier van het mineraal zink zijn dierlijke producten zoals vlees, zuivel en vis. Ook verschillende noten bevatten zink. Toch vind je zink vooral in schaal- en schelpdieren zoals oesters, garnalen en mosselen. In brood, peulvruchten en rijst zal je het dan weer een pak minder vinden. Probeer steeds te mikken op 90 Âµg/dL.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_MATIG",
                                                    "resultText": "Op basis van je DNA-analyse merken we dat je een verhoogde gevoeligheid hebt voor een tekort aan transferrine en ijzerwaarden in jouw bloedplasma. ",
                                                    "keyWords": "licht verhoogde nood",
                                                    "advice": "Een tekort aan ijzer kan ertoe leiden dat je sneller vermoeid en buiten adem bent, last hebt van een bleke huid en rusteloze benen die je steeds het gevoel geven dat je ze moet bewegen. Als je wil voorkomen dat jouw lichaam met een ijzertekort kampt, raden wij jou aan om met de volgende zaken rekening te houden.\n\n- Eet genoeg vlees(vervangers) die voldoende ijzer bevatten.\n- Kies vooral voor volkorenbrood, volkorenpasta en peulvruchten.\n- Neem bij iedere maaltijd groenten en/of fruitsoorten die rijk zijn aan vitamine C.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER",
                                            "name": "Ijzer",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 107,
                                                    "intValue": 107,
                                                    "stringValue": "107",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 123,
                                                    "intValue": 123,
                                                    "stringValue": "123",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 100,
                                                    "intValue": 100,
                                                    "stringValue": "100",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "resultText": "Je ijzerwaarde is normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Idealiter bedragen je ijzerwaarden tussen de 70 en 125Î¼g/dl. Door gezond en gevarieerd te eten krijg je dat normaal binnen. VegetariÃ«rs krijgen over het algemeen alleen non-heemijzer binnen, waardoor de opname door het lichaam wat lager is. Wie geen vlees eet, heeft soms lagere ijzervoorraden dan anderen, maar dat niveau is nog steeds voldoende.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_HOOG",
                                                    "resultText": "Uit je DNA-analyse kunnen we opmaken dat jouw lichaam een sterk verhoogde nood aan foliumzuur heeft.",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Probeer net iets meer te variÃ«ren in jouw voedingspatroon zodat je wat extra foliumzuur opneemt. Foliumzuur komt van nature vooral voor in groene groenten, volkorenproducten, brood, vlees en zuivel. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR",
                                            "name": "Foliumzuur",
                                            "unit": "Âµg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 22.21,
                                                    "stringValue": "22.21",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 7.86,
                                                    "stringValue": "7.86",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 9.43,
                                                    "stringValue": "9.43",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 90,
                                                    "intValue": 90,
                                                    "stringValue": "90",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_LAAG",
                                                    "resultText": "Je foliumzuurwaarden zijn licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Foliumzuur komt van nature voor in verschillende groenten. Vooral de groene soorten zoals spinazie, boerenkool, rucola, broccoli en sla zijn rijke bronnen van foliumzuur. Ook in fruit en volkorenproducten vind je deze vitamine. In vlees en melkproducten zit ook foliumzuur, maar in mindere mate dan in de groente en fruit. Een tekort aan foliumzuur kan je behandelen door het innemen van supplementen met extra foliumzuur. Na verloop van tijd kom je zo terug aan het gewenste niveau.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_HOOG",
                                                    "resultText": "Op basis van de resultaten van je DNA-analyse blijkt dat jouw lichaam een sterk verhoogde nood aan vitamine B12 heeft.",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Probeer in jouw voedingspatroon wat meer te variÃ«ren, zodat jouw lichaam over voldoende vitamine B12 beschikt. Je vindt die vitamine bijvoorbeeld in dierlijke producten zoals melk, melkproducten, vlees, vleeswaren, vis en eieren. Daarnaast kan vitamine B12 ook voorkomen in plantaardige producten, zoals zeewier en algen. Let uiteraard op mogelijke intoleranties. Met het DNA-onderzoek bepalen we zoals gezegd niet of je nu een tekort hebt aan vitamine B12. Om dat te weten te komen, moet je een bloedonderzoek laten doen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_VITB12",
                                            "name": "Vitamine B12",
                                            "unit": "ng/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 476,
                                                    "intValue": 476,
                                                    "stringValue": "476",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_VITB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 436,
                                                    "intValue": 436,
                                                    "stringValue": "436",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_VITB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 355,
                                                    "intValue": 355,
                                                    "stringValue": "355",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_VITB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 48,
                                                    "intValue": 48,
                                                    "stringValue": "48",
                                                    "tag": "RESULT_BLOOD_VOEDING_ALCOHOL_VITB12_NORMAAL",
                                                    "resultText": "Je vitamine B12-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Zelfs al zijn jouw waarden goed, het blijft belangrijk om in je voeding te variÃ«ren. Zo beschikt jouw lichaam steeds over voldoende vitamine B12. Je vindt die vitamine bijvoorbeeld in dierlijke producten zoals melk, melkproducten, vlees, vleeswaren, vis en eieren. Daarnaast kan vitamine B12 ook voorkomen in plantaardige producten, zoals zeewier en algen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD",
                                            "name": "Vitamine D",
                                            "unit": "ng/ml",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 38.6,
                                                    "stringValue": "38.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 58.7,
                                                    "stringValue": "58.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 31.8,
                                                    "stringValue": "31.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "resultText": "Je vitamine D-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Optimale waarden van 25-OH Vit D3 zijn tussen de 20ng/ml en 50 ng/ml. Is je waarde tussen 12ng/ml en 20ng/ml? Dan dien je extra aandacht te besteden aan je vitamine D-inname. \n\nOm normale vitamine D-waarden te behouden is het belangrijk om je lichaam voldoende bloot te stellen aan onmiddellijk zonlicht en voeding te eten die rijk is aan vitamine D. Je vindt vitamine D onder andere in vette vissoorten (paling, makreel, zalm en haring), eidooier en aan zonlicht blootgestelde paddenstoelen. Omdat calcium belangrijk is voor de opname van vitamine D combineer je die champignons of vette vis het best met een calciumrijk voedingsmiddel. Denk bijvoorbeeld aan spinazie, Chinese kool of tofoe.\n\nWaar wij wonen, is het makkelijker gezegd dan gedaan om vitamine D binnen te krijgen via zonlicht. In de zomer is een kwartier blootstelling van armen en hoofd op de middag voldoende om je vitamine D-gehalte in de bloedspiegel op niveau te houden. Het teveel aan aangemaakte vitamine D wordt opgeslagen in vetweefsel, een reserve die ontoereikend is om ons de hele winter en lente te voorzien van voldoende van die vitamine. Uit onderzoek blijkt dat zelfs tot ongeveer 90 procent van de Belgische bevolking aan het einde van de winter een gebrek aan vitamine D heeft.\n\nVoor iedereen geldt een dagelijkse aanbevolen hoeveelheid van 10 microgram vitamine D. Alleen mensen van boven de 70 moeten 20 microgram per dag binnenkrijgen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN",
                                            "name": "Gezonde vetten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "zeer goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "zeer goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GEZONDEVETTEN_GOOD",
                                                    "resultText": "Je schenkt voldoende aandacht aan de inname van gezonde vetten in je voedingspatroon.",
                                                    "keyWords": "goed",
                                                    "advice": "Goed bezig! Onverzadigde vetten hebben bewezen gezondheidsvoordelen en worden beschouwd als de gezondste van de vetten. Blijf deze op regelmatige basis toevoegen aan je eetpatroon. Wees steeds aandachtig om voldoende te variÃ«ren.",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN",
                                            "name": "Groenten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_GROENTEN_BAD",
                                                    "resultText": "Jij eet te weinig groenten of varieert te weinig tussen verschillende soorten groenten.\n",
                                                    "keyWords": "te weinig",
                                                    "advice": "Probeer je dagelijkse porties te vergroten of vaker groenten te eten. Kies ook voor voldoende variatie, want elke groente heeft haar eigen gezondheidsvoordelen. ",
                                                    "score": 25,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT",
                                            "name": "Fruit",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYBAD",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_FRUIT_VERYGOOD",
                                                    "resultText": "Uit je antwoorden blijkt dat je voldoende fruit eet.",
                                                    "keyWords": "goed",
                                                    "advice": "Jij eet voldoende fruit. Tracht ook steeds voldoende te variÃ«ren in je fruitkeuze, want elke fruitsoort heeft haar eigen gezondheidsvoordelen. ",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse blijkt dat jij een verminderde weerbaarheid voor oxidatieve stress hebt.",
                                                    "keyWords": "zeer gevoelig",
                                                    "advice": "Iedereen ondervindt tijdens een inspanning enige mate van oxidatieve stress. Te veel oxidatieve stress kan leiden tot meer ontstekingen, spiervermoeidheid en -schade. Tijdens de inspanning heeft het lichaam meer zuurstof nodig, waardoor sporters meer vrije radicalen produceren. \n\nAls we onze oxidatieve stress willen verminderen is het belangrijk groenten en fruit rijk aan antioxidanten toe te voegen aan ons voedingspatroon. Die groenten en fruit kan je herkennen aan hun felle en diepgaande kleur, zoals het geval is bij blauwe bessen, bramen, veenbessen en frambozen. Ook mandarijnen, navelsinaasappels, pompelmoes, kiwi, abrikozen, mango, banaan en citroensap zijn ideaal! \n\nVoor groenten rijk aan antioxidanten kan je kijken naar rauwe gember, broccoli, rode sla, asperges, avocado, rode bieten, (rode) uien, groene sla, pepers, aubergine, bloemkool, wortels, tomaat en galangawortel.\n\nOok noten en peulvruchten (pistachenoten, pecannoten, walnoten, rode bonen, linzen ...) en kruiden zoals kurkuma, kaneel, oregano, tijm of chili zijn perfect om de oxidatieve stress te verminderen. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_TAS",
                                            "name": "Totale antioxidantstatus",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.56,
                                                    "stringValue": "1.56",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_TAS_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 1.81,
                                                    "stringValue": "1.81",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_TAS_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.75,
                                                    "stringValue": "1.75",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_TAS_NORMAAL",
                                                    "resultText": "Je totale antioxidantenstatus is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Wanneer je je lichaam goed wil beschermen tegen oxidatieve stress is het belangrijk dat je voldoende antioxidanten binnenkrijgt via je voeding. Tracht te streven naar een waarde tussen 1,5 en 1,77 mmol/L.\n\nAntioxidanten zitten in gangbare producten zoals verschillende groenten, fruit, noten en kruiden. Vooral felgekleurde groenten en fruit bevatten verschillende antioxidatieve vitamines en mineralen. Daarnaast bevatten ze flavonoÃ¯de antioxidanten, die zorgen voor de kleur van groenten en fruit. Dat niet alleen: ze hebben ook een heel belangrijke werking op het lichaam. Ze bieden namelijk bescherming tegen de vrije radicalen. Zo zorgen ze ervoor dat gezonde cellen en weefsels worden behouden. Daarnaast zijn flavonoÃ¯den van essentieel belang voor de stofwisseling van vitamine C. Ze versterken elkaars effect, want flavonoÃ¯den zorgen ervoor dat gezonde cellen en weefsels worden behouden.\n\nDoor middel van je levensstijl kan je ook de productie van vrije radicalen verminderen. Vrije radicalen kunnen toenemen door ongezonde voeding, stresshormonen, roken, alcohol, overmatig sporten of juist de verzuring van onvoldoende beweging.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "SLIDER",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER",
                                            "name": "Inname water",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERGOED",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "minder dan 3",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERSLECHT",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "minder dan 3",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERSLECHT",
                                                    "resultText": "Jij drinkt minder dan 3 glazen water doorheen de dag.",
                                                    "keyWords": "minder dan 3",
                                                    "advice": "Dat is te weinig. Probeer je aantal glazen per dag geleidelijk aan op te drijven. In het ideale geval zou je acht of meer glazen per dag drinken.",
                                                    "score": 0,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE",
                                            "name": "DNA",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse leiden we af dat je tijdens het sporten last kan hebben van overmatig zweten.",
                                                    "keyWords": "verhoogde nood",
                                                    "advice": "Doordat jij van nature de neiging hebt om tijdens het sporten extra te zweten, raden we je aan om dagelijks minstens 1,5 liter water te drinken. Bij matige lichaamsbeweging zoals joggen of fietsen drink je beter wat extra. Ben je van plan om intensiever en langer te sporten? Drink dan voor, tijdens Ã©n na het sporten extra water om uitdroging te voorkomen. Per uur intensief sporten raden we een liter water aan.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL",
                                            "name": "Alcoholgebruik",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "geen alcohol",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_VERYGOOD",
                                                    "score": 100,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "af en toe",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "af en toe",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "resultText": "Jij drinkt zelden alcohol.",
                                                    "keyWords": "verantwoorde manier",
                                                    "advice": "We drinken alcohol omdat we het lekker vinden en omdat we er bepaalde positieve verwachtingen van hebben. Van alcohol kan je immers ontspannen, je zelfverzekerder voelen, losser worden of je zorgen vergeten. Dat is geen probleem als het geen dwingende gewoonte wordt. Anders gezegd: drink geen alcohol omdat het moet of omdat je vindt dat het moet.",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "710.0",
                                            "score": 710,
                                            "maxScore": 850,
                                            "goalScore": 810,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 20.535211267605632,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "585.0",
                                            "score": 585,
                                            "maxScore": 850,
                                            "goalScore": 810,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 25.436739851524248,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "585.0",
                                            "score": 585,
                                            "maxScore": 850,
                                            "goalScore": 810,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 25.44053072184489,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "585.0",
                                            "score": 585,
                                            "maxScore": 850,
                                            "goalScore": 810,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 25.451903332806825,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "560.0",
                                            "score": 560,
                                            "maxScore": 850,
                                            "goalScore": 820,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 26.992568690720642,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "550.0",
                                            "score": 550,
                                            "maxScore": 850,
                                            "goalScore": 810,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 27.160276274033972,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "545.0",
                                            "score": 545,
                                            "maxScore": 850,
                                            "goalScore": 805,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 27.244302946957283,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "545.0",
                                            "score": 545,
                                            "maxScore": 850,
                                            "goalScore": 805,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 27.25239090983303,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "545.0",
                                            "score": 545,
                                            "maxScore": 850,
                                            "goalScore": 805,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 27.30900664996327,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "545.0",
                                            "score": 545,
                                            "maxScore": 850,
                                            "goalScore": 805,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 27.325182575714763,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "545.0",
                                            "score": 545,
                                            "maxScore": 850,
                                            "goalScore": 805,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 27.636569146431064,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "545.0",
                                            "score": 545,
                                            "maxScore": 850,
                                            "goalScore": 805,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 27.689140905123423,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "545.0",
                                            "score": 545,
                                            "maxScore": 850,
                                            "goalScore": 805,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 27.693184886561298,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "8.5",
                                    "score": 8.526315789473685,
                                    "maxScore": 10,
                                    "goalScore": 9.578947368421053,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 20.22222222222222,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.2",
                                    "score": 6.2,
                                    "maxScore": 10,
                                    "goalScore": 9.771428571428572,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 28.95333983099765,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.2",
                                    "score": 6.2,
                                    "maxScore": 10,
                                    "goalScore": 9.771428571428572,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 28.95765478477276,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.1",
                                    "score": 6.057142857142857,
                                    "maxScore": 10,
                                    "goalScore": 9.771428571428572,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 29.653868505675877,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.914285714285715,
                                    "maxScore": 10,
                                    "goalScore": 9.82857142857143,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 30.63419602085793,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.9",
                                    "score": 5.857142857142857,
                                    "maxScore": 10,
                                    "goalScore": 9.771428571428572,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 30.766925426954476,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.828571428571428,
                                    "maxScore": 10,
                                    "goalScore": 9.742857142857142,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 30.831917435009597,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.828571428571428,
                                    "maxScore": 10,
                                    "goalScore": 9.742857142857142,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 30.841070445974417,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.828571428571428,
                                    "maxScore": 10,
                                    "goalScore": 9.742857142857142,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 30.905141522728186,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.828571428571428,
                                    "maxScore": 10,
                                    "goalScore": 9.742857142857142,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 30.923447544657837,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.828571428571428,
                                    "maxScore": 10,
                                    "goalScore": 9.742857142857142,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 31.27583846680356,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.828571428571428,
                                    "maxScore": 10,
                                    "goalScore": 9.742857142857142,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 31.335333038074914,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "5.8",
                                    "score": 5.828571428571428,
                                    "maxScore": 10,
                                    "goalScore": 9.742857142857142,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 31.339909543557322,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        },
                        {
                            "tag": "DASHBOARD_HEALTH_IMMUNITY",
                            "name": "Immuniteit",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_HEALTH_IMMUNITY_LIFESTYLE",
                                    "name": "Immuniteit en je levensstijl",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL",
                                            "name": "Hoeveelheid slaap",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_GOOD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_BAD",
                                                    "time": 1709116315184
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_BAD",
                                                    "time": 1709125621844
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_HOEVEEL_NEUTRAL",
                                                    "resultText": "Op basis van je antwoorden slaap je niet altijd zeven tot negen uren per nacht.",
                                                    "keyWords": "matig",
                                                    "advice": "Tracht toch zo vaak mogelijk te streven naar zeven tot negen uren slaap per nacht. Hou wel in gedachten dat je slaapkwaliteit belangrijker is dan de kwantiteit.",
                                                    "time": 1721056754687
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_UITGERUST",
                                            "name": "Uitgerust wakker worden",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "nooit",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_UITGERUST_VERYBAD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_UITGERUST_NEUTRAL",
                                                    "time": 1709116315184
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_UITGERUST_NEUTRAL",
                                                    "time": 1709125621844
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zelden",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_UITGERUST_BAD",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zelden",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_UITGERUST_BAD",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zelden",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_UITGERUST_BAD",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zelden",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_UITGERUST_BAD",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zelden",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_SLAAP_UITGERUST_BAD",
                                                    "resultText": "Je geeft aan zelden uitgerust wakker te worden.",
                                                    "keyWords": "zelden",
                                                    "advice": "Om jouw energieniveau te verbeteren, zijn er een aantal levensstijlaanpassingen die je hierbij kunnen helpen: \n- Zorg ervoor dat je slaapkamer een comfortabele en rustige omgeving is, met een koele temperatuur, een goede matras en degelijke kussens.\n- Probeer elke nacht op ongeveer hetzelfde tijdstip naar bed te gaan en op te staan, zelfs in het weekend. \n- Vermijd blootstelling aan beeldschermen zoals telefoons, tablets en computers minstens een uur voordat je naar bed gaat. Het blauwe licht van deze schermen kan de productie van melatonine, het slaaphormoon, verstoren.\n- Doe voor het slapengaan ontspanningstechnieken zoals diepe ademhaling, meditatie of het lezen van een ontspannend boek om je geest tot rust te brengen en je voor te bereiden op een goede nachtrust.\n- Vermijd cafeÃ¯nehoudende dranken zoals koffie, thee en energiedrankjes en vermijd stimulerende middelen zoals nicotine en alcohol enkele uren voor het slapengaan.",
                                                    "time": 1721056754687
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL",
                                            "name": "Algemeen stressniveau",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig stressniveau",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_NEUTRAL",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "laag stressniveau",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_GOOD",
                                                    "time": 1709116286347
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig stressniveau",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_NEUTRAL",
                                                    "time": 1709125604515
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog stressniveau",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog stressniveau",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog stressniveau",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog stressniveau",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog stressniveau",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_STRESS_OVERALL_BAD",
                                                    "resultText": "Je geeft aan een hoog stressniveau te ervaren.",
                                                    "keyWords": "hoog stressniveau",
                                                    "advice": "Om je algemeen stressniveau te beheersen, is het belangrijk om de volgende tips op te volgen.\n- Doe aan sport, maar overdrijf niet. Probeer regelmatig te bewegen, al is het maar voor een kleine wandeling. Let echter wel op voor overtraining, want dit kan je stressniveau negatief beÃ¯nvloeden. Vooral rustige vormen van beweging zijn een goed idee voor jou, zoals wandelen, fietsen en yoga.\n- Doe regelmatig ontspanningstechnieken om je geest te kalmeren en stress te verminderen, zoals diepe ademhaling of meditatie.\n- Zorg voor voldoende slaap, want als je uitgerust bent, kan je beter met stressprikkels omgaan. Probeer een vaste tijdstippen aan te houden om te gaan slapen en op te staan en zorg voor een rustgevende slaapomgeving.\n- Kies voor gezond en voedzaam eten met veel groenten, fruit, volkorengranen. Vermijd comfort food en bewerkt voedsel.\n- Neem bovendien ook voldoende tijd voor jezelf. Ontspan regelmatig en doe dagelijks iets waarvan je geniet.",
                                                    "time": 1721051562556
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT",
                                            "name": "Spierversterkende activiteiten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "heel goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_VERYGOOD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_VERYBAD",
                                                    "time": 1709116273299
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                                    "time": 1709125592987
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_KRACHT_NEUTRAL",
                                                    "resultText": "Uit je antwoorden blijkt dat je te weinig tijd aan spierversterkende oefeningen spendeert. ",
                                                    "keyWords": "matig",
                                                    "advice": "Om optimale gezondheidswinst uit spierversterkende oefeningen te halen, zou je die activiteit vaker moeten uitvoeren. Start eens met het uitvoeren van krachtoefeningen gedurende twintig Ã  dertig minuten. En tracht dit op wekelijkse basis twee keer uit te voeren. Good luck. We're in this together! ",
                                                    "time": 1721051549562
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE",
                                            "name": "Cardioactiviteten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "heel goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYGOOD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_BAD",
                                                    "time": 1709116273299
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_NEUTRAL",
                                                    "time": 1709125592987
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "veel te weinig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_BEWEGING_CONDITIE_VERYBAD",
                                                    "resultText": "Er staan bij jou veel te weinig cardio-activiteiten op de planning.",
                                                    "keyWords": "veel te weinig",
                                                    "advice": "Als je je conditie op peil wilt houden, dan is Ã©Ã©n uur cardio per week aanbevolen. Dat kan onder de vorm van wandelen, fietsen, joggen ...",
                                                    "time": 1721051549562
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN",
                                            "name": "Rookgedrag",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "time": 1709116168810
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "time": 1709124272513
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "time": 1709223914112
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "niet-roker",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MEDICALME_ROKEN_NEE_GOOD",
                                                    "resultText": "Je hebt aangegeven dat je op dit moment een niet-roker bent.",
                                                    "keyWords": "niet-roker",
                                                    "advice": "Niet roken is heel goed voor je gezondheid! Doe zo verder.  ",
                                                    "time": 1719837987002
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL",
                                            "name": "Alcoholgebruik",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "geen alcohol",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_VERYGOOD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "af en toe",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_NEUTRAL",
                                                    "time": 1709116249576
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "af en toe",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_NEUTRAL",
                                                    "time": 1709125568671
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "time": 1709224494496
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "time": 1711438861261
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "time": 1711641908053
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "verantwoorde manier",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_VOEDING_ALCOHOL_GOOD",
                                                    "resultText": "Jij drinkt zelden alcohol.",
                                                    "keyWords": "verantwoorde manier",
                                                    "advice": "We drinken alcohol omdat we het lekker vinden en omdat we er bepaalde positieve verwachtingen van hebben. Van alcohol kan je immers ontspannen, je zelfverzekerder voelen, losser worden of je zorgen vergeten. Dat is geen probleem als het geen dwingende gewoonte wordt. Anders gezegd: drink geen alcohol omdat het moet of omdat je vindt dat het moet.",
                                                    "time": 1720965038490
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_LIFESTYLE",
                                            "name": "Levensstijl en immuniteit",
                                            "values": [],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_IMMUNITY_VATBAARHEID",
                                    "name": "Vatbaarheid",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_COLDANDFLU",
                                            "name": "Griep en/of verkoudheid",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "minder dan 1 keer",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_COLDANDFLU_VERYGOOD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "1 tot 2 keer",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_COLDANDFLU_GOOD",
                                                    "resultText": "Je ervaarde Ã©Ã©n tot twee keer verkoudheids- en griepsymptomen (zoals koorts, keelpijn, loopneus, hoesten en/of extreme vermoeidheid) in de voorbije twaalf maanden. Volwassenen krijgen gemiddeld twee tot vier verkoudheden per jaar. Jij zit dus onder het gemiddelde, goed!",
                                                    "keyWords": "1 tot 2 keer",
                                                    "advice": "Het blijft belangrijk preventieve maatregelen te nemen die je risico op verkoudheids- en griepsymptomen beperken. Was regelmatig je handen met water en zeep. Doe dit op de volgende momenten:\n- Als je handen vuil zijn\n- Voor het (klaarmaken van) eten en na aanraken van rauw vlees\n- Na toiletbezoek\n- Na hoesten, niezen in de handen (tip: nies of hoest in de arm)\n- Na neus snuiten\n- Na verschonen van een kind\n- Na aaien of knuffelen van (huis-)dieren\n- Na schoonmaken",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_OTHERS",
                                            "name": "Vatbaarder dan anderen",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "meer dan anderen",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_OTHERS_BAD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "meer dan anderen",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_OTHERS_BAD",
                                                    "resultText": "Je hebt het gevoel dat je meer dan anderen in jouw omgeving (zoals je familie en/of collega's) verkouden wordt of de griep krijgt.",
                                                    "keyWords": "meer dan anderen",
                                                    "advice": "Volwassen krijgen gemiddeld twee tot vier keer een verkoudheid per jaar en Ã©Ã©n op vijftien volwassen krijgt de griep. Het belangrijkste middel om griep te voorkomen is je laten inenten met het griepvaccin. Een griepvaccin is beschikbaar voor iedereen die dat wil en aan te raden voor wie zich bij de risicogroepen bevindt. Heb je vragen over dit vaccin? Ga dan langs bij je huisarts. Daarnaast kan je enkele hygiÃ«nische maatregelen treffen om griep te voorkomen:\n- Was regelmatig je handen, zeker voor en nadat je contact hebt met kinderen of met personen die griep hebben.\n- Hou een elleboog of zakdoek voor je mond en neus wanneer je hoest of niest.\n- Gebruik een zakdoek maar Ã©Ã©n keer.\n- Poets harde oppervlakken, deurklinken en keukenapparaten regelmatig met een gewoon schoonmaakmiddel.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_DAILYACTIVITIES",
                                            "name": "Beperking van dagdagelijkse activiteiten",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "3 tot 4 dagen",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_DAILYACTIVITIES_NEUTRAL",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "1 tot 2 dagen",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_DAILYACTIVITIES_GOOD",
                                                    "resultText": "Een verkoudheid of griep beperkt je gemiddeld Ã©Ã©n tot twee dagen van je dagdagelijkse activiteiten, zoals werk of sporten.",
                                                    "keyWords": "1 tot 2 dagen",
                                                    "advice": "Luister naar je lichaam. Heb je of had je recentelijk een verstopte neus of last van je keel? Dan kan je in principe zonder problemen werken en sporten. Heb je spierpijn, rillingen en/of koorts? Dan heeft je lichaam rust nodig en zou sporten je herstel kunnen vertragen.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_RECOVERY",
                                            "name": "Aanhoudende symptomen",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_RECOVERY_GOOD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "wel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_RECOVERY_BAD",
                                                    "resultText": "Jij hebt last van symptomen die aanhouden na herstel van verkoudheid en griep, zoals neusklachten, verstopte neus of postnasale drip.",
                                                    "keyWords": "wel",
                                                    "advice": "Een 'gewone' verkoudheid duurt gemiddeld een paar dagen tot een week. Als de verkoudheid niet over gaat of als je je vaak (langdurig) verkouden bent, dan is er mogelijks iets anders aan de hand. Ga langs bij je huisarts om je klachten te bespreken.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_EPISODES",
                                            "name": "Terugkerende infecties",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "niet",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_EPISODES_VERYGOOD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "1 tot 2 keer",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_EPISODES_GOOD",
                                                    "resultText": "Je hebt Ã©Ã©n tot twee keer last gehad van dezelfde infectie of van symptomen van terugkerende infecties (zoals sinusitis, bronchitis, koortsblaasjes, huidinfecties zoals stafylokokken) in de afgelopen twaalf maanden.",
                                                    "keyWords": "1 tot 2 keer",
                                                    "advice": "Het blijft belangrijk om te zorgen voor een goede weerstand door voldoende te rusten en slapen, zeker op momenten dat je ziek bent. Het beste is om niet te roken, gezond te eten en voldoende te bewegen. Daarnaast is je neusholte schoonhouden eigenlijk minstens zo belangrijk als je handen wassen. Zachte neusdruppels op basis van natuurlijke bestanddelen of neusspoelmiddelen kun je zonder probleem preventief gebruiken. Reinig ten slotte wondes goed en zorg voor een goede hygiÃ«ne.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_FATIGUE",
                                            "name": "Langdurige vermoeidheid",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aanhoudend",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_FATIGUE_BAD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "aanhoudend",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_FATIGUE_BAD",
                                                    "resultText": "Je ervaart langdurige vermoeidheid en/of je hebt moeite om je âgoed te voelenâ in de weken na een verkoudheid of griep.",
                                                    "keyWords": "aanhoudend",
                                                    "advice": "Het is belangrijk om voldoende te slapen en bewegen en gezond te eten. Zorg steeds voor een goed evenwicht tussen werken/dingen doen en tussen ontspanning/rust. Als je rookt, kan je daar best mee stoppen. Bij moeheid door pijn, ziekte of medicijnen kan je best langsgaan bij je huisarts.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SUSCEPT",
                                            "name": "Totale vatbaarheidsscore",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SUSCEPT_GOOD",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SUSCEPT_NEUTRAL",
                                                    "resultText": "Uit de antwoorden die je gaf op de vragenlijst blijkt dat jij een beetje vatbaar bent voor griep- en verkoudheidsklachten en/of hinder ondervindt van de klachten.",
                                                    "keyWords": "matig",
                                                    "advice": "Ga steeds langs bij je huisarts bij klachten. Probeer daarnaast zoveel als mogelijk preventieve maatregelen te ondernemen om je risico op het krijgen van griep- en/of verkoudheidsklachten zo laag mogelijk te houden: was regelmatig je handen, hou een zakdoek of elleboog voor je mond en neus wanneer je hoest of niest en gebruik de zakdoek slechts Ã©Ã©n keer. Zorg voor een goede hygiÃ«ne in huis en verlucht binnenruimtes regelmatig.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 36.7419575633128,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 36.747433264887064,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 36.76386036960986,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 36.86789869952088,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 36.884325804243666,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 36.889801505817935,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 36.90075290896646,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 36.97741273100616,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 36.99931553730322,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 37.42094455852156,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 37.492128678986994,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 37.497604380561256,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_IMMUNITY_VITD",
                                    "name": "Vitamine D en immuniteit",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_LEVELS",
                                            "name": "Levels vitamine D",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "niet beschikbaar",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_LEVELS_NEUTRAL",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "niet beschikbaar",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_LEVELS_NEUTRAL",
                                                    "resultText": "Jij weet niet of vitamine D-gehalte voldoende of te laag is. Vitamine D speelt een belangrijke rol voor het immuunsysteem. Vitamine D zorgt onder andere voor een gezonde darmwand en dat is belangrijk om ziektekiemen uit het lichaam te houden. Vitamine D heeft ook een ontsekingsremmende functie en vitamine D versterkt het mechanisme voor de eliminatie van ziektekiemen.",
                                                    "keyWords": "niet beschikbaar",
                                                    "advice": "Ga langs bij je huisarts om je vitamine D-gehalte te laten controleren.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SUMMER",
                                            "name": "Tijd buiten in de zomer",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SUMMER_GOOD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SUMMER_GOOD",
                                                    "resultText": "Jij komt voldoende buiten in de zomer. Je huid maakt vitamine D aan door buiten te komen en zoals eerder beschreven is vitamine D belangrijk voor je afweer.",
                                                    "keyWords": "goed",
                                                    "advice": "Blijf dagelijks minstens een halfuur buitenkomen in de zomer.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_WINTER",
                                            "name": "Tijd buiten in de winter",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_WINTER_NEUTRAL",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_WINTER_NEUTRAL",
                                                    "resultText": "Jij komt net genoeg buiten in de winter. Je huid maakt vitamine D aan door buiten te komen en zoals eerder beschreven is vitamine D belangrijk voor je afweer.",
                                                    "keyWords": "neutraal",
                                                    "advice": "Probeer dagelijks minstens een halfuur buiten te komen in de winter.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_OVERALLVITD",
                                            "name": "Nutritionele vitamine D-status",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_OVERALLVITD_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_OVERALLVITD_NEUTRAL",
                                                    "resultText": "Uit de antwoorden die je gaf op de vragenlijst blijkt dat je net voldoende buitenkomt in de zomer en in de winter en dat je geen vitamine D-tekort hebt of dat je het niet weet.",
                                                    "keyWords": "neutraal",
                                                    "advice": "Probeer dagelijks minstens een halfuur buiten te komen en ga eens langs bij je huisarts om je vitamine D-gehalte te laten controleren.",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD",
                                            "name": "Vitamine D",
                                            "unit": "ng/ml",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 38.6,
                                                    "stringValue": "38.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 58.7,
                                                    "stringValue": "58.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 31.8,
                                                    "stringValue": "31.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "resultText": "Je vitamine D-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Optimale waarden van 25-OH Vit D3 zijn tussen de 20ng/ml en 50 ng/ml. Is je waarde tussen 12ng/ml en 20ng/ml? Dan dien je extra aandacht te besteden aan je vitamine D-inname. \n\nOm normale vitamine D-waarden te behouden is het belangrijk om je lichaam voldoende bloot te stellen aan onmiddellijk zonlicht en voeding te eten die rijk is aan vitamine D. Je vindt vitamine D onder andere in vette vissoorten (paling, makreel, zalm en haring), eidooier en aan zonlicht blootgestelde paddenstoelen. Omdat calcium belangrijk is voor de opname van vitamine D combineer je die champignons of vette vis het best met een calciumrijk voedingsmiddel. Denk bijvoorbeeld aan spinazie, Chinese kool of tofoe.\n\nWaar wij wonen, is het makkelijker gezegd dan gedaan om vitamine D binnen te krijgen via zonlicht. In de zomer is een kwartier blootstelling van armen en hoofd op de middag voldoende om je vitamine D-gehalte in de bloedspiegel op niveau te houden. Het teveel aan aangemaakte vitamine D wordt opgeslagen in vetweefsel, een reserve die ontoereikend is om ons de hele winter en lente te voorzien van voldoende van die vitamine. Uit onderzoek blijkt dat zelfs tot ongeveer 90 procent van de Belgische bevolking aan het einde van de winter een gebrek aan vitamine D heeft.\n\nVoor iedereen geldt een dagelijkse aanbevolen hoeveelheid van 10 microgram vitamine D. Alleen mensen van boven de 70 moeten 20 microgram per dag binnenkrijgen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "BLOOD"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "50.0",
                                            "score": 50,
                                            "maxScore": 50,
                                            "goalScore": 50,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 27.556468172484603,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 27.560574948665298,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 27.572895277207394,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 27.65092402464066,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 27.66324435318275,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 27.667351129363453,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 27.675564681724847,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 27.733059548254623,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 27.749486652977414,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 28.065708418891173,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 28.119096509240247,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "100.0",
                                            "score": 100,
                                            "maxScore": 150,
                                            "goalScore": 150,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 28.123203285420942,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_IMMUNITY_NUTRITION",
                                    "name": "Voeding en immuniteit",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER",
                                            "name": "Inname water",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERGOED",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "minder dan 3",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERSLECHT",
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "minder dan 3",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_WATER_ZEERSLECHT",
                                                    "resultText": "Jij drinkt minder dan 3 glazen water doorheen de dag.",
                                                    "keyWords": "minder dan 3",
                                                    "advice": "Dat is te weinig. Probeer je aantal glazen per dag geleidelijk aan op te drijven. In het ideale geval zou je acht of meer glazen per dag drinken.",
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GROENTEN",
                                            "name": "Inname groenten",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GROENTEN_ZEERGOED",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GROENTEN_ZEERSLECHT",
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "te weinig variatie",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_GROENTEN_MATIG",
                                                    "resultText": "Jij eet te weinig groenten of varieert te weinig tussen verschillende soorten groenten.",
                                                    "keyWords": "te weinig variatie",
                                                    "advice": "Probeer je dagelijkse porties te vergroten of vaker groenten te eten. Kies ook voor voldoende variatie, want elke groente heeft haar eigen gezondheidsvoordelen.",
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_FRUIT",
                                            "name": "Inname fruit",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "stringValue": "te weinig",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_FRUIT_ZEERSLECHT",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "te weinig variatie",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_FRUIT_MATIG",
                                                    "time": 1709117015232
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "te weinig variatie",
                                                    "tag": "RESULT_ANAMNESE_LIFESTYLE_VOEDING_VOEDINGSKEUZE_FRUIT_MATIG",
                                                    "resultText": "Uit je antwoorden blijkt dat je te weinig fruit eet, ofwel varieer je te weinig tussen verschillende soorten fruit.",
                                                    "keyWords": "te weinig variatie",
                                                    "advice": "Probeer je dagelijkse porties fruit te vergroten of vaker fruit te eten. Ga bovendien voor genoeg variatie in je fruit. Elke soort fruit heeft haar eigen gezondheidsvoordelen. ",
                                                    "time": 1709128701843
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SUPPLEMENTS",
                                            "name": "Supplementen",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SUPPLEMENTS_GOOD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SUPPLEMENTS_GOOD",
                                                    "resultText": "Jij neemt supplementen die je immuunsysteem boosten, zoals vitamine D, zink, selenium, vitamine C of omega-3 vetzuren.",
                                                    "keyWords": "goed",
                                                    "advice": "Je mag deze supplementen nemen, maar let er steeds op dat je geen overdosis van deze supplementen in je lichaam krijgt. Ga regelmatig langs bij je huisarts om je waarden in je bloed te laten controleren.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_FIBRES",
                                            "name": "Vezels",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_FIBRES_GOOD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_FIBRES_GOOD",
                                                    "resultText": "Jij eet vaak vezels. Door vezelrijk te eten, voorzie je je darmbacteriÃ«n van de juiste brandstof en voed je de ââgoedeââ bacteriÃ«n die je microbioom in balans houden. Je microbioom zijn alle microben die in je darm leven. Je microbioom ondersteunt je immuunsysteem bij het bestrijden van een virus of andere ziekteverwekker. Een vezelrijk eetpatroon draagt dus bij aan een microbioom in balans en ondersteunt op die manier je immuunsysteem.",
                                                    "keyWords": "vaak",
                                                    "advice": "Goed bezig! Maar let op: als je te weinig drinkt, kunnen de vezels niet genoeg vocht opnemen en wordt je ontlasting harder. Het is dus belangrijk dat je ook voldoende drinkt, ongeveer twee liter water per dag. ",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_PROBIOTICA",
                                            "name": "Probiotica",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "soms",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_PROBIOTICA_NEUTRAL",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_PROBIOTICA_GOOD",
                                                    "resultText": "Jij eet vaak probiotische voeding. Ongeveer 70-80% van je weerstand zit in je darmen, dus de gezondheid van je darmflora heeft een grote impact op de gezondheid van je immuunsysteem. Een slecht functionerende darm zorgt voor een verzwakt afweersysteem en dat betekent meer kans op verkoudheden en andere kwaaltjes. Probiotica zijn gunstige bacteriÃ«n die het evenwicht van onze darmflora kunnen herstellen.",
                                                    "keyWords": "vaak",
                                                    "advice": "Het is goed dat je vaak probiotische voeding eet. Let er echter op dat je er niet te veel van inneemt, want hoewel de meeste mensen geen nadelen van probiotica ervaren, hebben sommigen een aanpassingsperiode nodig waarin er sprake kan zijn van milde bijwerkingen. Heb jij last van gasvorming, een opgeblazen gevoel en/of een trage stoelgang? Dan kan het zijn dat je bijwerkingen ervaart van de probiotica. Ga in dat geval langs bij je huisarts om dit te bespreken.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_HISTAMINE",
                                            "name": "Histaminerijke voeding",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_GOOD",
                                                    "stringValue": "heel vaak",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_HISTAMINE_VERYGOOD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "soms",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_HISTAMINE_NEUTRAL",
                                                    "resultText": "Jij eet soms histaminerijke voeding of voeding die histamine vrijmaakt in het lichaam. Histamine speelt een rol in je immuunsysteem. Histamine wordt in je lichaam aangemaakt maar zit ook in voeding. Er is een kleine hoeveelheid opgeslagen in onze mestcellen. Dat zijn cellen waarin je lichaam stoffen bewaart die indringers onschadelijk kunnen maken. Histamine beschermt je hierdoor tegen stoffen die je lichaam als \"gevaarlijk\" beschouwt, bijvoorbeeld het gif van een wesp. Je lichaam brengt dan meer histamine naar de plek waar de gevaarlijke stof zit en maakt antistoffen aan. Het is dus een noodzakelijke stof maar als je er te veel aan blootgesteld wordt of als je histamine niet goed kunt afbreken, ontstaan er problemen. \n",
                                                    "keyWords": "soms",
                                                    "advice": "Wanneer de hoeveelheid histamine die zich in je lichaam ophoopt groter is dan de hoeveelheid die je lichaam kan verwerken en afbreken, ontstaat er een overschot, een disbalans. Te veel histamine in je lichaam werkt dus averechts en veroorzaakt vervelende allergische reacties, zoals irritatie van de neus, ogen, huid, keel en longen. Let dus op voor een teveel aan histamine, want dit kan leiden tot een histamine-intolerantie. Ga langs bij je huisarts om te controleren of je een intolerantie hebt ontwikkeld voor histamine.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SHORTAGE",
                                            "name": "Tekorten",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen tekort",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SHORTAGE_GOOD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "tekort",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_SHORTAGE_BAD",
                                                    "resultText": "Er is bij jou een tekort vastgesteld aan vitamine D, zink, selenuim, vitamine C en/of omega 3-vetzuren.",
                                                    "keyWords": "tekort",
                                                    "advice": "Ga langs bij je huisarts en bespreek hoe je dit tekort kan opvangen. Breng daarnaast dagelijks minstens een half uur in de buitenlucht door. Focus tenslotte op voeding die rijk is aan zink, selenium, vitamine C en/of omega 3-vetzuren, zoals:\n- Zink kan je binnenkrijgen door het eten van onder andere oesters, pompoenzaden, bonen en noten. \n- Selenium zit vooral in vis en bepaalde noten, zoals paranoten.  \n- Citrusvruchten, kiwi's, aardbeien, bessen, koolsoorten, paprika, tomaten, broccoli en zoete en normale aardappelen bevatten veel vitamine C.\n- Vissoorten, vooral de vette zoals makreel, zalm, haring, sardines en forel, en schelp- en schaaldieren, lijnzaadolie, raapzaadolie, sojaolie, walnoten en plantaardige margarines bevatten omega 3-vetzuren.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_ORALCONTRACEPTIVE",
                                            "name": "Orale anticonceptie",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "wel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_ORALCONTRACEPTIVE_BAD",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "wel",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_ORALCONTRACEPTIVE_BAD",
                                                    "resultText": "Jij hebt een oraal anticonceptiemiddel gebruikt hebt in de afgelopen zes maanden. Antioxidanten, B-vitamines en belangrijke mineralen zoals selenium en zink raken uitgeput wanneer een vrouw een oraal anticonceptiemiddel gebruikt. Deze voedingsstoffen zijn van cruciaal belang voor de regulering van het immuunsysteem.",
                                                    "keyWords": "wel",
                                                    "advice": "Zorg ervoor dat je voldoende gezond en gevarieerd eet om mogelijke tekorten op te vangen. Hieronder staan enkele tips om tekorten te vermijden:\n- Blauwe bessen, frambozen, granaatappel, kurkuma en zwarte chocolade zijn voorbeelden van antioxidantrijke voedingsmiddelen.\n- Een tekort op B-vitamines komt niet snel voor, met uitzondering van vitamine B12; eet hiervoor dierlijke producten, zoals gevogelte, vis en eieren.\n- Selenium zit vooral in vis en bepaalde noten, zoals paranoten. \n- Zink kan je binnenkrijgen door het eten van onder andere oesters, pompoenzaden, bonen en noten.  \nHeb je het gevoel dat je met een vitamine- of mineralentekort te kampen hebt? Ga dan langs bij je huisarts.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_NUTRITION",
                                            "name": "Preventieve voeding",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_NUTRITION_NEUTRAL",
                                                    "score": 50,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "goed",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_NUTRITION_GOOD",
                                                    "resultText": "Uit de antwoorden die je gaf op de vragenlijst blijkt dat jij goede voedingsgewoontes vooropstelt die je immuunsysteem ten goede komen.",
                                                    "keyWords": "goed",
                                                    "advice": "Blijf aandacht hebben voor gezonde, gevarieerde en verse voeding met focus op water, groenten, fruit, gezonde vetbronnen zoals vis en noten, peulvruchten en probiotische voeding die je darmen ondersteunt, zoals yoghurt, kefir en miso.",
                                                    "score": 75,
                                                    "maxScore": 100,
                                                    "goalScore": 100,
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 24.494638375541868,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 24.49828884325804,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 24.509240246406574,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 24.57859913301392,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 24.589550536162445,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 24.593201003878622,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 24.600501939310973,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 24.65160848733744,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 24.666210358202147,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 24.947296372347708,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 24.994752452657995,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "GOOD",
                                            "stringValue": "75.0",
                                            "score": 75,
                                            "maxScore": 100,
                                            "goalScore": 100,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 24.998402920374172,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_HEALTH_IMMUNITY_HORMETISCH",
                                    "name": "Hormetische prikkels",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_IF",
                                            "name": "Intermittent fasting",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "nee",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_IF_NO",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "ja",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_IF_YES",
                                                    "resultText": "Je doet weleens aan intermittent fasting. Door periodes niet te eten, zoals bij intermittent fasting, zal je lichaam zich beschermen om niet om te komen van de honger. ",
                                                    "keyWords": "ja",
                                                    "advice": "Door af en toe te vasten, zal je lichaam beter worden in het verbranden van vetreserves en geen onnodige energie verspillen aan cellen die niet optimaal functioneren. Je vetmetabolisme verbetert hierdoor en je immuunsysteem ruimt slecht werkende cellen op. Let op: als je te weinig van de stressor toedient, is er geen enkel effect waarneembaar. Als je een te hoge dosis van de stressor toedient, heeft de stressor een negatief effect en kan het in sommige gevallen zelfs zeer gevaarlijk zijn. Het is persoonsafhankelijk of je deze prikkel al dan niet kan toedienen en is dus niet bruikbaar voor iedereen.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_COLDSHOWER",
                                            "name": "Koude douche en/of ijsbad",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "nee",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_COLDSHOWER_NO",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "ja",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_COLDSHOWER_YES",
                                                    "resultText": "Je neemt weleens een koude douche en/of een ijsbad. Je lichaam heeft een innerlijke thermostaat die je temperatuur heel goed in de gaten houdt. Als we te koud hebben, vernauwen onze bloedvaten waardoor de huid koeler wordt en we minder warmte afstaan aan de omgeving. Maar als onze omgevingstemperatuur altijd min of meer constant is (doordat we de verwarming lekker warm zetten in de winter en we ons kleden naar de seizoenen), hoeft onze innerlijke thermostaat niks meer te doen. Op korte termijn zal je dus lekker warm hebben, maar op lange termijn is je lichaam niet meer in staat om effeciÃ«nt warmte te produceren. Door kunstmatig grote temperatuurverschillen te creÃ«ren, zet je je innerlijke thermostaat terug aan het werk.  ",
                                                    "keyWords": "ja",
                                                    "advice": "Een kortdurende blootstelling aan koude, zoals koude douches en ijsbaden, drijft je celmetabolisme op en zorgt voor een omzetting van wit vet naar bruin vet. Wit vet dient vooral als opslagruimte voor energie. Bruin vet dient vooral als brandstof voor de productie van warmte. Let op: als je te weinig van de stressor toedient, is er geen enkel effect waarneembaar. Als je een te hoge dosis van de stressor toedient, heeft de stressor een negatief effect en kan het in sommige gevallen zelfs zeer gevaarlijk zijn. Het is persoonsafhankelijk of je deze prikkel al dan niet kan toedienen en is dus niet bruikbaar voor iedereen.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_HIIT",
                                            "name": "HIIT",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "nee",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_HIIT_NO",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "ja",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_HIIT_YES",
                                                    "resultText": "Je doet weleens HIIT. HIIT is een korte maar krachtige prikkel.",
                                                    "keyWords": "ja",
                                                    "advice": "EÃ©n keer per week tien minuten wandelen of steeds dezelfde oefening doen aan dezelfde intensiteit heeft weinig meerwaarde. Te snel te zware gewichten tillen daarentegen leidt dan weer tot blessures. Het is belangrijk een prikkel te vinden die intens genoeg is om lichte schade toe te brengen aan het lichaam, maar nog wel licht genoeg om ervan te herstellen en er sterker van te worden. Het is persoonsafhankelijk of je deze prikkel al dan niet kan toedienen en is dus niet bruikbaar voor iedereen.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_HEAT",
                                            "name": "Sauna en/of hete douche",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "nee",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_HEAT_NO",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "ja",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_HEAT_YES",
                                                    "resultText": "Je gaat weleens in de sauna en/of neemt weleens een hete douche. Je lichaam heeft een innerlijke thermostaat die je temperatuur heel goed in de gaten houdt. Als we te warm hebben, zetten onze bloedvaten uit en zweten we. Maar als onze omgevingstemperatuur altijd min of meer constant is (doordat we de airco lekker koel zetten in de zomer en we ons kleden naar de seizoenen), hoeft onze innerlijke thermostaat niks meer te doen. Op korte termijn zal je dus lekker koel hebben, maar op lange termijn is je lichaam niet meer in staat om effeciÃ«nt koelte te produceren. Door kunstmatig grote temperatuurverschillen te creÃ«ren, zet je je innerlijke thermostaat terug aan het werk.  ",
                                                    "keyWords": "ja",
                                                    "advice": "De sauna verbetert je immuunsysteem en stimuleert en stabiliseert je bloedsomloop. Je lichaam reageert namelijk heftig op de warmte van de sauna en de kou wanneer je afkoelt en maakt daardoor antistoffen aan. Af een toe een bezoek brengen aan de sauna beschermt je beter tegen verkoudheid, al vermindert het de symptomen niet. Let op: als je te weinig van de stressor toedient, is er geen enkel effect waarneembaar. Als je een te hoge dosis van de stressor toedient, heeft de stressor een negatief effect en kan het in sommige gevallen zelfs zeer gevaarlijk zijn. Het is persoonsafhankelijk of je deze prikkel al dan niet kan toedienen en is dus niet bruikbaar voor iedereen.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        },
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_BREATHINGEXERCISES",
                                            "name": "Ademhalingsoefeningen",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "nee",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_BREATHINGEXERCISES_NO",
                                                    "time": 1709116406607
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "ja",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_IMMUNE_BREATHINGEXERCISES_YES",
                                                    "resultText": "Je doet weleens ademhalingsoefeningen. Een efficiÃ«nte zuurstoftoevoer is essentieel voor een optimale gezondheid en een goede energie. Door je lichaam af en toe kort bloot te stellen aan een zuurstoftekort zal het zich extra wapenen om beter om te kunnen gaan met lage hoeveelheden zuurstof.",
                                                    "keyWords": "ja",
                                                    "advice": "Bepaalde ademhalingsoefeningen waarbij je je lichaam even wat minder zuurstof geeft, zorgen onder andere voor het vehogen van je weerstand tegen bacteriÃ«le infecties. Let op: als je te weinig van de stressor toedient, is er geen enkel effect waarneembaar. Als je een te hoge dosis van de stressor toedient, heeft de stressor een negatief effect en kan het in sommige gevallen zelfs zeer gevaarlijk zijn. Het is persoonsafhankelijk of je deze prikkel al dan niet kan toedienen en is dus niet bruikbaar voor iedereen. Deze oefeningen doe je bovendien best onder deskundige beleiding.",
                                                    "time": 1709126385525
                                                }
                                            ],
                                            "visualization": "TEXTUAL",
                                            "source": "INTAKE"
                                        }
                                    ],
                                    "scoreResult": [
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 27.211498973305954,
                                            "leadlifeAge": 18,
                                            "goalAge": 18,
                                            "time": 1672613999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.369609856262834,
                                            "leadlifeAge": 18.3709787816564,
                                            "goalAge": 18.3709787816564,
                                            "time": 1709161199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.372347707049965,
                                            "leadlifeAge": 18.373716632443532,
                                            "goalAge": 18.373716632443532,
                                            "time": 1709247599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.380561259411362,
                                            "leadlifeAge": 18.38193018480493,
                                            "goalAge": 18.38193018480493,
                                            "time": 1709506799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.432580424366872,
                                            "leadlifeAge": 18.43394934976044,
                                            "goalAge": 18.43394934976044,
                                            "time": 1711148399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.44079397672827,
                                            "leadlifeAge": 18.442162902121833,
                                            "goalAge": 18.442162902121833,
                                            "time": 1711407599000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.4435318275154,
                                            "leadlifeAge": 18.444900752908968,
                                            "goalAge": 18.444900752908968,
                                            "time": 1711493999000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.449007529089666,
                                            "leadlifeAge": 18.45037645448323,
                                            "goalAge": 18.45037645448323,
                                            "time": 1711666799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.487337440109513,
                                            "leadlifeAge": 18.48870636550308,
                                            "goalAge": 18.48870636550308,
                                            "time": 1712872799000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.49828884325804,
                                            "leadlifeAge": 18.49965776865161,
                                            "goalAge": 18.49965776865161,
                                            "time": 1713218399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.709103353867214,
                                            "leadlifeAge": 18.71047227926078,
                                            "goalAge": 18.71047227926078,
                                            "time": 1719871199000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.744695414099933,
                                            "leadlifeAge": 18.746064339493497,
                                            "goalAge": 18.746064339493497,
                                            "time": 1720994399000
                                        },
                                        {
                                            "riskLevel": "NOT_AVAILABLE",
                                            "stringValue": "0.0",
                                            "score": 0,
                                            "maxScore": 0,
                                            "goalScore": 0,
                                            "realAge": 28.747433264887064,
                                            "leadlifeAge": 18.748802190280628,
                                            "goalAge": 18.748802190280628,
                                            "time": 1721080799000
                                        }
                                    ]
                                }
                            ],
                            "results": [],
                            "scoreResult": [
                                {
                                    "riskLevel": "GOOD",
                                    "stringValue": "10.0",
                                    "score": 10,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 27.211498973305954,
                                    "leadlifeAge": 18,
                                    "goalAge": 18,
                                    "time": 1672613999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.369609856262834,
                                    "leadlifeAge": 28.577078104798844,
                                    "goalAge": 18.3709787816564,
                                    "time": 1709161199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.372347707049965,
                                    "leadlifeAge": 28.581336983801048,
                                    "goalAge": 18.373716632443532,
                                    "time": 1709247599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.380561259411362,
                                    "leadlifeAge": 28.594113620807665,
                                    "goalAge": 18.38193018480493,
                                    "time": 1709506799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.432580424366872,
                                    "leadlifeAge": 28.67503232184957,
                                    "goalAge": 18.43394934976044,
                                    "time": 1711148399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.44079397672827,
                                    "leadlifeAge": 28.687808958856184,
                                    "goalAge": 18.442162902121833,
                                    "time": 1711407599000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.4435318275154,
                                    "leadlifeAge": 28.692067837858392,
                                    "goalAge": 18.444900752908968,
                                    "time": 1711493999000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.449007529089666,
                                    "leadlifeAge": 28.7005855958628,
                                    "goalAge": 18.45037645448323,
                                    "time": 1711666799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.487337440109513,
                                    "leadlifeAge": 28.760209901893678,
                                    "goalAge": 18.48870636550308,
                                    "time": 1712872799000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.49828884325804,
                                    "leadlifeAge": 28.777245417902503,
                                    "goalAge": 18.49965776865161,
                                    "time": 1713218399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.709103353867214,
                                    "leadlifeAge": 29.105179101072324,
                                    "goalAge": 18.71047227926078,
                                    "time": 1719871199000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.744695414099933,
                                    "leadlifeAge": 29.160544528100992,
                                    "goalAge": 18.746064339493497,
                                    "time": 1720994399000
                                },
                                {
                                    "riskLevel": "NEUTRAL",
                                    "stringValue": "6.4",
                                    "score": 6.428571428571429,
                                    "maxScore": 10,
                                    "goalScore": 10,
                                    "realAge": 28.747433264887064,
                                    "leadlifeAge": 29.164803407103197,
                                    "goalAge": 18.748802190280628,
                                    "time": 1721080799000
                                }
                            ]
                        }
                    ],
                    "results": [],
                    "scoreResult": [
                        {
                            "riskLevel": "GOOD",
                            "stringValue": "8.2",
                            "score": 8.246112831097353,
                            "maxScore": 10,
                            "goalScore": 8.731148950808393,
                            "realAge": 27.211498973305954,
                            "leadlifeAge": 19.058759482634546,
                            "goalAge": 18,
                            "time": 1672613999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.0",
                            "score": 5.96348488113194,
                            "maxScore": 10,
                            "goalScore": 9.615729967200556,
                            "realAge": 28.369609856262834,
                            "leadlifeAge": 29.62200369728257,
                            "goalAge": 18.3709787816564,
                            "time": 1709161199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.3",
                            "score": 6.3107071033541615,
                            "maxScore": 10,
                            "goalScore": 9.615729967200556,
                            "realAge": 28.372347707049965,
                            "leadlifeAge": 27.996339354354493,
                            "goalAge": 18.373716632443532,
                            "time": 1709247599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "6.3",
                            "score": 6.286897579544639,
                            "maxScore": 10,
                            "goalScore": 9.615729967200556,
                            "realAge": 28.380561259411362,
                            "leadlifeAge": 28.11492865863097,
                            "goalAge": 18.38193018480493,
                            "time": 1709506799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.7",
                            "score": 5.726595681007446,
                            "maxScore": 10,
                            "goalScore": 9.6674651057004,
                            "realAge": 28.432580424366872,
                            "leadlifeAge": 31.119634076856336,
                            "goalAge": 18.43394934976044,
                            "time": 1711148399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.6",
                            "score": 5.628354760707702,
                            "maxScore": 10,
                            "goalScore": 9.569224185400657,
                            "realAge": 28.44079397672827,
                            "leadlifeAge": 31.355022697946104,
                            "goalAge": 18.442162902121833,
                            "time": 1711407599000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.8963429816371,
                            "maxScore": 10,
                            "goalScore": 9.722833321362732,
                            "realAge": 28.4435318275154,
                            "leadlifeAge": 30.41490228911677,
                            "goalAge": 18.444900752908968,
                            "time": 1711493999000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.8963429816371,
                            "maxScore": 10,
                            "goalScore": 9.722833321362732,
                            "realAge": 28.449007529089666,
                            "leadlifeAge": 30.42393150161168,
                            "goalAge": 18.45037645448323,
                            "time": 1711666799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.8963429816371,
                            "maxScore": 10,
                            "goalScore": 9.722833321362732,
                            "realAge": 28.487337440109513,
                            "leadlifeAge": 30.48713598907608,
                            "goalAge": 18.48870636550308,
                            "time": 1712872799000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.8963429816371,
                            "maxScore": 10,
                            "goalScore": 9.722833321362732,
                            "realAge": 28.49828884325804,
                            "leadlifeAge": 30.505194414065905,
                            "goalAge": 18.49965776865161,
                            "time": 1713218399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.8963429816371,
                            "maxScore": 10,
                            "goalScore": 9.722833321362732,
                            "realAge": 28.709103353867214,
                            "leadlifeAge": 30.852819095120083,
                            "goalAge": 18.71047227926078,
                            "time": 1719871199000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.8963429816371,
                            "maxScore": 10,
                            "goalScore": 9.722833321362732,
                            "realAge": 28.744695414099933,
                            "leadlifeAge": 30.91150897633702,
                            "goalAge": 18.746064339493497,
                            "time": 1720994399000
                        },
                        {
                            "riskLevel": "NEUTRAL",
                            "stringValue": "5.9",
                            "score": 5.8963429816371,
                            "maxScore": 10,
                            "goalScore": 9.722833321362732,
                            "realAge": 28.747433264887064,
                            "leadlifeAge": 30.916023582584476,
                            "goalAge": 18.748802190280628,
                            "time": 1721080799000
                        }
                    ]
                },
                {
                    "tag": "DASHBOARD_MOTIVATION",
                    "name": "Mindset",
                    "groups": [
                        {
                            "tag": "DASHBOARD_MOTIVATION_MOTIVATION",
                            "name": "Jouw motivatie",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_MOTIVATION_MOTIVATION_INTERNAL",
                                    "name": "Intrinsieke motivatie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTERNAL",
                                            "name": "Intrinsieke motivatie",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTERNAL_GOOD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTERNAL_NEUTRAL",
                                                    "resultText": "Je intrinsieke motivatie is neutraal.",
                                                    "keyWords": "neutraal",
                                                    "advice": "Dat betekent dat je motivatie soms uit jezelf en soms uit een ander komt. De redenen om gezonder te leven verschillen. Het is belangrijk voor je om haalbare doelen op te stellen. Deel je einddoelen op in kleinere en concrete subdoelen.",
                                                    "time": 1709130266302
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOTIVATION_MOTIVATION_INTROJECTED",
                                    "name": "Geaccepteerde motivatie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTROJECTED",
                                            "name": "Geaccepteerde motivatie",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTROJECTED_BAD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "laag",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_INTROJECTED_GOOD",
                                                    "resultText": "Je geaccepteerde motivatie is laag.",
                                                    "keyWords": "laag",
                                                    "advice": "Dat betekent dat je motivatie om gezond te leven niet afhankelijk is van wat je denkt dat anderen denken. Dat is positief. Jij bepaalt zelf dat het goed is voor je om gezond te leven.",
                                                    "time": 1709130266302
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOTIVATION_MOTIVATION_EXTERNAL",
                                    "name": "Externe motivatie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_EXTERNAL",
                                            "name": "Externe motivatie",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "laag",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_EXTERNAL_GOOD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_EXTERNAL_BAD",
                                                    "resultText": "Je externe motivatie is hoog.",
                                                    "keyWords": "hoog",
                                                    "advice": "Dat betekent dat je bepaald gedrag stelt, omdat het van je verwacht wordt. Het is goed voor jou om jezelf eens een beloning te geven als je je (sub)doel bereikt hebt. Durf jezelf bemoedigend toe te spreken als je een taak succesvol hebt afgerond.",
                                                    "time": 1709130266302
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOTIVATION_MOTIVATION_AMOTIVATION",
                                    "name": "Amotivatie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_AMOTIVATION",
                                            "name": "Amotivatie",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoog",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_AMOTIVATION_BAD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_AMOTIVATION_NEUTRAL",
                                                    "resultText": "Je amotivatie is neutraal.",
                                                    "keyWords": "neutraal",
                                                    "advice": "Dat betekent dat je soms gemotiveerd bent en soms niet. Je ziet niet altijd het nut van gedragsverandering in. Het is voor jou belangrijk om in kleine stappen te werken. Het is ook goed om je vooruitgang bij te houden.",
                                                    "time": 1709130266302
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_MOTIVATION_MOTIVATION_RAI",
                                    "name": "Relatieve autonomie index",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_RAI",
                                            "name": "Relatieve autonomie index",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "laag",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_RAI_BAD",
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "laag",
                                                    "tag": "RESULT_LEADLIFE_ANAMNESE_MOTIVATION_RAI_BAD",
                                                    "resultText": "Je relatieve autonomie index is laag.",
                                                    "keyWords": "laag",
                                                    "advice": "Dat betekent dat het moeilijk is voor je om gezonder te leven. Extra inzichten en persoonlijke coaching zijn nuttig voor jou. Dit zal je helpen om een gezondere levensstijl te hanteren.",
                                                    "time": 1709130266302
                                                }
                                            ],
                                            "visualization": "TEXTUAL_COLOR",
                                            "source": "INTAKE"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        }
                    ],
                    "results": []
                },
                {
                    "tag": "DASHBOARD_DNA",
                    "name": "DASHBOARD_DNA",
                    "groups": [
                        {
                            "tag": "DASHBOARD_DNA_LIFESTYLE",
                            "name": "Lifestyle",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_DNA_LIFESTYLE_CARDIO",
                                    "name": "Hart- en vaataandoeningen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL",
                                            "name": "HDL of goede cholesterol",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "lagere waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "hogere waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "hogere waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "lagere waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_HDL_HOOG",
                                                    "resultText": "We kunnen uit jouw DNA-resultaten afleiden dat je lichaam van nature de neiging heeft om wat lagere HDL-waarden in het bloed te hebben. HDL is de goede cholesterol en helpt je te beschermen tegen hart- en vaatziekten. Het is dan ook belangrijk die waarden zo hoog mogelijk te houden. Met de juiste voeding en een gezonde levensstijl kan je alvast een stap in de juiste richting zetten.",
                                                    "keyWords": "lagere waarden",
                                                    "advice": "Wil jij je HDL-waarden verhogen? Laat dan het roken zeker links liggen, omdat de HDL-waarden daardoor sterk afnemen. De verhouding tussen goede en slechte cholesterol kan grondig verstoord worden als je te veel verzadigde vetten eet. Probeer die verhouding te verbeteren door enkelvoudige onverzadigde vetten te kiezen, waardoor de HDL-cholesterol stijgt. \n\nVoldoende lichaamsbeweging heeft ook een gunstig effect op de HDL-waarden: doorgaans is meer bewegen ook beter. Heb je een chronische aandoening en/of verschillende risicofactoren voor hart- en vaatziekten? Hou dan rekening met speciale voorzorgsmaatregelen bij het opstarten van een trainingsprogramma. Raadpleeg in dat geval zeker een arts om jou te begeleiden!",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL",
                                            "name": "LDL of slechte cholesterol",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_LDL_HOOG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat je lichaam de neiging heeft om verhoogde LDL-cholesterolwaarden te hebben. LDL is de 'slechte' cholesterol in jouw bloed. Dit resultaat betekent niet dat jouw LDL-waarden op dit moment verhoogd zijn of dat ze sowieso verhoogd zullen worden, want jouw genen zijn maar Ã©Ã©n van de factoren die een impact hebben. Hoe je leeft, heeft een veel grotere impact. Een gezonde levensstijl kan ertoe leiden dat jouw LDL-waarden minder de neiging hebben om de lucht in te gaan.",
                                                    "keyWords": "verhoogde waarden",
                                                    "advice": "Voor jou is het heel belangrijk de factoren die een impact hebben op je LDL-cholesterol zo goed mogelijk onder controle te houden. Er zijn verschillende manieren om je LDL-waarden zo laag mogelijk te houden, waarvan dit de belangrijkste zijn. Ga voor een gezond dieet, door bijvoorbeeld minder verzadigde vetten te gebruiken en veel groenten, fruit en voedingsvezels te eten. Beperk het gebruik van zout, rook niet en beweeg minimaal 2,5 uur per week.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN",
                                            "name": "Triglyceriden",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TRIGLYCERIDEN_MATIG",
                                                    "resultText": "Uit jouw DNA-resultaten konden we afleiden dat jouw lichaam de neiging heeft om licht verhoogde triglyceridelevels in jouw bloed te hebben. Die uitkomst betekent niet dat je nooit verhoogde waarden zal hebben, want jouw genen vormen maar Ã©Ã©n factor in het grotere geheel. Een gezonde levensstijl kan helpen om jouw triglyceridelevels onder controle te houden.",
                                                    "keyWords": "licht verhoogde waarden",
                                                    "advice": "Wil jij de triglyceridenwaarden in je bloed verlagen? Kies dan zeker voor een gezonde levensstijl. Begin alvast met een gezond gewicht te bereiken en/of te behouden. Als je overgewicht hebt, helpt gewichtsverlies via een dieet om je triglyceridenwaarden te verminderen. Ook voldoende bewegen heeft een positief effect op die waarden. Ga voor minstens 30 minuten beweging per dag, minstens vijf dagen per week.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL",
                                            "name": "Totale cholesterol",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CHOLESTEROL_TOTALCHOLESTEROL_MATIG",
                                                    "resultText": "Als het aankomt op je totale cholesterol, blijkt uit jouw DNA-analyse dat jij van nature de neiging hebt om licht verhoogde waarden te hebben in vergelijking met de algemene bevolking. Dat betekent natuurlijk niet dat die waarden nu al verhoogd zijn of dat ze sowieso zullen verhogen. Jouw genen zijn maar Ã©Ã©n factor binnen het grotere geheel hoe je jouw cholesterol kan regelen, want ook jouw levensstijl speelt mee!",
                                                    "keyWords": "licht verhoogde waarden",
                                                    "advice": "Het is aangeraden voor een gezonde levensstijl te kiezen om jouw totale cholesterol zo laag mogelijk te houden. Heel wat zaken kunnen een toename van het totale cholesterolgehalte vermijden. Denk bijvoorbeeld aan gezonde voeding, voldoende bewegen, niet roken, een gezond gewicht...",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION",
                                            "name": "Hoge bloeddruk",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde waarden",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_HYPERTENSION_HOOG",
                                                    "resultText": "Uit de resultaten van je DNA-analyse blijkt dat jouw lichaam de neiging heeft om een verhoogde bloeddruk te ontwikkelen. Dat betekent niet dat jij nu al een verhoogde bloeddruk hebt of die zeker zal krijgen: jouw genen vormen maar Ã©Ã©n factor. Naarmate we ouder worden, neemt onze bloeddruk automatisch toe. Een gezonde levensstijl is heel belangrijk om een verhoogde bloeddruk te vermijden. ",
                                                    "keyWords": "verhoogde waarden",
                                                    "advice": "Omdat het ontwikkelen van een verhoogde bloeddruk in de aard van jouw lichaam ligt, is het aanbevolen om rekening te houden met bepaalde factoren. Beweeg voldoende en streef naar een gezond gewicht, bijvoorbeeld. Laat daarnaast sigaretten, vet, suiker en zout links liggen. Zout zit in heel veel voedingswaren verwerkt zonder dat we er ons bewust van zijn. Een groot brood bevat bijvoorbeeld 4 gram zout. Bouillonblokjes en bereide vleeswaren kunnen ook heel veel zout bevatten. Je hoeft dus niet altijd extra zout toe te voegen aan gewone voeding!",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD",
                                            "name": "Coronaire aandoeningen",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_CARDIO_CAD_MATIG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat er een kans bestaat dat jij coronaire aandoeningen ontwikkelt. Dat betekent niet dat je nu ziek bent of dat je die aandoening met zekerheid zal krijgen. Het goede nieuws is dat je jouw algemeen risico op die aandoeningen kan beÃ¯nvloeden omdat de genen maar Ã©Ã©n factor zijn binnen het geheel van elementen die de oorzaak vormen voor het ontwikkelen ervan. Jouw levensstijl heeft de grootste impact.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Omdat jouw lichaam de neiging heeft om aandoeningen ter hoogte van de kransslagaders te ontwikkelen, is een gezonde levensstijl voor jou enorm belangrijk. Verschillende zaken kunnen je helpen om aandoeningen te vermijden. Denk maar aan regelmatig bewegen en gezonde voeding, of het vermijden van overgewicht en niet roken.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_LIFESTYLE_DIABETES",
                                    "name": "Diabetes type 2",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_DIABETES",
                                            "name": "Diabetes type 2",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DIABETES_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DIABETES_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DIABETES_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DIABETES_MATIG",
                                                    "resultText": "Als we jou met anderen vergelijken, kunnen we op basis van jouw DNA-analyse afleiden dat jij een licht verhoogde vatbaarheid hebt om diabetes type 2 te ontwikkelen. Dat betekent niet dat jij momenteel ziek bent of dat jij die aandoening met zekerheid zal ontwikkelen. Jouw genen vormen namelijk maar een deel van je vatbaarheid, ook je levensstijl kan daar een beschermende of risicoverhogende rol in spelen. Het is belangrijk die factoren zo goed mogelijk onder controle te houden.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een gezonde levensstijl is zeer belangrijk als je de ontwikkeling van diabetes type 2 wil verminderen of voorkomen. Zorg voor voldoende beweging, hou je gewicht onder controle, eet gezond, rook niet of stop met roken. Probeer daar rekening mee te houden, omdat je volgens jouw DNA een licht verhoogde vatbaarheid hebt.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_LIFESTYLE_LONGEN",
                                    "name": "Longen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_LUNG_ASTMA",
                                            "name": "Astma",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_ASTMA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_ASTMA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_ASTMA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_ASTMA_MATIG",
                                                    "resultText": "Als we jouw DNA-analyse naast de resultaten van anderen leggen, blijkt dat jij een licht verhoogde vatbaarheid hebt voor het ontwikkelen van astma. Dat betekent natuurlijk niet dat jij nu ziek bent of dat jij met zekerheid die aandoening zal ontwikkelen. Jouw genen zijn maar Ã©Ã©n deel binnen het grotere geheel. Andere factoren zoals roken, verbrandingsassen en allergieÃ«n kunnen een rol spelen bij het ontwikkelen van astma. Probeer die factoren zo goed mogelijk onder controle te houden!",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Doordat jij een licht verhoogde vatbaarheid voor astma hebt, raden we je aan om te letten op een aantal factoren die de aandoening kunnen veroorzaken. Vermijd roken en wees waakzaam voor overgewicht. Vermijd daarnaast blootstelling aan bepaalde allergenen zoals huisstofmijt, katten, honden, pollen of tabaksrook.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_LUNG_COPD",
                                            "name": "COPD",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normaal ",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_COPD_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_COPD_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_COPD_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_COPD_HOOG",
                                                    "resultText": "Op basis van je DNA-resultaten kunnen we concluderen dat de kans dat jouw lichaam COPD ontwikkelt verhoogd is. Dat betekent niet dat jij momenteel ziek bent of dat jij met zekerheid die aandoening zal ontwikkelen. Je genetische aanleg speelt weliswaar een rol, maar ook jouw levensstijl en werkomgeving kunnen daaraan bijdragen. Het is voor jou heel belangrijk die factoren zo goed mogelijk onder controle te houden.",
                                                    "keyWords": "sterk verhoogd",
                                                    "advice": "Een gezonde levensstijl is belangrijk als je COPD-klachten wil voorkomen of verminderen. Probeer daarom gezond te eten en voldoende te bewegen. Laat het roken links liggen en vermijd als niet-roker ook rokerige ruimtes. Volg daarnaast altijd de aanwijzingen van je arts op.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_LUNG_SLEEPAPNEA",
                                            "name": "Slaapapneu",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_SLEEPAPNEA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_SLEEPAPNEA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_SLEEPAPNEA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_LUNG_SLEEPAPNEA_MATIG",
                                                    "resultText": "Op basis van je DNA-analyse kunnen we afleiden dat jouw lichaam in mindere mate de neiging heeft om slaapapneu te ontwikkelen. Dat betekent niet dat jij nu al ziek bent of dat jij die aandoening met zekerheid zal ontwikkelen.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Er zijn verschillende factoren die een rol spelen bij de ontwikkeling van slaapapneu. Denk bijvoorbeeld aan overgewicht, overmatig alcoholgebruik en allergieÃ«n. Hou daar zeker rekening mee.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_LIFESTYLE_DARMEN",
                                    "name": "Darmen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_DARM_CROHN",
                                            "name": "Crohn",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DARM_CROHN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DARM_CROHN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DARM_CROHN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DARM_CROHN_MATIG",
                                                    "resultText": "We konden uit jouw DNA-resultaten afleiden dat de kans dat je lichaam de ziekte van Crohn ontwikkelt licht aanwezig is. Dat betekent niet dat jij nu al die aandoening hebt of dat je ze met zekerheid zal krijgen. Je risico op de ziekte van Crohn kan in de loop van de tijd wijzigen, omdat naast je genen vooral je levensstijl daarop een grote impact kan hebben.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "De precieze oorzaak van de ziekte van Crohn is niet bekend. Wel lijken naast genetische vatbaarheid ook omgevings- en levensstijlfactoren een grote rol te spelen in de ontwikkeling van de ziekte. Denk daarbij aan stress, roken of een overmatig gebruik van reinigings- en desinfectiemiddelen. Een typisch westers leefpatroon, met veel suiker en vet gecombineerd met weinig groenten en fruit, kan de ziekte van Crohn in de hand werken. Doordat jij een licht verhoogde vatbaarheid voor de aandoening hebt, is het dus belangrijk daar rekening mee te houden.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_DARM_COLITIS",
                                            "name": "Colitis Ulcerosa",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DARM_COLITIS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DARM_COLITIS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DARM_COLITIS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_DARM_COLITIS_MATIG",
                                                    "resultText": "Uit jouw DNA-resultaten konden we afleiden dat de kans dat je lichaam colitis ulcerosa ontwikkelt licht aanwezig is. Dat betekent niet dat je momenteel al ziek bent of dat je de aandoening sowieso zal ontwikkelen. Jouw risico kan in de loop van de tijd namelijk wijzigen, omdat je genen maar een onderdeel zijn van het grotere geheel. Ook jouw levensstijl heeft een grote impact.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Roken is een risicofactor die het ontwikkelen van colitis ulcerosa kan stimuleren. De sigaretten links laten liggen is dus zeer belangrijk, net als het hanteren van een gezond voedingspatroon. Ga voor regelmaat, voldoende zachte vezels, vitamines, voeding rijk aan eiwitten maar arm aan verzadigde vetten en zoetigheden. Omdat jouw lichaam van nature uit in beperkte mate de neiging heeft om colitis ulcerosa te ontwikkelen, is het belangrijk daarmee rekening te houden.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_LIFESTYLE_FRACTUUR",
                                    "name": "Fractuurrisico",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MEDICAL_FRACTUURRISICO",
                                            "name": "Fractuurrisico",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_FRACTUURRISICO_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_FRACTUURRISICO_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_FRACTUURRISICO_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogd",
                                                    "tag": "RESULT_DNA_MEDICAL_FRACTUURRISICO_MATIG",
                                                    "resultText": "Als we het resultaat van je DNA-analyse bekijken, zien we dat de kans dat jouw lichaam van nature osteoporose ontwikkelt licht verhoogd is. Dat betekent niet dat jij nu ziek bent of dat je de aandoening zeker en vast zal krijgen. Jouw genen vormen maar Ã©Ã©n deel van het geheel, want ook je levensstijl speelt een belangrijke rol bij de ontwikkeling van osteoporose.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Wil je het risico op osteoporose onder controle houden? Omdat jij een licht verhoogde kans op de ziekte hebt, raden we je aan op de volgende zaken te letten. Eet gezonde calciumrijke voeding, zoals melkproducten, met calcium verrijkte plantaardige alternatieven, sardines of tofoe. Zorg ervoor dat je voldoende zonlicht krijgt, want dat bezorgt je vitamine D waarmee je lichaam calcium aanmaakt. Rook ten slotte niet en beperk het gebruik van alcohol en cafeÃ¯ne. Hou uiteraard altijd rekening met mogelijke intoleranties!",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        },
                        {
                            "tag": "DASHBOARD_DNA_FOOD",
                            "name": "Voeding",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_DNA_FOOD_EETGEDRAG",
                                    "name": "Eetgedrag",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET",
                                            "name": "Zoete smaak",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_ZOET_MATIG",
                                                    "resultText": "Jij bent een kleine snoeper: jouw DNA toont aan dat je een lichte voorkeur voor zoete smaken hebt.",
                                                    "keyWords": "lichte voorkeur",
                                                    "advice": "Geniet, maar met mate. Te veel zoete voedingsproducten zijn slecht voor je lichaam. Een overvloed aan suiker kan je alvleesklier overbelasten, overgewicht veroorzaken en de kans op diabetes type 2 verhogen. Daarnaast is het, maar dat wist je hopelijk al, slecht voor je tanden. Laat die suikerrijke hap dus liever links liggen en kies voor gezondere en vezelrijke alternatieven zoals groenten, fruit of noten. Let wel op je intoleranties en allergieÃ«n!",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER",
                                            "name": "Bittere smaak",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "moeilijk te proeven",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "neutraal",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SMAAK_BITTER_MATIG",
                                                    "resultText": "Jouw DNA wijst uit dat je neutraal in staat bent om de smaak 'bitter' te proeven.",
                                                    "keyWords": "neutraal",
                                                    "advice": "Doordat je toch in staat bent om de smaak wat te proeven is de kans groot dat je bittere voedingsproducten links laat liggen. Toch is dat geen slim idee, want ze bevatten vaak belangrijke vitamines Ã©n helpen jouw zin in zoetigheid te verminderen. Het is niet zo moeilijk om te weten over welke voeding het gaat: het zijn de (donker)groene groenten zoals spinazie, broccoli, kolenâ¦ Wat Popeye zou eten dus! Je bent misschien geneigd om daar een hoop zout over te gooien om âde boel wat op smaak te brengenâ, maar hou jezelf wat in: te veel zout kan leiden tot een verhoogde bloeddruk.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS",
                                            "name": "Tussendoortjes",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SNACKS_HOOG",
                                                    "resultText": "Jij snakt naar snacks! Op basis van jouw DNA-resultaten blijkt namelijk dat jij een verhoogde neiging hebt om tussendoortjes te eten.",
                                                    "keyWords": "verhoogde neiging",
                                                    "advice": "Als we je een tip mogen geven: plan je maaltijden zo goed mogelijk in en probeer er geen te skippen. Zo zal je minder snel naar suikerrijke tussendoortjes zoals koeken, snoep of chocolade grijpen. Natuurlijk is het prima om af en toe een zak chips open te trekken, maar kies vooral voor gezondere en vezelrijke alternatieven zoals groenten, fruit of noten. Let uiteraard wel altijd op mogelijke intoleranties.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING",
                                            "name": "Verzadiging",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "iets trager ervaren",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijker ervaren",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "iets trager ervaren",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijker ervaren",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_VERZADIGING_HOOG",
                                                    "resultText": "Het DNA-onderzoek wijst uit dat jij niet snel een verzadigd gevoel hebt na het eten van een maaltijd.",
                                                    "keyWords": "moeilijker ervaren",
                                                    "advice": "Doordat jij minder snel het gevoel hebt verzadigd te zijn, is er een kans dat jij je overeet of snoept tussen maaltijden door. Let daar dus mee op en eet trager zodat je van je maaltijd kan genieten. Probeer daarnaast om zowel tijdens als tussen je maaltijden door te kiezen voor voedingsstoffen die een verzadigd gevoel opwekken. Denk bijvoorbeeld aan eiwitten of (vette) vis en voeding met trage koolhydraten, zoals volkorenproducten en peulvruchten.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING",
                                            "name": "Spreiding maaltijden",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte nood",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge nood",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge nood",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte nood",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_SPREIDING_MATIG",
                                                    "resultText": "Uit jouw DNA-resultaten kunnen we opmaken dat een regelmatig eetpatroon zeer belangrijk is voor jou.",
                                                    "keyWords": "lichte nood",
                                                    "advice": "Op regelmatige tijdstippen eten is voor jou echt belangrijk. Hou daar dan ook rekening mee als je je dagelijkse maaltijden inplant. Af en toe kan je tijdelijk vasten, maar besteed toch aandacht aan regelmaat tijdens de periode waarin je eet.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_BINGEEATING",
                                            "name": "Binge eating",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_BINGEEATING_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_BINGEEATING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_BINGEEATING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_EETGEDRAG_BINGEEATING_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse blijkt dat jij een aanleg voor binge eating hebt.",
                                                    "keyWords": "verhoogde neiging",
                                                    "advice": "Zoals het ernaar uitziet, interpreteert jouw lichaam emotionele eetbuien als een goede manier om met sterke gevoelens om te gaan. Laat je emoties jouw eetgedrag niet bepalen! Word je bewust van de link tussen negatieve emoties en jouw eetgedrag, door die relatie goed in kaart te brengen aan de hand van de volgende vragen.\n\n- Bedenk drie situaties waarin je veel eet.\n- Hoe voel je je wanneer je te veel gegeten hebt?\n- Waar heb je, los van eten, Ã©cht behoefte aan op die momenten?",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_FOOD_LICHAAMSBOUW",
                                    "name": "Lichaamsbouw",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_GEWICHT",
                                            "name": "Bijkomen in gewicht",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_GEWICHT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_GEWICHT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_GEWICHT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_GEWICHT_MATIG",
                                                    "resultText": "Uit jouw genen kunnen we afleiden dat jouw lichaam eerder de neiging heeft om in gewicht bij te komen. ",
                                                    "keyWords": "lichte neiging",
                                                    "advice": "Op basis van je DNA raden we je aan om een gezond eetpatroon te combineren met licht verhoogde fysieke activiteiten, naast de aanbevolen dagelijkse hoeveelheid beweging. Sta bijvoorbeeld af en toe recht, maak een korte wandeling of neem eens de trap in plaats van de lift.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BUIKVET",
                                            "name": "Buikvet",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BUIKVET_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BUIKVET_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BUIKVET_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte neiging",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BUIKVET_MATIG",
                                                    "resultText": "De analyse van jouw DNA wijst uit dat jouw lichaam mogelijk wat extra vet opslaat ter hoogte van de buikzone. ",
                                                    "keyWords": "lichte neiging",
                                                    "advice": "Doordat je iets gevoeliger bent voor buikvet, raden we je aan waakzaam te zijn over je buikomtrek. Voor vrouwen is die ideaal onder 80 centimeter, bij mannen is dat 94 centimeter. Wie daarboven zit, heeft meer kans op levensstijlgebonden aandoeningen zoals hart- en vaatziekten, diabetes type 2 (suikerziekte) Ã©n een te hoge bloeddruk. Volg daarom een eetpatroon met voornamelijk magere eiwitten uit bijvoorbeeld kip, kalkoen, vis, zeevruchten of linzen. Beperk het eten of drinken van verzadigde vetten die je in vet vlees en volle melkproducten vindt. Naast een gezonde voeding blijft dagelijks bewegen uiteraard ook belangrijk.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BEWEGEN",
                                            "name": "Bewegen en gewicht",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte nood",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BEWEGEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte nood",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BEWEGEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BEWEGEN_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_NUTRITION_LICHAAMSBOUW_BEWEGEN_LAAG",
                                                    "resultText": "Gewicht verliezen gaat vrij makkelijk voor jou. Volgens jouw DNA-analyse heb je geen nood aan extra beweging boven op de dagelijks voorgeschreven hoeveelheid.",
                                                    "keyWords": "geen extra nood",
                                                    "advice": "Volgens jouw DNA-analyse reageer je goed op beweging in functie van gewichtsverlies of het behouden van jouw gewicht. Probeer altijd te streven naar de normale hoeveelheid beweging, want voldoende bewegen is belangrijk voor een goede gezondheid.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_FOOD_VETTEN",
                                    "name": "Vetten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN",
                                            "name": "Verzadigde vetten",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_VERZADIGDEVETTEN_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse blijkt dat jouw lichaam het moeilijker heeft om de verzadigde vetten te verwerken.",
                                                    "keyWords": "moeilijke verwerking",
                                                    "advice": "Doordat jouw lichaam het moeilijk heeft om verzadigde vetten te verwerken, is een voedingspatroon met zo weinig mogelijk verzadigde vetten in jouw geval optimaal. Bij een te hoge inname stijgt de kans op overgewicht, insulineresistentie en diabetes type 2 (suikerziekte). Probeer het energieprocent van je hoeveelheid verzadigde vetten terug te dringen tot minder dan 7 procent. Bronnen van verzadigde vetten zijn onder andere vet vlees, volle melkproducten en volvette kaas. Daarnaast zit er veel verzadigd vet in koekjes en gebakjes.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN",
                                            "name": "Transvetten",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "minder goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_TRANSVETTEN_MATIG",
                                                    "resultText": "Het onderzoek van jouw genen wijst uit dat jouw lichaam transvetten niet zo goed verwerkt.",
                                                    "keyWords": "minder goede verwerking",
                                                    "advice": "Het is sowieso niet aangeraden om veel transvetten te eten, maar in jouw geval is het zeker belangrijk daarop te letten. Door je hoeveelheid transvetten onder 1% energiewaarde per dag te houden beperk je het risico op hart- en vaatziekten. Transvetten komen van nature voor in melk en vlees van herkauwers zoals koeien en schapen. Daarom kom je ze ook tegen in harde margarines, bak- en braadvetten. Zoals we al vertelden, duiken ze vooral op in gebak, koekjes en snacks. Probeer dus zo veel mogelijk te kiezen voor vloeibaar of zacht vet en eet niet te veel koekjes en gebakjes om de inname van transvet te beperken.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA",
                                            "name": "Enkelvoudig onverzadigde vetten",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_MUFA_MATIG",
                                                    "resultText": "Uit jouw DNA-analyse kunnen we opmaken dat jouw lichaam behoefte heeft aan een voedingspatroon dat rijk is aan enkelvoudig onverzadigde vetten. Dat is vooral belangrijk om overgewicht tegen te gaan.",
                                                    "keyWords": "hogere nood",
                                                    "advice": "In jouw geval is het aangeraden te kiezen voor een gezond en gevarieerd eetpatroon met een minimum van 13% energiewaarde uit enkelvoudig onverzadigde vetten. Die mono-onverzadigde vetten vind je vooral in olijven, olijfolie, pinda's en de meeste noten. Olijfolie bevat daarnaast omega 9-vetzuur, dat helpt om het cholesterolgehalte in je bloed te doen dalen. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA",
                                            "name": "Meervoudig onverzadigde vetten",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hogere nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_VETTEN_PUFA_HOOG",
                                                    "resultText": "Op basis van jouw DNA-analyse kunnen we vaststellen dat jouw lichaam nood heeft aan een voedingspatroon rijk aan meervoudig onverzadigde vetten.",
                                                    "keyWords": "hogere nood",
                                                    "advice": "Als we je een tip mogen geven: let erop dat je voldoende omega 3-vetzuren opneemt. Ze zullen je helpen om een gezonde BMI te behouden. Tot de meervoudige of polyonverzadigde vetzuren behoren de essentiÃ«le omega 6- en omega 3-vetzuren. Die eerste vind je onder andere in zonnebloem-, mais-, soja-, tarwekiem-, saffloer- en druivenpitolie. De omega 3-vetzuren zitten dan weer in lijnzaad, koolzaad, noten, soja en de olie van die producten. Die oliÃ«n zijn ideaal voor koude bereidingen! Maar ook vette vissoorten, zoals zalm, zijn rijk aan omega 3. Voeg ze vaker toe aan je voedingspatroon om gezonder te leven.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS",
                                            "name": "Suikers",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_SUIKERS_MATIG",
                                                    "resultText": "Op basis van jouw DNA-resultaten kunnen we vaststellen dat jouw lichaam koolhydraten en suikers niet optimaal verwerkt. ",
                                                    "keyWords": "matige verwerking",
                                                    "advice": "Als jij te veel koolhydraten binnenkrijgt, ben je gevoeliger om bij te komen of insulineresistentie te ontwikkelen. Dat laatste betekent dat je lichaam niet goed reageert op insuline, waardoor je kans hebt op een te hoge bloedsuikerspiegel en type 2 diabetes kan krijgen. Spring dan ook slim met koolhydraten om. Dat doe je door voedingsmiddelen te kiezen waarvan is aangetoond dat ze gezondheidswinst opleveren of andere goede voedingsstoffen zoals vezels, vitaminen en mineralen bevatten. Het best zijn complexe koolhydraten en voedingsproducten met een lage glycemische index. Denk daarbij aan volkoren graanproducten (volkorenbrood en volkorenpasta), aardappelen, peulvruchten, groenten en fruit. Vermijd anderzijds koolhydraatrijke producten die arm zijn aan voedingsstoffen, zoals frisdrank, koekjes en snoep.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL",
                                            "name": "Zetmeel",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "zeer goede verwerking",
                                                    "tag": "RESULT_DNA_NUTRITION_MACRONUTRIENTEN_KOOLHYDRATEN_ZETMEEL_MATIG",
                                                    "resultText": "Uit de resultaten van jouw DNA-analyse blijkt dat jij zetmeelhoudende producten zeer goed verwerkt.",
                                                    "keyWords": "zeer goede verwerking",
                                                    "advice": "Zetmeelhoudende producten zoals pasta, rijst en aardappelen vormen voor jouw lichaam geen uitdaging! Doordat die heel goed verwerkt worden, zal jij bij inname ervan niet extra snel bijkomen. Zetmeelhoudende producten kunnen dus zonder problemen deel uitmaken van je voedingspatroon.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_FOOD_VITAMINES",
                                    "name": "Vitamines en mineralen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2",
                                            "name": "Vitamine B2",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B2_HOOG",
                                                    "resultText": "Op basis van de resultaten van jouw DNA-analyse blijkt dat jouw lichaam een sterk verhoogde nood aan vitamine B2 heeft. ",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Vitamine B2 vind je vooral in melk en melkproducten, maar ook in vlees, vleeswaren, groenten, fruit, brood en graanproducten. Probeer die producten dan ook toe te voegen aan jouw eetpatroon en let daarbij altijd op mogelijke intoleranties. Met het DNA-onderzoek bepalen we zoals gezegd niet of je nu een tekort hebt aan vitamine B2. Om dat te weten te komen, moet je een bloedonderzoek laten doen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6",
                                            "name": "Vitamine B6",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B6_HOOG",
                                                    "resultText": "Op basis van jouw DNA-analyse kunnen we concluderen dat jouw lichaam een sterk verhoogde nood aan vitamine B6 heeft.",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Vitamine B6 vind je vooral in vlees, eieren, vis, brood, graanproducten, aardappelen, peulvruchten, groenten, melk en melkproducten en kaas. Probeer die producten dan ook toe te voegen aan jouw eetpatroon en let daarbij altijd op mogelijke intoleranties. Met het DNA-onderzoek bepalen we zoals gezegd niet of je nu een tekort hebt aan vitamine B6. Om dat te weten te komen, moet je een bloedonderzoek laten doen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR",
                                            "name": "Foliumzuur",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_FOLIUMZUUR_HOOG",
                                                    "resultText": "Uit je DNA-analyse kunnen we opmaken dat jouw lichaam een sterk verhoogde nood aan foliumzuur heeft.",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Probeer net iets meer te variÃ«ren in jouw voedingspatroon zodat je wat extra foliumzuur opneemt. Foliumzuur komt van nature vooral voor in groene groenten, volkorenproducten, brood, vlees en zuivel. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12",
                                            "name": "Vitamine B12",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_VIT_B12_HOOG",
                                                    "resultText": "Op basis van de resultaten van je DNA-analyse blijkt dat jouw lichaam een sterk verhoogde nood aan vitamine B12 heeft.",
                                                    "keyWords": "sterk verhoogde nood",
                                                    "advice": "Probeer in jouw voedingspatroon wat meer te variÃ«ren, zodat jouw lichaam over voldoende vitamine B12 beschikt. Je vindt die vitamine bijvoorbeeld in dierlijke producten zoals melk, melkproducten, vlees, vleeswaren, vis en eieren. Daarnaast kan vitamine B12 ook voorkomen in plantaardige producten, zoals zeewier en algen. Let uiteraard op mogelijke intoleranties. Met het DNA-onderzoek bepalen we zoals gezegd niet of je nu een tekort hebt aan vitamine B12. Om dat te weten te komen, moet je een bloedonderzoek laten doen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER",
                                            "name": "Ijzer",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_NUTRITION_MICRONUTRIENTEN_IJZER_MATIG",
                                                    "resultText": "Op basis van je DNA-analyse merken we dat je een verhoogde gevoeligheid hebt voor een tekort aan transferrine en ijzerwaarden in jouw bloedplasma. ",
                                                    "keyWords": "licht verhoogde nood",
                                                    "advice": "Een tekort aan ijzer kan ertoe leiden dat je sneller vermoeid en buiten adem bent, last hebt van een bleke huid en rusteloze benen die je steeds het gevoel geven dat je ze moet bewegen. Als je wil voorkomen dat jouw lichaam met een ijzertekort kampt, raden wij jou aan om met de volgende zaken rekening te houden.\n\n- Eet genoeg vlees(vervangers) die voldoende ijzer bevatten.\n- Kies vooral voor volkorenbrood, volkorenpasta en peulvruchten.\n- Neem bij iedere maaltijd groenten en/of fruitsoorten die rijk zijn aan vitamine C.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_FOOD_INTOL",
                                    "name": "Overgevoeligheden",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE",
                                            "name": "CafeÃ¯ne",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "snel",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "snel",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "snel",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_CAFEINE_LAAG",
                                                    "resultText": "Volgens jouw DNA-analyse ben je een 'fast metabolizer' als het aankomt op de verwerking van cafeÃ¯ne. Jij breekt cafeÃ¯ne met andere woorden heel snel af.",
                                                    "keyWords": "snel",
                                                    "advice": "CafeÃ¯ne kan helpen om je sport- en mentale prestaties te optimaliseren. Jouw lichaam is dan misschien wel in staat om cafeÃ¯ne snel af te breken, dat betekent nog altijd niet dat je kan overdrijven. Het advies van de Hoge Gezondheidsraad is om als gezonde volwassene per dag maximaal 5,7 mg cafeÃ¯ne per kg lichaamsgewicht binnen te krijgen. Een persoon van 60 kg mag dus hoogstens 340 mg cafeÃ¯ne per dag opnemen. Wanneer je een doorsnee kopje koffie van 80 mg cafeÃ¯ne neemt, komt dat dus neer op maximaal 4 koppen per dag.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN",
                                            "name": "Gluten",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_GLUTEN_HOOG",
                                                    "resultText": "In jouw DNA-onderzoek vonden we meerdere variaties in jouw genen die aanleiding kunnen geven tot een slechte vertering van gluten. Dat betekent dat de kans bestaat dat jouw lichaam het moeilijker heeft om gluten te verteren.",
                                                    "keyWords": "zeer gevoelig",
                                                    "advice": "Gluten binnenspelen is op basis van je DNA niet ideaal voor jouw lichaam. Typische klachten die jij misschien herkent, zijn diarree, buikpijn, vermoeidheid, neerslachtigheid en gewichtsverlies. Vaak komen die op of worden die erger bij volwassenen tussen 30 en 50 jaar. We raden jou aan om over te schakelen op een glutenvrij dieet. Dat betekent dat je bepaalde granen en graanproducten voortaan beter links laat liggen. Pas wel op, want veel graanproducten zoals brood en pasta bevatten voedingsvezels, ijzer, vitamine B1 en foliumzuur. Zorg er dus voor dat je die stoffen toch voldoende binnenkrijgt!",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE",
                                            "name": "Lactose",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_LACTOSE_HOOG",
                                                    "resultText": "Uit de analyse van jouw genen blijkt dat de kans bestaat dat je lactose-intolerant bent. Dat betekent dat jouw lichaam gevoelig kan reageren bij opname van lactose. Typische klachten die daarbij komen kijken en die jij misschien herkent, zijn braken, krampen, diarree of winderigheid.",
                                                    "keyWords": "zeer gevoelig",
                                                    "advice": "Jouw lichaam geeft een duidelijk signaal: het vindt lactose niet fijn. In jouw geval is het aangewezen over te schakelen op een lactosevrij voedingspatroon of dieet. Kies daarbij voor plantaardige alternatieven voor zuivel zoals amandel- of rijstmelk.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT",
                                            "name": "Zout",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig gevoelig",
                                                    "tag": "RESULT_DNA_NUTRITION_RESTRICTIES_ZOUT_LAAG",
                                                    "resultText": "Uit jouw DNA-analyse kunnen we opmaken dat je beschikt over een normale gevoeligheid voor zout. Er is voor jou geen grotere kans op verhoogde bloeddruk als je een normale hoeveelheid zout eet.",
                                                    "keyWords": "weinig gevoelig",
                                                    "advice": "Hou je aan de normale hoeveelheid zout. Voor een volwassene bedraagt die minder dan 5 gram zout (2000 milligram natrium), de aanbevolen hoeveelheid kalium per dag is 3510 milligram.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        },
                        {
                            "tag": "DASHBOARD_DNA_MOVE",
                            "name": "Beweging",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_DNA_MOVE_SPORT",
                                    "name": "Sporttype",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT",
                                            "name": "Duursport",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_DUURSPORT_HOOG",
                                                    "resultText": "Op basis van jouw DNA-analyse kunnen we opmaken dat jouw lichaam een voorkeur heeft om aan duursport te doen.",
                                                    "keyWords": "grote voorkeur",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT",
                                            "name": "Krachtsport",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "lichte voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT_MATIG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "grote voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_KRACHTSPORT_HOOG",
                                                    "resultText": "Uit jouw DNA kunnen we afleiden dat jouw lichaam een voorkeur voor krachtsporten heeft.",
                                                    "keyWords": "grote voorkeur",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN",
                                            "name": "Sportprofiel",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "duursporter",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN_DUURSPORT",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "kracht- en duursporter",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN_GEMENGD",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "kracht- en duursporter",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN_GEMENGD",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "kracht- en duursporter",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SPORTPROFIEL_SPORTEN_GEMENGD",
                                                    "resultText": "Wat jouw sportprofiel betreft, kunnen we concluderen dat jouw lichaam een lichte voorkeur voor zowel kracht- als duursport heeft.",
                                                    "keyWords": "kracht- en duursporter",
                                                    "advice": "Als jij op zoek bent naar een geschikte sport, kan je op basis van jouw genen zowel voor duur- als krachtsport gaan. Keuze zat dus! Ideale duursporten zijn lopen, zwemmen of andere gelijkaardige sporten met een matige intensiteit maar een langere duur. Ga ook voor sprinten en high intensity intervaltrainingen.\n\nKrachtsport wordt vooral gekenmerkt door intensieve oefeningen met focus op kracht, snelheid en weerstandstrainingen. Denk bijvoorbeeld aan oefeningen met gewichten, fitness en crossfit. \n\nAls je gewichtstrainingen doet, is het belangrijk jouw kracht op te bouwen voor je met zware gewichten aan de slag gaat. Eerst leren stappen voor je gaat lopen dus! Let daarnaast steeds op mogelijke blessurerisico's.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_MOVE_BLESSURE",
                                    "name": "Blessurerisico",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_GEVOELIGHEID",
                                            "name": "Blessurerisico",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger ",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_GEVOELIGHEID_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel gevoelig ",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_GEVOELIGHEID_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel gevoelig ",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_GEVOELIGHEID_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger ",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_GEVOELIGHEID_MATIG",
                                                    "resultText": "Volgens jouw DNA ben jij - zelfs bij verantwoord sporten - heel wat gevoeliger aan blessures in vergelijking met anderen.",
                                                    "keyWords": "gevoeliger ",
                                                    "advice": "Pas je frequentie en intensiteit van sporten aan aan je conditieniveau. Respecteer dat ook door niet steeds over je grenzen te gaan. Besteed altijd voldoende aandacht aan je opwarming, lenigheid en oefeningen voor flexibiliteit. Hou er ook steeds rekening mee dat een blessure acuut kan ontstaan door een val of botsing.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE",
                                            "name": "Opwarming",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "aandachtspunt",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel belangrijk",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel belangrijk",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "aandachtspunt",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_PREVENTIE_MATIG",
                                                    "resultText": "Op basis van jouw DNA-resultaten blijkt dat jij toch wat extra aandacht moet besteden aan specifieke oefeningen ter preventie van blessures.",
                                                    "keyWords": "aandachtspunt",
                                                    "advice": "Om blessures te voorkomen is het belangrijk dat je voldoende aandacht besteedt aan het opwarmen en afkoelen voor en na het sporten. Warm zeker tien tot vijftien minuten op. Als je in jouw opwarming statische en dynamische rekoefeningen integreert en/of lopen, dan mag die maximaal dertig minuten duren. De periode waarin je na het sporten afkoelt, duurt ongeveer tien minuten, maar let er ook op dat je voldoende rust tussen twee trainingen.\n\nWissel op regelmatige basis weerstands- en lenigheidsoefeningen met elkaar af. Die eerste worden gekenmerkt door trainen met een gewicht waarbij vermoeidheid ontstaat bij acht tot twaalf herhalingen. Rekken en strekken zijn dan weer typische lenigheidsoefeningen.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE",
                                            "name": "Ontstekingen",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wat gevoeliger",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "heel gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_BLESSURE_INFLAMMATIE_HOOG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat je heel wat gevoeliger bent dan anderen voor ontstekingen.",
                                                    "keyWords": "heel gevoelig",
                                                    "advice": "Geen paniek: dit resultaat betekent niet dat je altijd ontstekingen zal hebben. Vermijd overtraining, slaapgebrek, een te grote inname van cafeÃ¯ne of geraffineerde suikers en stress, want dat zijn veelvoorkomende oorzaken van (chronische) ontstekingen. Naast gezond sporten met aandacht voor opwarmen, afkoelen en eventueel weerstands- en lenigheidsoefeningen en voldoende rust, is het voor jou ook belangrijk te focussen op anti-inflammatoire voeding. Avocadoâs, gember, olijfolie en vette vis zijn ontstekingsremmend en kunnen het lichaam helpen korte metten te maken met zichtbare en onzichtbare ontstekingen. Luister vooral goed naar je lichaam: wanneer je vermoeid bent of je je ziek voelt, is het tijd om even uit te rusten. Laat ook regelmatig de zogenaamde âinflammatie markersâ in je bloed nakijken.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_MOVE_TRAINING",
                                    "name": "Trainingsschema",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD",
                                            "name": "Hersteltijd",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "ietwat langer",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "langer",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "langer",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "langer",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_HERSTELTIJD_HOOG",
                                                    "resultText": "Gebaseerd op onze analyse en interpretatie van jouw DNA-resultaten heeft jouw lichaam nood aan iets langere hersteltijden tussen trainingen.",
                                                    "keyWords": "langer",
                                                    "advice": "Bouw jouw trainingen langzaam op en plan voldoende hersteltijd tussen de trainingen in. Je hebt nood aan 24 tot 48 uur rust na een extensieve training waarbij je wel zweette, maar nog kon praten. Na een heel intensieve training kan de volledige hersteltijd zelfs drie dagen in beslag nemen. Op basis van jouw DNA raden we je aan wat extra hersteltijd te nemen: verleng de normale hersteltijd met een halve tot een volledige dag.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP",
                                            "name": "Slaap",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_SLAAP_MATIG",
                                                    "resultText": "Op basis van jouw DNA-resultaten blijkt dat jouw lichaam de neiging heeft om minder te slapen dan wat goed is voor jouw sportrecuperatie.",
                                                    "keyWords": "licht verhoogde nood",
                                                    "advice": "Sporters eisen meer van hun lichaam dan niet-sporters. Voor zowel amateurs als professionele sporters zijn slapen en sporten onlosmakelijk met elkaar verbonden. Een goede slaaphygiÃ«ne is voor jou dan ook belangrijk. Dat betekent dat je per nacht zeker zeven tot acht uren zou moeten slapen om jouw lichaam te laten herstellen.\n\nProbeer daarnaast ook elke dag ongeveer op hetzelfde tijdstip te gaan slapen. Kies ervoor om te slapen in een duistere, frisse kamer tussen 18 en 22Â°C. Vermijd ook blauw licht, bijvoorbeeld van je laptop of smartphone, vÃ³Ã³r het slapen. Dat zal je helpen om de doelstellingen van jouw trainingsschema te realiseren.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT",
                                            "name": "Intensiteit",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "matig tot laag",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT_MATIG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "matig tot laag",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT_MATIG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "matig tot laag",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT_MATIG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "matig tot laag",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_INTENSITEIT_MATIG",
                                                    "resultText": "Jouw DNA-resultaten vertellen ons dat het voor jouw lichaam aangewezen is om langdurig aan een matige tot lage intensiteit te sporten.",
                                                    "keyWords": "matig tot laag",
                                                    "advice": "We raden jou aan om te trainen met een matige intensiteit. Concreet komt dat erop neer dat je jouw hartslag tussen 60 Ã  70% van jouw maximale hartslag probeert te houden.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD",
                                            "name": "Beste tijd om te sporten",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD_GEENVOORKEUR",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD_GEENVOORKEUR",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD_AVOND",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_PERFORMANCE_SCHEMA_TIJD_GEENVOORKEUR",
                                                    "resultText": "Het onderzoek naar je DNA gaf aan dat jouw lichaam geen specifieke voorkeur qua tijdstip om te sporten heeft.",
                                                    "keyWords": "geen specifieke voorkeur",
                                                    "advice": "In jouw geval is er geen ideaal trainingsmoment, wat betekent dat jij zowel 's ochtends, 's middags als 's avonds mag trainen. Het tijdstip zal geen impact op je sportprestaties hebben, maar probeer wel een regelmaat in te bouwen. Op die manier kan je lichaam eraan wennen en kan je jouw resultaten optimaliseren.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_MOVE_SPORTYFOOD",
                                    "name": "Sport en voeding",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI",
                                            "name": "Oxidatieve stress",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ANTIOXI_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse blijkt dat jij een verminderde weerbaarheid voor oxidatieve stress hebt.",
                                                    "keyWords": "zeer gevoelig",
                                                    "advice": "Iedereen ondervindt tijdens een inspanning enige mate van oxidatieve stress. Te veel oxidatieve stress kan leiden tot meer ontstekingen, spiervermoeidheid en -schade. Tijdens de inspanning heeft het lichaam meer zuurstof nodig, waardoor sporters meer vrije radicalen produceren. \n\nAls we onze oxidatieve stress willen verminderen is het belangrijk groenten en fruit rijk aan antioxidanten toe te voegen aan ons voedingspatroon. Die groenten en fruit kan je herkennen aan hun felle en diepgaande kleur, zoals het geval is bij blauwe bessen, bramen, veenbessen en frambozen. Ook mandarijnen, navelsinaasappels, pompelmoes, kiwi, abrikozen, mango, banaan en citroensap zijn ideaal! \n\nVoor groenten rijk aan antioxidanten kan je kijken naar rauwe gember, broccoli, rode sla, asperges, avocado, rode bieten, (rode) uien, groene sla, pepers, aubergine, bloemkool, wortels, tomaat en galangawortel.\n\nOok noten en peulvruchten (pistachenoten, pecannoten, walnoten, rode bonen, linzen ...) en kruiden zoals kurkuma, kaneel, oregano, tijm of chili zijn perfect om de oxidatieve stress te verminderen. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE",
                                            "name": "Zweten",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_HYDRATATIE_HOOG",
                                                    "resultText": "Uit jouw DNA-analyse leiden we af dat je tijdens het sporten last kan hebben van overmatig zweten.",
                                                    "keyWords": "verhoogde nood",
                                                    "advice": "Doordat jij van nature de neiging hebt om tijdens het sporten extra te zweten, raden we je aan om dagelijks minstens 1,5 liter water te drinken. Bij matige lichaamsbeweging zoals joggen of fietsen drink je beter wat extra. Ben je van plan om intensiever en langer te sporten? Drink dan voor, tijdens Ã©n na het sporten extra water om uitdroging te voorkomen. Per uur intensief sporten raden we een liter water aan.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM",
                                            "name": "Calcium",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CALCIUM_LAAG",
                                                    "resultText": "Op basis van jouw DNA-resultaten blijkt dat je geen verhoogde nood hebt aan calcium voor jouw botstevigheid.",
                                                    "keyWords": "geen extra nood",
                                                    "advice": "Doordat jij geen genetische aanleg hebt voor verlaagde calciumniveaus volstaat het voor jou om gezond en gevarieerd te blijven eten. Extra calcium innemen is voor jou dan ook niet noodzakelijk.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE",
                                            "name": "CafeÃ¯ne",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "minder gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "gunstig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_CAFEINE_LAAG",
                                                    "resultText": "Op basis van jouw DNA-analyse blijkt dat jij cafeÃ¯ne snel afbreekt.",
                                                    "keyWords": "gunstig effect",
                                                    "advice": "Omdat jij cafeÃ¯ne snel afbreekt, kan je een maximaal voordeel halen uit cafeÃ¯ne door die minder dan een uur voor de aanvang van jouw training of wedstrijd in te nemen. Afhankelijk van hoelang je sport, kan je tijdens de training of wedstrijd extra cafeÃ¯ne innemen.\n\nHet is heel simpel om te berekenen hoeveel cafeÃ¯ne je nodig hebt om effect te ervaren. De ondergrens ligt op 3 mg/kg lichaamsgewicht, de bovengrens op 6 mg/kg. Wanneer je die bovengrens overschrijdt, verdwijnen de voordelen en ervaar je nadelen.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ZOUT",
                                            "name": "Zout",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale gevoeligheid",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ZOUT_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "gevoeliger",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ZOUT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "zeer gevoelig",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ZOUT_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "normale gevoeligheid",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_ZOUT_LAAG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat jij een normale gevoeligheid voor zout hebt.",
                                                    "keyWords": "normale gevoeligheid",
                                                    "advice": "Doordat jij een normale gevoeligheid voor zout hebt, kan sportvoeding met voldoende zouten een positief effect op jou hebben. Dat heeft heel wat voordelen!\n\nZo stimuleert de inname van zout het dorstgevoel, waardoor je meer zal drinken en minder kans op uitdroging hebt. Het leidt ook tot een betere opname van water en koolhydraten, wat dan weer energie geeft en spiervermoeidheid tegengaat.\n\nZout innemen tijdens het sporten zorgt er ook voor dat wanneer het water is opgenomen in de darm, het beter wordt vastgehouden door het lichaam. Daardoor functioneert je lichaam beter en gaan je sportprestaties erop vooruit.\n\nWe raden je dan ook aan om tijdens lange inspanningen en inspanningen wanneer het warm is sportvoeding te eten die voldoende zouten bevat. Onderzoek toont aan dat 450 mg natrium of 1 g zout inname per uur sporten aanbevolen is om de lichaamsfuncties - en dus sportprestaties - zo goed mogelijk te houden.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN",
                                            "name": "Suikers",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matige verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_KOOLHYDRATEN_MATIG",
                                                    "resultText": "Op basis van jouw DNA-resultaten blijkt dat jouw lichaam koolhydraten matig verwerkt.",
                                                    "keyWords": "matige verwerking",
                                                    "advice": "Probeer je inname van vrije suikers tot slechts 5% van je dagelijkse energie-inname te beperken. Snelle suikers zijn voor jou goede energiebronnen tijdens het sporten. De laatste uren vÃ³Ã³r je van start gaat, moet je voorzichtig zijn met eten. \n\nAls je kort voor het sporten nog allerlei hapjes naar binnen werkt, kan je maag flink van streek raken. Bovendien krijgt je lichaam het dan te druk met het verteren van de voeding. Het is een goede richtlijn om twee tot drie uur vÃ³Ã³r de wedstrijd voor het laatst te eten. Na zoân anderhalf uur intensieve inspanning begint de voorraad koolhydraten in je lichaam op te raken. Om je spieren van voldoende energie te voorzien, moet je dus snel opneembare koolhydraten naar binnen werken. Dat kan bijvoorbeeld door een sportdrankje te drinken - zeer handig tijdens het hardlopen - of door wat te eten. Dat laatste is natuurlijk eenvoudiger als je op de fiets zit. In zoân geval kan je een stuk fruit, een mueslireep of een boterham met zoet beleg meenemen. Let uiteraard altijd op mogelijke intoleranties.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_IJZER",
                                            "name": "Ijzer",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "sterk verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_IJZER_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_IJZER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "geen extra nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_IJZER_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "licht verhoogde nood",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_IJZER_MATIG",
                                                    "resultText": "Op basis van jouw DNA-analyse kunnen we concluderen dat jouw lichaam in lichte mate de neiging heeft tot een verlaagd transferrinegehalte van het plasma en lagere ijzerwaarden.",
                                                    "keyWords": "licht verhoogde nood",
                                                    "advice": "Zelfs als je, zoals in jouw geval, geen verhoogd risico op een ijzertekort hebt, is het belangrijk een gezond en gevarieerd eetpatroon te volgen. Doordat je sport, verhoogt de vraag naar ijzer in je lichaam. Wanneer je minder ijzer uit voeding opneemt dan er wordt ingenomen, loop je dus alsnog kans op bloedarmoede.\n\nEr zijn heel wat voedingsmiddelen die (veel) ijzer bevatten, zoals vlees, vis, granen, aardappelen, peulvruchten, bonen en groenten. De opname van ijzer wordt gestimuleerd in een zure 'omgevingâ. Combineer je eten met bijvoorbeeld sinaasappelsap dat rijk is aan vitamine C. Anderzijds wordt de opname afgeremd door melk, thee en koffie.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA",
                                            "name": "BCAA",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA_LAAG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "normale verwerking",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOEDING_BCAA_LAAG",
                                                    "resultText": "Volgens jouw DNA-analyse heeft jouw lichaam een normale verwerking van BCAA's.",
                                                    "keyWords": "normale verwerking",
                                                    "advice": "Als jij extra valine of leucine zou innemen zal jij weinig tot geen verschillen in jouw sportprestaties opmerken. Een gezond en gevarieerd voedingspatroon blijft voor jou uiterst belangrijk.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_MOVE_VOORDEEL",
                                    "name": "Voordeel van sporten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT",
                                            "name": "Gewicht en sporten",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "weinig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT_LAAG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "weinig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_GEWICHT_LAAG",
                                                    "resultText": "Op basis van jouw DNA-resultaten kunnen we afleiden dat extra bewegen weinig tot geen effect zal hebben wanneer je gewicht wil verliezen of behouden.",
                                                    "keyWords": "weinig effect",
                                                    "advice": "Extra beweging mag dan misschien weinig merkbaar effect op jouw gewicht hebben, toch raden we je aan om in functie van je algemene gezondheid voldoende actief te blijven bewegen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA",
                                            "name": "Bijkomen in spiermassa",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke aanmaak",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke aanmaak",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "moeilijke aanmaak",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "vlotte aanmaak",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_SPIERMASSA_LAAG",
                                                    "resultText": "Als jij op krachtoefeningen zou werken, dan zou dat volgens ons DNA-onderzoek een gunstig effect op jouw spiermassa hebben.",
                                                    "keyWords": "vlotte aanmaak",
                                                    "advice": "Jouw lichaam maakt op een normale wijze spiermassa aan. Als je net dat tikkeltje meer wil, is het aangeraden om krachtoefeningen met een gezond en gevarieerd eetpatroon te combineren.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        },
                                        {
                                            "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL",
                                            "name": "Bewegen en HDL",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "matig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "weinig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL_LAAG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "weinig effect",
                                                    "tag": "RESULT_DNA_PERFORMANCE_VOORDEEL_HDL_LAAG",
                                                    "resultText": "Uit jouw DNA-onderzoek blijkt dat bewegen geen bijkomende invloed op jouw goede cholesterol (HDL) heeft.",
                                                    "keyWords": "weinig effect",
                                                    "advice": "Sowieso is bewegen goed voor je gezondheid Ã©n verlaagt het de kans op hart- en vaataandoeningen. Blijf dan ook bewegen! Doe wekelijks verspreid over diverse dagen minstens 150 minuten aan matig intensieve inspanning. Doe je dat langer, vaker en/of intensiever? Dan heb je een extra gezondheidsvoordeel. Doe ook minstens twee keer per week activiteiten die je spieren en botten versterken.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        },
                        {
                            "tag": "DASHBOARD_DNA_STRESS",
                            "name": "Stress",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_DNA_STRESS_IMPACT",
                                    "name": "Stressimpact",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS",
                                            "name": "Stressrespons",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wisselend positief/negatief",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "eerder negatief",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wisselend positief/negatief",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wisselend positief/negatief",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_STRESSRESPONS_MATIG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat jij wisselend met stress en emotie omgaat. In sommige situaties maken stress en emoties het jou niet makkelijk, maar er is niet altijd een negatieve impact op jouw lichaam.",
                                                    "keyWords": "wisselend positief/negatief",
                                                    "advice": "Een goede balans tussen stress en ontspanning vinden is belangrijk voor jou. Besteed dan ook voldoende aandacht aan activiteiten die je kunnen helpen bij het omgaan met stress als het je even te veel wordt. Denk bijvoorbeeld aan mindfulness, meditatie, yoga of hartcoherentie. Het zijn voorbeelden van zogenaamde âcopingtechniekenâ, activiteiten rond stressmanagement die jou in lastige situaties kunnen ondersteunen. Ook sociaal contact en sporten kunnen je daarbij helpen. Zodra je weet welke situaties jou extra stress bezorgen, is het zaak die in de mate van het mogelijke te mijden.",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_STRESS_WORRIER",
                                    "name": "Worrier versus warrior",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER",
                                            "name": "Worrier versus warrior",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "wisselende stressbeleving",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "eerder worrier",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER_LAAG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "eerder warrior",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER_HOOG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "eerder worrier",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_WORRIER_LAAG",
                                                    "resultText": "Uit jouw resultaten blijkt dat jij een worrier bent: stress maakt bij jou vaak heel wat angsten los. Die innerlijke onrust en angst kunnen ertoe leiden dat je minder goed presteert doordat je vertrouwen in een situatie door stress afzwakt. Als je met depressieve gevoelens kampt of hoge en langdurige stress ervaart, is het aangeraden om extra hulp te zoeken die je kan ondersteunen.",
                                                    "keyWords": "eerder worrier",
                                                    "advice": "In situaties waarin weinig stressfactoren zijn, presteer jij goed en slaag je erin je focus te behouden. Als de zaken plots niet meer zoals gepland lopen, stapelt de stress zich op. Op basis van je DNA-analyse kunnen we opmaken dat jouw lichaam in zoân geval de neiging heeft de controle te verliezen. Het is belangrijk dat je je daarvan bewust bent en de stressvolle situaties zo veel mogelijk probeert te vermijden. Dat is uiteraard niet altijd haalbaar - ga daarom op zoek naar technieken die jou kunnen helpen om de stress onder controle te houden. Denk bijvoorbeeld aan yoga en meditatie. Als je die onder de knie hebt, zal je ondanks de stress beter kunnen presteren!",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_STRESS_BINGE",
                                    "name": "Binge eating",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING",
                                            "name": "Binge eating",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig kans",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte kans",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_BINGEEATING_HOOG",
                                                    "resultText": "Uit jouw DNA-onderzoek blijkt dat jij aanleg tot binge-eten hebt, wat betekent dat jouw lichaam bij voorkeur emotionele eetbuien verkiest om stresserende situaties te verwerken. Probeer je daarvan bewust te zijn en schakel indien nodig zeker hulp in.",
                                                    "keyWords": "verhoogde kans",
                                                    "advice": "Het kan altijd dat jouw lichaam het wat moeilijker heeft met stress of een tekort aan zelfvertrouwen. Die ervaringen kunnen zeer rot zijn, maar de drang naar eten tijdens die emotionele periodes kan onder controle gehouden worden. Probeer dat soort situaties te mijden en ga op zoek naar alternatieve manieren om met emoties om te gaan. Denk bijvoorbeeld aan yoga, meditatie of mindfulness. Nood aan extra ondersteuning? Aarzel niet om die in te schakelen! Binge-eten is niet iets waar je heel je leven mee moet kampen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_STRESS_SPANNING",
                                    "name": "Spanningsbehoefte",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_STRESS_SPANNINGSBEHOEFTE",
                                            "name": "Spanningsbehoefte",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig nood ",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_SPANNINGSBEHOEFTE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig nood ",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_SPANNINGSBEHOEFTE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig nood ",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_SPANNINGSBEHOEFTE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig nood ",
                                                    "tag": "RESULT_DNA_MENTAL_STRESS_SPANNINGSBEHOEFTE_LAAG",
                                                    "resultText": "Op basis van jouw DNA-analyse blijkt dat jij geen specifieke drang hebt om altijd op zoek te gaan naar nieuwe stimuli, prikkels en uitdagingen.",
                                                    "keyWords": "weinig nood ",
                                                    "advice": "Impulsieve beslissingen en ondoordachte stappen zijn volgens jouw genen niet de weg die jouw lichaam verkiest. Natuurlijk betekent dat resultaat niet dat jij nooit een impulsieve beslissing kan of mag nemen, jouw DNA vertelt ons enkel dat jij meestal wel controle over jouw gedrag hebt.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        },
                        {
                            "tag": "DASHBOARD_DNA_SLEEP",
                            "name": "Slaap",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_DNA_SLEEP_OCHTEND",
                                    "name": "Chronotype",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE",
                                            "name": "Chronotype",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_GEENVOORKEUR",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_GEENVOORKEUR",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "avond",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_AVOND",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen specifieke voorkeur",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CHRONOTYPE_GEENVOORKEUR",
                                                    "resultText": "Uit jouw DNA-resultaten leiden we af dat jouw lichaam geen voorkeur voor ochtenden of avonden heeft.",
                                                    "keyWords": "geen specifieke voorkeur",
                                                    "advice": "Jij presteert zowel vroeg in de ochtend als laat op de avond. Ideaal, want zo heb je heel wat ruimte bij het inplannen van taken, opdrachten, evenementen en prestaties. Let wel op dat je jouw lichaam voldoende rust en regelmaat geeft. Als je te flexibel omspringt met die 'vrijheid in planningsmogelijkheden' zou dat kunnen leiden tot een onregelmatig slaap- en eetpatroon.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_SLEEP_HOEVEEL",
                                    "name": "Hoeveelheid slaap",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR",
                                            "name": "Hoeveelheid slaap",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "hoge nood",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR_LANG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "geen verhoogde nood",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR_GEEN",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "hoge nood",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR_LANG",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "stringValue": "weinig nood",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_DUUR_KORT",
                                                    "resultText": "Uit jouw DNA-analyse kunnen we afleiden dat jij minder uren slaap nodig hebt dan de gemiddelde persoon. Toch is en blijft slaap wel degelijk belangrijk!",
                                                    "keyWords": "weinig nood",
                                                    "advice": "Het onderzoek naar jouw genen wijst uit dat 7 uur slaap per nacht in jouw geval voldoende is. Doordat je minder nood aan slaap hebt, ben je vatbaarder om een slaaptekort op te bouwen. Dat kan op zijn beurt een effect op jouw immuunsysteem hebben, waardoor je sneller infecties kan oplopen. Probeer daar dus op te letten!",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_SLEEP_CAFEINE",
                                    "name": "CafeÃ¯ne en slaap",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE",
                                            "name": "CafeÃ¯ne en slaap",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "lichte hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig hinder",
                                                    "tag": "RESULT_DNA_MENTAL_SLAAP_CAFEINE_LAAG",
                                                    "resultText": "Volgens jouw DNA-analyse breek jij cafeÃ¯ne zeer snel af. Daarom zal jij weinig tot geen effect ervaren als je vlak voor het slapen cafeÃ¯ne inneemt.",
                                                    "keyWords": "weinig hinder",
                                                    "advice": "Als slaapmutsje kan een koffie of een ander drankje dat cafeÃ¯ne bevat in jouw geval geen kwaad. Het zal jou niet nodeloos wakker houden, maar overdrijf er ook niet mee.",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        },
                        {
                            "tag": "DASHBOARD_DNA_MIDDELEN",
                            "name": "Middelen",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_DNA_MIDDELEN_ROOKVERSLAVING",
                                    "name": "Rookverslaving",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING",
                                            "name": "Rookverslaving",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_VERSLAVING_MATIG",
                                                    "resultText": "De kans dat jij een rookverslaving ontwikkelt, is een beetje hoger in vergelijking met anderen. Dat betekent dat als jij begint te roken - op basis van jouw DNA - de kans op afhankelijkheid van een sigaret wel degelijk aanwezig is. Pas daar dus mee op, want roken is verslavend Ã©n schadelijk voor de gezondheid.",
                                                    "keyWords": "verhoogde kans",
                                                    "advice": "Mocht het zo zijn dat je rookt, is het zeer belangrijk dat je stopt. Daarvoor kan je uiteraard altijd hulp inschakelen. Wist je dat dat je slaagkansen vergroot? Van de mensen die zonder hulp afkicken, is 3 tot 5 procent langer dan 1 jaar gestopt, terwijl 23% van mensen onder begeleiding gemiddeld langer dan 1 jaar gestopt is. Ben je een niet-roker? Houden zo!",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_MIDDELEN_ZWAREROKER",
                                    "name": "Zware roker",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL",
                                            "name": "Zware roker",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL_HOOG",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "weinig kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_HOEVEEL_LAAG",
                                                    "resultText": "Uit jouw DNA-resultaten blijkt dat jij - als je rookt - geen verhoogd risico hebt om een zware roker te zijn of te worden. Dat betekent natuurlijk niet dat jij zonder gevaar kan roken, want het blijft verslavend Ã©n ongezond!",
                                                    "keyWords": "weinig kans",
                                                    "advice": "Stoppen met roken is belangrijk voor jou. Als dat niet meteen lukt, probeer dan af te bouwen en indien nodig externe hulp in te schakelen. Rook je niet? Ideaal!",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_MIDDELEN_ROOKSTOP",
                                    "name": "Rookstop",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP",
                                            "name": "Rookstop",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "mogelijk minder vlot",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "mogelijk vlot",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP_LAAG",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "mogelijk minder vlot",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "mogelijk vlot",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ROKEN_ROOKSTOP_LAAG",
                                                    "resultText": "Op basis van jouw DNA-analyse kunnen we afleiden dat bij jou - als je rookt of zou roken - de kans groot is dat je erin zal slagen te stoppen met roken.",
                                                    "keyWords": "mogelijk vlot",
                                                    "advice": "Als jij rookt, zou een rookstop voor jou vrij 'eenvoudig' moeten zijn. Dat blijkt uit jouw DNA-analyse. Toch vraagt het stoppen met roken van iedereen een inspanning. Veel rokers trachten het op eigen houtje te doen, maar dat is niet voor iedereen evident. Wanneer je wil stoppen, probeer dan uit elke poging een les te trekken. Het is geen schande eventueel extra hulp in te schakelen om jouw slaagkansen te vergroten!",
                                                    "score": 10,
                                                    "maxScore": 10,
                                                    "goalScore": 10,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_DNA_MIDDELEN_ALCOHOLVERSLAVING",
                                    "name": "Alcoholverslaving",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING",
                                            "name": "Alcoholverslaving",
                                            "values": [
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1672527600000
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711120924050
                                                },
                                                {
                                                    "riskLevel": "NEUTRAL",
                                                    "stringValue": "verhoogde kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING_MATIG",
                                                    "score": 5,
                                                    "maxScore": 10,
                                                    "goalScore": 5,
                                                    "time": 1711383360935
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "stringValue": "hoge kans",
                                                    "tag": "RESULT_DNA_MENTAL_MIDDELEN_ALCOHOL_VERSLAVING_HOOG",
                                                    "resultText": "Op basis van jouw DNA-resultaten kunnen we concluderen dat de kans op een alcoholverslaving zeker aanwezig is. Wees dus uiterst waakzaam zodat jij niet afhankelijk van alcohol wordt: overdadig alcoholgebruik is gevaarlijk, verslavend Ã©n schadelijk voor de gezondheid.",
                                                    "keyWords": "hoge kans",
                                                    "advice": "Jouw genetische gevoeligheid om afhankelijk te zijn van alcohol is hoog. Daarom is alcohol volledig links laten liggen in jouw geval de beste optie. Merk je dat je afhankelijk bent van alcohol, probeer dan hulp in te schakelen.",
                                                    "score": 0,
                                                    "maxScore": 10,
                                                    "goalScore": 0,
                                                    "time": 1711438861261
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "DNA"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        }
                    ],
                    "results": []
                },
                {
                    "tag": "DASHBOARD_BLOOD",
                    "name": "DASHBOARD_BLOOD",
                    "groups": [
                        {
                            "tag": "DASHBOARD_BLOOD_LIFESTYLE",
                            "name": "Lifestyle",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_BLOOD_LIFESTYLE_CARDIO",
                                    "name": "Hart- en vaatziekten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL",
                                            "name": "Totale cholesterol",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 173,
                                                    "intValue": 173,
                                                    "stringValue": "173",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 170,
                                                    "intValue": 170,
                                                    "stringValue": "170",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 224,
                                                    "intValue": 224,
                                                    "stringValue": "224",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROLTOTAAL_HOOG",
                                                    "resultText": "Je totale cholesterolwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Wil je je âslechteâ LDL-cholesterol verlagen en de âgoedeâ HDL-cholesterol verhogen? Trek dan je sportkleren maar aan! Door voldoende te bewegen en gevarieerd te eten kom je al een heel eind. Dat laatste doe je onder andere door veel groenten, fruit en voedingsvezels te eten en je zoutgebruik te minderen. Probeer daarnaast ook zo veel mogelijk verzadigd vet in je eten te vervangen door onverzadigd vet.\n\nDoor je voeding aan te passen kun je je cholesterolgehalte met zoân 10 procent verlagen! Door daarnaast ook plantensterolen te gebruiken kun je het nog eens met 10 procent doen dalen. Die plantensterolen zijn vetachtige stoffen die je, uiteraard, in planten vindt. Qua structuur lijken ze heel erg op cholesterol, maar ze zorgen ervoor dat cholesterol minder opgenomen wordt in de darmen. Door dagelijks 1,5 Ã  3 gram plantensterolen uit verrijkte voedingsmiddelen te gebruiken kun je je cholesterolgehalte met ongeveer 10 procent verlagen. Probeer daar ook niet mee te overdrijven, want als je meer dan 3 gram plantensterolen per dag gebruikt, daalt je cholesterolgehalte niet verder.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL",
                                            "name": "HDL of goede cholesterol",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 94,
                                                    "intValue": 94,
                                                    "stringValue": "94",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 58,
                                                    "intValue": 58,
                                                    "stringValue": "58",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 83,
                                                    "intValue": 83,
                                                    "stringValue": "83",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_HDL_NORMAAL",
                                                    "resultText": "Je HDL-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Je HDL-cholesterol kan je verder doen stijgen door een gezondere levensstijl aan te nemen. Denk bijvoorbeeld aan een veranderd voedingspatroon, met meer aandacht voor verse groenten en fruit. Deze bevatten veel gezonde vezels. Daarnaast is het ook belangrijk om gezonde, onverzadigde vetten te eten. Die vind je in noten en zaden of avocado, maar ook in vette vis in de vorm van omega 3. Probeer ook regelmatig te bewegen. Dat kan door simpelweg iedere dag een wandeling te maken. Ben je een roker? Dan stop je daar best mee, aangezien het een negatieve invloed heeft op de cholesterol.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL",
                                            "name": "LDL of slechte cholesterol",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 67,
                                                    "intValue": 67,
                                                    "stringValue": "67",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 96,
                                                    "intValue": 96,
                                                    "stringValue": "96",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 124,
                                                    "intValue": 124,
                                                    "stringValue": "124",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 67,
                                                    "intValue": 67,
                                                    "stringValue": "67",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_LDL_NORMAAL",
                                                    "resultText": "Je LDL-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Wil je je cholesterolniveau goed onder controle houden? Topplan! Tracht te streven naar waarden lager dan 100 mg/dl. Het belangrijkste is om te beginnen of blijven bewegen. Probeer dat ongeveer dagelijks een halfuurtje te doen, om zo wekelijks aan 2,5 uur beweging te komen. Hoe meer je dat doet, hoe lager je LDL-waarden en hoe hoger je HDL-waarden zullen zijn. Wat soms ook kan helpen is gewicht verliezen, al hangt het niet alleen daarvan af. Slechts 5 tot 10 procent van je lichaamsgewicht kan een grote invloed hebben op het verlagen van je cholesterol.\n\nZoals steeds speelt een gezond dieet een belangrijke rol. Probeer verzadigde vetten te mijden, want zij bedekken je lichaam met cholesterol. Je vindt deze vetten onder andere in zuivel en vet vlees. Die kan je vervangen door mager, âhuidloosâ vlees. Vermijd daarnaast ook transvetten, die onder andere in commercieel verpakte bakkerijproducten zoals koekjes en crackers zitten. Betere tussendoortjes zijn hele granen, fruit, noten en groenten.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING",
                                            "name": "Cholesterolratio",
                                            "unit": "ratio",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.85,
                                                    "stringValue": "1.85",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.92,
                                                    "stringValue": "2.92",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.69,
                                                    "stringValue": "2.69",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_CHOLESTEROL_VERHOUDING_NORMAAL",
                                                    "resultText": "Je verhouding totale cholesterol/HDL-cholesterol is normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Cholesterol wordt voor grotendeels in de lever aangemaakt. Door een gezonde levensstijl kun je de cholesterol blijvend positief beÃ¯nvloeden. Een optimale cholesterolratio is lager dan 4. Onder een gezonde levensstijl verstaan we een gezond gewicht, gezonde voeding, voldoende beweging en niet roken.\n\n  * Gezond gewicht. Het risico op een te hoge cholesterol is al veel lager bij een gezond gewicht. Een paar kiloâs eraf heeft al een gunstig effect!\n\n\n  * Gezond eten. Cholesterol in voeding wordt via de darmen opgenomen in het bloed en naar de lever gebracht, maar daarnaast kan de cholesterol ook beÃ¯nvloed worden door andere voedingsstoffen. Zo zorgen verzadigde (verkeerde) vetten en transvetten voor een stijging van de slechte LDL-cholesterol. Verzadigde vetten zitten vooral in dierlijke producten als volle melkproducten, worstsoorten en vette vlees(waren). Transvetten zitten met name in de lekkere extraâs zoals koek, gebak, chocolade, chips, zoutjes en andere snacks. Voedingsvezels en onverzadigde (okÃ©) vetten zorgen juist voor een daling van de slechte LDL-cholesterol. Voedingsvezels zitten in volkoren graanproducten, fruit en groenten. Denk bij onverzadigde vetten aan plantaardige olie, noten, avocado en vis. Vis bevat echter ook weer DHA, een omega 3-vetzuur dat de LDL-cholesterol doet stijgen. Het is daarom belangrijk vis met mate te nemen.\n\n\n  * Voldoende lichaamsbeweging zorgt voor een verlaging van de LDL-cholesterol, doordat de HDL-cholesterol verhoogd wordt. De verhoging van de HDL-cholesterol is een voordeel dat de meeste medicatie niet eens heeft! Dagelijks een halfuur matig intensief bewegen is voldoende.\n\n\n  * Niet roken. Roken leidt tot vernauwing en beschadigingen van de bloedvaten, waardoor de LDL-cholesterol zich beter kan hechten aan de wand. Daarnaast verlaagt roken de hoeveelheid HDL-cholesterol, waardoor de LDL-cholesterol niet voldoende afgevoerd kan worden.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN",
                                            "name": "Triglyceriden",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 62,
                                                    "intValue": 62,
                                                    "stringValue": "62",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 77,
                                                    "intValue": 77,
                                                    "stringValue": "77",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 85,
                                                    "intValue": 85,
                                                    "stringValue": "85",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_TRIGLYCERIDEN_NORMAAL",
                                                    "resultText": "Je triglyceridenwaarden zijn neutraal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Zoals wel vaker in dit rapport is het ook voor je triglyceridenwaarden belangrijk om een gezonde levensstijl te hanteren. Tracht steeds te streven naar triglyceridewaarden lager dan 100 mg/dl. Matig de verzadigde vetten die je binnenkrijgt en zorg vooral dat je voldoende groenten eet. Beperk ook je alcoholverbruik en probeer 30 minuten per dag te bewegen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_URINEZUUR",
                                            "name": "Urinezuur",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 3.8,
                                                    "stringValue": "3.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_URINEZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.8,
                                                    "stringValue": "4.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_URINEZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.1,
                                                    "stringValue": "4.1",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_URINEZUUR_NORMAAL",
                                                    "resultText": "Je urinezuurwaarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Wat je eet, bevat vaak purinehoudende voedingsstoffen die kunnen bijdragen tot een verhoging van het urinezuur. Door je dieet te wijzigen kan je de productie van urinezuur dus verlagen! We kunnen voeding opdelen in drie categorieÃ«n:\n\n * Voedsel met een hoog purinegehalte: wild, gans, sardines, haring, ansjovis, forel, zalm, kabeljauw, zeevruchten (kreeft, mosselen, oesters) orgaanvlees, peulvruchten en spinazie.\n  * Voedsel met een gemiddeld purinegehalte: konijn, schaap, rund, kalf, duif, kalkoen, eend, schaaldieren, asperges, paddenstoelen en bloemkool.\n  * Voedsel waarin weinig of geen purines zitten: fruit, melk, kaas, bladgroenten, eieren, rijst, deegwaren, granen, brood, aardappelen en jam of confituur.\n\nDrink ook voldoende water. Gesuikerde dranken, ook de lightvarianten, geven namelijk een verhoogd urinezuurgehalte in je bloed.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP",
                                            "name": "hsCRP",
                                            "unit": "mg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.2,
                                                    "stringValue": "1.2",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<4.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 1.08,
                                                    "stringValue": "1.08",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP_HOOG",
                                                    "resultText": "Je hsCRP-waarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Om je hsCRP-niveau laag te krijgen speelt een gezonde levensstijl een belangrijke rol. Genoeg lichaamsbeweging, voldoende ontspanning en een gezond voedingspatroon zijn enkele voorbeelden die je daarbij kunnen helpen. Voedsel en dranken met veel suikers kunnen het best vermeden of in kleine hoeveelheden genuttigd worden. Broccoli, vette vis en groene thee zijn voedingsmiddelen die worden aanbevolen om het hsCRP-niveau te verlagen.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HOMOCYSTEINE",
                                            "name": "HomocysteÃ¯ne",
                                            "unit": "Âµmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.83,
                                                    "stringValue": "4.83",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HOMOCYSTEINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 6.96,
                                                    "stringValue": "6.96",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HOMOCYSTEINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "NOT_AVAILABLE",
                                                    "stringValue": "onbepaald",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HOMOCYSTEINE_ERROR",
                                                    "resultText": "Je homocysteÃ¯newaarden werden niet bepaald",
                                                    "keyWords": "onbepaald",
                                                    "advice": "Neem contact op met het Leadlife-team om je waarde opnieuw te laten bepalen via support@leadlife.com.",
                                                    "score": 0,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1672527600000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_LIFESTYLE_SUIKER",
                                    "name": "Diabetes type 2",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_GLUCOSE",
                                            "name": "Glucose",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 90,
                                                    "intValue": 90,
                                                    "stringValue": "90",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_GLUCOSE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 80,
                                                    "intValue": 80,
                                                    "stringValue": "80",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_GLUCOSE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 87,
                                                    "intValue": 87,
                                                    "stringValue": "87",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_GLUCOSE_NORMAAL",
                                                    "resultText": "Je glucosewaarden nuchter zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Iedereen heeft een andere energiebehoefte. Als je veel beweegt, heb je uiteraard meer energie nodig dan iemand die weinig beweegt. Bovendien hebben we allemaal een bepaalde glucosetolerantie. Dat is de mate waarin je lichaam glucose uit het bloed kan verwerken. Als je gezond en gevarieerd eet, krijg je dagelijks voldoende koolhydraten en dus glucose binnen. Als je een gezonde glucosetolerantie hebt, is de bloedsuiker binnen twee uur na een maaltijd weer op peil. Sommige mensen hebben een verminderde glucosetolerantie. Alles werkt dan net iets trager. De bloedsuiker is dan veel te hoog, maar dat wordt snel gecorrigeerd door het lichaam. Probeer te mikken op nuchtere glucosewaarden tussen de 70 mg/dl en 95 mg/dl.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE",
                                            "name": "Insuline",
                                            "unit": "mU/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 8.7,
                                                    "stringValue": "8.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4,
                                                    "stringValue": "4.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 3.7,
                                                    "stringValue": "3.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "doubleValue": 4,
                                                    "intValue": 4,
                                                    "stringValue": "4",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_INSULINE_LAAGLAAG",
                                                    "resultText": "Je insulinewaarden nuchter zijn sterk verlaagd.",
                                                    "keyWords": "sterk verlaagd",
                                                    "advice": "Insuline wordt aangemaakt in de alvleesklier of pancreas en zorgt ervoor dat suiker vanuit je bloed wordt opgenomen in je cellen. Wanneer je lichaam onvoldoende insuline aanmaakt, verloopt die opname van suiker dus minder vlot en stijgt het suikergehalte in je bloed. Te veel suiker in je bloed kan je bloedvaten beschadigen. De productie van insuline wordt gestimuleerd door voedingsproducten met een hoge glycemische lading. Denk bijvoorbeeld aan 120 gram rozijnen of een portie aardappelen.",
                                                    "score": 0,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C",
                                            "name": "HbA1c",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5.4,
                                                    "stringValue": "5.4",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5,
                                                    "stringValue": "5.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5.5,
                                                    "stringValue": "5.5",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HBA1C_NORMAAL",
                                                    "resultText": "Je HbA1c-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Door je levensstijl hier en daar bij te sturen kan je al heel wat doen om je bloedsuikerspiegel stabiel te houden:\n \n  * Verminder je suikerinname uit zoetigheden, koekjes en bewerkt voedsel.\n  * Vervang de snelle koolhydraten door complexe koolhydraten zoals in granen, bonen en noten.\n  * Afwisselend vasten of je maaltijdfrequentie verlagen wordt steeds belangrijker. Een studie in het World Journal of Diabetes claimt dat afwisselend vasten helpt om het bloedsuikerniveau te verbeteren en gewicht te verliezen. De lange periode van vasten fixeert de bloedsuiker en de stofwisseling (het metabolisme) gaat over op het verbranden van vetreserves.\n  * Eet minder verzadigde vetten. Een teveel aan verzadigde vetten kan leiden tot overgewicht, en dat alleen al heeft een heel grote invloed op je bloedsuikerspiegel.\n  * Eet geen transvetten. Niet alleen neemt de kans op overgewicht toe bij consumptie van te veel transvetten, ook krijg je last van inflammatie, zoals bij kunstmatige suikers. Deze ontstekingen in je lichaam hebben een grote invloed op je bloedsuikerspiegel.\n  * Eet wel meer onverzadigde vetten. Die vetten hebben precies de tegenovergestelde effecten op je gezondheid in vergelijking met transvetten. Onverzadigde vetten zorgen ervoor dat je hart- en vaatstelsel gezond en soepel blijft. Daarnaast werken ze ontstekingsremmend. Ontstekingen leiden tot een hoge bloedsuikerspiegel en dat is precies datgene wat door onverzadigde vetten te eten wordt voorkomen.\n  * Eet meer eiwitten. Van alle voedingsgroepen hebben eiwitten de minste invloed op je bloedsuikerspiegel. Door een groter deel van je dieet uit eiwitten te laten bestaan heb je dus wel de energie, maar niet de stijging van je bloedsuikerspiegel.\n  * Drink minder cafeÃ¯ne.\n  * Laat ook alcohol links liggen. Zoals je misschien wel weet, is je alvleesklier verantwoordelijk voor de aanmaak van insuline. Diezelfde alvleesklier maakt ook deel uit van de groep organen die belast is met het verwijderen van alcohol uit je systeem. Als je dus regelmatig alcohol drinkt, belast je de alvleesklier onnodig.\n  * Beweeg voldoende en op regelmatige basis. Meer bewegen vermindert de insulineresistentie en heeft tot gevolg dat je meer calorieÃ«n verbrandt. Er zit wel een addertje onder het gras: je moet consistent bewegen om een effect te hebben.\n  * Slaap voldoende. Wanneer je te weinig slaapt, kan je problemen krijgen met je cellen voor insuline. Tracht minimaal 6 Ã  7 uur per nacht te slapen.\n  * Wees stress de baas. Stresshormonen jagen je bloedsuikerspiegel omhoog. Op het moment dat jouw hersenen een potentiÃ«le noodsituatie detecteren, schakelt dit mechanisme in en je kunt het niet stoppen. Wat je wel kan doen, is stresssituaties leren beheersen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_SHBG",
                                            "name": "SHBG",
                                            "unit": "nmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 101,
                                                    "stringValue": "101.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_SHBG_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 40.3,
                                                    "stringValue": "40.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_SHBG_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 41,
                                                    "stringValue": "41.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_SHBG_NORMAAL",
                                                    "resultText": "Je SHBG-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Wil jij je SHBG goed onder controle blijven houden? Let dan op deze aspecten en onthoud dat je SHBG-waarden kunnen variÃ«ren naargelang je leeftijd:\n\n* Houd je gewicht onder controle. SHBG daalt wanneer ons gewicht stijgt. Dat geldt ook voor het omgekeerde: ondergewicht kan leiden tot verhoogde SHBG-waarden.\n* Eet gevarieerd: eiwitten en vezels staan centraal in het onder controle houden van je SHBG-waarden.\n* Beweeg op regelmatige basis.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR",
                                            "name": "HOMA-IR",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 1.13,
                                                    "stringValue": "1.13",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.51,
                                                    "stringValue": "0.51",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.48,
                                                    "stringValue": "0.48",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 16,
                                                    "intValue": 16,
                                                    "stringValue": "16",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 96,
                                                    "intValue": 96,
                                                    "stringValue": "96",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIR_NORMAAL",
                                                    "resultText": "Je HOMA-IR-waarde is een berekende waarde.",
                                                    "keyWords": "berekende waarde",
                                                    "advice": "Een ideale HOMA-IR-index is rond 1%. Wees insulineresistentie steeds een stap voor en houd rekening met deze aspecten: \n\n  * Eet langzaam verterend voedsel\n  * Sport kort, maar krachtig\n  * Eet minder koolhydraten\n  * Slaap voldoende\n  * Drink groene thee\n  * Streef naar een gezond gewicht\n  * Gebruik kruiden zoals gember, kaneel, ginseng, appelazijn of kurkuma\n\nIs je waarde hoger dan 1%? Weet dan dat insulineresistentie meerdere oorzaken kan hebben. Vaak is het dan ook een combinatie van meerdere factoren. Zoals bij iedere lichamelijke klacht is er een genetische component, maar hoe je leeft kan ervoor zorgen dat bepaalde genen tot uiting komen. Als we kijken naar levensstijl dan zien we een aantal dingen die de kans verhogen op insulineresistentie:\n\n  * Overgewicht en veel buikvet of orgaanvet\n  * Een hoge inname van sterk bewerkte (geraffineerde) voedingsmiddelen met toegevoegde suikers die de bloedsuiker snel laten stijgen\n  * Inactief leven \n  * Chronische stress \n  * Laaggradige ontstekingen door bijvoorbeeld voedselovergevoeligheden, âlekkende darmsyndroomâ, onbalans in de darmbacteriÃ«n, hoge suikerinname en stress.\n  * Roken\n  * Hoge alcohol- en fructoseconsumptie (alcoholische en niet-alcoholische leververvetting) \n  * Zwangerschap (zwangerschapsresistentie en zwangerschapsdiabetes) \n  * Slaaptekort (slaapgebrek) \n  * Gebruik van bepaalde medicijnen zoals corticosteroÃ¯den \n\nMaak voor jezelf even de balans op. Aan welke factoren kan je werken?",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIS",
                                            "name": "HOMA %S",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 88.7,
                                                    "stringValue": "88.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIS_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 197.3,
                                                    "stringValue": "197.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIS_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 208.6,
                                                    "stringValue": "208.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIS_NORMAAL",
                                                    "resultText": "Je HOMA-IS-waarde is een berekende waarde.",
                                                    "keyWords": "berekende waarde",
                                                    "advice": "HOMA-IS geeft een indicatie van de insulinegevoeligheid van je lichaam. Hoe hoger deze waarde is, hoe gevoeliger je cellen zijn voor insuline en dus hoe beter jouw lichaam suikers verwerkt. Lagere waarden worden geassocieerd met verminderde insulinegevoeligheid, wat kan wijzen op insulineresistentie. Idealiter heb je een HOMA-IS die 100 is (of hoger). Over het algemeen wordt een hogere HOMA-IS-waarde geassocieerd met een betere bÃ¨tacelfunctie. Of omgekeerd: als de insulinegevoeligheid is gedaald, zullen de bÃ¨tacellen meer actief moeten zijn om een normale nuchtere bloedsuikerspiegel te kunnen blijven behouden.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB",
                                            "name": "HOMA %B",
                                            "unit": "10^6/Âµl",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 103.5,
                                                    "stringValue": "103.5",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 63.2,
                                                    "stringValue": "63.2",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 74,
                                                    "intValue": 74,
                                                    "stringValue": "74",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 22,
                                                    "intValue": 22,
                                                    "stringValue": "22",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DIABETES_HOMAIB_NORMAAL",
                                                    "resultText": "Je HOMA-IB-waarde is een berekende waarde.",
                                                    "keyWords": "berekende waarde",
                                                    "advice": "HOMA-IB geeft een indicatie van de bÃ¨tacelactiviteit van je pancreas. De bÃ¨tacellen van je pancreas zijn de cellen die insuline aanmaken. Als je HOMA-IB-waarde verhoogd is, wijst dit op het feit dat jouw pancreas âoverurenâ aan het draaien is om een normale suikerstofwisseling te kunnen blijven behouden en dat je lichaam het lastig heeft om suiker te verwerken. Idealiter is de HOMA-IB-waarde rond de 100. Waarden boven de 100 tonen aan dat jouw pancreas het lastig heeft met de suikerstofwisseling.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_LIFESTYLE_SAMENSTELLING",
                                    "name": "Bloedsamenstelling",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_BLOED_MCV",
                                            "name": "MCV",
                                            "unit": "fl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 92.2,
                                                    "stringValue": "92.2",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_MCV_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 89.4,
                                                    "stringValue": "89.4",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_MCV_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 96.8,
                                                    "stringValue": "96.8",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_MCV_NORMAAL",
                                                    "resultText": "Je MCV-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Jouw rode bloedcellen hebben een normale grootte. Toch kan je met een normale MCV bloedarmoede hebben als er te weinig rode bloedcellen zijn of als andere RBC-indices abnormaal zijn.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_BLOED_MCH",
                                            "name": "MCH",
                                            "unit": "pg",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 30.6,
                                                    "stringValue": "30.6",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_MCH_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 30.8,
                                                    "stringValue": "30.8",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_MCH_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 33,
                                                    "stringValue": "33.0",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_MCH_NORMAAL",
                                                    "resultText": "Je MCH-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Een normale MCH-waarde betekent dat je een goede concentratie van hemoglobine in je rode bloedcellen hebt. Dat zorgt voor een goede verspreiding van zuurstof door je lichaam heen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_BLOED_CONCENTRATIONMCH",
                                            "name": "MCHC",
                                            "unit": "g/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 33.3,
                                                    "stringValue": "33.3",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_CONCENTRATIONMCH_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 34.4,
                                                    "stringValue": "34.4",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_CONCENTRATIONMCH_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 34.1,
                                                    "stringValue": "34.1",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_CONCENTRATIONMCH_NORMAAL",
                                                    "resultText": "Je MCHC-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "De MCHC-waarde hangt samen met de MCH-waarde (de hoeveelheid hemoglobine die in de rode bloedcel past). Bij gezonde mensen ligt de MCHC-waarde tussen de 19 en 23 mmol/liter.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_RBC",
                                            "name": "Erythrocyten",
                                            "unit": "10^6/Âµl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.47,
                                                    "stringValue": "4.47",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_RBC_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.91,
                                                    "stringValue": "4.91",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_RBC_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.64,
                                                    "stringValue": "4.64",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_RBC_NORMAAL",
                                                    "resultText": "Je rode bloedcellen zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Gemiddeld heeft iedereen minimaal vier miljard rode bloedcellen per liter bloed. Dit is de normaalwaarde van erytrocyten. Voor een goede aanmaak van rode bloedcellen zijn een paar zaken heel belangrijk: \n\n  * Beweeg voldoende. Als we te weinig bewegen, daalt het aantal rode bloedcellen. Bovendien verhindert deze inactiviteit de aanmaak van nieuwe rode bloedcellen.\n  * Drink minder of geen alcohol. Alcohol vermindert namelijk de opname van zuurstof in het bloed. Daarnaast resulteert het drinken van veel alcohol in onvolgroeide rode bloedcellen die onvoldoende hemoglobine bevatten.\n  * Eet ijzerrijke voeding. IJzer verhoogt het aantal rode bloedcellen en helpt ze bovendien beter te functioneren, omdat het een belangrijk onderdeel is van hemoglobine.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_HEMATOCRIET",
                                            "name": "Hematocriet",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 41.2,
                                                    "stringValue": "41.2",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_HEMATOCRIET_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 43.9,
                                                    "stringValue": "43.9",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_HEMATOCRIET_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 44.9,
                                                    "stringValue": "44.9",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_HEMATOCRIET_NORMAAL",
                                                    "resultText": "Je hematocrietwaarde is normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Goede hematocrietwaarden kan je behouden door een gezonde levensstijl. Probeer te letten op deze zaken:\n\n  * Eet veel ijzerrijk voedsel, zoals tofoe, groene bladgroenten, mager rood vlees, linzen, bonen en met ijzer verrijkte ontbijtgranen en brood.\n  * Eet en drink voedsel en dranken rijk aan vitamine C.\n  * Drink geen thee of koffie bij de maaltijden, omdat die een invloed kunnen hebben op de ijzerabsorptie.\n  * Zorg voor voldoende vitamine B12 en foliumzuur in je dieet.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_WBC",
                                            "name": "Leukocyten",
                                            "unit": "10^3/Âµl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 9.18,
                                                    "stringValue": "9.18",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_WBC_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 7.65,
                                                    "stringValue": "7.65",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_WBC_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.76,
                                                    "stringValue": "4.76",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_WBC_NORMAAL",
                                                    "resultText": "Je witte bloedcellen zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Je witte bloedcellen op peil houden staat gelijk aan de opbouw van een goede weerstand. Dit zijn enkele zaken die helpen om je witte bloedcellen op peil te houden: \n\n  * Vitamine A, want deze vitamine heeft op twee manieren een belangrijke invloed op ons immuunsysteem. Ze verhoogt niet alleen de aanmaak van witte bloedcellen, maar zorgt ook voor gezonde huid- en slijmvliescellen. Die vormen de eerste verdedigingslinie tegen schadelijke stoffen. Je vindt de vitamine vooral terug in lever en vleeswaren, eidooiers, sommige vissoorten zoals gerookte paling en tonijn, volle zuivelproducten en bepaalde groenten zoals kool, spinazie, wortels en broccoli.\n  * Vitamine B6. Deze vitamine zwengelt namelijk de productie van witte bloedcellen aan, waardoor lichaamsvreemde stoffen zich niet kunnen verspreiden. Vitamine B6 zit in heel wat voeding, zoals vlees en vis, eieren, zuivelproducten, (volkoren) graanproducten, aardappelen, peulvruchten, bananen en zaden zoals zonnebloempitten en pistachenoten.\n  * Vitamine C, want die stimuleert de werking van witte bloedcellen en de aanmaak van antilichamen. Vooral groenten en fruit zitten boordevol vitamine C. Denk maar aan aardappelen, spinazie, wortels, sinaasappels, peren, broccoli en avocadoâs.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_NEUTROFIELEN",
                                            "name": "Neutrofielen",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 75.4,
                                                    "stringValue": "75.4",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_NEUTROFIELEN_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 69.7,
                                                    "stringValue": "69.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_NEUTROFIELEN_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 45.8,
                                                    "stringValue": "45.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_NEUTROFIELEN_NORMAAL",
                                                    "resultText": "Je neutrofielen zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Je kan een aantal zaken doen om de hoeveelheid neutrofielen in je lichaam op peil te houden:\n\n  * Eet veel groenten en fruit met vitamine C. Denk bijvoorbeeld aan bananen, sinaasappels, broccoli of tomaten.\n  * Voeg voedingsmiddelen toe die vitamine E en zink bevatten. Vitamine E vind je terug in amandelen, avocado's, zonnebloempitjes en olijfolie. Bronnen van zink zijn oesters, gevogelte, bonen, noten en volkorengranen.\n  * Eet veel omega 3-vetzuren. Voedingsmiddelen zoals zalm, makreel en lijnzaadolie zijn rijk aan omega 3-vetzuren.\n  * Voeg vitamine B12 toe aan je voedingspatroon. Voorbeelden zijn onder andere eieren, gevogelte, vlees, vis, melk en andere zuivelproducten.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_BASOFIELEN",
                                            "name": "Basofielen",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.7,
                                                    "stringValue": "0.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_BASOFIELEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.5,
                                                    "stringValue": "0.5",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_BASOFIELEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.6,
                                                    "stringValue": "0.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_BASOFIELEN_NORMAAL",
                                                    "resultText": "Je basofielen zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Om je basofielen binnen de normale perken te houden is het belangrijk om je blootstelling aan bekende allergenen te mijden. Typische voorbeelden zijn hooikoorts, voedselallergie of allergische reacties op medicijnen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_EOSINOFIELEN",
                                            "name": "Eosinofielen",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.4,
                                                    "stringValue": "1.4",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_EOSINOFIELEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.7,
                                                    "stringValue": "1.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_EOSINOFIELEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 8,
                                                    "stringValue": "8.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_EOSINOFIELEN_HOOG",
                                                    "resultText": "Je eosinofielen zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Het is niet uitzonderlijk om verhoogde waarden van eosinofielen te hebben. In geï¿½ï¿½ndustrialiseerde landen zijn allergische reacties de meest voorkomende oorzaak, maar wereldwijd zijn parasitaire infecties waarschijnlijk de grote boosdoener. Eosinofilie kan afhankelijk van de oorzaak gepaard gaan met een hele waaier aan mogelijke klachten. Deze klachten zijn meestal het gevolg van de onderliggende aandoening en worden zelden door de eosinofilie zelf veroorzaakt.\n\nIn de meeste gevallen zal het eosinofielgehalte dalen zodra je de onderliggende oorzaak hebt behandeld. Dat gezegd zijnde kunnen een hygiÃ«nische, gezonde levensstijl en ontstekingsremmende middelen ook helpen om een ongewoon hoog gehalte terug te dringen. Dit zijn alvast enkele zaken die je kan doen:\n\n  * Verlaag de stress in je leven. Ontspanningstechnieken zoals mediteren, yoga en spierontspanning kunnen je helpen te ontspannen wanneer je je gespannen of overbelast voelt.\n  * Verlaag je blootstelling aan gekende allergenen.\n  * Houd je huis schoon. Stofmijten kunnen een reactie veroorzaken die de eosinofielen doen stijgen.\n  * Neem dagelijks meer vitamine D. Mensen men een laag vitamine D-gehalte hebben meer kans op een hoog gehalte aan eosinofielen.\n  * Al eens gember geprobeerd? Van gember is bekend dat het de ontstekingen vermindert. Hoewel de effecten ervan nog steeds worden bestudeerd, kan gember helpen bij het verminderen van het aantal eosinofielen.\n  * Of voeg kurkuma aan je gerechten toe. Kurkuma (ook wel curcumine genoemd) kan in bepaalde situaties in staat zijn om eosinofielen te verminderen.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_LYMFOCYTEN",
                                            "name": "Lymfocyten",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 18.7,
                                                    "stringValue": "18.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_LYMFOCYTEN_LAAG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 20.3,
                                                    "stringValue": "20.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_LYMFOCYTEN_LAAG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 39.7,
                                                    "stringValue": "39.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_LYMFOCYTEN_NORMAAL",
                                                    "resultText": "Je lymfocyten zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Lymfocyten zijn witte bloedcellen die, net als alle andere bloedcellen, in ons beenmerg geproduceerd worden. Na de rijping tot actieve lymfocyten bevinden ze zich in het bloed en het lymfestelsel. Dat laatste zorgt onder andere voor de afweer van het lichaam. Zelf kan je niet veel doen om je hoeveelheid aan lymfocyten te beÃ¯nvloeden, behalve gezond en hygiÃ«nisch leven.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_MONOCYTEN",
                                            "name": "Monocyten",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 3.8,
                                                    "stringValue": "3.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_MONOCYTEN_LAAG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 7.8,
                                                    "stringValue": "7.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_MONOCYTEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 5.9,
                                                    "stringValue": "5.9",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_MONOCYTEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 39,
                                                    "intValue": 39,
                                                    "stringValue": "39",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_MONOCYTEN_LAAG",
                                                    "resultText": "Je monocyten zijn licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Een verlaagde hoeveelheid aan monocyten komt niet zo vaak voor. Je kan niet veel doen om de hoeveelheid monocyten te beÃ¯nvloeden, behalve gezond en hygiÃ«nisch leven.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_THROMBOCYTEN",
                                            "name": "Thrombocyten",
                                            "unit": "Âµg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 370,
                                                    "intValue": 370,
                                                    "stringValue": "370",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_THROMBOCYTEN_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 278,
                                                    "intValue": 278,
                                                    "stringValue": "278",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_THROMBOCYTEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 56,
                                                    "intValue": 56,
                                                    "stringValue": "56",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_THROMBOCYTEN_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 76,
                                                    "intValue": 76,
                                                    "stringValue": "76",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_THROMBOCYTEN_NORMAAL",
                                                    "resultText": "Je trombocyten zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Je kan je bloedplaatjes ook op natuurlijke wijze in balans proberen te houden: \n\n  * Eet zo veel mogelijk verse groente en fruit. Bessen, groene bladgroenten, sinaasappels, tomaten, en kiwi's kunnen je helpen de hoeveelheid bloedplaatjes te vergroten.\n  * Neem voedingsmiddelen die omega 3-vetzuren bevatten zoals vette vis, lijnzaadolie of tonijn.\n  * Slaap en rust voldoende.\n  * Beweeg! Kracht- en cardiotraining kunnen de doorbloeding in je lichaam bevorderen. Ook voldoende bewegen kan je immuunsysteem versterken.\n\nLet op: de gemiddelde levensduur van een bloedplaatje is zo'n tien dagen. Daarom dien je, om je waarden op peil te houden, bovenstaande remedies regelmatig in te zetten.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_LIFESTYLE_DETOX",
                                    "name": "Detox",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_AST",
                                            "name": "AST",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 25,
                                                    "intValue": 25,
                                                    "stringValue": "25",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_AST_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 23,
                                                    "intValue": 23,
                                                    "stringValue": "23",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_AST_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 19,
                                                    "intValue": 19,
                                                    "stringValue": "19",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_AST_NORMAAL",
                                                    "resultText": "Je AST-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Er zijn een aantal zaken die je kan doen om je AST-waarden te beÃ¯nvloeden:\n\n * Beperk je alcoholgebruik. Alcoholmisbruik zal namelijk leiden tot een toename van je AST omdat ethanol giftig is voor levercellen en die beschadigt. Af en toe wat alcohol drinken (wijn, bier, highballs of cocktails) zal geen aanzienlijke invloed hebben op je AST of andere leverenzymen. Toch zal regelmatig gematigd drinken (meer dan een paar glazen per dag) of doorzakken in het weekend zeker een impact hebben op je enzymniveaus. \n  * Probeer een supplement met kurkumapoeder. Het is het meest klinisch geteste kruid, want het is een krachtige ontstekingsremmer en antioxidant die veel organen in het lichaam helpt genezen, inclusief je lever. De meest geneeskrachtige stof in kurkuma is curcumine, waarvan is aangetoond dat die een hoog leverenzymniveau (ALT en AST) bij zowel dieren als mensen kan verminderen. De benodigde hoeveelheden om een duidelijke impact te hebben op leverenzymen zijn ongeveer 3000 mg per dag, maximaal 12 weken lang.\n  * Drink af en toe wat koffie. Onderzoek uit 2014 heeft uitgewezen dat het regelmatig drinken van matige hoeveelheden gewone of cafeÃ¯nevrije koffie de gezondheid van de lever kan verbeteren en circulatie van leverenzymen, zoals AST, kan doen afnemen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_ALT",
                                            "name": "ALT",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 18,
                                                    "intValue": 18,
                                                    "stringValue": "18",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_ALT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_ALT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_ALT_NORMAAL",
                                                    "resultText": "Je ALT-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Om je ALT-waarde normaal te houden is een gezonde levensstijl belangrijk. Dit zijn enkele zaken die je kan doen:\n\n * Drink zo weinig mogelijk alcohol. Overmatig alcoholgebruik is de meest voorkomende oorzaak van leverschade, maar zelfs matige alcoholconsumptie kan de levercellen na verloop van tijd al beschadigen.\n  * Beperk het eten van fastfood. Veel suiker en vet is slecht voor de lever, dus als je dat laat staan wordt je lever gezonder en verlaag je je ALT-waarde.\n  * Eet meer groenten en fruit, want die ontgiften het lichaam op natuurlijke wijze. Terwijl ze dat doen komt er minder druk te staan op de lever, waardoor die beter kan herstellen en je ALT-waarde omlaag gaat. \n  * Wees voorzichtig met het nemen van supplementen. Hoewel er kruidenmiddelen zijn waarvan wordt gezegd dat ze de lever gezonder maken en de ALT-waarde verbeteren, is er meestal weinig wetenschappelijk bewijs dat ze werken. Sommige kruidenmiddelen en supplementen kunnen zelfs schadelijk zijn voor de lever en de ALT-waarde verslechteren.\n  * Beweeg regelmatig. Door beweging verbetert je algehele gezondheid, dus als je regelmatig aan cardiovasculaire en aerobe beweging doet, verbetert dat ook de gezondheid van je lever en je ALT-waarde.\n  * Stop met roken, indien van toepassing. Chemische toevoegingen in sigaretten bevatten gifstoffen die de levercellen beschadigen als je lever ze probeert te filteren. Als je stopt met roken wordt je lever sterker en daalt je ALT-waarde.\n  * Vermijd chemische stoffen in je omgeving. Veel huishoudelijke schoonmaakmiddelen bevatten ook allerlei gifstoffen die de lever kunnen beschadigen, dus probeer zo min mogelijk aan deze stoffen bloot te staan als je je lever gezonder wil maken en je ALT-waarde wil verlagen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_GAMMAGT",
                                            "name": "GGT",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 11,
                                                    "intValue": 11,
                                                    "stringValue": "11",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_GAMMAGT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 15,
                                                    "intValue": 15,
                                                    "stringValue": "15",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_GAMMAGT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_GAMMAGT_NORMAAL",
                                                    "resultText": "Je gamma-GT-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "De aanwezigheid van gamma-GT in het bloed is normaal gesproken laag. Een gezonde levensstijl en geen overmatig alcoholgebruik kunnen je helpen deze waarden zo laag mogelijk te houden.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_EGFR",
                                            "name": "e-GFR",
                                            "unit": "ml/min",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 90,
                                                    "intValue": 90,
                                                    "stringValue": "90",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_EGFR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 89,
                                                    "intValue": 89,
                                                    "stringValue": "89",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_EGFR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 77,
                                                    "intValue": 77,
                                                    "stringValue": "77",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_EGFR_NORMAAL",
                                                    "resultText": "Je eGFR-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Normale eGFR-waarden wijzen op een normale nierfunctie. Belangrijk is hierbij een algemene goede gezondheid. Denk bijvoorbeeld aan het vermijden van een hoge bloeddruk en het hebben van goede suikerspiegels in je bloed.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_UREUM",
                                            "name": "Ureum",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 24,
                                                    "intValue": 24,
                                                    "stringValue": "24",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_UREUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 42,
                                                    "intValue": 42,
                                                    "stringValue": "42",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_UREUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 26,
                                                    "intValue": 26,
                                                    "stringValue": "26",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_UREUM_NORMAAL",
                                                    "resultText": "Je ureumwaarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Deze tips kunnen je helpen voor een gezonde nierfunctie:\n\n  * Houd je bloeddruk in de gaten.\n  * Beperk je alcoholinname.\n  * Rook niet of stop met roken.\n  * Blijf fit en actief. Tracht dagelijks 30 minuten aan lichaamsbeweging te doen.\n  * Zorg voor voldoende slaap: streef elke nacht naar 7 tot 8 uur slaap. \n  * Hou je gewicht onder controle.\n  * Beperk je zoutinname.\n  * Drink voldoende water: 1,5 tot 2 liter water per dag.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_FIB4",
                                            "name": "Fib4-Index",
                                            "unit": "index",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.54,
                                                    "stringValue": "0.54",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_FIB4_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.58,
                                                    "stringValue": "0.58",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_FIB4_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.1,
                                                    "stringValue": "1.10",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_FIB4_NORMAAL",
                                                    "resultText": "Je Fib-4-index is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Normale waarden duiden op de afwezigheid van leverfibrose, ook wel leverbeschadiging genaamd. Optimaal trachten we te streven naar een Fib-4-index lager dan 1,30. \nDit zijn alvast enkele tips voor een gezonde lever:  \n\n  * Matig je alcoholgebruik. Overmatig alcoholgebruik kan een ontsteking van de levercellen veroorzaken.\n  * Eet gezond en gevarieerd, en doe aan regelmatige lichaamsbeweging. Je lever zal je dankbaar zijn. \n  * Hou je gewicht onder controle. Dat zorgt ervoor dat je minder snel last krijgt van niet-alcoholische leververvetting.\n  * Kijk uit met bepaalde medicatie.\n  * Voeg eens knoflook toe aan je gerechten. Knoflook bevat talrijke zwavelhoudende verbindingen die verantwoordelijk zijn voor het verwijderen van afvalproducten uit het lichaam. Het ondersteunt de leverenzymen die je lichaam helpen bij het ontgiftingsproces. Knoflook is ook rijk aan allicine en selenium, twee natuurlijke stoffen die helpen bij leverreiniging.\n  * Groene groenten beschermen de lever. Groene bladgroenten, zoals rucola, spinazie, paksoi en waterkers zitten bomvol antioxidanten, vitaminen, mineralen en vezels. Deze groenten bieden bescherming voor de lever en het is vooral chlorofyl, wat helpt bij het verwijderen van gifstoffen zoals zware metalen.\n  * Eet walnoten. Die bevatten een hoge hoeveelheid van het aminozuur arginine. Daarnaast bevatten ze ook glutathion en omega 3-vetzuren. Arginine helpt de lever te ontgiften van ammoniak, een cytotoxine dat bij de afbraak van proteÃ¯nen ontstaat. Omega 3-vetzuren verminderen vet in de lever\n  * Omarm de heilzame werking van kurkuma. Kurkuma, veel gebruikt in de Indiase keuken, is een van de krachtigste voedingsmiddelen voor het verkrijgen en behouden van een gezonde lever. Het is aangetoond dat kurkuma actieve bescherming biedt van de lever tegen toxische beschadiging.\n  * Bietensap is een bron van nitraten en antioxidanten genaamd betalains. Die kunnen leiden tot gezondheidseffecten zoals een verbeterde cardiovasculaire gezondheid. Bietensap beschermt de lever tegen oxidatieve schade en ontsteking, terwijl de natuurlijke ontgiftingsenzymen worden verhoogd.\n\nBen je jonger dan 35 jaar? Dan is deze score niet volledig betrouwbaar.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_LIFESTYLE_SCHILDKLIER",
                                    "name": "Schildklier",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_SCHILDKLIER_TSH",
                                            "name": "TSH",
                                            "unit": "mU/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.8,
                                                    "stringValue": "1.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_SCHILDKLIER_TSH_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.8,
                                                    "stringValue": "1.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_SCHILDKLIER_TSH_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2,
                                                    "stringValue": "2.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_SCHILDKLIER_TSH_NORMAAL",
                                                    "resultText": "Je TSH-waarde is normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Probeer te mikken op een TSH tussen de 0,5 en 1,4 mU/l. Wil je werk maken van een gezonde schildklierfunctie? Deze tips op vlak van voeding en levensstijl kunnen je helpen: \n\n  * Eet voldoende groenten en fruit rijk aan kalium en magnesium.\n  * Hanteer rust en regelmaat zowel wat betreft eetmomenten, slaapmomenten als rust- en actiemomenten.\n  * Beweeg dagelijks.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_T3",
                                            "name": "T3",
                                            "unit": "pg/ml",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 3.11,
                                                    "stringValue": "3.11",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_T3_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 3.84,
                                                    "stringValue": "3.84",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_T3_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 3.3,
                                                    "stringValue": "3.30",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_T3_NORMAAL",
                                                    "resultText": "Je T3-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Je hebt in de biologieles ongetwijfeld geleerd dat je een schildklier hebt, maar weet je ook wanneer die gezond is of waar ze voor dient? Of welke problemen er kunnen opduiken? HypothyreoÃ¯die, bijvoorbeeld? Die naam hoef je niet te onthouden, zolang je maar weet dat je met een aangepast voedingspatroon heel wat problemen kan voorkomen. Deze voedingsmiddelen ondersteunen de werking van je schildklier:\n\n  * Voedsel rijk aan jodium, zoals zalm, schelpdieren of paddenstoelen.\n  * Voedsel rijk aan vezels. Die zijn van essentieel belang om de stofwisseling te reguleren.\n  * Voedsel rijk aan vitamines.\n  * Voedsel rijk aan zink. Denk maar aan oesters, lam, gember, noten of groene erwten.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_T4",
                                            "name": "T4",
                                            "unit": "pmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 12.64,
                                                    "stringValue": "12.64",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_T4_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 14.71,
                                                    "stringValue": "14.71",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_T4_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 11.87,
                                                    "stringValue": "11.87",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_T4_NORMAAL",
                                                    "resultText": "Je T4-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Uit jouw bloedwaarden kunnen we optekenen dat je T4-waarden normaal zijn. Wanneer je TSH-waarden ook normaal zijn, functioneert je schildklier goed. Blijf wel steeds een gezonde levensstijl nastreven waarin balans centraal staat.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        },
                        {
                            "tag": "DASHBOARD_BLOOD_FOOD",
                            "name": "Voeding",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_BLOOD_FOOD_VITAMINES",
                                    "name": "Vitamines en mineralen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD",
                                            "name": "Vitamine D",
                                            "unit": "ng/ml",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 38.6,
                                                    "stringValue": "38.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 58.7,
                                                    "stringValue": "58.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 31.8,
                                                    "stringValue": "31.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "resultText": "Je vitamine D-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Optimale waarden van 25-OH Vit D3 zijn tussen de 20ng/ml en 50 ng/ml. Is je waarde tussen 12ng/ml en 20ng/ml? Dan dien je extra aandacht te besteden aan je vitamine D-inname. \n\nOm normale vitamine D-waarden te behouden is het belangrijk om je lichaam voldoende bloot te stellen aan onmiddellijk zonlicht en voeding te eten die rijk is aan vitamine D. Je vindt vitamine D onder andere in vette vissoorten (paling, makreel, zalm en haring), eidooier en aan zonlicht blootgestelde paddenstoelen. Omdat calcium belangrijk is voor de opname van vitamine D combineer je die champignons of vette vis het best met een calciumrijk voedingsmiddel. Denk bijvoorbeeld aan spinazie, Chinese kool of tofoe.\n\nWaar wij wonen, is het makkelijker gezegd dan gedaan om vitamine D binnen te krijgen via zonlicht. In de zomer is een kwartier blootstelling van armen en hoofd op de middag voldoende om je vitamine D-gehalte in de bloedspiegel op niveau te houden. Het teveel aan aangemaakte vitamine D wordt opgeslagen in vetweefsel, een reserve die ontoereikend is om ons de hele winter en lente te voorzien van voldoende van die vitamine. Uit onderzoek blijkt dat zelfs tot ongeveer 90 procent van de Belgische bevolking aan het einde van de winter een gebrek aan vitamine D heeft.\n\nVoor iedereen geldt een dagelijkse aanbevolen hoeveelheid van 10 microgram vitamine D. Alleen mensen van boven de 70 moeten 20 microgram per dag binnenkrijgen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12",
                                            "name": "Vitamine B12",
                                            "unit": "ng/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 476,
                                                    "intValue": 476,
                                                    "stringValue": "476",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 436,
                                                    "intValue": 436,
                                                    "stringValue": "436",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 355,
                                                    "intValue": 355,
                                                    "stringValue": "355",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 48,
                                                    "intValue": 48,
                                                    "stringValue": "48",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_VITAMINEB12_NORMAAL",
                                                    "resultText": "Je vitamine B12-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Voor mannen en vrouwen boven de 14 is het aanbevolen om dagelijks 2,8 microgram vitamine B12 binnen te krijgen. Als je gezond en gevarieerd eet, krijg je voldoende vitamine B12 binnen. Tracht te streven naar waarden boven de 500ng/l.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR",
                                            "name": "Foliumzuur",
                                            "unit": "Âµg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 22.21,
                                                    "stringValue": "22.21",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 7.86,
                                                    "stringValue": "7.86",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 9.43,
                                                    "stringValue": "9.43",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 90,
                                                    "intValue": 90,
                                                    "stringValue": "90",
                                                    "tag": "RESULT_BLOOD_MEDICAL_AFWEER_FOLIUMZUUR_LAAG",
                                                    "resultText": "Je foliumzuurwaarden zijn licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Foliumzuur komt van nature voor in verschillende groenten. Vooral de groene soorten zoals spinazie, boerenkool, rucola, broccoli en sla zijn rijke bronnen van foliumzuur. Ook in fruit en volkorenproducten vind je deze vitamine. In vlees en melkproducten zit ook foliumzuur, maar in mindere mate dan in de groente en fruit. Een tekort aan foliumzuur kan je behandelen door het innemen van supplementen met extra foliumzuur. Na verloop van tijd kom je zo terug aan het gewenste niveau.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM",
                                            "name": "Calcium",
                                            "unit": "10^6/Âµl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.25,
                                                    "stringValue": "2.25",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.41,
                                                    "stringValue": "2.41",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 98,
                                                    "intValue": 98,
                                                    "stringValue": "98",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 45,
                                                    "intValue": 45,
                                                    "stringValue": "45",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "resultText": "Je calciumwaarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Wanneer je gezond en gevarieerd eet, krijgt je normaal gezien voldoende calcium binnen. \n\nCalciumrijke voedingsproducten zijn vooral zuivelproducten (bijvoorbeeld melk of yoghurt) of met calcium verrijkte plantaardige varianten van zuivel, zoals sojamelk en amandelmelk. \n\nDaarnaast zijn nog heel wat andere voedingsstoffen rijk aan calcium. Denk bijvoorbeeld aan noten, groene groenten (zoals broccoli, spinazie, Chinese kool of rammenas), bonen, zeewier, vis (zoals maatjes, zeebrasem of sardines) en zaden.\n\nOmdat vitamine D onmisbaar is voor de opname van calcium in je lichaam, is het belangrijk dat je er voldoende binnenkrijgt.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM",
                                            "name": "Magnesium",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.84,
                                                    "stringValue": "0.84",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.8,
                                                    "stringValue": "0.80",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.81,
                                                    "stringValue": "0.81",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_MAGNESIUM_HOOG",
                                                    "resultText": "Je magnesiumwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een overschot aan magnesium ontstaat enkel bij gebruik van tabletten waarin magnesium zit, magnesiumzouten of mineraalwater waarin veel magnesium zit. \n\nBij meer dan 250 milligram magnesium per dag extra, dus naast het magnesium in je eten, kunnen darmklachten zoals diarree ontstaan.\n",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM",
                                            "name": "Natrium",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 142,
                                                    "intValue": 142,
                                                    "stringValue": "142",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 141,
                                                    "intValue": 141,
                                                    "stringValue": "141",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 143,
                                                    "intValue": 143,
                                                    "stringValue": "143",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 2,
                                                    "intValue": 2,
                                                    "stringValue": "2",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_NATRIUM_LAAG",
                                                    "resultText": "Je natriumwaarden zijn licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Het gebeurt niet vaak dat iemand een tekort aan natrium heeft. Doordat het in bijna al onze voeding zit, krijg je al snel voldoende binnen. Zelfs mensen met een zoutarm dieet krijgen vaak alsnog voldoende natrium via hun voeding binnen. Een tekort aan zout kan ontstaan als gevolg van uitdroging door ernstige diarree of hevig braken.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_KALIUM",
                                            "name": "Kalium",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.26,
                                                    "stringValue": "4.26",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_KALIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 5.22,
                                                    "stringValue": "5.22",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_KALIUM_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 5.59,
                                                    "stringValue": "5.59",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_KALIUM_HOOG",
                                                    "resultText": "Je kaliumwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Probeer kaliumrijke producten wat te beperken. Voedingsmiddelen die veel kalium bevatten, zijn:\n \n  * Aardappelen\n  * Cacao\n  * Groenten (vooral tomaten)\n  * Fruit\n  * Vloeibare melkproducten zoals melk en yoghurt\n  * Noten en zaden zoals amandelen, cashewnoten, pinda's of lijnzaad\n  * Peulvruchten en linzen\n  * Koffie (ook cafeÃ¯nevrij)",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK",
                                            "name": "Zink",
                                            "unit": "pg",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 76.7,
                                                    "stringValue": "76.7",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 71.7,
                                                    "stringValue": "71.7",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 25,
                                                    "intValue": 25,
                                                    "stringValue": "25",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 46,
                                                    "intValue": 46,
                                                    "stringValue": "46",
                                                    "tag": "RESULT_BLOOD_VOEDING_VITAMINES_ZINK_NORMAAL",
                                                    "resultText": "Je zinkwaarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "De belangrijkste leverancier van het mineraal zink zijn dierlijke producten zoals vlees, zuivel en vis. Ook verschillende noten bevatten zink. Toch vind je zink vooral in schaal- en schelpdieren zoals oesters, garnalen en mosselen. In brood, peulvruchten en rijst zal je het dan weer een pak minder vinden. Probeer steeds te mikken op 90 Âµg/dL.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_FOOD_IJZER",
                                    "name": "Ijzer",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER",
                                            "name": "Ijzer",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 107,
                                                    "intValue": 107,
                                                    "stringValue": "107",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 123,
                                                    "intValue": 123,
                                                    "stringValue": "123",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 100,
                                                    "intValue": 100,
                                                    "stringValue": "100",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_IJZER_NORMAAL",
                                                    "resultText": "Je ijzerwaarde is normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Idealiter bedragen je ijzerwaarden tussen de 70 en 125Î¼g/dl. Door gezond en gevarieerd te eten krijg je dat normaal binnen. VegetariÃ«rs krijgen over het algemeen alleen non-heemijzer binnen, waardoor de opname door het lichaam wat lager is. Wie geen vlees eet, heeft soms lagere ijzervoorraden dan anderen, maar dat niveau is nog steeds voldoende.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE",
                                            "name": "Ferritine",
                                            "unit": "Âµg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 22.3,
                                                    "stringValue": "22.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 186.3,
                                                    "stringValue": "186.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 60.6,
                                                    "stringValue": "60.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 40,
                                                    "intValue": 40,
                                                    "stringValue": "40",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_HOOG",
                                                    "resultText": "Je ferritinewaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een methode om je ferritinewaarden te verlagen is je voedselpatroon aan te passen aan het te hoge ferritinegehalte in je bloed. Een speciaal voedingspatroon kan een oplossing zijn om het overschot te beperken. Er zijn namelijk een aantal producten die je kunnen helpen om je ijzeroverschot naar beneden te brengen, zoals:\n\n  * Thee tijdens de maaltijd\n  * Vruchtensappen overdag\n  * Boter, kaas en eieren\n  * Vis\n  * Volkorenproducten\n\nVolgende producten kan je beter vermijden:\n\n  * Koffie\n  * Sla\n  * Gedroogd fruit\n  * Rundvlees en varkensvlees\n  * Groenten zoals broccoli, sperziebonen en andijvie\n  * Olijven, vooral zwarte\n  * Artisjokken\n\nEen belangrijke tip om de ferritinewaarden in je bloed te verlagen is om rekening te houden met je gewicht. Overgewicht werkt niet bevorderlijk om het ijzergehalte in je bloed te reduceren. Als je het terugdringen van je gewicht combineert met een regelmatig bezoek aan de sportschool en aan een aangepast dieet merk je al snel dat je lichaam daar positief op reageert.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_TRANSFERRINE",
                                            "name": "Transferrine",
                                            "unit": "g/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 3.21,
                                                    "stringValue": "3.21",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_TRANSFERRINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.28,
                                                    "stringValue": "2.28",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_TRANSFERRINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 2.02,
                                                    "stringValue": "2.02",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_TRANSFERRINE_LAAG",
                                                    "resultText": "Je transferrinewaarde is licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Een verlaagd transferrine zou kunnen wijzen op een overschot aan ijzer in het lichaam. Ook eiwitarme voeding of het minder goed functioneren van de lever kan verlaagde transferrinewaarden met zich meebrengen. Daarnaast verlaagt transferrine ook bij metabole stress.\n\nTransferrine is een negatief acute fase-eiwit. Wanneer de lever de productie van ontstekingsgerelateerde eiwitten (bijvoorbeeld CRP of ferritine) verhoogt, vermindert het de productie van transferrine. Infecties kunnen dus de transferrinewaarden verlagen.\n\nIn een observationele studie onder 297 mensen hadden mensen met actieve inflammatoire darmaandoening (IBD: zowel de ziekte van Crohn als colitis ulcerosa) significant lagere transferrinewaarden. Verhoogde IBD-activiteit en ernst van ontsteking waren geassocieerd met lagere transferrinewaarden.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_SATURATIE",
                                            "name": "Ijzersaturatie",
                                            "unit": "%",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 30.3,
                                                    "stringValue": "30.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_SATURATIE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 49,
                                                    "stringValue": "49.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_SATURATIE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 45,
                                                    "stringValue": "45.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_SATURATIE_NORMAAL",
                                                    "resultText": "Je ijzersaturatiewaarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Idealiter ligt je ijzersaturatie tussen de 24 en 40%. Met een gezond en gevarieerd voedingspatroon krijgen de meeste mensen voldoende ijzer binnen. VegetariÃ«rs krijgen over het algemeen alleen non-heemijzer binnen, waardoor de opname door het lichaam wat lager ligt.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_FOOD_ALCOHOL",
                                    "name": "Alcoholgebruik",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_GAMMAGT",
                                            "name": "GGT",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 11,
                                                    "intValue": 11,
                                                    "stringValue": "11",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_GAMMAGT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 15,
                                                    "intValue": 15,
                                                    "stringValue": "15",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_GAMMAGT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_GAMMAGT_NORMAAL",
                                                    "resultText": "Je gamma-GT-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "De aanwezigheid van gamma-GT in het bloed is normaal gesproken laag. Een gezonde levensstijl en geen overmatig alcoholgebruik kunnen je helpen deze waarden zo laag mogelijk te houden.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_AST",
                                            "name": "AST",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 25,
                                                    "intValue": 25,
                                                    "stringValue": "25",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_AST_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 23,
                                                    "intValue": 23,
                                                    "stringValue": "23",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_AST_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 19,
                                                    "intValue": 19,
                                                    "stringValue": "19",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_AST_NORMAAL",
                                                    "resultText": "Je AST-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Er zijn een aantal zaken die je kan doen om je AST-waarden te beÃ¯nvloeden:\n\n * Beperk je alcoholgebruik. Alcoholmisbruik zal namelijk leiden tot een toename van je AST omdat ethanol giftig is voor levercellen en die beschadigt. Af en toe wat alcohol drinken (wijn, bier, highballs of cocktails) zal geen aanzienlijke invloed hebben op je AST of andere leverenzymen. Toch zal regelmatig gematigd drinken (meer dan een paar glazen per dag) of doorzakken in het weekend zeker een impact hebben op je enzymniveaus. \n  * Probeer een supplement met kurkumapoeder. Het is het meest klinisch geteste kruid, want het is een krachtige ontstekingsremmer en antioxidant die veel organen in het lichaam helpt genezen, inclusief je lever. De meest geneeskrachtige stof in kurkuma is curcumine, waarvan is aangetoond dat die een hoog leverenzymniveau (ALT en AST) bij zowel dieren als mensen kan verminderen. De benodigde hoeveelheden om een duidelijke impact te hebben op leverenzymen zijn ongeveer 3000 mg per dag, maximaal 12 weken lang.\n  * Drink af en toe wat koffie. Onderzoek uit 2014 heeft uitgewezen dat het regelmatig drinken van matige hoeveelheden gewone of cafeÃ¯nevrije koffie de gezondheid van de lever kan verbeteren en circulatie van leverenzymen, zoals AST, kan doen afnemen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_ALT",
                                            "name": "ALT",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 18,
                                                    "intValue": 18,
                                                    "stringValue": "18",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_ALT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 17,
                                                    "intValue": 17,
                                                    "stringValue": "17",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_ALT_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_ALT_NORMAAL",
                                                    "resultText": "Je ALT-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Om je ALT-waarde normaal te houden is een gezonde levensstijl belangrijk. Dit zijn enkele zaken die je kan doen:\n\n * Drink zo weinig mogelijk alcohol. Overmatig alcoholgebruik is de meest voorkomende oorzaak van leverschade, maar zelfs matige alcoholconsumptie kan de levercellen na verloop van tijd al beschadigen.\n  * Beperk het eten van fastfood. Veel suiker en vet is slecht voor de lever, dus als je dat laat staan wordt je lever gezonder en verlaag je je ALT-waarde.\n  * Eet meer groenten en fruit, want die ontgiften het lichaam op natuurlijke wijze. Terwijl ze dat doen komt er minder druk te staan op de lever, waardoor die beter kan herstellen en je ALT-waarde omlaag gaat. \n  * Wees voorzichtig met het nemen van supplementen. Hoewel er kruidenmiddelen zijn waarvan wordt gezegd dat ze de lever gezonder maken en de ALT-waarde verbeteren, is er meestal weinig wetenschappelijk bewijs dat ze werken. Sommige kruidenmiddelen en supplementen kunnen zelfs schadelijk zijn voor de lever en de ALT-waarde verslechteren.\n  * Beweeg regelmatig. Door beweging verbetert je algehele gezondheid, dus als je regelmatig aan cardiovasculaire en aerobe beweging doet, verbetert dat ook de gezondheid van je lever en je ALT-waarde.\n  * Stop met roken, indien van toepassing. Chemische toevoegingen in sigaretten bevatten gifstoffen die de levercellen beschadigen als je lever ze probeert te filteren. Als je stopt met roken wordt je lever sterker en daalt je ALT-waarde.\n  * Vermijd chemische stoffen in je omgeving. Veel huishoudelijke schoonmaakmiddelen bevatten ook allerlei gifstoffen die de lever kunnen beschadigen, dus probeer zo min mogelijk aan deze stoffen bloot te staan als je je lever gezonder wil maken en je ALT-waarde wil verlagen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_BLOED_MCV",
                                            "name": "MCV",
                                            "unit": "fl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 92.2,
                                                    "stringValue": "92.2",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_MCV_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 89.4,
                                                    "stringValue": "89.4",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_MCV_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 96.8,
                                                    "stringValue": "96.8",
                                                    "tag": "RESULT_BLOOD_STRESS_BLOED_MCV_NORMAAL",
                                                    "resultText": "Je MCV-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Jouw rode bloedcellen hebben een normale grootte. Toch kan je met een normale MCV bloedarmoede hebben als er te weinig rode bloedcellen zijn of als andere RBC-indices abnormaal zijn.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_HEMOGLOBINE",
                                            "name": "Hemoglobine",
                                            "unit": "g/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 13.7,
                                                    "stringValue": "13.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_HEMOGLOBINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 15.1,
                                                    "stringValue": "15.1",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_HEMOGLOBINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 15.3,
                                                    "stringValue": "15.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_HEMOGLOBINE_NORMAAL",
                                                    "resultText": "Je hemoglobinewaarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Een gezond en gevarieerd voedingspatroon helpt je om je hemoglobinewaarden goed te houden. Dit zijn alvast enkele zaken die je kan doen:\n\n  * Drink voldoende water, tussen 1,5 en 2 liter per dag. Als je urine lichtgeel is of de kleur heeft van stro, wil dat zeggen dat je lichaam water vrijlaat en je urine verdund is. Je bent dus voldoende gehydrateerd. Heeft je urine daarentegen een donkere kleur, dan houdt je lichaam vocht vast. Dat wil zeggen dat je meer moet drinken.\n  * Eet voldoende ijzerrijke voedingsmiddelen. De belangrijkste zijn groene bladgroenten zoals spinazie, rode biet, tofoe, asperges, kippenlever, eieren, oesters, appel, granaatappel, abrikoos, watermeloen, pruimen, pompoenpitten, dadels, amandelen, rozijnen, amla (Indiase kruisbes) en rietsuiker.\n  * Zorg voor voldoende inname van vitamine C zoals in sinaasappels, citroen, aardbeien, papaja, paprika, broccoli, grapefruit en tomaten.\n  * Let op je inname van foliumzuur. Dat kan je vinden in groene bladgroenten, spruiten, tarwekiemen, pinda's, bananen, broccoli en kippenlever.\n  * Beweeg voldoende.\n\nMannen streven het best naar waarden tussen de 14 en 16g/dl en vrouwen tussen de 13 en 14g/dl.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_URINEZUUR",
                                            "name": "Urinezuur",
                                            "unit": "mg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 3.8,
                                                    "stringValue": "3.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_URINEZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.8,
                                                    "stringValue": "4.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_URINEZUUR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 4.1,
                                                    "stringValue": "4.1",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_URINEZUUR_NORMAAL",
                                                    "resultText": "Je urinezuurwaarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Wat je eet, bevat vaak purinehoudende voedingsstoffen die kunnen bijdragen tot een verhoging van het urinezuur. Door je dieet te wijzigen kan je de productie van urinezuur dus verlagen! We kunnen voeding opdelen in drie categorieÃ«n:\n\n * Voedsel met een hoog purinegehalte: wild, gans, sardines, haring, ansjovis, forel, zalm, kabeljauw, zeevruchten (kreeft, mosselen, oesters) orgaanvlees, peulvruchten en spinazie.\n  * Voedsel met een gemiddeld purinegehalte: konijn, schaap, rund, kalf, duif, kalkoen, eend, schaaldieren, asperges, paddenstoelen en bloemkool.\n  * Voedsel waarin weinig of geen purines zitten: fruit, melk, kaas, bladgroenten, eieren, rijst, deegwaren, granen, brood, aardappelen en jam of confituur.\n\nDrink ook voldoende water. Gesuikerde dranken, ook de lightvarianten, geven namelijk een verhoogd urinezuurgehalte in je bloed.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_FOOD_COELIAKIE",
                                    "name": "Gluten",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_VOEDING_COELIAKIE_GLUTEN",
                                            "name": "Glutenintolerantie",
                                            "unit": "U/ml",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<3.0",
                                                    "tag": "RESULT_BLOOD_VOEDING_COELIAKIE_GLUTEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<3.0",
                                                    "tag": "RESULT_BLOOD_VOEDING_COELIAKIE_GLUTEN_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<3.0",
                                                    "tag": "RESULT_BLOOD_VOEDING_COELIAKIE_GLUTEN_NORMAAL",
                                                    "resultText": "Je anti-tTG IgA-waarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "In de test merken we geen antistoffen tegen gluten. Dat betekent dat de kans op coeliakie of glutenintolerantie bij jou heel klein is. Blijf je toch last hebben van bepaalde klachten zoals een opgezwollen buik, diarree, hoofdpijn of vermoeidheid? Ga dan zeker raad vragen bij je (huis)arts.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        },
                        {
                            "tag": "DASHBOARD_BLOOD_MOVE",
                            "name": "Beweging",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_BLOOD_MOVE_BOTTEN",
                                    "name": "Botmassa",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_TESTOSTERON",
                                            "name": "Testosteron",
                                            "unit": "nmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.7,
                                                    "stringValue": "0.7",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_TESTOSTERON_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 22.4,
                                                    "stringValue": "22.4",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_TESTOSTERON_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<0.4",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_TESTOSTERON_NORMAAL",
                                                    "resultText": "Je testosteronwaarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Je kunt zelf heel wat ondernemen om een tekort aan testosteron te vermijden wanneer je ouder wordt. Hieronder geven we je enkele praktische tips om de hoeveelheid van dit hormoon te verhogen.\n\n  * Slaap voldoende, want de productie van testosteron neemt vooral in de nacht toe wanneer je aan het slapen bent. Uit onderzoek is dus ook gebleken dat slaap erg belangrijk is om je testosterongehalte op peil te houden. Probeer elke dag netjes 7 Ã  8 uur te slapen en de kwaliteit van je nachtrust te verbeteren. Je kunt dat onder andere doen door in een donkere en niet te warme kamer te slapen, en vlak voor je naar bed gaat geen schermen meer te bekijken.\n\n  * Denk aan je voeding, want die kan veel invloed hebben op een testosterontekort. Drink bijvoorbeeld niet te veel alcohol. Alcohol heeft invloed op de cellen waarin het hormoon wordt geproduceerd, met als gevolg dat de productie afneemt. Eet juist wel een hoop groenten waarin diindolylmethane zit. Dat is een stof die zorgt voor een hogere productie van testosteron. Je vindt deze stof vooral in bloemkool, spruiten, broccoli en andere koolsoorten. \n\n  * Misschien wel de leukste: heb regelmatig seks. Het zal je niet verbazen, maar seks zorgt er ook voor dat je productie van testosteron pijlsnel omhoogschiet. Mannen die regelmatig seks hebben, hebben over het algemeen een hoger gehalte van dit hormoon dan mannen die weinig seks hebben. Het kan dus zeker geen kwaad om actief te blijven op seksgebied.\n\n  * Neem extra vitamine B. Deze vitamine heeft niet direct veel invloed op je testosterongehalte, maar wel op je oestrogeengehalte. Oestrogeen wordt meestal gezien als het vrouwelijke hormoon, terwijl mannen het in mindere mate ook hebben. Mannen willen liever niet een te hoog gehalte aan oestrogeen in hun lichaam hebben, want dit hormoon heeft bij hen namelijk een dikmakende werking. Bij een vitamine B-tekort zorgt je lichaam ervoor dat je oestrogeenniveau stijgt, iets wat je als man dus niet wil. Let er daarom op dat je voldoende vitamine B binnenkrijgt.\n\n  * Bij een vitamine B-tekort zorgt je lichaam ervoor dat je niveau aan oestrogeen stijgt, iets wat je als man dus niet wil. Let er dus op dat je voldoende vitamine B binnenkrijgt.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS",
                                            "name": "DHEA-S",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 365,
                                                    "intValue": 365,
                                                    "stringValue": "365",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 410,
                                                    "intValue": 410,
                                                    "stringValue": "410",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 16,
                                                    "intValue": 16,
                                                    "stringValue": "16",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_LAAG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 89,
                                                    "intValue": 89,
                                                    "stringValue": "89",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_LAAG",
                                                    "resultText": "Je DHEAS-waarden zijn licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Lage DHEAS-niveaus gaan vaak gepaard met onverklaarbaar gewichtsverlies, duizeligheid of misselijkheid. DHEAS-waarden nemen normaal gesproken af.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD",
                                            "name": "Vitamine D",
                                            "unit": "ng/ml",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 38.6,
                                                    "stringValue": "38.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 58.7,
                                                    "stringValue": "58.7",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 31.8,
                                                    "stringValue": "31.8",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_VITD_NORMAAL",
                                                    "resultText": "Je vitamine D-waarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Optimale waarden van 25-OH Vit D3 zijn tussen de 20ng/ml en 50 ng/ml. Is je waarde tussen 12ng/ml en 20ng/ml? Dan dien je extra aandacht te besteden aan je vitamine D-inname. \n\nOm normale vitamine D-waarden te behouden is het belangrijk om je lichaam voldoende bloot te stellen aan onmiddellijk zonlicht en voeding te eten die rijk is aan vitamine D. Je vindt vitamine D onder andere in vette vissoorten (paling, makreel, zalm en haring), eidooier en aan zonlicht blootgestelde paddenstoelen. Omdat calcium belangrijk is voor de opname van vitamine D combineer je die champignons of vette vis het best met een calciumrijk voedingsmiddel. Denk bijvoorbeeld aan spinazie, Chinese kool of tofoe.\n\nWaar wij wonen, is het makkelijker gezegd dan gedaan om vitamine D binnen te krijgen via zonlicht. In de zomer is een kwartier blootstelling van armen en hoofd op de middag voldoende om je vitamine D-gehalte in de bloedspiegel op niveau te houden. Het teveel aan aangemaakte vitamine D wordt opgeslagen in vetweefsel, een reserve die ontoereikend is om ons de hele winter en lente te voorzien van voldoende van die vitamine. Uit onderzoek blijkt dat zelfs tot ongeveer 90 procent van de Belgische bevolking aan het einde van de winter een gebrek aan vitamine D heeft.\n\nVoor iedereen geldt een dagelijkse aanbevolen hoeveelheid van 10 microgram vitamine D. Alleen mensen van boven de 70 moeten 20 microgram per dag binnenkrijgen.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM",
                                            "name": "Magnesium",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.84,
                                                    "stringValue": "0.84",
                                                    "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.8,
                                                    "stringValue": "0.80",
                                                    "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 0.81,
                                                    "stringValue": "0.81",
                                                    "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 13,
                                                    "intValue": 13,
                                                    "stringValue": "13",
                                                    "tag": "RESULT_BLOOD_STRESS_VITAMINES_MAGNESIUM_HOOG",
                                                    "resultText": "Je magnesiumwaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een overschot aan magnesium ontstaat enkel bij gebruik van tabletten waarin magnesium zit, magnesiumzouten of mineraalwater waarin veel magnesium zit. \n\nBij meer dan 250 milligram magnesium per dag extra, dus naast het magnesium in je eten, kunnen darmklachten zoals diarree ontstaan.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM",
                                            "name": "Calcium",
                                            "unit": "10^6/Âµl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.25,
                                                    "stringValue": "2.25",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 2.41,
                                                    "stringValue": "2.41",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 98,
                                                    "intValue": 98,
                                                    "stringValue": "98",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 45,
                                                    "intValue": 45,
                                                    "stringValue": "45",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_CALCIUM_NORMAAL",
                                                    "resultText": "Je calciumwaarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Wanneer je gezond en gevarieerd eet, krijgt je normaal gezien voldoende calcium binnen. \n\nCalciumrijke voedingsproducten zijn vooral zuivelproducten (bijvoorbeeld melk of yoghurt) of met calcium verrijkte plantaardige varianten van zuivel, zoals sojamelk en amandelmelk. \n\nDaarnaast zijn nog heel wat andere voedingsstoffen rijk aan calcium. Denk bijvoorbeeld aan noten, groene groenten (zoals broccoli, spinazie, Chinese kool of rammenas), bonen, zeewier, vis (zoals maatjes, zeebrasem of sardines) en zaden.\n\nOmdat vitamine D onmisbaar is voor de opname van calcium in je lichaam, is het belangrijk dat je er voldoende binnenkrijgt.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_PTH",
                                            "name": "Parathormoon",
                                            "unit": "ng/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 45,
                                                    "stringValue": "45.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_PTH_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 18,
                                                    "stringValue": "18.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_PTH_LAAG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 39,
                                                    "stringValue": "39.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_FRACTUUR_PTH_NORMAAL",
                                                    "resultText": "Je parathormoonwaarden zijn normaal.",
                                                    "keyWords": "normaal ",
                                                    "advice": "Hoewel ze qua naam op elkaar lijken, hebben de bijschildklieren niets te maken met de productie van schildklierhormoon. Die eerste produceren namelijk het parathyreoÃ¯dhormoon of parathormoon (PTH), een hormoon dat een belangrijke rol speelt in de calcium- en fosfaathuishouding. PTH stimuleert de calciumopname uit de darmen en de afgifte van calcium door de beenderen, activeert vitamine D en vermindert de uitscheiding van calcium via de nieren/urine. Op die manier zorgt het ervoor dat het calciumgehalte in het bloed stijgt en het fosfaatgehalte in het bloed daalt.\n\nDe bijschildklieren registreren het calciumgehalte in het bloed nauwkeurig en houden dit in evenwicht door de productie van PTH te verhogen of verlagen naargelang de calciumwaarden in het bloed dalen of stijgen. Ze sturen continu bij van zodra de calciumspiegel in het bloed verandert. Dat doet PTH samen met het door de schildklier geproduceerde hormoon calcitonine, dat precies het omgekeerde doet.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_MOVE_OVERTRAINING",
                                    "name": "Overtraining",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_SPORT_OVERTRAINING_CK",
                                            "name": "Creatine kinase",
                                            "unit": "U/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 80,
                                                    "intValue": 80,
                                                    "stringValue": "80",
                                                    "tag": "RESULT_BLOOD_SPORT_OVERTRAINING_CK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 124,
                                                    "intValue": 124,
                                                    "stringValue": "124",
                                                    "tag": "RESULT_BLOOD_SPORT_OVERTRAINING_CK_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 72,
                                                    "intValue": 72,
                                                    "stringValue": "72",
                                                    "tag": "RESULT_BLOOD_SPORT_OVERTRAINING_CK_NORMAAL",
                                                    "resultText": "Je CK-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Er is nog weinig onderzoek dat uitlegt hoe je je CK laag kan houden. We kunnen daarom niet meer doen dan aanraden om voldoende rust te nemen zodat je lichaam kan herstellen. Een ontspannende massage of een bezoek aan de spa is ook een goede optie!",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_MOVE_ONTSTEKING",
                                    "name": "Onstekingen",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP",
                                            "name": "hsCRP",
                                            "unit": "mg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.2,
                                                    "stringValue": "1.2",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "stringValue": "<4.0",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 1.08,
                                                    "stringValue": "1.08",
                                                    "tag": "RESULT_BLOOD_MEDICAL_CARDIO_HSCRP_HOOG",
                                                    "resultText": "Je hsCRP-waarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Om je hsCRP-niveau laag te krijgen speelt een gezonde levensstijl een belangrijke rol. Genoeg lichaamsbeweging, voldoende ontspanning en een gezond voedingspatroon zijn enkele voorbeelden die je daarbij kunnen helpen. Voedsel en dranken met veel suikers kunnen het best vermeden of in kleine hoeveelheden genuttigd worden. Broccoli, vette vis en groene thee zijn voedingsmiddelen die worden aanbevolen om het hsCRP-niveau te verlagen.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE",
                                            "name": "Ferritine",
                                            "unit": "Âµg/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 22.3,
                                                    "stringValue": "22.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 186.3,
                                                    "stringValue": "186.3",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 60.6,
                                                    "stringValue": "60.6",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 40,
                                                    "intValue": 40,
                                                    "stringValue": "40",
                                                    "tag": "RESULT_BLOOD_MEDICAL_BLOOD_FERRITINE_HOOG",
                                                    "resultText": "Je ferritinewaarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Een methode om je ferritinewaarden te verlagen is je voedselpatroon aan te passen aan het te hoge ferritinegehalte in je bloed. Een speciaal voedingspatroon kan een oplossing zijn om het overschot te beperken. Er zijn namelijk een aantal producten die je kunnen helpen om je ijzeroverschot naar beneden te brengen, zoals:\n\n  * Thee tijdens de maaltijd\n  * Vruchtensappen overdag\n  * Boter, kaas en eieren\n  * Vis\n  * Volkorenproducten\n\nVolgende producten kan je beter vermijden:\n\n  * Koffie\n  * Sla\n  * Gedroogd fruit\n  * Rundvlees en varkensvlees\n  * Groenten zoals broccoli, sperziebonen en andijvie\n  * Olijven, vooral zwarte\n  * Artisjokken\n\nEen belangrijke tip om de ferritinewaarden in je bloed te verlagen is om rekening te houden met je gewicht. Overgewicht werkt niet bevorderlijk om het ijzergehalte in je bloed te reduceren. Als je het terugdringen van je gewicht combineert met een regelmatig bezoek aan de sportschool en aan een aangepast dieet merk je al snel dat je lichaam daar positief op reageert.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                },
                                {
                                    "tag": "DASHBOARD_BLOOD_MOVE_HYDRATATIE",
                                    "name": "Hydratatie",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_MEDICAL_DETOX_EGFR",
                                            "name": "e-GFR",
                                            "unit": "ml/min",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 90,
                                                    "intValue": 90,
                                                    "stringValue": "90",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_EGFR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 89,
                                                    "intValue": 89,
                                                    "stringValue": "89",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_EGFR_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 77,
                                                    "intValue": 77,
                                                    "stringValue": "77",
                                                    "tag": "RESULT_BLOOD_MEDICAL_DETOX_EGFR_NORMAAL",
                                                    "resultText": "Je eGFR-waarde is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Normale eGFR-waarden wijzen op een normale nierfunctie. Belangrijk is hierbij een algemene goede gezondheid. Denk bijvoorbeeld aan het vermijden van een hoge bloeddruk en het hebben van goede suikerspiegels in je bloed.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        },
                        {
                            "tag": "DASHBOARD_BLOOD_STRESS",
                            "name": "Stress",
                            "groups": [
                                {
                                    "tag": "DASHBOARD_BLOOD_MOVE_NIVEAU",
                                    "name": "Stressniveau",
                                    "groups": [],
                                    "results": [
                                        {
                                            "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_CORTISOL",
                                            "name": "Cortisol",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "VERY_BAD",
                                                    "doubleValue": 23.45,
                                                    "stringValue": "23.45",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_CORTISOL_HOOGHOOG",
                                                    "score": 0,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 10.78,
                                                    "stringValue": "10.78",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_CORTISOL_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 8.36,
                                                    "stringValue": "8.36",
                                                    "tag": "RESULT_BLOOD_GEWICHT_ENERGIE_CORTISOL_NORMAAL",
                                                    "resultText": "Je cortisolwaarden zijn normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Voor we verdergaan is het belangrijk dat je weet dat cortisol op zich niet ongezond is. Het is, net als bijvoorbeeld adrenaline, een bij momenten zeer nuttig hormoon. Zonder cortisol zou je âs ochtends bijvoorbeeld minder energie hebben wanneer je uit bed stapt. Wat je doet, kan een impact hebben op je cortisolniveau:\n\n  * Eet gezond, want ongezond eten functioneert als een stressfactor voor je lichaam. Bepaalde voedingsstoffen kunnen voor jouw lichaam van extra nut zijn. Denk bijvoorbeeld aan vitamine C, vitamine B, foliumzuur, magnesium en omega 3-vetten.\n  * Beperk koffie en probeer alcohol te vermijden.\n  * Vermijd snelle suikers en ga liever voor trage koolhydraten zoals volkoren granen, groenten en fruit.\n  * Beweeg genoeg, maar overdrijf niet.\n  * Slaap voldoende en let op je slaapkwaliteit.\n  * Meditatie en ademhalingsoefeningen hebben nog steeds een beetje een zweverig imago. Toch kunnen ze je enorm helpen om tot rust te komen!\n  * Knuffel eens wat meer (en neen, dit is geen grapje). Bij het knuffelen wordt het hormoon oxytocine aangemaakt. Dat is hÃ©t hormoon dat cortisol reguleert. Meer oxytocine hebben is dus goed tegen te veel stress.\n  * Plan je rust in.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS",
                                            "name": "DHEA-S",
                                            "unit": "Âµg/dl",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 365,
                                                    "intValue": 365,
                                                    "stringValue": "365",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 410,
                                                    "intValue": 410,
                                                    "stringValue": "410",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 16,
                                                    "intValue": 16,
                                                    "stringValue": "16",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_LAAG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 89,
                                                    "intValue": 89,
                                                    "stringValue": "89",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_DHEAS_LAAG",
                                                    "resultText": "Je DHEAS-waarden zijn licht verlaagd.",
                                                    "keyWords": "licht verlaagd",
                                                    "advice": "Lage DHEAS-niveaus gaan vaak gepaard met onverklaarbaar gewichtsverlies, duizeligheid of misselijkheid. DHEAS-waarden nemen normaal gesproken af.",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL",
                                            "name": "Cortisol/DHEA-S",
                                            "unit": "index",
                                            "values": [
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.0642466,
                                                    "stringValue": "0.0642466",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.0262927,
                                                    "stringValue": "0.0262927",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 0.512883,
                                                    "stringValue": "0.512883",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1638455400000
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 18,
                                                    "intValue": 18,
                                                    "stringValue": "18",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711120920560
                                                },
                                                {
                                                    "riskLevel": "NOT_APPLICABLE",
                                                    "doubleValue": 6,
                                                    "intValue": 6,
                                                    "stringValue": "6",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_VERHOUDINGCORTISOL_NORMAAL",
                                                    "resultText": "Je cortisol/DHEAS-waarde is een berekende waarde.",
                                                    "keyWords": "berekende waarde",
                                                    "advice": "Goede cortisol/DHEAS-waarden duiden op een goed functionerend stress-systeem in het lichaam. Ideale waarden zijn lager of gelijk aan 0,2. \n\nOm de balans tussen cortisol en DHEAS weer te normaliseren kan je verschillende zaken doen. Zo zijn er studies die aantonen dat DHEAS blijkt toe te nemen als reactie op actieve inspanning.\n\nHet hangt wel af van de inspanning: weerstandstraining vertoont een sterkere toename in vergelijking met duurtraining. Uiteraard hangt je hormonale reactie ook af van hoe getraind je bent. Ongetrainde mensen ervaren een significantere stijging van de DHEAS- en cortisolspiegels. Dat effect werd zowel bij jongeren als bij mensen ouder dan zestig waargenomen.\n\nIn sommige gevallen kan het aangewezen zijn zoethoutextract te nemen. Dat komt omdat zoethout de bijnieren helpt de afbraak van cortisol te voorkomen. Pas wel op, want zoethout werkt bloeddrukverhogend. Als je al last hebt van een verhoogde bloeddruk moet je hier dus zeker niet mee overdrijven.\n\nWat voeding betreft: probeer je inname van eiwitten, gezonde vetten en koolhydraten in evenwicht te brengen. Het helpt ook om je groente-inname te verhogen om zo de benodigde hoeveelheid vitamines en mineralen binnen te krijgen. Daarnaast zullen voedingsmiddelen met veel vitamine C, B5, B6 en magnesium helpen bij het handhaven van de gezondheid van de bijnieren.",
                                                    "score": 0,
                                                    "maxScore": 0,
                                                    "goalScore": 0,
                                                    "time": 1711438740448
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_GLUTATHIONPEROXIDASE",
                                            "name": "Glutathion Peroxidase",
                                            "unit": "IU/l",
                                            "values": [
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 76,
                                                    "intValue": 76,
                                                    "stringValue": "76",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_GLUTATHIONPEROXIDASE_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 75,
                                                    "intValue": 75,
                                                    "stringValue": "75",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_GLUTATHIONPEROXIDASE_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 117,
                                                    "intValue": 117,
                                                    "stringValue": "117",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_GLUTATHIONPEROXIDASE_HOOG",
                                                    "resultText": "Je GPx-waarden zijn licht verhoogd.",
                                                    "keyWords": "licht verhoogd",
                                                    "advice": "Verhoogde waarden van glutathionperoxidase kunnen komen door selenium rijke supplementen of voedsel.\nDit essentieel mineraal is een belangrijke co-factor voor de aanmaak van glutathion. Bronnen van selenium zijn rundvlees, kip, orgaanvlees, hÃ¼ttenkÃ¤se, bruine rijst en paranoten. Door de inname van selenium te verhogen, verhoog je indirect ook de glutathionspiegel. Volwassenen mikken best op 55 microgram selenium per dag, want zoveel heb je nodig om de aanmaak van het enzym glutathionperoxidase te maximaliseren. De meeste gezonde volwassenen zullen niet direct supplementen nodig hebben als ze seleniumrijke voeding consumeren.\n\n",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        },
                                        {
                                            "tag": "RESULT_BLOOD_STRESS_STRESS_TAS",
                                            "name": "Totale antioxidantstatus",
                                            "unit": "mmol/l",
                                            "values": [
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.56,
                                                    "stringValue": "1.56",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_TAS_NORMAAL",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1618296780000
                                                },
                                                {
                                                    "riskLevel": "BAD",
                                                    "doubleValue": 1.81,
                                                    "stringValue": "1.81",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_TAS_HOOG",
                                                    "score": 15,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1636450560000
                                                },
                                                {
                                                    "riskLevel": "GOOD",
                                                    "doubleValue": 1.75,
                                                    "stringValue": "1.75",
                                                    "tag": "RESULT_BLOOD_STRESS_STRESS_TAS_NORMAAL",
                                                    "resultText": "Je totale antioxidantenstatus is normaal.",
                                                    "keyWords": "normaal",
                                                    "advice": "Wanneer je je lichaam goed wil beschermen tegen oxidatieve stress is het belangrijk dat je voldoende antioxidanten binnenkrijgt via je voeding. Tracht te streven naar een waarde tussen 1,5 en 1,77 mmol/L.\n\nAntioxidanten zitten in gangbare producten zoals verschillende groenten, fruit, noten en kruiden. Vooral felgekleurde groenten en fruit bevatten verschillende antioxidatieve vitamines en mineralen. Daarnaast bevatten ze flavonoÃ¯de antioxidanten, die zorgen voor de kleur van groenten en fruit. Dat niet alleen: ze hebben ook een heel belangrijke werking op het lichaam. Ze bieden namelijk bescherming tegen de vrije radicalen. Zo zorgen ze ervoor dat gezonde cellen en weefsels worden behouden. Daarnaast zijn flavonoÃ¯den van essentieel belang voor de stofwisseling van vitamine C. Ze versterken elkaars effect, want flavonoÃ¯den zorgen ervoor dat gezonde cellen en weefsels worden behouden.\n\nDoor middel van je levensstijl kan je ook de productie van vrije radicalen verminderen. Vrije radicalen kunnen toenemen door ongezonde voeding, stresshormonen, roken, alcohol, overmatig sporten of juist de verzuring van onvoldoende beweging.",
                                                    "score": 50,
                                                    "maxScore": 50,
                                                    "goalScore": 50,
                                                    "time": 1638455400000
                                                }
                                            ],
                                            "visualization": "RAWRESULT",
                                            "source": "BLOOD"
                                        }
                                    ]
                                }
                            ],
                            "results": []
                        }
                    ],
                    "results": []
                }
            ],
            "results": [],
            "scoreResult": [
                {
                    "riskLevel": "GOOD",
                    "stringValue": "7.5",
                    "score": 7.533060164993588,
                    "maxScore": 10,
                    "goalScore": 9.638300478327084,
                    "realAge": 27.211498973305954,
                    "leadlifeAge": 23.03040262655796,
                    "goalAge": 18,
                    "time": 1672613999000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "6.2",
                    "score": 6.1638972005060735,
                    "maxScore": 10,
                    "goalScore": 9.75663538090668,
                    "realAge": 28.369609856262834,
                    "leadlifeAge": 29.078833687926966,
                    "goalAge": 18.3709787816564,
                    "time": 1709161199000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "6.7",
                    "score": 6.742340951743941,
                    "maxScore": 10,
                    "goalScore": 9.75663538090668,
                    "realAge": 28.372347707049965,
                    "leadlifeAge": 26.588043389957033,
                    "goalAge": 18.373716632443532,
                    "time": 1709247599000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "6.7",
                    "score": 6.738372697775687,
                    "maxScore": 10,
                    "goalScore": 9.75663538090668,
                    "realAge": 28.380561259411362,
                    "leadlifeAge": 26.615593772310287,
                    "goalAge": 18.38193018480493,
                    "time": 1709506799000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "5.8",
                    "score": 5.838186658347617,
                    "maxScore": 10,
                    "goalScore": 9.590149742696992,
                    "realAge": 28.432580424366872,
                    "leadlifeAge": 30.280692440815137,
                    "goalAge": 18.43394934976044,
                    "time": 1711148399000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "5.9",
                    "score": 5.885303299054713,
                    "maxScore": 10,
                    "goalScore": 9.669946121966177,
                    "realAge": 28.44079397672827,
                    "leadlifeAge": 30.30170452977085,
                    "goalAge": 18.442162902121833,
                    "time": 1711407599000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "5.6",
                    "score": 5.580202742579771,
                    "maxScore": 10,
                    "goalScore": 9.65097869131637,
                    "realAge": 28.4435318275154,
                    "leadlifeAge": 31.900515508415687,
                    "goalAge": 18.444900752908968,
                    "time": 1711493999000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "5.4",
                    "score": 5.4377526001296275,
                    "maxScore": 10,
                    "goalScore": 9.294853335191014,
                    "realAge": 28.449007529089666,
                    "leadlifeAge": 31.537577329169974,
                    "goalAge": 18.45037645448323,
                    "time": 1711666799000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "5.4",
                    "score": 5.440203580521785,
                    "maxScore": 10,
                    "goalScore": 9.294853335191014,
                    "realAge": 28.487337440109513,
                    "leadlifeAge": 31.588857196458275,
                    "goalAge": 18.48870636550308,
                    "time": 1712872799000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "5.4",
                    "score": 5.440203580521785,
                    "maxScore": 10,
                    "goalScore": 9.294853335191014,
                    "realAge": 28.49828884325804,
                    "leadlifeAge": 31.607568203238348,
                    "goalAge": 18.49965776865161,
                    "time": 1713218399000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "5.4",
                    "score": 5.440203580521785,
                    "maxScore": 10,
                    "goalScore": 9.294853335191014,
                    "realAge": 28.709103353867214,
                    "leadlifeAge": 31.967755083754753,
                    "goalAge": 18.71047227926078,
                    "time": 1719871199000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "5.4",
                    "score": 5.440203580521785,
                    "maxScore": 10,
                    "goalScore": 9.294853335191014,
                    "realAge": 28.744695414099933,
                    "leadlifeAge": 32.028565855789985,
                    "goalAge": 18.746064339493497,
                    "time": 1720994399000
                },
                {
                    "riskLevel": "NEUTRAL",
                    "stringValue": "5.4",
                    "score": 5.440203580521785,
                    "maxScore": 10,
                    "goalScore": 9.294853335191014,
                    "realAge": 28.747433264887064,
                    "leadlifeAge": 32.033243607485005,
                    "goalAge": 18.748802190280628,
                    "time": 1721080799000
                }
            ]
        }
    }
  }
);

export var ENCODED_DUMMY_DATA = btoa(encodeURIComponent(PRIVATE_DATA));